/* eslint-disable */
import * as Types from './types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@saleor/hooks/graphql';
const defaultOptions = {} as const;
export const FieldOrderLinesFragmentDoc = gql`
    fragment fieldOrderLines on TempOrderLine {
  id
  shippingMark
  paymentTerm
  itemNo
  prcGroup1
  product {
    id
    code
    description
    salesUnit
  }
  inquiryMethod
  requestDate
  requestDateChangeReason
  confirmedDate
  quantity
  unit
  weight
  weightUnit
  plant
  price
  netPrice
  priceCurrency
  paymentCondition
  itemCategory
  shippingPoint
  route
  poNo
  prcGroup1
  poNoExternal
  poDate
  overDeliveryTol
  underDeliveryTol
  deliveryTolUnlimited
  iplan {
    atpCtp
    atpCtpDetail
    block
    run
    paperMachine
    iplantConfirmQuantity
    salesUnit
  }
  shipTo
  internalCommentsToWarehouse
  externalCommentsToCustomer
  internalCommentsToLogistic
  productInformation
  status
  variant {
    id
    weight
    code
    descriptionEn
  }
  contractProduct {
    id
    remain
    price
    currency
  }
}
    `;
export const CashSaleResponseFragmentDoc = gql`
    fragment cashSaleResponse on CashSaleResponse {
  id
  arAmount
  cashFlag
  cashAmount
  balanceFlag
  balanceAmount
  feeAmount
  feeType
  feeAbsorbFlag
  withHoldTax
  remark
  files {
    id
    fileName
    fileSize
    documentType
    paymentMethod
  }
}
    `;
export const SyncFieldOrderLinesFragmentDoc = gql`
    fragment syncFieldOrderLines on CipTempOrderLine {
  id
  itemNo
  parentId
  bomUnitQuantity
  __typename
}
    `;
export const FieldOrderLinesCipFragmentDoc = gql`
    fragment fieldOrderLinesCip on CipTempOrderLine {
  id
  itemNo
  materialCode
  materialDescription
  customerMatCode
  quantity
  bomFlag
  parentId
  parentItemNo
  bomUnitQuantity
  salesUnit
  salesUnitList {
    toUnit
    fromUnit
    calculation
    __typename
  }
  weight
  weightUnit
  batchFlag
  batchNo
  plant
  requestDate
  price
  netPrice
  materialType
  priceCurrency
  paymentTermItem
  priceDate
  poItemNo
  poNo
  productionFlag
  overDeliveryTol
  underDeliveryTol
  shipTo
  internalCommentsToWarehouse
  externalCommentsToCustomer
  remark
  saleText1
  saleText2
  saleText3
  saleText4
  batchChoiceFlag
  itemNote
  lotNo
  prItemText
  productionMemo
  otcShipTo {
    soldToCode
    address {
      addressCode
      name1
      name2
      name3
      name4
      city
      postalCode
      district
      street1
      street2
      street3
      street4
      location
      transportZoneCode
      transportZoneName
      countryCode
      countryName
      telephoneNo
      telephoneExtension
      mobileNo
      faxNo
      faxNoExt
      email
      language
      taxNumber1
      taxNumber2
    }
  }
  __typename
}
    `;
export const ChangeFieldOrderLinesFragmentDoc = gql`
    fragment changeFieldOrderLines on CipGetChangeOrderItemData {
  id
  itemNo
  materialCode
  customerMatCode
  productionFlag
  batchNo
  batchChoiceFlag
  batchFlag
  materialDescription
  quantity
  salesUnit
  plant
  paymentTerm
  paymentTermDescTh
  poNo
  itemCategory
  materialGroup1
  saleText1
  saleText2
  saleText3
  saleText4
  routeId
  routeName
  requestDate
  originalRequestDate
  weightPerUnit
  orderQty
  confirmQty
  deliveryQty
  deliveryStatus
  saleQtyDivision
  saleQtyFactor
  prdHierachy
  shippingPoint
  poDate
  reasonReject
  confirmedDate
  weight
  internalCommentsToWarehouse
  externalCommentsToCustomer
  saleText1
  saleText2
  saleText3
  saleText4
  remark
  itemNote
  prItemText
  lotNo
  productionMemo
  overDeliveryTol
  underDeliveryTol
  deliveryTolUnlimited
  shipTo
  refPiStock
  assignQuantity
  itemStatusEn
  itemStatusTh
  netValue
  requestDateChangeReason
  weightDisplay
  poStatus
  materialGroup1Desc
  weightUnit
  prNoOs
  poNoOs
  prItemOs
  poItemNumber
  poItemNoOs
  materialType
  pricePerUnit
  priceCurrency
  bomFlag
  parentItemNo
  priceDate
  netWeight
  grossWeight
  baseUnit
  grStatusOs
  isSplitEnabled
  manualPriceFlag
  deliveryBlock
  bomUnitQuantity
  salesUnitList {
    toUnit
    fromUnit
    calculation
  }
  salesTextMaster {
    saleText1
    saleText2
    saleText3
    saleText4
  }
  __typename
}
    `;
export const UserPermissionFragmentDoc = gql`
    fragment UserPermission on UserPermission {
  code
  name
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  email
  firstName
  lastName
  isStaff
  displayName
  isSuperuser
  userPermissions {
    ...UserPermission
  }
  avatar {
    url
  }
}
    ${UserPermissionFragmentDoc}`;
export const UserBaseFragmentDoc = gql`
    fragment UserBase on User {
  id
  firstName
  lastName
}
    `;
export const CustomerFragmentDoc = gql`
    fragment Customer on User {
  id
  email
  firstName
  lastName
}
    `;
export const MetadataItemFragmentDoc = gql`
    fragment MetadataItem on MetadataItem {
  key
  value
}
    `;
export const MetadataFragmentDoc = gql`
    fragment Metadata on ObjectWithMetadata {
  metadata {
    ...MetadataItem
  }
  privateMetadata {
    ...MetadataItem
  }
}
    ${MetadataItemFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  city
  cityArea
  companyName
  country {
    __typename
    code
    country
  }
  countryArea
  firstName
  id
  lastName
  phone
  postalCode
  streetAddress1
  streetAddress2
}
    `;
export const CustomerDetailsFragmentDoc = gql`
    fragment CustomerDetails on User {
  ...Customer
  ...Metadata
  dateJoined
  lastLogin
  defaultShippingAddress {
    ...Address
  }
  defaultBillingAddress {
    ...Address
  }
  note
  isActive
}
    ${CustomerFragmentDoc}
${MetadataFragmentDoc}
${AddressFragmentDoc}`;
export const CustomerAddressesFragmentDoc = gql`
    fragment CustomerAddresses on User {
  ...Customer
  addresses {
    ...Address
  }
  defaultBillingAddress {
    id
  }
  defaultShippingAddress {
    id
  }
}
    ${CustomerFragmentDoc}
${AddressFragmentDoc}`;
export const AccountErrorFragmentDoc = gql`
    fragment AccountError on AccountError {
  code
  field
  message
}
    `;
export const ShopErrorFragmentDoc = gql`
    fragment ShopError on ShopError {
  code
  field
  message
}
    `;
export const UploadErrorFragmentDoc = gql`
    fragment UploadError on UploadError {
  code
  field
  message
}
    `;
export const ShopSettingsUpdateErrorFragmentFragmentDoc = gql`
    fragment ShopSettingsUpdateErrorFragment on ShopError {
  code
  field
  message
}
    `;
export const ShopFetchTaxRatesErrorFragmentFragmentDoc = gql`
    fragment ShopFetchTaxRatesErrorFragment on ShopError {
  code
  field
  message
}
    `;
export const ProductTranslateErrorFragmentFragmentDoc = gql`
    fragment ProductTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const ProductVariantTranslateErrorFragmentFragmentDoc = gql`
    fragment ProductVariantTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const CategoryTranslateErrorFragmentFragmentDoc = gql`
    fragment CategoryTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const CollectionTranslateErrorFragmentFragmentDoc = gql`
    fragment CollectionTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const PageTranslateErrorFragmentFragmentDoc = gql`
    fragment PageTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const VoucherTranslateErrorFragmentFragmentDoc = gql`
    fragment VoucherTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const SaleTranslateErrorFragmentFragmentDoc = gql`
    fragment SaleTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const AttributeTranslateErrorFragmentFragmentDoc = gql`
    fragment AttributeTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const AttributeValueTranslateErrorFragmentFragmentDoc = gql`
    fragment AttributeValueTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const ShippingPriceTranslateErrorFragmentFragmentDoc = gql`
    fragment ShippingPriceTranslateErrorFragment on TranslationError {
  code
  field
  message
}
    `;
export const FileFragmentDoc = gql`
    fragment File on File {
  url
  contentType
}
    `;
export const GiftCardsSettingsFragmentDoc = gql`
    fragment GiftCardsSettings on GiftCardSettings {
  expiryType
  expiryPeriod {
    type
    amount
  }
}
    `;
export const OrderSettingsFragmentDoc = gql`
    fragment OrderSettings on OrderSettings {
  automaticallyConfirmAllNewOrders
  automaticallyFulfillNonShippableGiftCard
}
    `;
export const ShopOrderSettingsFragmentDoc = gql`
    fragment ShopOrderSettings on Shop {
  fulfillmentAutoApprove
  fulfillmentAllowUnpaid
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
}
    `;
export const PermissionGroupFragmentDoc = gql`
    fragment PermissionGroup on Group {
  id
  name
  users {
    id
    firstName
    lastName
  }
}
    `;
export const PermissionFragmentDoc = gql`
    fragment Permission on Permission {
  code
  name
}
    `;
export const StaffMemberFragmentDoc = gql`
    fragment StaffMember on User {
  id
  email
  firstName
  isActive
  lastName
}
    `;
export const PermissionGroupMemberFragmentDoc = gql`
    fragment PermissionGroupMember on User {
  ...StaffMember
  avatar(size: 48) {
    url
  }
}
    ${StaffMemberFragmentDoc}`;
export const PermissionGroupDetailsFragmentDoc = gql`
    fragment PermissionGroupDetails on Group {
  ...PermissionGroup
  permissions {
    ...Permission
  }
  users {
    ...PermissionGroupMember
  }
}
    ${PermissionGroupFragmentDoc}
${PermissionFragmentDoc}
${PermissionGroupMemberFragmentDoc}`;
export const CountryWithCodeFragmentDoc = gql`
    fragment CountryWithCode on CountryDisplay {
  country
  code
}
    `;
export const LanguageFragmentDoc = gql`
    fragment Language on LanguageDisplay {
  code
  language
}
    `;
export const LimitInfoFragmentDoc = gql`
    fragment LimitInfo on Limits {
  channels @include(if: $channels)
  orders @include(if: $orders)
  productVariants @include(if: $productVariants)
  staffUsers @include(if: $staffUsers)
  warehouses @include(if: $warehouses)
}
    `;
export const ShopLimitFragmentDoc = gql`
    fragment ShopLimit on Shop {
  limits {
    currentUsage {
      ...LimitInfo
    }
    allowedUsage {
      ...LimitInfo
    }
  }
}
    ${LimitInfoFragmentDoc}`;
export const ShopFragmentDoc = gql`
    fragment Shop on Shop {
  countries {
    code
    country
  }
  customerSetPasswordUrl
  defaultMailSenderAddress
  defaultMailSenderName
  description
  domain {
    host
  }
  name
  reserveStockDurationAnonymousUser
  reserveStockDurationAuthenticatedUser
  limitQuantityPerCheckout
}
    `;
export const StaffMemberDetailsFragmentDoc = gql`
    fragment StaffMemberDetails on User {
  ...StaffMember
  permissionGroups {
    id
    name
  }
  userPermissions {
    code
    name
  }
  avatar(size: 120) {
    url
  }
}
    ${StaffMemberFragmentDoc}`;
export const CountryFragmentDoc = gql`
    fragment Country on CountryDisplay {
  country
  code
}
    `;
export const CountryWithTaxesFragmentDoc = gql`
    fragment CountryWithTaxes on CountryDisplay {
  ...Country
  vat {
    standardRate
    reducedRates {
      rateType
      rate
    }
  }
}
    ${CountryFragmentDoc}`;
export const ShopTaxesFragmentDoc = gql`
    fragment ShopTaxes on Shop {
  chargeTaxesOnShipping
  includeTaxesInPrices
  displayGrossPrices
}
    `;
export const TimePeriodFragmentDoc = gql`
    fragment TimePeriod on TimePeriod {
  amount
  type
}
    `;
export const PrintPdfOrderConfirmDocument = gql`
    mutation printPdfOrderConfirm($orders: SendEmailOrderInput!, $reportLanguage: String!) {
  printPdfOrderConfirmation(
    listOrderConfirmationSap: $orders
    reportLanguage: $reportLanguage
  ) {
    exportedFileBase64
    fileName
    errors {
      field
      message
      code
    }
  }
}
    `;
export type PrintPdfOrderConfirmMutationFn = Apollo.MutationFunction<Types.PrintPdfOrderConfirmMutation, Types.PrintPdfOrderConfirmMutationVariables>;

/**
 * __usePrintPdfOrderConfirmMutation__
 *
 * To run a mutation, you first call `usePrintPdfOrderConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintPdfOrderConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printPdfOrderConfirmMutation, { data, loading, error }] = usePrintPdfOrderConfirmMutation({
 *   variables: {
 *      orders: // value for 'orders'
 *      reportLanguage: // value for 'reportLanguage'
 *   },
 * });
 */
export function usePrintPdfOrderConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PrintPdfOrderConfirmMutation, Types.PrintPdfOrderConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PrintPdfOrderConfirmMutation, Types.PrintPdfOrderConfirmMutationVariables>(PrintPdfOrderConfirmDocument, options);
      }
export type PrintPdfOrderConfirmMutationHookResult = ReturnType<typeof usePrintPdfOrderConfirmMutation>;
export type PrintPdfOrderConfirmMutationResult = Apollo.MutationResult<Types.PrintPdfOrderConfirmMutation>;
export type PrintPdfOrderConfirmMutationOptions = Apollo.BaseMutationOptions<Types.PrintPdfOrderConfirmMutation, Types.PrintPdfOrderConfirmMutationVariables>;
export const FilterDomesticOrderConfirmationCompanyDocument = gql`
    query filterDomesticOrderConfirmationCompany {
  filterDomesticOrderConfirmationCompany {
    name
    code
  }
}
    `;

/**
 * __useFilterDomesticOrderConfirmationCompanyQuery__
 *
 * To run a query within a React component, call `useFilterDomesticOrderConfirmationCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterDomesticOrderConfirmationCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterDomesticOrderConfirmationCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterDomesticOrderConfirmationCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterDomesticOrderConfirmationCompanyQuery, Types.FilterDomesticOrderConfirmationCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterDomesticOrderConfirmationCompanyQuery, Types.FilterDomesticOrderConfirmationCompanyQueryVariables>(FilterDomesticOrderConfirmationCompanyDocument, options);
      }
export function useFilterDomesticOrderConfirmationCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterDomesticOrderConfirmationCompanyQuery, Types.FilterDomesticOrderConfirmationCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterDomesticOrderConfirmationCompanyQuery, Types.FilterDomesticOrderConfirmationCompanyQueryVariables>(FilterDomesticOrderConfirmationCompanyDocument, options);
        }
export type FilterDomesticOrderConfirmationCompanyQueryHookResult = ReturnType<typeof useFilterDomesticOrderConfirmationCompanyQuery>;
export type FilterDomesticOrderConfirmationCompanyLazyQueryHookResult = ReturnType<typeof useFilterDomesticOrderConfirmationCompanyLazyQuery>;
export type FilterDomesticOrderConfirmationCompanyQueryResult = Apollo.QueryResult<Types.FilterDomesticOrderConfirmationCompanyQuery, Types.FilterDomesticOrderConfirmationCompanyQueryVariables>;
export const FilterMaterialCodeNameDomesticOrderDocument = gql`
    query filterMaterialCodeNameDomesticOrder($distributionChannelType: DistributionChannelType!, $filter: DomesticMaterialCodeNameFilterInput, $before: String, $after: String, $first: Int) {
  filterMaterialCodeNameDomesticOrder(
    distributionChannelType: $distributionChannelType
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        name: descriptionEn
        code
      }
    }
  }
}
    `;

/**
 * __useFilterMaterialCodeNameDomesticOrderQuery__
 *
 * To run a query within a React component, call `useFilterMaterialCodeNameDomesticOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterMaterialCodeNameDomesticOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterMaterialCodeNameDomesticOrderQuery({
 *   variables: {
 *      distributionChannelType: // value for 'distributionChannelType'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterMaterialCodeNameDomesticOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FilterMaterialCodeNameDomesticOrderQuery, Types.FilterMaterialCodeNameDomesticOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterMaterialCodeNameDomesticOrderQuery, Types.FilterMaterialCodeNameDomesticOrderQueryVariables>(FilterMaterialCodeNameDomesticOrderDocument, options);
      }
export function useFilterMaterialCodeNameDomesticOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterMaterialCodeNameDomesticOrderQuery, Types.FilterMaterialCodeNameDomesticOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterMaterialCodeNameDomesticOrderQuery, Types.FilterMaterialCodeNameDomesticOrderQueryVariables>(FilterMaterialCodeNameDomesticOrderDocument, options);
        }
export type FilterMaterialCodeNameDomesticOrderQueryHookResult = ReturnType<typeof useFilterMaterialCodeNameDomesticOrderQuery>;
export type FilterMaterialCodeNameDomesticOrderLazyQueryHookResult = ReturnType<typeof useFilterMaterialCodeNameDomesticOrderLazyQuery>;
export type FilterMaterialCodeNameDomesticOrderQueryResult = Apollo.QueryResult<Types.FilterMaterialCodeNameDomesticOrderQuery, Types.FilterMaterialCodeNameDomesticOrderQueryVariables>;
export const GetListAdminOrderConfirmationDocument = gql`
    query getListAdminOrderConfirmation($sortBy: DomesticOrderConfirmationSortingInput, $filter: DomesticOrderConfirmationFilterInput, $before: String, $after: String, $first: Int, $last: Int) {
  domesticOrderConfirmation(
    sortBy: $sortBy
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    totalCount
    latestPageItemNumber
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        company {
          code
          name
        }
        contract {
          customer {
            soldToCode
            soldToName
          }
        }
        createdAt
        soNo
        poNo
        poNumber
        orderLines {
          id
          sapConfirmStatus
          itemNo
          variant {
            descriptionTh
          }
          quantity
          assignedQuantity
          confirmQuantity
          nonConfirmQuantity
          salesUnit
          requestDate
          confirmedDate
        }
      }
    }
  }
}
    `;

/**
 * __useGetListAdminOrderConfirmationQuery__
 *
 * To run a query within a React component, call `useGetListAdminOrderConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListAdminOrderConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListAdminOrderConfirmationQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetListAdminOrderConfirmationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListAdminOrderConfirmationQuery, Types.GetListAdminOrderConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListAdminOrderConfirmationQuery, Types.GetListAdminOrderConfirmationQueryVariables>(GetListAdminOrderConfirmationDocument, options);
      }
export function useGetListAdminOrderConfirmationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListAdminOrderConfirmationQuery, Types.GetListAdminOrderConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListAdminOrderConfirmationQuery, Types.GetListAdminOrderConfirmationQueryVariables>(GetListAdminOrderConfirmationDocument, options);
        }
export type GetListAdminOrderConfirmationQueryHookResult = ReturnType<typeof useGetListAdminOrderConfirmationQuery>;
export type GetListAdminOrderConfirmationLazyQueryHookResult = ReturnType<typeof useGetListAdminOrderConfirmationLazyQuery>;
export type GetListAdminOrderConfirmationQueryResult = Apollo.QueryResult<Types.GetListAdminOrderConfirmationQuery, Types.GetListAdminOrderConfirmationQueryVariables>;
export const GetListCustomerOrderConfirmationDocument = gql`
    query getListCustomerOrderConfirmation($sortBy: CustomerOrderConfirmationSortingInput, $filter: CustomerOrderConfirmationFilterInput, $before: String, $after: String, $first: Int, $last: Int) {
  customerOrderConfirmation(
    sortBy: $sortBy
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    totalCount
    latestPageItemNumber
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        company {
          name
          code
        }
        contract {
          soldTo {
            soldToCode
            soldToName
          }
        }
        createdAt
        soNo
        poNo
        lines {
          id
          sapConfirmStatus
          itemNo
          variant {
            descriptionTh
          }
          quantity
          assignedQuantity
          confirmQuantity
          nonConfirmQuantity
          salesUnit
          requestDeliveryDate
          confirmedDate
        }
      }
    }
  }
}
    `;

/**
 * __useGetListCustomerOrderConfirmationQuery__
 *
 * To run a query within a React component, call `useGetListCustomerOrderConfirmationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListCustomerOrderConfirmationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListCustomerOrderConfirmationQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetListCustomerOrderConfirmationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListCustomerOrderConfirmationQuery, Types.GetListCustomerOrderConfirmationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListCustomerOrderConfirmationQuery, Types.GetListCustomerOrderConfirmationQueryVariables>(GetListCustomerOrderConfirmationDocument, options);
      }
export function useGetListCustomerOrderConfirmationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListCustomerOrderConfirmationQuery, Types.GetListCustomerOrderConfirmationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListCustomerOrderConfirmationQuery, Types.GetListCustomerOrderConfirmationQueryVariables>(GetListCustomerOrderConfirmationDocument, options);
        }
export type GetListCustomerOrderConfirmationQueryHookResult = ReturnType<typeof useGetListCustomerOrderConfirmationQuery>;
export type GetListCustomerOrderConfirmationLazyQueryHookResult = ReturnType<typeof useGetListCustomerOrderConfirmationLazyQuery>;
export type GetListCustomerOrderConfirmationQueryResult = Apollo.QueryResult<Types.GetListCustomerOrderConfirmationQuery, Types.GetListCustomerOrderConfirmationQueryVariables>;
export const DistributionChannelsDomesticDocument = gql`
    query distributionChannelsDomestic {
  distributionChannelsDomestic {
    code
    name
  }
}
    `;

/**
 * __useDistributionChannelsDomesticQuery__
 *
 * To run a query within a React component, call `useDistributionChannelsDomesticQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionChannelsDomesticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionChannelsDomesticQuery({
 *   variables: {
 *   },
 * });
 */
export function useDistributionChannelsDomesticQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DistributionChannelsDomesticQuery, Types.DistributionChannelsDomesticQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DistributionChannelsDomesticQuery, Types.DistributionChannelsDomesticQueryVariables>(DistributionChannelsDomesticDocument, options);
      }
export function useDistributionChannelsDomesticLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DistributionChannelsDomesticQuery, Types.DistributionChannelsDomesticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DistributionChannelsDomesticQuery, Types.DistributionChannelsDomesticQueryVariables>(DistributionChannelsDomesticDocument, options);
        }
export type DistributionChannelsDomesticQueryHookResult = ReturnType<typeof useDistributionChannelsDomesticQuery>;
export type DistributionChannelsDomesticLazyQueryHookResult = ReturnType<typeof useDistributionChannelsDomesticLazyQuery>;
export type DistributionChannelsDomesticQueryResult = Apollo.QueryResult<Types.DistributionChannelsDomesticQuery, Types.DistributionChannelsDomesticQueryVariables>;
export const DistributionChannelsExportDocument = gql`
    query distributionChannelsExport {
  distributionChannelsExport {
    code
    name
  }
}
    `;

/**
 * __useDistributionChannelsExportQuery__
 *
 * To run a query within a React component, call `useDistributionChannelsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributionChannelsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributionChannelsExportQuery({
 *   variables: {
 *   },
 * });
 */
export function useDistributionChannelsExportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DistributionChannelsExportQuery, Types.DistributionChannelsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DistributionChannelsExportQuery, Types.DistributionChannelsExportQueryVariables>(DistributionChannelsExportDocument, options);
      }
export function useDistributionChannelsExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DistributionChannelsExportQuery, Types.DistributionChannelsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DistributionChannelsExportQuery, Types.DistributionChannelsExportQueryVariables>(DistributionChannelsExportDocument, options);
        }
export type DistributionChannelsExportQueryHookResult = ReturnType<typeof useDistributionChannelsExportQuery>;
export type DistributionChannelsExportLazyQueryHookResult = ReturnType<typeof useDistributionChannelsExportLazyQuery>;
export type DistributionChannelsExportQueryResult = Apollo.QueryResult<Types.DistributionChannelsExportQuery, Types.DistributionChannelsExportQueryVariables>;
export const ListOrderConfirmationSapDocument = gql`
    query listOrderConfirmationSap($filter: SAPOrderConfirmationInput) {
  listOrderConfirmationSap(filter: $filter) {
    contractName
    contractNo
    orderDate
    shipToCode
    isNotRef
    orderLines {
      saleOrg
      soldToCode
      soldToName
      status
      itemNo
      materialDescription
      orderQty
      confirmQuantity
      nonConfirmQuantity
      saleUnit
      requestDate
      confirmDate
      remarkOrder
      materialCode
    }
    paymentMethodName
    poNo
    salesOrgName
    soNo
    soldToName
  }
}
    `;

/**
 * __useListOrderConfirmationSapQuery__
 *
 * To run a query within a React component, call `useListOrderConfirmationSapQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrderConfirmationSapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrderConfirmationSapQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListOrderConfirmationSapQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListOrderConfirmationSapQuery, Types.ListOrderConfirmationSapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListOrderConfirmationSapQuery, Types.ListOrderConfirmationSapQueryVariables>(ListOrderConfirmationSapDocument, options);
      }
export function useListOrderConfirmationSapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListOrderConfirmationSapQuery, Types.ListOrderConfirmationSapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListOrderConfirmationSapQuery, Types.ListOrderConfirmationSapQueryVariables>(ListOrderConfirmationSapDocument, options);
        }
export type ListOrderConfirmationSapQueryHookResult = ReturnType<typeof useListOrderConfirmationSapQuery>;
export type ListOrderConfirmationSapLazyQueryHookResult = ReturnType<typeof useListOrderConfirmationSapLazyQuery>;
export type ListOrderConfirmationSapQueryResult = Apollo.QueryResult<Types.ListOrderConfirmationSapQuery, Types.ListOrderConfirmationSapQueryVariables>;
export const PrintPendingOrderReportDocument = gql`
    mutation printPendingOrderReport($input: SAPPendingOrderReportInput) {
  printPendingOrderReport(input: $input) {
    exportedFileBase64
    fileName
    errors {
      field
      message
      code
    }
  }
}
    `;
export type PrintPendingOrderReportMutationFn = Apollo.MutationFunction<Types.PrintPendingOrderReportMutation, Types.PrintPendingOrderReportMutationVariables>;

/**
 * __usePrintPendingOrderReportMutation__
 *
 * To run a mutation, you first call `usePrintPendingOrderReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintPendingOrderReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printPendingOrderReportMutation, { data, loading, error }] = usePrintPendingOrderReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintPendingOrderReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PrintPendingOrderReportMutation, Types.PrintPendingOrderReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PrintPendingOrderReportMutation, Types.PrintPendingOrderReportMutationVariables>(PrintPendingOrderReportDocument, options);
      }
export type PrintPendingOrderReportMutationHookResult = ReturnType<typeof usePrintPendingOrderReportMutation>;
export type PrintPendingOrderReportMutationResult = Apollo.MutationResult<Types.PrintPendingOrderReportMutation>;
export type PrintPendingOrderReportMutationOptions = Apollo.BaseMutationOptions<Types.PrintPendingOrderReportMutation, Types.PrintPendingOrderReportMutationVariables>;
export const DownloadPendingOrderReportDocument = gql`
    mutation downloadPendingOrderReport($input: SAPPendingOrderReportInput) {
  downloadPendingOrderReport(input: $input) {
    exportedFileBase64
    fileName
  }
}
    `;
export type DownloadPendingOrderReportMutationFn = Apollo.MutationFunction<Types.DownloadPendingOrderReportMutation, Types.DownloadPendingOrderReportMutationVariables>;

/**
 * __useDownloadPendingOrderReportMutation__
 *
 * To run a mutation, you first call `useDownloadPendingOrderReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPendingOrderReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPendingOrderReportMutation, { data, loading, error }] = useDownloadPendingOrderReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadPendingOrderReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DownloadPendingOrderReportMutation, Types.DownloadPendingOrderReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DownloadPendingOrderReportMutation, Types.DownloadPendingOrderReportMutationVariables>(DownloadPendingOrderReportDocument, options);
      }
export type DownloadPendingOrderReportMutationHookResult = ReturnType<typeof useDownloadPendingOrderReportMutation>;
export type DownloadPendingOrderReportMutationResult = Apollo.MutationResult<Types.DownloadPendingOrderReportMutation>;
export type DownloadPendingOrderReportMutationOptions = Apollo.BaseMutationOptions<Types.DownloadPendingOrderReportMutation, Types.DownloadPendingOrderReportMutationVariables>;
export const SendEmailPendingOrderDocument = gql`
    mutation sendEmailPendingOrder($listTo: String!, $listCc: String!, $subject: String!, $emailContent: String!, $input: SAPPendingOrderReportInput!, $soldToCode: String!) {
  sendEmailPendingOrder(
    listTo: $listTo
    listCc: $listCc
    subject: $subject
    emailContent: $emailContent
    soldToCode: $soldToCode
    input: $input
  ) {
    status
    errors {
      message
    }
  }
}
    `;
export type SendEmailPendingOrderMutationFn = Apollo.MutationFunction<Types.SendEmailPendingOrderMutation, Types.SendEmailPendingOrderMutationVariables>;

/**
 * __useSendEmailPendingOrderMutation__
 *
 * To run a mutation, you first call `useSendEmailPendingOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailPendingOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailPendingOrderMutation, { data, loading, error }] = useSendEmailPendingOrderMutation({
 *   variables: {
 *      listTo: // value for 'listTo'
 *      listCc: // value for 'listCc'
 *      subject: // value for 'subject'
 *      emailContent: // value for 'emailContent'
 *      input: // value for 'input'
 *      soldToCode: // value for 'soldToCode'
 *   },
 * });
 */
export function useSendEmailPendingOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SendEmailPendingOrderMutation, Types.SendEmailPendingOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SendEmailPendingOrderMutation, Types.SendEmailPendingOrderMutationVariables>(SendEmailPendingOrderDocument, options);
      }
export type SendEmailPendingOrderMutationHookResult = ReturnType<typeof useSendEmailPendingOrderMutation>;
export type SendEmailPendingOrderMutationResult = Apollo.MutationResult<Types.SendEmailPendingOrderMutation>;
export type SendEmailPendingOrderMutationOptions = Apollo.BaseMutationOptions<Types.SendEmailPendingOrderMutation, Types.SendEmailPendingOrderMutationVariables>;
export const Suggestion_Search_Sold_To_Report_Order_PendingDocument = gql`
    query suggestion_search_sold_to_report_order_pending($filter: ReportOrderPendingSoldToFilterInput, $before: String, $after: String, $first: Int, $last: Int) {
  suggestionSearchSoldToReportOrderPending(
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        name
        code
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSuggestion_Search_Sold_To_Report_Order_PendingQuery__
 *
 * To run a query within a React component, call `useSuggestion_Search_Sold_To_Report_Order_PendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestion_Search_Sold_To_Report_Order_PendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestion_Search_Sold_To_Report_Order_PendingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useSuggestion_Search_Sold_To_Report_Order_PendingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.Suggestion_Search_Sold_To_Report_Order_PendingQuery, Types.Suggestion_Search_Sold_To_Report_Order_PendingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.Suggestion_Search_Sold_To_Report_Order_PendingQuery, Types.Suggestion_Search_Sold_To_Report_Order_PendingQueryVariables>(Suggestion_Search_Sold_To_Report_Order_PendingDocument, options);
      }
export function useSuggestion_Search_Sold_To_Report_Order_PendingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.Suggestion_Search_Sold_To_Report_Order_PendingQuery, Types.Suggestion_Search_Sold_To_Report_Order_PendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.Suggestion_Search_Sold_To_Report_Order_PendingQuery, Types.Suggestion_Search_Sold_To_Report_Order_PendingQueryVariables>(Suggestion_Search_Sold_To_Report_Order_PendingDocument, options);
        }
export type Suggestion_Search_Sold_To_Report_Order_PendingQueryHookResult = ReturnType<typeof useSuggestion_Search_Sold_To_Report_Order_PendingQuery>;
export type Suggestion_Search_Sold_To_Report_Order_PendingLazyQueryHookResult = ReturnType<typeof useSuggestion_Search_Sold_To_Report_Order_PendingLazyQuery>;
export type Suggestion_Search_Sold_To_Report_Order_PendingQueryResult = Apollo.QueryResult<Types.Suggestion_Search_Sold_To_Report_Order_PendingQuery, Types.Suggestion_Search_Sold_To_Report_Order_PendingQueryVariables>;
export const SuggestionSearchMaterialNoGradeGramReportOrderPendingDocument = gql`
    query suggestionSearchMaterialNoGradeGramReportOrderPending($filter: SuggestionSearchMaterialGradeGramFilterInput, $materialGradeGram: String, $before: String, $after: String, $first: Int, $last: Int) {
  suggestionSearchMaterialNoGradeGramReportOrderPending(
    filter: $filter
    materialGradeGram: $materialGradeGram
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        code
        descriptionEn
      }
    }
  }
}
    `;

/**
 * __useSuggestionSearchMaterialNoGradeGramReportOrderPendingQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchMaterialNoGradeGramReportOrderPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchMaterialNoGradeGramReportOrderPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchMaterialNoGradeGramReportOrderPendingQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      materialGradeGram: // value for 'materialGradeGram'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useSuggestionSearchMaterialNoGradeGramReportOrderPendingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQuery, Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQuery, Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryVariables>(SuggestionSearchMaterialNoGradeGramReportOrderPendingDocument, options);
      }
export function useSuggestionSearchMaterialNoGradeGramReportOrderPendingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQuery, Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQuery, Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryVariables>(SuggestionSearchMaterialNoGradeGramReportOrderPendingDocument, options);
        }
export type SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryHookResult = ReturnType<typeof useSuggestionSearchMaterialNoGradeGramReportOrderPendingQuery>;
export type SuggestionSearchMaterialNoGradeGramReportOrderPendingLazyQueryHookResult = ReturnType<typeof useSuggestionSearchMaterialNoGradeGramReportOrderPendingLazyQuery>;
export type SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryResult = Apollo.QueryResult<Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQuery, Types.SuggestionSearchMaterialNoGradeGramReportOrderPendingQueryVariables>;
export const SuggestionSearchSalesOrganizationReportOrderPendingDocument = gql`
    query suggestionSearchSalesOrganizationReportOrderPending {
  suggestionSearchSalesOrganizationReportOrderPending {
    id
    code
    name
  }
}
    `;

/**
 * __useSuggestionSearchSalesOrganizationReportOrderPendingQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchSalesOrganizationReportOrderPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchSalesOrganizationReportOrderPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchSalesOrganizationReportOrderPendingQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuggestionSearchSalesOrganizationReportOrderPendingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchSalesOrganizationReportOrderPendingQuery, Types.SuggestionSearchSalesOrganizationReportOrderPendingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchSalesOrganizationReportOrderPendingQuery, Types.SuggestionSearchSalesOrganizationReportOrderPendingQueryVariables>(SuggestionSearchSalesOrganizationReportOrderPendingDocument, options);
      }
export function useSuggestionSearchSalesOrganizationReportOrderPendingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchSalesOrganizationReportOrderPendingQuery, Types.SuggestionSearchSalesOrganizationReportOrderPendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchSalesOrganizationReportOrderPendingQuery, Types.SuggestionSearchSalesOrganizationReportOrderPendingQueryVariables>(SuggestionSearchSalesOrganizationReportOrderPendingDocument, options);
        }
export type SuggestionSearchSalesOrganizationReportOrderPendingQueryHookResult = ReturnType<typeof useSuggestionSearchSalesOrganizationReportOrderPendingQuery>;
export type SuggestionSearchSalesOrganizationReportOrderPendingLazyQueryHookResult = ReturnType<typeof useSuggestionSearchSalesOrganizationReportOrderPendingLazyQuery>;
export type SuggestionSearchSalesOrganizationReportOrderPendingQueryResult = Apollo.QueryResult<Types.SuggestionSearchSalesOrganizationReportOrderPendingQuery, Types.SuggestionSearchSalesOrganizationReportOrderPendingQueryVariables>;
export const SuggestionSearchShipToReportOrderPendingDocument = gql`
    query suggestionSearchShipToReportOrderPending($shipToSearch: String, $soldToCode: [String]) {
  suggestionSearchShipToReportOrderPending(
    shipToSearch: $shipToSearch
    soldToCode: $soldToCode
  ) {
    name
    code
  }
}
    `;

/**
 * __useSuggestionSearchShipToReportOrderPendingQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchShipToReportOrderPendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchShipToReportOrderPendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchShipToReportOrderPendingQuery({
 *   variables: {
 *      shipToSearch: // value for 'shipToSearch'
 *      soldToCode: // value for 'soldToCode'
 *   },
 * });
 */
export function useSuggestionSearchShipToReportOrderPendingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchShipToReportOrderPendingQuery, Types.SuggestionSearchShipToReportOrderPendingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchShipToReportOrderPendingQuery, Types.SuggestionSearchShipToReportOrderPendingQueryVariables>(SuggestionSearchShipToReportOrderPendingDocument, options);
      }
export function useSuggestionSearchShipToReportOrderPendingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchShipToReportOrderPendingQuery, Types.SuggestionSearchShipToReportOrderPendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchShipToReportOrderPendingQuery, Types.SuggestionSearchShipToReportOrderPendingQueryVariables>(SuggestionSearchShipToReportOrderPendingDocument, options);
        }
export type SuggestionSearchShipToReportOrderPendingQueryHookResult = ReturnType<typeof useSuggestionSearchShipToReportOrderPendingQuery>;
export type SuggestionSearchShipToReportOrderPendingLazyQueryHookResult = ReturnType<typeof useSuggestionSearchShipToReportOrderPendingLazyQuery>;
export type SuggestionSearchShipToReportOrderPendingQueryResult = Apollo.QueryResult<Types.SuggestionSearchShipToReportOrderPendingQuery, Types.SuggestionSearchShipToReportOrderPendingQueryVariables>;
export const ListOfSaleOrderPendingSapDocument = gql`
    query listOfSaleOrderPendingSap($filter: SAPListOfSaleOrderPendingInput) {
  listOfSaleOrderPendingSap(filter: $filter) {
    soldTo
    soldToName
    productGroups {
      productGroup
      materialGroup
      orderLines {
        saleOrg
        soldTo
        shipTo
        requestDate
        orderDate
        poNo
        soNo
        itemNo
        materialCode
        materialDescription
        orderQty
        pendingQty
        atpQty
        ctpQty
        deliveryQty
        saleUnit
        shipToPoDate
        confirmDate
        bomFlag
        parentItemNo
        __typename
      }
      summary {
        orderQty
        pendingQty
        atpQty
        ctpQty
        deliveryQty
        saleUnit
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useListOfSaleOrderPendingSapQuery__
 *
 * To run a query within a React component, call `useListOfSaleOrderPendingSapQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfSaleOrderPendingSapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfSaleOrderPendingSapQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListOfSaleOrderPendingSapQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListOfSaleOrderPendingSapQuery, Types.ListOfSaleOrderPendingSapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListOfSaleOrderPendingSapQuery, Types.ListOfSaleOrderPendingSapQueryVariables>(ListOfSaleOrderPendingSapDocument, options);
      }
export function useListOfSaleOrderPendingSapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListOfSaleOrderPendingSapQuery, Types.ListOfSaleOrderPendingSapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListOfSaleOrderPendingSapQuery, Types.ListOfSaleOrderPendingSapQueryVariables>(ListOfSaleOrderPendingSapDocument, options);
        }
export type ListOfSaleOrderPendingSapQueryHookResult = ReturnType<typeof useListOfSaleOrderPendingSapQuery>;
export type ListOfSaleOrderPendingSapLazyQueryHookResult = ReturnType<typeof useListOfSaleOrderPendingSapLazyQuery>;
export type ListOfSaleOrderPendingSapQueryResult = Apollo.QueryResult<Types.ListOfSaleOrderPendingSapQuery, Types.ListOfSaleOrderPendingSapQueryVariables>;
export const GetEmailToAndCcBySoldToDocument = gql`
    query getEmailToAndCcBySoldTo($soldToCode: String!, $saleOrg: String!, $saleOrgList: [String], $productGroup: [String], $bu: String!) {
  getEmailToAndCcBySoldTo(
    soldToCode: $soldToCode
    saleOrg: $saleOrg
    saleOrgList: $saleOrgList
    productGroup: $productGroup
    bu: $bu
  ) {
    soldToName
    to
    cc
  }
}
    `;

/**
 * __useGetEmailToAndCcBySoldToQuery__
 *
 * To run a query within a React component, call `useGetEmailToAndCcBySoldToQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailToAndCcBySoldToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailToAndCcBySoldToQuery({
 *   variables: {
 *      soldToCode: // value for 'soldToCode'
 *      saleOrg: // value for 'saleOrg'
 *      saleOrgList: // value for 'saleOrgList'
 *      productGroup: // value for 'productGroup'
 *      bu: // value for 'bu'
 *   },
 * });
 */
export function useGetEmailToAndCcBySoldToQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetEmailToAndCcBySoldToQuery, Types.GetEmailToAndCcBySoldToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetEmailToAndCcBySoldToQuery, Types.GetEmailToAndCcBySoldToQueryVariables>(GetEmailToAndCcBySoldToDocument, options);
      }
export function useGetEmailToAndCcBySoldToLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetEmailToAndCcBySoldToQuery, Types.GetEmailToAndCcBySoldToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetEmailToAndCcBySoldToQuery, Types.GetEmailToAndCcBySoldToQueryVariables>(GetEmailToAndCcBySoldToDocument, options);
        }
export type GetEmailToAndCcBySoldToQueryHookResult = ReturnType<typeof useGetEmailToAndCcBySoldToQuery>;
export type GetEmailToAndCcBySoldToLazyQueryHookResult = ReturnType<typeof useGetEmailToAndCcBySoldToLazyQuery>;
export type GetEmailToAndCcBySoldToQueryResult = Apollo.QueryResult<Types.GetEmailToAndCcBySoldToQuery, Types.GetEmailToAndCcBySoldToQueryVariables>;
export const SearchSuggestionDomesticShipTosDocument = gql`
    query searchSuggestionDomesticShipTos($first: Int, $filter: PendingOrderReportShipTosFilterInput) {
  searchSuggestionDomesticShipTos(first: $first, filter: $filter) {
    edges {
      node {
        partnerCode
        displayCodeName
      }
    }
  }
}
    `;

/**
 * __useSearchSuggestionDomesticShipTosQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionDomesticShipTosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionDomesticShipTosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionDomesticShipTosQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSuggestionDomesticShipTosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SearchSuggestionDomesticShipTosQuery, Types.SearchSuggestionDomesticShipTosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchSuggestionDomesticShipTosQuery, Types.SearchSuggestionDomesticShipTosQueryVariables>(SearchSuggestionDomesticShipTosDocument, options);
      }
export function useSearchSuggestionDomesticShipTosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchSuggestionDomesticShipTosQuery, Types.SearchSuggestionDomesticShipTosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchSuggestionDomesticShipTosQuery, Types.SearchSuggestionDomesticShipTosQueryVariables>(SearchSuggestionDomesticShipTosDocument, options);
        }
export type SearchSuggestionDomesticShipTosQueryHookResult = ReturnType<typeof useSearchSuggestionDomesticShipTosQuery>;
export type SearchSuggestionDomesticShipTosLazyQueryHookResult = ReturnType<typeof useSearchSuggestionDomesticShipTosLazyQuery>;
export type SearchSuggestionDomesticShipTosQueryResult = Apollo.QueryResult<Types.SearchSuggestionDomesticShipTosQuery, Types.SearchSuggestionDomesticShipTosQueryVariables>;
export const UploadAlternativeMaterialsDocument = gql`
    mutation UploadAlternativeMaterials($file: Upload!) {
  uploadAlternativeMaterials(file: $file) {
    status
    errors {
      message
      field
    }
  }
}
    `;
export type UploadAlternativeMaterialsMutationFn = Apollo.MutationFunction<Types.UploadAlternativeMaterialsMutation, Types.UploadAlternativeMaterialsMutationVariables>;

/**
 * __useUploadAlternativeMaterialsMutation__
 *
 * To run a mutation, you first call `useUploadAlternativeMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAlternativeMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAlternativeMaterialsMutation, { data, loading, error }] = useUploadAlternativeMaterialsMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAlternativeMaterialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UploadAlternativeMaterialsMutation, Types.UploadAlternativeMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UploadAlternativeMaterialsMutation, Types.UploadAlternativeMaterialsMutationVariables>(UploadAlternativeMaterialsDocument, options);
      }
export type UploadAlternativeMaterialsMutationHookResult = ReturnType<typeof useUploadAlternativeMaterialsMutation>;
export type UploadAlternativeMaterialsMutationResult = Apollo.MutationResult<Types.UploadAlternativeMaterialsMutation>;
export type UploadAlternativeMaterialsMutationOptions = Apollo.BaseMutationOptions<Types.UploadAlternativeMaterialsMutation, Types.UploadAlternativeMaterialsMutationVariables>;
export const AddAlternativeMaterialDocument = gql`
    mutation addAlternativeMaterial($input: AlternativeMaterialAddInput!) {
  addAlternativeMaterial(input: $input) {
    alternativeMaterials {
      id
      salesOrganization {
        id
      }
      soldTo {
        id
      }
    }
    errors {
      message
      code
      field
    }
  }
}
    `;
export type AddAlternativeMaterialMutationFn = Apollo.MutationFunction<Types.AddAlternativeMaterialMutation, Types.AddAlternativeMaterialMutationVariables>;

/**
 * __useAddAlternativeMaterialMutation__
 *
 * To run a mutation, you first call `useAddAlternativeMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAlternativeMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAlternativeMaterialMutation, { data, loading, error }] = useAddAlternativeMaterialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAlternativeMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddAlternativeMaterialMutation, Types.AddAlternativeMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddAlternativeMaterialMutation, Types.AddAlternativeMaterialMutationVariables>(AddAlternativeMaterialDocument, options);
      }
export type AddAlternativeMaterialMutationHookResult = ReturnType<typeof useAddAlternativeMaterialMutation>;
export type AddAlternativeMaterialMutationResult = Apollo.MutationResult<Types.AddAlternativeMaterialMutation>;
export type AddAlternativeMaterialMutationOptions = Apollo.BaseMutationOptions<Types.AddAlternativeMaterialMutation, Types.AddAlternativeMaterialMutationVariables>;
export const DeleteAlternativeMaterialDocument = gql`
    mutation deleteAlternativeMaterial($alternativeMaterialOsId: ID!) {
  deleteAlternativeMaterialOs(alternativeMaterialOsId: $alternativeMaterialOsId) {
    errors {
      message
      code
    }
    status
  }
}
    `;
export type DeleteAlternativeMaterialMutationFn = Apollo.MutationFunction<Types.DeleteAlternativeMaterialMutation, Types.DeleteAlternativeMaterialMutationVariables>;

/**
 * __useDeleteAlternativeMaterialMutation__
 *
 * To run a mutation, you first call `useDeleteAlternativeMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlternativeMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlternativeMaterialMutation, { data, loading, error }] = useDeleteAlternativeMaterialMutation({
 *   variables: {
 *      alternativeMaterialOsId: // value for 'alternativeMaterialOsId'
 *   },
 * });
 */
export function useDeleteAlternativeMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteAlternativeMaterialMutation, Types.DeleteAlternativeMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteAlternativeMaterialMutation, Types.DeleteAlternativeMaterialMutationVariables>(DeleteAlternativeMaterialDocument, options);
      }
export type DeleteAlternativeMaterialMutationHookResult = ReturnType<typeof useDeleteAlternativeMaterialMutation>;
export type DeleteAlternativeMaterialMutationResult = Apollo.MutationResult<Types.DeleteAlternativeMaterialMutation>;
export type DeleteAlternativeMaterialMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAlternativeMaterialMutation, Types.DeleteAlternativeMaterialMutationVariables>;
export const ExportAlternativeMaterialDocument = gql`
    mutation exportAlternativeMaterial {
  exportAlternativeMaterial {
    fileName
    contentType
    exportedFileBase64
  }
}
    `;
export type ExportAlternativeMaterialMutationFn = Apollo.MutationFunction<Types.ExportAlternativeMaterialMutation, Types.ExportAlternativeMaterialMutationVariables>;

/**
 * __useExportAlternativeMaterialMutation__
 *
 * To run a mutation, you first call `useExportAlternativeMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAlternativeMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAlternativeMaterialMutation, { data, loading, error }] = useExportAlternativeMaterialMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportAlternativeMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExportAlternativeMaterialMutation, Types.ExportAlternativeMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExportAlternativeMaterialMutation, Types.ExportAlternativeMaterialMutationVariables>(ExportAlternativeMaterialDocument, options);
      }
export type ExportAlternativeMaterialMutationHookResult = ReturnType<typeof useExportAlternativeMaterialMutation>;
export type ExportAlternativeMaterialMutationResult = Apollo.MutationResult<Types.ExportAlternativeMaterialMutation>;
export type ExportAlternativeMaterialMutationOptions = Apollo.BaseMutationOptions<Types.ExportAlternativeMaterialMutation, Types.ExportAlternativeMaterialMutationVariables>;
export const ExportLogChangeDocument = gql`
    mutation exportLogChange {
  exportLogChange {
    fileName
    contentType
    exportedFileBase64
  }
}
    `;
export type ExportLogChangeMutationFn = Apollo.MutationFunction<Types.ExportLogChangeMutation, Types.ExportLogChangeMutationVariables>;

/**
 * __useExportLogChangeMutation__
 *
 * To run a mutation, you first call `useExportLogChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportLogChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportLogChangeMutation, { data, loading, error }] = useExportLogChangeMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportLogChangeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExportLogChangeMutation, Types.ExportLogChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExportLogChangeMutation, Types.ExportLogChangeMutationVariables>(ExportLogChangeDocument, options);
      }
export type ExportLogChangeMutationHookResult = ReturnType<typeof useExportLogChangeMutation>;
export type ExportLogChangeMutationResult = Apollo.MutationResult<Types.ExportLogChangeMutation>;
export type ExportLogChangeMutationOptions = Apollo.BaseMutationOptions<Types.ExportLogChangeMutation, Types.ExportLogChangeMutationVariables>;
export const EditAlternativeMaterialDocument = gql`
    mutation editAlternativeMaterial($id: ID!, $input: AlternativeMaterialEditInput!) {
  editAlternativeMaterial(id: $id, input: $input) {
    errors {
      message
      code
      field
    }
    alternativeMaterial {
      id
    }
  }
}
    `;
export type EditAlternativeMaterialMutationFn = Apollo.MutationFunction<Types.EditAlternativeMaterialMutation, Types.EditAlternativeMaterialMutationVariables>;

/**
 * __useEditAlternativeMaterialMutation__
 *
 * To run a mutation, you first call `useEditAlternativeMaterialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAlternativeMaterialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAlternativeMaterialMutation, { data, loading, error }] = useEditAlternativeMaterialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAlternativeMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditAlternativeMaterialMutation, Types.EditAlternativeMaterialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditAlternativeMaterialMutation, Types.EditAlternativeMaterialMutationVariables>(EditAlternativeMaterialDocument, options);
      }
export type EditAlternativeMaterialMutationHookResult = ReturnType<typeof useEditAlternativeMaterialMutation>;
export type EditAlternativeMaterialMutationResult = Apollo.MutationResult<Types.EditAlternativeMaterialMutation>;
export type EditAlternativeMaterialMutationOptions = Apollo.BaseMutationOptions<Types.EditAlternativeMaterialMutation, Types.EditAlternativeMaterialMutationVariables>;
export const SalesOrganizationsDocument = gql`
    query salesOrganizations {
  salesOrganizations {
    label: name
    value: id
    code
    businessUnit {
      id
      code
    }
  }
}
    `;

/**
 * __useSalesOrganizationsQuery__
 *
 * To run a query within a React component, call `useSalesOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SalesOrganizationsQuery, Types.SalesOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SalesOrganizationsQuery, Types.SalesOrganizationsQueryVariables>(SalesOrganizationsDocument, options);
      }
export function useSalesOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SalesOrganizationsQuery, Types.SalesOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SalesOrganizationsQuery, Types.SalesOrganizationsQueryVariables>(SalesOrganizationsDocument, options);
        }
export type SalesOrganizationsQueryHookResult = ReturnType<typeof useSalesOrganizationsQuery>;
export type SalesOrganizationsLazyQueryHookResult = ReturnType<typeof useSalesOrganizationsLazyQuery>;
export type SalesOrganizationsQueryResult = Apollo.QueryResult<Types.SalesOrganizationsQuery, Types.SalesOrganizationsQueryVariables>;
export const ScgSoldTosDocument = gql`
    query scgSoldTos($first: Int, $filter: ScgSoldTosFilterInput) {
  scgSoldTos(first: $first, filter: $filter) {
    edges {
      node {
        code
        name
        id
      }
    }
  }
}
    `;

/**
 * __useScgSoldTosQuery__
 *
 * To run a query within a React component, call `useScgSoldTosQuery` and pass it any options that fit your needs.
 * When your component renders, `useScgSoldTosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScgSoldTosQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScgSoldTosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ScgSoldTosQuery, Types.ScgSoldTosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ScgSoldTosQuery, Types.ScgSoldTosQueryVariables>(ScgSoldTosDocument, options);
      }
export function useScgSoldTosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ScgSoldTosQuery, Types.ScgSoldTosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ScgSoldTosQuery, Types.ScgSoldTosQueryVariables>(ScgSoldTosDocument, options);
        }
export type ScgSoldTosQueryHookResult = ReturnType<typeof useScgSoldTosQuery>;
export type ScgSoldTosLazyQueryHookResult = ReturnType<typeof useScgSoldTosLazyQuery>;
export type ScgSoldTosQueryResult = Apollo.QueryResult<Types.ScgSoldTosQuery, Types.ScgSoldTosQueryVariables>;
export const MaterialOwnDocument = gql`
    query materialOwn($first: Int, $filter: TempProductFilterInput, $distributionChannelType: DistributionChannelType!, $bu: String, $saleOrg: String) {
  materialAlter(
    first: $first
    filter: $filter
    distributionChannelType: $distributionChannelType
    bu: $bu
    saleOrg: $saleOrg
  ) {
    edges {
      node {
        id
        code
      }
    }
  }
}
    `;

/**
 * __useMaterialOwnQuery__
 *
 * To run a query within a React component, call `useMaterialOwnQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialOwnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialOwnQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      distributionChannelType: // value for 'distributionChannelType'
 *      bu: // value for 'bu'
 *      saleOrg: // value for 'saleOrg'
 *   },
 * });
 */
export function useMaterialOwnQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MaterialOwnQuery, Types.MaterialOwnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MaterialOwnQuery, Types.MaterialOwnQueryVariables>(MaterialOwnDocument, options);
      }
export function useMaterialOwnLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MaterialOwnQuery, Types.MaterialOwnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MaterialOwnQuery, Types.MaterialOwnQueryVariables>(MaterialOwnDocument, options);
        }
export type MaterialOwnQueryHookResult = ReturnType<typeof useMaterialOwnQuery>;
export type MaterialOwnLazyQueryHookResult = ReturnType<typeof useMaterialOwnLazyQuery>;
export type MaterialOwnQueryResult = Apollo.QueryResult<Types.MaterialOwnQuery, Types.MaterialOwnQueryVariables>;
export const GradeGramDocument = gql`
    query gradeGram($first: Int, $filter: TempProductFilterInput, $distributionChannelType: DistributionChannelType!, $bu: String, $saleOrg: String) {
  materialAlter(
    first: $first
    filter: $filter
    distributionChannelType: $distributionChannelType
    bu: $bu
    saleOrg: $saleOrg
  ) {
    edges {
      node {
        id
        dia
        code
      }
    }
  }
}
    `;

/**
 * __useGradeGramQuery__
 *
 * To run a query within a React component, call `useGradeGramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradeGramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradeGramQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      distributionChannelType: // value for 'distributionChannelType'
 *      bu: // value for 'bu'
 *      saleOrg: // value for 'saleOrg'
 *   },
 * });
 */
export function useGradeGramQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GradeGramQuery, Types.GradeGramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GradeGramQuery, Types.GradeGramQueryVariables>(GradeGramDocument, options);
      }
export function useGradeGramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GradeGramQuery, Types.GradeGramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GradeGramQuery, Types.GradeGramQueryVariables>(GradeGramDocument, options);
        }
export type GradeGramQueryHookResult = ReturnType<typeof useGradeGramQuery>;
export type GradeGramLazyQueryHookResult = ReturnType<typeof useGradeGramLazyQuery>;
export type GradeGramQueryResult = Apollo.QueryResult<Types.GradeGramQuery, Types.GradeGramQueryVariables>;
export const SuggestionSearchUserByNameDocument = gql`
    query suggestionSearchUserByName($filter: SuggestionSearchUserByNameFilterInput, $before: String, $after: String, $first: Int, $last: Int) {
  suggestionSearchUserByName(
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useSuggestionSearchUserByNameQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchUserByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchUserByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchUserByNameQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useSuggestionSearchUserByNameQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchUserByNameQuery, Types.SuggestionSearchUserByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchUserByNameQuery, Types.SuggestionSearchUserByNameQueryVariables>(SuggestionSearchUserByNameDocument, options);
      }
export function useSuggestionSearchUserByNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchUserByNameQuery, Types.SuggestionSearchUserByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchUserByNameQuery, Types.SuggestionSearchUserByNameQueryVariables>(SuggestionSearchUserByNameDocument, options);
        }
export type SuggestionSearchUserByNameQueryHookResult = ReturnType<typeof useSuggestionSearchUserByNameQuery>;
export type SuggestionSearchUserByNameLazyQueryHookResult = ReturnType<typeof useSuggestionSearchUserByNameLazyQuery>;
export type SuggestionSearchUserByNameQueryResult = Apollo.QueryResult<Types.SuggestionSearchUserByNameQuery, Types.SuggestionSearchUserByNameQueryVariables>;
export const AlternatedMaterialsDocument = gql`
    query alternatedMaterials($filter: AlternatedMaterialFilterInput, $before: String, $after: String, $first: Int, $last: Int, $sortBy: AlternatedMaterialSortInput) {
  alternatedMaterials(
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
    sortBy: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
      __typename
    }
    latestPageItemNumber
    totalCount
    edges {
      node {
        id
        quantityChangeOfRoll
        quantityChangeOfTon
        errorType
        oldProduct {
          name
          code
          __typename
        }
        newProduct {
          name
          code
          __typename
        }
        orderLine {
          plant
          product {
            name
            __typename
          }
          itemNo
          quantity
          requestDate
          order {
            customer {
              name
            }
            poUploadFileName
            poNumber
            orderNo
            soNo
            saleOrganization {
              name
              code
              __typename
            }
            soldTo: customer {
              id
              code
              name
            }
            requestDate
            createdAt
            createdBy {
              lastName
              firstName
              email
            }
            updatedAt
            updateBy {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAlternatedMaterialsQuery__
 *
 * To run a query within a React component, call `useAlternatedMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlternatedMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlternatedMaterialsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useAlternatedMaterialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AlternatedMaterialsQuery, Types.AlternatedMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AlternatedMaterialsQuery, Types.AlternatedMaterialsQueryVariables>(AlternatedMaterialsDocument, options);
      }
export function useAlternatedMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AlternatedMaterialsQuery, Types.AlternatedMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AlternatedMaterialsQuery, Types.AlternatedMaterialsQueryVariables>(AlternatedMaterialsDocument, options);
        }
export type AlternatedMaterialsQueryHookResult = ReturnType<typeof useAlternatedMaterialsQuery>;
export type AlternatedMaterialsLazyQueryHookResult = ReturnType<typeof useAlternatedMaterialsLazyQuery>;
export type AlternatedMaterialsQueryResult = Apollo.QueryResult<Types.AlternatedMaterialsQuery, Types.AlternatedMaterialsQueryVariables>;
export const SuggestionSearchMaterialDocument = gql`
    query suggestionSearchMaterial($distributionChannelType: DistributionChannelType!, $filter: SuggestionMaterialFilterInput, $before: String, $after: String, $first: Int, $last: Int, $bu: String) {
  suggestionSearchMaterial(
    distributionChannelType: $distributionChannelType
    first: $first
    filter: $filter
    before: $before
    after: $after
    last: $last
    bu: $bu
  ) {
    edges {
      node {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useSuggestionSearchMaterialQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchMaterialQuery({
 *   variables: {
 *      distributionChannelType: // value for 'distributionChannelType'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      bu: // value for 'bu'
 *   },
 * });
 */
export function useSuggestionSearchMaterialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchMaterialQuery, Types.SuggestionSearchMaterialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchMaterialQuery, Types.SuggestionSearchMaterialQueryVariables>(SuggestionSearchMaterialDocument, options);
      }
export function useSuggestionSearchMaterialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchMaterialQuery, Types.SuggestionSearchMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchMaterialQuery, Types.SuggestionSearchMaterialQueryVariables>(SuggestionSearchMaterialDocument, options);
        }
export type SuggestionSearchMaterialQueryHookResult = ReturnType<typeof useSuggestionSearchMaterialQuery>;
export type SuggestionSearchMaterialLazyQueryHookResult = ReturnType<typeof useSuggestionSearchMaterialLazyQuery>;
export type SuggestionSearchMaterialQueryResult = Apollo.QueryResult<Types.SuggestionSearchMaterialQuery, Types.SuggestionSearchMaterialQueryVariables>;
export const AlternativeMaterialsOsDocument = gql`
    query alternativeMaterialsOs($filter: AlterMaterialFilterInput, $sortBy: AlternativeMaterialOsInput, $before: String, $after: String, $first: Int, $last: Int) {
  alternativeMaterialsOs(
    filter: $filter
    sortBy: $sortBy
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    latestPageItemNumber
    totalCount
    lastUpdateDate
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        diameter
        alternativeMaterial {
          id
          salesOrganization {
            id
            code
            name
          }
          soldTo {
            code
            name
          }
          materialOwn {
            code
            gram
            grade
            dia
          }
          type
          updatedBy {
            firstName
            lastName
          }
          updatedAt
        }
        materialOs {
          code
          dia
        }
        priority
      }
    }
  }
}
    `;

/**
 * __useAlternativeMaterialsOsQuery__
 *
 * To run a query within a React component, call `useAlternativeMaterialsOsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlternativeMaterialsOsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlternativeMaterialsOsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useAlternativeMaterialsOsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AlternativeMaterialsOsQuery, Types.AlternativeMaterialsOsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AlternativeMaterialsOsQuery, Types.AlternativeMaterialsOsQueryVariables>(AlternativeMaterialsOsDocument, options);
      }
export function useAlternativeMaterialsOsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AlternativeMaterialsOsQuery, Types.AlternativeMaterialsOsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AlternativeMaterialsOsQuery, Types.AlternativeMaterialsOsQueryVariables>(AlternativeMaterialsOsDocument, options);
        }
export type AlternativeMaterialsOsQueryHookResult = ReturnType<typeof useAlternativeMaterialsOsQuery>;
export type AlternativeMaterialsOsLazyQueryHookResult = ReturnType<typeof useAlternativeMaterialsOsLazyQuery>;
export type AlternativeMaterialsOsQueryResult = Apollo.QueryResult<Types.AlternativeMaterialsOsQuery, Types.AlternativeMaterialsOsQueryVariables>;
export const AlternativeMaterialDetailDocument = gql`
    query alternativeMaterialDetail($id: ID!) {
  alternativeMaterial(id: $id) {
    id
    materialOwn {
      id
      code
    }
    salesOrganization {
      id
      name
      code
    }
    soldTo {
      id
      code
      name
    }
    type
    materialsOs {
      id
      diameter
      materialOs {
        id
        code
      }
      priority
    }
  }
}
    `;

/**
 * __useAlternativeMaterialDetailQuery__
 *
 * To run a query within a React component, call `useAlternativeMaterialDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlternativeMaterialDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlternativeMaterialDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAlternativeMaterialDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.AlternativeMaterialDetailQuery, Types.AlternativeMaterialDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AlternativeMaterialDetailQuery, Types.AlternativeMaterialDetailQueryVariables>(AlternativeMaterialDetailDocument, options);
      }
export function useAlternativeMaterialDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AlternativeMaterialDetailQuery, Types.AlternativeMaterialDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AlternativeMaterialDetailQuery, Types.AlternativeMaterialDetailQueryVariables>(AlternativeMaterialDetailDocument, options);
        }
export type AlternativeMaterialDetailQueryHookResult = ReturnType<typeof useAlternativeMaterialDetailQuery>;
export type AlternativeMaterialDetailLazyQueryHookResult = ReturnType<typeof useAlternativeMaterialDetailLazyQuery>;
export type AlternativeMaterialDetailQueryResult = Apollo.QueryResult<Types.AlternativeMaterialDetailQuery, Types.AlternativeMaterialDetailQueryVariables>;
export const DownloadPdfOrderDocument = gql`
    mutation downloadPdfOrder($orderId: ID, $soNo: String, $sortType: String!) {
  downloadPdfOrder(orderId: $orderId, soNo: $soNo, sortType: $sortType) {
    exportedFileBase64
    fileName
    errors {
      field
      message
      code
    }
  }
}
    `;
export type DownloadPdfOrderMutationFn = Apollo.MutationFunction<Types.DownloadPdfOrderMutation, Types.DownloadPdfOrderMutationVariables>;

/**
 * __useDownloadPdfOrderMutation__
 *
 * To run a mutation, you first call `useDownloadPdfOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPdfOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPdfOrderMutation, { data, loading, error }] = useDownloadPdfOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      soNo: // value for 'soNo'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function useDownloadPdfOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DownloadPdfOrderMutation, Types.DownloadPdfOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DownloadPdfOrderMutation, Types.DownloadPdfOrderMutationVariables>(DownloadPdfOrderDocument, options);
      }
export type DownloadPdfOrderMutationHookResult = ReturnType<typeof useDownloadPdfOrderMutation>;
export type DownloadPdfOrderMutationResult = Apollo.MutationResult<Types.DownloadPdfOrderMutation>;
export type DownloadPdfOrderMutationOptions = Apollo.BaseMutationOptions<Types.DownloadPdfOrderMutation, Types.DownloadPdfOrderMutationVariables>;
export const PrintChangeOrderDocument = gql`
    mutation printChangeOrder($orderId: ID!, $sortType: String!) {
  printChangeOrder(orderId: $orderId, sortType: $sortType) {
    exportedFileBase64
    fileName
    errors {
      field
      message
      code
    }
  }
}
    `;
export type PrintChangeOrderMutationFn = Apollo.MutationFunction<Types.PrintChangeOrderMutation, Types.PrintChangeOrderMutationVariables>;

/**
 * __usePrintChangeOrderMutation__
 *
 * To run a mutation, you first call `usePrintChangeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintChangeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printChangeOrderMutation, { data, loading, error }] = usePrintChangeOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      sortType: // value for 'sortType'
 *   },
 * });
 */
export function usePrintChangeOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PrintChangeOrderMutation, Types.PrintChangeOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PrintChangeOrderMutation, Types.PrintChangeOrderMutationVariables>(PrintChangeOrderDocument, options);
      }
export type PrintChangeOrderMutationHookResult = ReturnType<typeof usePrintChangeOrderMutation>;
export type PrintChangeOrderMutationResult = Apollo.MutationResult<Types.PrintChangeOrderMutation>;
export type PrintChangeOrderMutationOptions = Apollo.BaseMutationOptions<Types.PrintChangeOrderMutation, Types.PrintChangeOrderMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($email: String!, $redirectUrl: String!) {
  requestPasswordReset(email: $email, redirectUrl: $redirectUrl) {
    errors {
      ...AccountError
    }
  }
}
    ${AccountErrorFragmentDoc}`;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectUrl: // value for 'redirectUrl'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<Types.RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<Types.RequestPasswordResetMutation, Types.RequestPasswordResetMutationVariables>;
export const GenerateTokenDocument = gql`
    mutation generateToken($idToken: String!) {
  generateToken(idToken: $idToken) {
    token
    csrfToken
    refreshToken
    user {
      id
      email
      lastName
    }
    errors {
      message
      field
      code
    }
  }
}
    `;
export type GenerateTokenMutationFn = Apollo.MutationFunction<Types.GenerateTokenMutation, Types.GenerateTokenMutationVariables>;

/**
 * __useGenerateTokenMutation__
 *
 * To run a mutation, you first call `useGenerateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTokenMutation, { data, loading, error }] = useGenerateTokenMutation({
 *   variables: {
 *      idToken: // value for 'idToken'
 *   },
 * });
 */
export function useGenerateTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.GenerateTokenMutation, Types.GenerateTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.GenerateTokenMutation, Types.GenerateTokenMutationVariables>(GenerateTokenDocument, options);
      }
export type GenerateTokenMutationHookResult = ReturnType<typeof useGenerateTokenMutation>;
export type GenerateTokenMutationResult = Apollo.MutationResult<Types.GenerateTokenMutation>;
export type GenerateTokenMutationOptions = Apollo.BaseMutationOptions<Types.GenerateTokenMutation, Types.GenerateTokenMutationVariables>;
export const ScgpUserSendMailResetPasswordDocument = gql`
    mutation scgpUserSendMailResetPassword($email: String!) {
  scgpUserSendMailResetPassword(email: $email) {
    message
    errors {
      field
      message
      code
    }
  }
}
    `;
export type ScgpUserSendMailResetPasswordMutationFn = Apollo.MutationFunction<Types.ScgpUserSendMailResetPasswordMutation, Types.ScgpUserSendMailResetPasswordMutationVariables>;

/**
 * __useScgpUserSendMailResetPasswordMutation__
 *
 * To run a mutation, you first call `useScgpUserSendMailResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpUserSendMailResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpUserSendMailResetPasswordMutation, { data, loading, error }] = useScgpUserSendMailResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useScgpUserSendMailResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpUserSendMailResetPasswordMutation, Types.ScgpUserSendMailResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpUserSendMailResetPasswordMutation, Types.ScgpUserSendMailResetPasswordMutationVariables>(ScgpUserSendMailResetPasswordDocument, options);
      }
export type ScgpUserSendMailResetPasswordMutationHookResult = ReturnType<typeof useScgpUserSendMailResetPasswordMutation>;
export type ScgpUserSendMailResetPasswordMutationResult = Apollo.MutationResult<Types.ScgpUserSendMailResetPasswordMutation>;
export type ScgpUserSendMailResetPasswordMutationOptions = Apollo.BaseMutationOptions<Types.ScgpUserSendMailResetPasswordMutation, Types.ScgpUserSendMailResetPasswordMutationVariables>;
export const ScgpUserCheckValidTokenResetPasswordDocument = gql`
    mutation scgpUserCheckValidTokenResetPassword($email: String!, $token: String!) {
  scgpUserCheckValidTokenResetPassword(email: $email, token: $token) {
    email
    token
    errors {
      field
      message
      code
    }
  }
}
    `;
export type ScgpUserCheckValidTokenResetPasswordMutationFn = Apollo.MutationFunction<Types.ScgpUserCheckValidTokenResetPasswordMutation, Types.ScgpUserCheckValidTokenResetPasswordMutationVariables>;

/**
 * __useScgpUserCheckValidTokenResetPasswordMutation__
 *
 * To run a mutation, you first call `useScgpUserCheckValidTokenResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpUserCheckValidTokenResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpUserCheckValidTokenResetPasswordMutation, { data, loading, error }] = useScgpUserCheckValidTokenResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useScgpUserCheckValidTokenResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpUserCheckValidTokenResetPasswordMutation, Types.ScgpUserCheckValidTokenResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpUserCheckValidTokenResetPasswordMutation, Types.ScgpUserCheckValidTokenResetPasswordMutationVariables>(ScgpUserCheckValidTokenResetPasswordDocument, options);
      }
export type ScgpUserCheckValidTokenResetPasswordMutationHookResult = ReturnType<typeof useScgpUserCheckValidTokenResetPasswordMutation>;
export type ScgpUserCheckValidTokenResetPasswordMutationResult = Apollo.MutationResult<Types.ScgpUserCheckValidTokenResetPasswordMutation>;
export type ScgpUserCheckValidTokenResetPasswordMutationOptions = Apollo.BaseMutationOptions<Types.ScgpUserCheckValidTokenResetPasswordMutation, Types.ScgpUserCheckValidTokenResetPasswordMutationVariables>;
export const ScgpUserConfirmResetPasswordDocument = gql`
    mutation scgpUserConfirmResetPassword($email: String!, $token: String!, $new_password: String!, $confirm_password: String!) {
  scgpUserConfirmResetPassword(
    email: $email
    token: $token
    newPassword: $new_password
    confirmPassword: $confirm_password
  ) {
    message
    errors {
      field
      message
      code
    }
  }
}
    `;
export type ScgpUserConfirmResetPasswordMutationFn = Apollo.MutationFunction<Types.ScgpUserConfirmResetPasswordMutation, Types.ScgpUserConfirmResetPasswordMutationVariables>;

/**
 * __useScgpUserConfirmResetPasswordMutation__
 *
 * To run a mutation, you first call `useScgpUserConfirmResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpUserConfirmResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpUserConfirmResetPasswordMutation, { data, loading, error }] = useScgpUserConfirmResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      new_password: // value for 'new_password'
 *      confirm_password: // value for 'confirm_password'
 *   },
 * });
 */
export function useScgpUserConfirmResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpUserConfirmResetPasswordMutation, Types.ScgpUserConfirmResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpUserConfirmResetPasswordMutation, Types.ScgpUserConfirmResetPasswordMutationVariables>(ScgpUserConfirmResetPasswordDocument, options);
      }
export type ScgpUserConfirmResetPasswordMutationHookResult = ReturnType<typeof useScgpUserConfirmResetPasswordMutation>;
export type ScgpUserConfirmResetPasswordMutationResult = Apollo.MutationResult<Types.ScgpUserConfirmResetPasswordMutation>;
export type ScgpUserConfirmResetPasswordMutationOptions = Apollo.BaseMutationOptions<Types.ScgpUserConfirmResetPasswordMutation, Types.ScgpUserConfirmResetPasswordMutationVariables>;
export const ScgpUserLoginDocument = gql`
    mutation scgpUserLogin($email: String!, $password: String!, $cfTurnstileToken: String) {
  scgpUserLogin(
    email: $email
    password: $password
    cfTurnstileToken: $cfTurnstileToken
  ) {
    message
    status
    tempToken
    username
    token
    csrfToken
    refreshToken
    errors {
      field
      code
      message
    }
  }
}
    `;
export type ScgpUserLoginMutationFn = Apollo.MutationFunction<Types.ScgpUserLoginMutation, Types.ScgpUserLoginMutationVariables>;

/**
 * __useScgpUserLoginMutation__
 *
 * To run a mutation, you first call `useScgpUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpUserLoginMutation, { data, loading, error }] = useScgpUserLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      cfTurnstileToken: // value for 'cfTurnstileToken'
 *   },
 * });
 */
export function useScgpUserLoginMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpUserLoginMutation, Types.ScgpUserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpUserLoginMutation, Types.ScgpUserLoginMutationVariables>(ScgpUserLoginDocument, options);
      }
export type ScgpUserLoginMutationHookResult = ReturnType<typeof useScgpUserLoginMutation>;
export type ScgpUserLoginMutationResult = Apollo.MutationResult<Types.ScgpUserLoginMutation>;
export type ScgpUserLoginMutationOptions = Apollo.BaseMutationOptions<Types.ScgpUserLoginMutation, Types.ScgpUserLoginMutationVariables>;
export const ScgpUserFirstLoginUpdateDocument = gql`
    mutation scgpUserFirstLoginUpdate($username: String!, $tempToken: String!, $email: String, $password: String, $confirmPassword: String) {
  scgpUserFirstLoginUpdate(
    username: $username
    tempToken: $tempToken
    email: $email
    password: $password
    confirmPassword: $confirmPassword
  ) {
    message
    status
    tempToken
    username
    token
    csrfToken
    refreshToken
    errors {
      code
      message
      field
    }
  }
}
    `;
export type ScgpUserFirstLoginUpdateMutationFn = Apollo.MutationFunction<Types.ScgpUserFirstLoginUpdateMutation, Types.ScgpUserFirstLoginUpdateMutationVariables>;

/**
 * __useScgpUserFirstLoginUpdateMutation__
 *
 * To run a mutation, you first call `useScgpUserFirstLoginUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpUserFirstLoginUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpUserFirstLoginUpdateMutation, { data, loading, error }] = useScgpUserFirstLoginUpdateMutation({
 *   variables: {
 *      username: // value for 'username'
 *      tempToken: // value for 'tempToken'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useScgpUserFirstLoginUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpUserFirstLoginUpdateMutation, Types.ScgpUserFirstLoginUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpUserFirstLoginUpdateMutation, Types.ScgpUserFirstLoginUpdateMutationVariables>(ScgpUserFirstLoginUpdateDocument, options);
      }
export type ScgpUserFirstLoginUpdateMutationHookResult = ReturnType<typeof useScgpUserFirstLoginUpdateMutation>;
export type ScgpUserFirstLoginUpdateMutationResult = Apollo.MutationResult<Types.ScgpUserFirstLoginUpdateMutation>;
export type ScgpUserFirstLoginUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ScgpUserFirstLoginUpdateMutation, Types.ScgpUserFirstLoginUpdateMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($csrfToken: String, $refreshToken: String) {
  tokenRefresh(csrfToken: $csrfToken, refreshToken: $refreshToken) {
    token
    errors {
      field
      code
      message
    }
    user {
      id
      email
      lastName
      isStaff
    }
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      csrfToken: // value for 'csrfToken'
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<Types.RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<Types.RefreshTokenMutation, Types.RefreshTokenMutationVariables>;
export const AvailableExternalAuthenticationsDocument = gql`
    query AvailableExternalAuthentications {
  shop {
    availableExternalAuthentications {
      id
      name
    }
  }
}
    `;

/**
 * __useAvailableExternalAuthenticationsQuery__
 *
 * To run a query within a React component, call `useAvailableExternalAuthenticationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableExternalAuthenticationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableExternalAuthenticationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableExternalAuthenticationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.AvailableExternalAuthenticationsQuery, Types.AvailableExternalAuthenticationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.AvailableExternalAuthenticationsQuery, Types.AvailableExternalAuthenticationsQueryVariables>(AvailableExternalAuthenticationsDocument, options);
      }
export function useAvailableExternalAuthenticationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.AvailableExternalAuthenticationsQuery, Types.AvailableExternalAuthenticationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.AvailableExternalAuthenticationsQuery, Types.AvailableExternalAuthenticationsQueryVariables>(AvailableExternalAuthenticationsDocument, options);
        }
export type AvailableExternalAuthenticationsQueryHookResult = ReturnType<typeof useAvailableExternalAuthenticationsQuery>;
export type AvailableExternalAuthenticationsLazyQueryHookResult = ReturnType<typeof useAvailableExternalAuthenticationsLazyQuery>;
export type AvailableExternalAuthenticationsQueryResult = Apollo.QueryResult<Types.AvailableExternalAuthenticationsQuery, Types.AvailableExternalAuthenticationsQueryVariables>;
export const UserDetailsDocument = gql`
    query UserDetails {
  me {
    ...User
    permissionGroups {
      name
      id
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UserDetailsQuery, Types.UserDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UserDetailsQuery, Types.UserDetailsQueryVariables>(UserDetailsDocument, options);
      }
export function useUserDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UserDetailsQuery, Types.UserDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UserDetailsQuery, Types.UserDetailsQueryVariables>(UserDetailsDocument, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQueryHookResult = ReturnType<typeof useUserDetailsLazyQuery>;
export type UserDetailsQueryResult = Apollo.QueryResult<Types.UserDetailsQuery, Types.UserDetailsQueryVariables>;
export const UserCompanyDocument = gql`
    query UserCompany {
  scgpMe {
    soldTos {
      id
      soldToCode
      soldToName
      showPoUpload
    }
  }
}
    `;

/**
 * __useUserCompanyQuery__
 *
 * To run a query within a React component, call `useUserCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.UserCompanyQuery, Types.UserCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.UserCompanyQuery, Types.UserCompanyQueryVariables>(UserCompanyDocument, options);
      }
export function useUserCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.UserCompanyQuery, Types.UserCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.UserCompanyQuery, Types.UserCompanyQueryVariables>(UserCompanyDocument, options);
        }
export type UserCompanyQueryHookResult = ReturnType<typeof useUserCompanyQuery>;
export type UserCompanyLazyQueryHookResult = ReturnType<typeof useUserCompanyLazyQuery>;
export type UserCompanyQueryResult = Apollo.QueryResult<Types.UserCompanyQuery, Types.UserCompanyQueryVariables>;
export const DuplicateOrderDocument = gql`
    mutation DuplicateOrder($id: ID!) {
  duplicateOrder(id: $id) {
    errors {
      field
      message
      code
    }
    order {
      id
      lines(first: 10) {
        edges {
          node {
            id
            quantity
          }
        }
      }
    }
  }
}
    `;
export type DuplicateOrderMutationFn = Apollo.MutationFunction<Types.DuplicateOrderMutation, Types.DuplicateOrderMutationVariables>;

/**
 * __useDuplicateOrderMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderMutation, { data, loading, error }] = useDuplicateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DuplicateOrderMutation, Types.DuplicateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DuplicateOrderMutation, Types.DuplicateOrderMutationVariables>(DuplicateOrderDocument, options);
      }
export type DuplicateOrderMutationHookResult = ReturnType<typeof useDuplicateOrderMutation>;
export type DuplicateOrderMutationResult = Apollo.MutationResult<Types.DuplicateOrderMutation>;
export type DuplicateOrderMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateOrderMutation, Types.DuplicateOrderMutationVariables>;
export const CallApiSapRouteDocument = gql`
    mutation callApiSapRoute($maxRecords: Int!, $piMessageId: String!, $route: String!, $routeDescription: String!) {
  callApiSapRoute(
    maxRecords: $maxRecords
    piMessageId: $piMessageId
    route: $route
    routeDescription: $routeDescription
  ) {
    response {
      piMessageId
      status
      reason
      routeList {
        route
        routeDescription
      }
    }
  }
}
    `;
export type CallApiSapRouteMutationFn = Apollo.MutationFunction<Types.CallApiSapRouteMutation, Types.CallApiSapRouteMutationVariables>;

/**
 * __useCallApiSapRouteMutation__
 *
 * To run a mutation, you first call `useCallApiSapRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallApiSapRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callApiSapRouteMutation, { data, loading, error }] = useCallApiSapRouteMutation({
 *   variables: {
 *      maxRecords: // value for 'maxRecords'
 *      piMessageId: // value for 'piMessageId'
 *      route: // value for 'route'
 *      routeDescription: // value for 'routeDescription'
 *   },
 * });
 */
export function useCallApiSapRouteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CallApiSapRouteMutation, Types.CallApiSapRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CallApiSapRouteMutation, Types.CallApiSapRouteMutationVariables>(CallApiSapRouteDocument, options);
      }
export type CallApiSapRouteMutationHookResult = ReturnType<typeof useCallApiSapRouteMutation>;
export type CallApiSapRouteMutationResult = Apollo.MutationResult<Types.CallApiSapRouteMutation>;
export type CallApiSapRouteMutationOptions = Apollo.BaseMutationOptions<Types.CallApiSapRouteMutation, Types.CallApiSapRouteMutationVariables>;
export const CancelOrderDocument = gql`
    mutation cancelOrder($id: ID!) {
  cancelExportOrder(id: $id) {
    errors {
      field
      message
      code
    }
    order {
      status
      id
    }
  }
}
    `;
export type CancelOrderMutationFn = Apollo.MutationFunction<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>(CancelOrderDocument, options);
      }
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<Types.CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<Types.CancelOrderMutation, Types.CancelOrderMutationVariables>;
export const CancelRevertContractOrderLineDocument = gql`
    mutation cancelRevertContractOrderLine($id: [ID], $status: OrderLineStatus) {
  cancelRevertContractOrderLine(id: $id, status: $status) {
    orderline {
      id
    }
  }
}
    `;
export type CancelRevertContractOrderLineMutationFn = Apollo.MutationFunction<Types.CancelRevertContractOrderLineMutation, Types.CancelRevertContractOrderLineMutationVariables>;

/**
 * __useCancelRevertContractOrderLineMutation__
 *
 * To run a mutation, you first call `useCancelRevertContractOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRevertContractOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRevertContractOrderLineMutation, { data, loading, error }] = useCancelRevertContractOrderLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCancelRevertContractOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelRevertContractOrderLineMutation, Types.CancelRevertContractOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelRevertContractOrderLineMutation, Types.CancelRevertContractOrderLineMutationVariables>(CancelRevertContractOrderLineDocument, options);
      }
export type CancelRevertContractOrderLineMutationHookResult = ReturnType<typeof useCancelRevertContractOrderLineMutation>;
export type CancelRevertContractOrderLineMutationResult = Apollo.MutationResult<Types.CancelRevertContractOrderLineMutation>;
export type CancelRevertContractOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.CancelRevertContractOrderLineMutation, Types.CancelRevertContractOrderLineMutationVariables>;
export const DeleteContractOrderLinesDocument = gql`
    mutation deleteContractOrderLines($ids: [ID!]!) {
  deleteContractOrderLines(ids: $ids) {
    errors {
      field
      message
      code
    }
  }
}
    `;
export type DeleteContractOrderLinesMutationFn = Apollo.MutationFunction<Types.DeleteContractOrderLinesMutation, Types.DeleteContractOrderLinesMutationVariables>;

/**
 * __useDeleteContractOrderLinesMutation__
 *
 * To run a mutation, you first call `useDeleteContractOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractOrderLinesMutation, { data, loading, error }] = useDeleteContractOrderLinesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContractOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteContractOrderLinesMutation, Types.DeleteContractOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteContractOrderLinesMutation, Types.DeleteContractOrderLinesMutationVariables>(DeleteContractOrderLinesDocument, options);
      }
export type DeleteContractOrderLinesMutationHookResult = ReturnType<typeof useDeleteContractOrderLinesMutation>;
export type DeleteContractOrderLinesMutationResult = Apollo.MutationResult<Types.DeleteContractOrderLinesMutation>;
export type DeleteContractOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteContractOrderLinesMutation, Types.DeleteContractOrderLinesMutationVariables>;
export const AddSplitOrderLineItemDocument = gql`
    mutation addSplitOrderLineItem($originLineItem: AddSplitOrderLineItemInput, $soNo: String, $splitLineItems: [AddSplitOrderLineItemInput!]) {
  addSplitOrderLineItem(
    soNo: $soNo
    originLineItem: $originLineItem
    splitLineItems: $splitLineItems
  ) {
    status
    errors {
      code
      field
      message
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
  }
}
    `;
export type AddSplitOrderLineItemMutationFn = Apollo.MutationFunction<Types.AddSplitOrderLineItemMutation, Types.AddSplitOrderLineItemMutationVariables>;

/**
 * __useAddSplitOrderLineItemMutation__
 *
 * To run a mutation, you first call `useAddSplitOrderLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSplitOrderLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSplitOrderLineItemMutation, { data, loading, error }] = useAddSplitOrderLineItemMutation({
 *   variables: {
 *      originLineItem: // value for 'originLineItem'
 *      soNo: // value for 'soNo'
 *      splitLineItems: // value for 'splitLineItems'
 *   },
 * });
 */
export function useAddSplitOrderLineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddSplitOrderLineItemMutation, Types.AddSplitOrderLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddSplitOrderLineItemMutation, Types.AddSplitOrderLineItemMutationVariables>(AddSplitOrderLineItemDocument, options);
      }
export type AddSplitOrderLineItemMutationHookResult = ReturnType<typeof useAddSplitOrderLineItemMutation>;
export type AddSplitOrderLineItemMutationResult = Apollo.MutationResult<Types.AddSplitOrderLineItemMutation>;
export type AddSplitOrderLineItemMutationOptions = Apollo.BaseMutationOptions<Types.AddSplitOrderLineItemMutation, Types.AddSplitOrderLineItemMutationVariables>;
export const UpdateAtpCtpContractOrderLineDocument = gql`
    mutation updateAtpCtpContractOrderLine($input: [UpdateAtpCtpContractOrderLineInput]) {
  updateAtpCtpContractOrderLine(input: $input) {
    status
  }
}
    `;
export type UpdateAtpCtpContractOrderLineMutationFn = Apollo.MutationFunction<Types.UpdateAtpCtpContractOrderLineMutation, Types.UpdateAtpCtpContractOrderLineMutationVariables>;

/**
 * __useUpdateAtpCtpContractOrderLineMutation__
 *
 * To run a mutation, you first call `useUpdateAtpCtpContractOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAtpCtpContractOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAtpCtpContractOrderLineMutation, { data, loading, error }] = useUpdateAtpCtpContractOrderLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAtpCtpContractOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateAtpCtpContractOrderLineMutation, Types.UpdateAtpCtpContractOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateAtpCtpContractOrderLineMutation, Types.UpdateAtpCtpContractOrderLineMutationVariables>(UpdateAtpCtpContractOrderLineDocument, options);
      }
export type UpdateAtpCtpContractOrderLineMutationHookResult = ReturnType<typeof useUpdateAtpCtpContractOrderLineMutation>;
export type UpdateAtpCtpContractOrderLineMutationResult = Apollo.MutationResult<Types.UpdateAtpCtpContractOrderLineMutation>;
export type UpdateAtpCtpContractOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAtpCtpContractOrderLineMutation, Types.UpdateAtpCtpContractOrderLineMutationVariables>;
export const SendOrderEmailDocument = gql`
    mutation sendOrderEmail($cc: String!, $content: String!, $orders: [SendEmailOrderInput], $subject: String!, $to: String!, $reportLanguage: String) {
  sendOrderEmail(
    to: $to
    cc: $cc
    subject: $subject
    content: $content
    listOrderConfirmationSap: $orders
    reportLanguage: $reportLanguage
  ) {
    status
    errors {
      message
      code
      field
    }
  }
}
    `;
export type SendOrderEmailMutationFn = Apollo.MutationFunction<Types.SendOrderEmailMutation, Types.SendOrderEmailMutationVariables>;

/**
 * __useSendOrderEmailMutation__
 *
 * To run a mutation, you first call `useSendOrderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrderEmailMutation, { data, loading, error }] = useSendOrderEmailMutation({
 *   variables: {
 *      cc: // value for 'cc'
 *      content: // value for 'content'
 *      orders: // value for 'orders'
 *      subject: // value for 'subject'
 *      to: // value for 'to'
 *      reportLanguage: // value for 'reportLanguage'
 *   },
 * });
 */
export function useSendOrderEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SendOrderEmailMutation, Types.SendOrderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SendOrderEmailMutation, Types.SendOrderEmailMutationVariables>(SendOrderEmailDocument, options);
      }
export type SendOrderEmailMutationHookResult = ReturnType<typeof useSendOrderEmailMutation>;
export type SendOrderEmailMutationResult = Apollo.MutationResult<Types.SendOrderEmailMutation>;
export type SendOrderEmailMutationOptions = Apollo.BaseMutationOptions<Types.SendOrderEmailMutation, Types.SendOrderEmailMutationVariables>;
export const CancelDeleteOrderLinesDocument = gql`
    mutation cancelDeleteOrderLines($orderLines: [CancelDeleteOrderLinesInput], $soNo: String!) {
  cancelDeleteOrderLines(soNo: $soNo, orderLines: $orderLines) {
    status
    errors {
      message
      code
      field
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
  }
}
    `;
export type CancelDeleteOrderLinesMutationFn = Apollo.MutationFunction<Types.CancelDeleteOrderLinesMutation, Types.CancelDeleteOrderLinesMutationVariables>;

/**
 * __useCancelDeleteOrderLinesMutation__
 *
 * To run a mutation, you first call `useCancelDeleteOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeleteOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeleteOrderLinesMutation, { data, loading, error }] = useCancelDeleteOrderLinesMutation({
 *   variables: {
 *      orderLines: // value for 'orderLines'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useCancelDeleteOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelDeleteOrderLinesMutation, Types.CancelDeleteOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelDeleteOrderLinesMutation, Types.CancelDeleteOrderLinesMutationVariables>(CancelDeleteOrderLinesDocument, options);
      }
export type CancelDeleteOrderLinesMutationHookResult = ReturnType<typeof useCancelDeleteOrderLinesMutation>;
export type CancelDeleteOrderLinesMutationResult = Apollo.MutationResult<Types.CancelDeleteOrderLinesMutation>;
export type CancelDeleteOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.CancelDeleteOrderLinesMutation, Types.CancelDeleteOrderLinesMutationVariables>;
export const ChangeOrderAddNewOrderLineDocument = gql`
    mutation changeOrderAddNewOrderLine($input: ChangeOrderAddNewOrderLineInput!) {
  changeOrderAddNewOrderLine(input: $input) {
    success
    isRedirectPreview
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    iplanConfirmFailedErrors {
      field
      message
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      code
      field
      message
    }
  }
}
    `;
export type ChangeOrderAddNewOrderLineMutationFn = Apollo.MutationFunction<Types.ChangeOrderAddNewOrderLineMutation, Types.ChangeOrderAddNewOrderLineMutationVariables>;

/**
 * __useChangeOrderAddNewOrderLineMutation__
 *
 * To run a mutation, you first call `useChangeOrderAddNewOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderAddNewOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderAddNewOrderLineMutation, { data, loading, error }] = useChangeOrderAddNewOrderLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeOrderAddNewOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ChangeOrderAddNewOrderLineMutation, Types.ChangeOrderAddNewOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ChangeOrderAddNewOrderLineMutation, Types.ChangeOrderAddNewOrderLineMutationVariables>(ChangeOrderAddNewOrderLineDocument, options);
      }
export type ChangeOrderAddNewOrderLineMutationHookResult = ReturnType<typeof useChangeOrderAddNewOrderLineMutation>;
export type ChangeOrderAddNewOrderLineMutationResult = Apollo.MutationResult<Types.ChangeOrderAddNewOrderLineMutation>;
export type ChangeOrderAddNewOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.ChangeOrderAddNewOrderLineMutation, Types.ChangeOrderAddNewOrderLineMutationVariables>;
export const ChangeOrderUpdateDocument = gql`
    mutation changeOrderUpdate($input: ChangeOrderEditInput!, $soNo: ID!) {
  changeOrderUpdate(input: $input, soNo: $soNo) {
    success
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    errors {
      field
      message
      code
    }
    order {
      id
    }
    sapWarningMessages {
      order
      source
      message
    }
    iplanConfirmFailedErrors {
      field
      message
    }
  }
}
    `;
export type ChangeOrderUpdateMutationFn = Apollo.MutationFunction<Types.ChangeOrderUpdateMutation, Types.ChangeOrderUpdateMutationVariables>;

/**
 * __useChangeOrderUpdateMutation__
 *
 * To run a mutation, you first call `useChangeOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrderUpdateMutation, { data, loading, error }] = useChangeOrderUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useChangeOrderUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ChangeOrderUpdateMutation, Types.ChangeOrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ChangeOrderUpdateMutation, Types.ChangeOrderUpdateMutationVariables>(ChangeOrderUpdateDocument, options);
      }
export type ChangeOrderUpdateMutationHookResult = ReturnType<typeof useChangeOrderUpdateMutation>;
export type ChangeOrderUpdateMutationResult = Apollo.MutationResult<Types.ChangeOrderUpdateMutation>;
export type ChangeOrderUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ChangeOrderUpdateMutation, Types.ChangeOrderUpdateMutationVariables>;
export const UndoOrderLinesDocument = gql`
    mutation undoOrderLines($itemNo: [String]!, $soNo: String!) {
  undoOrderLines(itemNo: $itemNo, soNo: $soNo) {
    success
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
  }
}
    `;
export type UndoOrderLinesMutationFn = Apollo.MutationFunction<Types.UndoOrderLinesMutation, Types.UndoOrderLinesMutationVariables>;

/**
 * __useUndoOrderLinesMutation__
 *
 * To run a mutation, you first call `useUndoOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoOrderLinesMutation, { data, loading, error }] = useUndoOrderLinesMutation({
 *   variables: {
 *      itemNo: // value for 'itemNo'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useUndoOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UndoOrderLinesMutation, Types.UndoOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UndoOrderLinesMutation, Types.UndoOrderLinesMutationVariables>(UndoOrderLinesDocument, options);
      }
export type UndoOrderLinesMutationHookResult = ReturnType<typeof useUndoOrderLinesMutation>;
export type UndoOrderLinesMutationResult = Apollo.MutationResult<Types.UndoOrderLinesMutation>;
export type UndoOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.UndoOrderLinesMutation, Types.UndoOrderLinesMutationVariables>;
export const DeleteNewlyAddedOrderLineDocument = gql`
    mutation deleteNewlyAddedOrderLine($soNo: String, $listItemNo: [String]) {
  deleteNewlyAddedOrderLine(soNo: $soNo, listItemNo: $listItemNo) {
    status
  }
}
    `;
export type DeleteNewlyAddedOrderLineMutationFn = Apollo.MutationFunction<Types.DeleteNewlyAddedOrderLineMutation, Types.DeleteNewlyAddedOrderLineMutationVariables>;

/**
 * __useDeleteNewlyAddedOrderLineMutation__
 *
 * To run a mutation, you first call `useDeleteNewlyAddedOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewlyAddedOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNewlyAddedOrderLineMutation, { data, loading, error }] = useDeleteNewlyAddedOrderLineMutation({
 *   variables: {
 *      soNo: // value for 'soNo'
 *      listItemNo: // value for 'listItemNo'
 *   },
 * });
 */
export function useDeleteNewlyAddedOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteNewlyAddedOrderLineMutation, Types.DeleteNewlyAddedOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteNewlyAddedOrderLineMutation, Types.DeleteNewlyAddedOrderLineMutationVariables>(DeleteNewlyAddedOrderLineDocument, options);
      }
export type DeleteNewlyAddedOrderLineMutationHookResult = ReturnType<typeof useDeleteNewlyAddedOrderLineMutation>;
export type DeleteNewlyAddedOrderLineMutationResult = Apollo.MutationResult<Types.DeleteNewlyAddedOrderLineMutation>;
export type DeleteNewlyAddedOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.DeleteNewlyAddedOrderLineMutation, Types.DeleteNewlyAddedOrderLineMutationVariables>;
export const CheckContractExpiredCompleteInvalidDocument = gql`
    mutation checkContractExpiredCompleteInvalid($contractNo: String!) {
  checkContractExpiredCompleteInvalid(contractNo: $contractNo) {
    isInvalid
  }
}
    `;
export type CheckContractExpiredCompleteInvalidMutationFn = Apollo.MutationFunction<Types.CheckContractExpiredCompleteInvalidMutation, Types.CheckContractExpiredCompleteInvalidMutationVariables>;

/**
 * __useCheckContractExpiredCompleteInvalidMutation__
 *
 * To run a mutation, you first call `useCheckContractExpiredCompleteInvalidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckContractExpiredCompleteInvalidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkContractExpiredCompleteInvalidMutation, { data, loading, error }] = useCheckContractExpiredCompleteInvalidMutation({
 *   variables: {
 *      contractNo: // value for 'contractNo'
 *   },
 * });
 */
export function useCheckContractExpiredCompleteInvalidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CheckContractExpiredCompleteInvalidMutation, Types.CheckContractExpiredCompleteInvalidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CheckContractExpiredCompleteInvalidMutation, Types.CheckContractExpiredCompleteInvalidMutationVariables>(CheckContractExpiredCompleteInvalidDocument, options);
      }
export type CheckContractExpiredCompleteInvalidMutationHookResult = ReturnType<typeof useCheckContractExpiredCompleteInvalidMutation>;
export type CheckContractExpiredCompleteInvalidMutationResult = Apollo.MutationResult<Types.CheckContractExpiredCompleteInvalidMutation>;
export type CheckContractExpiredCompleteInvalidMutationOptions = Apollo.BaseMutationOptions<Types.CheckContractExpiredCompleteInvalidMutation, Types.CheckContractExpiredCompleteInvalidMutationVariables>;
export const ShowAtpCtpPopupDocument = gql`
    query showAtpCtpPopup($lineIds: [ID]) {
  showAtpCtpPopup(lineIds: $lineIds) {
    status
    itemErrors
    flag
    __typename
  }
}
    `;

/**
 * __useShowAtpCtpPopupQuery__
 *
 * To run a query within a React component, call `useShowAtpCtpPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowAtpCtpPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowAtpCtpPopupQuery({
 *   variables: {
 *      lineIds: // value for 'lineIds'
 *   },
 * });
 */
export function useShowAtpCtpPopupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ShowAtpCtpPopupQuery, Types.ShowAtpCtpPopupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ShowAtpCtpPopupQuery, Types.ShowAtpCtpPopupQueryVariables>(ShowAtpCtpPopupDocument, options);
      }
export function useShowAtpCtpPopupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ShowAtpCtpPopupQuery, Types.ShowAtpCtpPopupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ShowAtpCtpPopupQuery, Types.ShowAtpCtpPopupQueryVariables>(ShowAtpCtpPopupDocument, options);
        }
export type ShowAtpCtpPopupQueryHookResult = ReturnType<typeof useShowAtpCtpPopupQuery>;
export type ShowAtpCtpPopupLazyQueryHookResult = ReturnType<typeof useShowAtpCtpPopupLazyQuery>;
export type ShowAtpCtpPopupQueryResult = Apollo.QueryResult<Types.ShowAtpCtpPopupQuery, Types.ShowAtpCtpPopupQueryVariables>;
export const FilterSoldToDomesticOrderDocument = gql`
    query filterSoldToDomesticOrder($filter: DomesticSoldToFilterInput, $before: String, $after: String, $first: Int) {
  filterSoldToDomesticOrder(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useFilterSoldToDomesticOrderQuery__
 *
 * To run a query within a React component, call `useFilterSoldToDomesticOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterSoldToDomesticOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterSoldToDomesticOrderQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterSoldToDomesticOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterSoldToDomesticOrderQuery, Types.FilterSoldToDomesticOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterSoldToDomesticOrderQuery, Types.FilterSoldToDomesticOrderQueryVariables>(FilterSoldToDomesticOrderDocument, options);
      }
export function useFilterSoldToDomesticOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterSoldToDomesticOrderQuery, Types.FilterSoldToDomesticOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterSoldToDomesticOrderQuery, Types.FilterSoldToDomesticOrderQueryVariables>(FilterSoldToDomesticOrderDocument, options);
        }
export type FilterSoldToDomesticOrderQueryHookResult = ReturnType<typeof useFilterSoldToDomesticOrderQuery>;
export type FilterSoldToDomesticOrderLazyQueryHookResult = ReturnType<typeof useFilterSoldToDomesticOrderLazyQuery>;
export type FilterSoldToDomesticOrderQueryResult = Apollo.QueryResult<Types.FilterSoldToDomesticOrderQuery, Types.FilterSoldToDomesticOrderQueryVariables>;
export const FilterSaleEmployeeDomesticOrderDocument = gql`
    query filterSaleEmployeeDomesticOrder($filter: DomesticSaleEmployeeFilterInput, $before: String, $after: String, $first: Int) {
  filterSaleEmployeeDomesticOrder(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useFilterSaleEmployeeDomesticOrderQuery__
 *
 * To run a query within a React component, call `useFilterSaleEmployeeDomesticOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterSaleEmployeeDomesticOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterSaleEmployeeDomesticOrderQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterSaleEmployeeDomesticOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterSaleEmployeeDomesticOrderQuery, Types.FilterSaleEmployeeDomesticOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterSaleEmployeeDomesticOrderQuery, Types.FilterSaleEmployeeDomesticOrderQueryVariables>(FilterSaleEmployeeDomesticOrderDocument, options);
      }
export function useFilterSaleEmployeeDomesticOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterSaleEmployeeDomesticOrderQuery, Types.FilterSaleEmployeeDomesticOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterSaleEmployeeDomesticOrderQuery, Types.FilterSaleEmployeeDomesticOrderQueryVariables>(FilterSaleEmployeeDomesticOrderDocument, options);
        }
export type FilterSaleEmployeeDomesticOrderQueryHookResult = ReturnType<typeof useFilterSaleEmployeeDomesticOrderQuery>;
export type FilterSaleEmployeeDomesticOrderLazyQueryHookResult = ReturnType<typeof useFilterSaleEmployeeDomesticOrderLazyQuery>;
export type FilterSaleEmployeeDomesticOrderQueryResult = Apollo.QueryResult<Types.FilterSaleEmployeeDomesticOrderQuery, Types.FilterSaleEmployeeDomesticOrderQueryVariables>;
export const DomesticOrderTypeDocument = gql`
    query domesticOrderType($before: String, $after: String, $first: Int) {
  domesticOrderType(before: $before, after: $after, first: $first) {
    edges {
      node {
        orderType
      }
    }
  }
}
    `;

/**
 * __useDomesticOrderTypeQuery__
 *
 * To run a query within a React component, call `useDomesticOrderTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomesticOrderTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomesticOrderTypeQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDomesticOrderTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DomesticOrderTypeQuery, Types.DomesticOrderTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DomesticOrderTypeQuery, Types.DomesticOrderTypeQueryVariables>(DomesticOrderTypeDocument, options);
      }
export function useDomesticOrderTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DomesticOrderTypeQuery, Types.DomesticOrderTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DomesticOrderTypeQuery, Types.DomesticOrderTypeQueryVariables>(DomesticOrderTypeDocument, options);
        }
export type DomesticOrderTypeQueryHookResult = ReturnType<typeof useDomesticOrderTypeQuery>;
export type DomesticOrderTypeLazyQueryHookResult = ReturnType<typeof useDomesticOrderTypeLazyQuery>;
export type DomesticOrderTypeQueryResult = Apollo.QueryResult<Types.DomesticOrderTypeQuery, Types.DomesticOrderTypeQueryVariables>;
export const DomesticOrdersDocument = gql`
    query domesticOrders($sortBy: DomesticOrderSortingInput, $filter: DomesticOrderFilterInput, $before: String, $after: String, $first: Int, $last: Int) {
  domesticOrders(
    sortBy: $sortBy
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    totalCount
    latestPageItemNumber
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        soNo
        poNumber
        contractPiNo
        soldTo {
          displayText
        }
        contract {
          projectName
          contractNo
          customer {
            displayText
          }
          paymentTermKey
        }
        company {
          name
          code
        }
        paymentTerm
        creditStatus
        orderDate
        statusSap
        status
      }
    }
  }
}
    `;

/**
 * __useDomesticOrdersQuery__
 *
 * To run a query within a React component, call `useDomesticOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomesticOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomesticOrdersQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useDomesticOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DomesticOrdersQuery, Types.DomesticOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DomesticOrdersQuery, Types.DomesticOrdersQueryVariables>(DomesticOrdersDocument, options);
      }
export function useDomesticOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DomesticOrdersQuery, Types.DomesticOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DomesticOrdersQuery, Types.DomesticOrdersQueryVariables>(DomesticOrdersDocument, options);
        }
export type DomesticOrdersQueryHookResult = ReturnType<typeof useDomesticOrdersQuery>;
export type DomesticOrdersLazyQueryHookResult = ReturnType<typeof useDomesticOrdersLazyQuery>;
export type DomesticOrdersQueryResult = Apollo.QueryResult<Types.DomesticOrdersQuery, Types.DomesticOrdersQueryVariables>;
export const ContractOrderDomesticDocument = gql`
    query contractOrderDomestic($soNo: String!) {
  contractOrder(soNo: $soNo) {
    id
    soNo
    orderType
    orderTypeDesc
    poNumber
    status
    soldToAddress
    orderAmtBeforeVat
    orderAmtVat
    orderAmtAfterVat
    itemCategory
    routeId
    routeName
    salesGroup
    untimatedTol
    itemCategory
    billTo
    routeId
    routeName
    customer {
      id
      name
      code
      soldToCode
      soldToName
      representatives {
        addresses {
          streetAddress1
          streetAddress2
        }
        firstName
        lastName
      }
      displayText
      addressText
    }
    contract {
      id
      contractNo
      billTo
      currency
      shipTo
      paymentTerm
      customer {
        soldToName
        soldToCode
        displayText
        addressText
      }
      projectName
    }
    taxPercent
    soldTo {
      displayText
      addressText
    }
    shipTo
    billTo
    customerGroup {
      id
      code
      name
    }
    customerGroup1 {
      id
      code
      name
    }
    customerGroup2 {
      id
      code
      name
    }
    customerGroup3 {
      id
      code
      name
    }
    customerGroup4 {
      id
      code
      name
    }
    poDate
    requestDate
    paymentTerm
    dpNo
    invoiceNo
    deliveryBlock
    incoterm
    incoterms1 {
      id
      code
      description
    }
    route
    shippingPoint
    internalCommentsToLogistic
    internalCommentsToWarehouse
    externalCommentsToCustomer
    productInformation
    saleOrganization {
      id
      code
      name
    }
    saleGroup {
      id
      name
      code
    }
    saleOffice {
      id
      name
      code
    }
    division {
      id
      name
      code
    }
    distributionChannel {
      id
      name
      code
    }
    orderLines {
      splitItems {
        ...fieldOrderLines
      }
      ...fieldOrderLines
    }
  }
}
    ${FieldOrderLinesFragmentDoc}`;

/**
 * __useContractOrderDomesticQuery__
 *
 * To run a query within a React component, call `useContractOrderDomesticQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractOrderDomesticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractOrderDomesticQuery({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useContractOrderDomesticQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractOrderDomesticQuery, Types.ContractOrderDomesticQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractOrderDomesticQuery, Types.ContractOrderDomesticQueryVariables>(ContractOrderDomesticDocument, options);
      }
export function useContractOrderDomesticLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractOrderDomesticQuery, Types.ContractOrderDomesticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractOrderDomesticQuery, Types.ContractOrderDomesticQueryVariables>(ContractOrderDomesticDocument, options);
        }
export type ContractOrderDomesticQueryHookResult = ReturnType<typeof useContractOrderDomesticQuery>;
export type ContractOrderDomesticLazyQueryHookResult = ReturnType<typeof useContractOrderDomesticLazyQuery>;
export type ContractOrderDomesticQueryResult = Apollo.QueryResult<Types.ContractOrderDomesticQuery, Types.ContractOrderDomesticQueryVariables>;
export const ContractChangeOrderDomesticDocument = gql`
    query contractChangeOrderDomestic($soNo: String!) {
  changeOrder(soNo: $soNo) {
    orderId
    poDate
    orderType
    orderTypeDesc
    itemNoLatest
    assignedQty
    contractNo
    currency
    customerGroup
    customerGroup1
    customerGroup1Name
    customerGroup2
    customerGroup2Name
    customerGroup3
    customerGroup3Name
    customerGroup4
    customerGroup4Name
    customerGroupName
    deliveryBlock
    distributionChannel
    distributionChannelName
    division
    divisionName
    dp {
      dpNo
    }
    incoterms1
    incoterms1Name
    incoterms2
    incoterms2Name
    invoice {
      invoiceNo
    }
    orderAmtAfterVat
    orderAmtBeforeVat
    orderAmtVat
    orderCondition {
      itemNo
      conditionBaseValue
      conditionPriceOrder
      conditionType
      conditionPriceUnit
      conditionRate
      conditionUnit
      currency
    }
    orderDate
    orderItems {
      weightUnit
      grossWeightTon
      netWeightTon
      weightUnitTon
      allowChangeInquiryMethod
      itemStatusEn
      itemStatusEnDisplayText
      inquiryMethod
      orderType
      originalRequestDate
      assignQuantity
      confirmedDate
      poDate
      reasonReject
      comfirmQty
      contractItemNo
      contractNo
      deliveryQty
      deliveryStatus
      itemCategory
      id
      itemNo
      itemQty
      material
      materialDesc
      materialGroup1
      materialGroup1Desc
      netPrice
      orderQty
      paymentTerm
      paymentTermDescTh
      plant
      poNumber
      poSubcontract
      prNo
      prItem
      prdHierachy
      requestedDate
      routeId
      routeName
      saleQtyDivision
      saleQtyFactor
      saleText1Th
      salesUnit
      shippingPoint
      shipTo
      untimatedTol
      weightPerUnit
      atp
      atpDetails
      block
      run
      paperMachine
      remainWeight
      shipTo
      weight
      weightDisplay
      productMaterial
      internalCommentsToLogistic
      internalCommentsToWarehouse
      externalCommentsToCustomer
      product_Information
      contractProductId
      deliveryTolUnlimited
      overDeliveryTol
      underDeliveryTol
      flagR5
      requestDateChangeReason
      sapConfirmStatus
      shippingMark
    }
    orderPartners {
      addrLink
      itemNo
      address {
        addrNo
        city
        country
        district
        name
        postCode
        street
        transpzone
        strSuppl1
        strSuppl2
        strSuppl3
        location
      }
      partnerNo
      partnerRole
    }
    orderText {
      itemNo
      language
      textId
      textLine {
        text
      }
    }
    cashSale {
      ...cashSaleResponse
      __typename
    }
    overTol
    underTol
    paymentTerms
    poNo
    priceDate
    requestDate
    salesGroup
    salesGroupName
    salesOff
    salesOffName
    salesOrg
    salesOrgName
    salesOrgShortName
    soNo
    status
  }
}
    ${CashSaleResponseFragmentDoc}`;

/**
 * __useContractChangeOrderDomesticQuery__
 *
 * To run a query within a React component, call `useContractChangeOrderDomesticQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractChangeOrderDomesticQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractChangeOrderDomesticQuery({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useContractChangeOrderDomesticQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractChangeOrderDomesticQuery, Types.ContractChangeOrderDomesticQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractChangeOrderDomesticQuery, Types.ContractChangeOrderDomesticQueryVariables>(ContractChangeOrderDomesticDocument, options);
      }
export function useContractChangeOrderDomesticLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractChangeOrderDomesticQuery, Types.ContractChangeOrderDomesticQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractChangeOrderDomesticQuery, Types.ContractChangeOrderDomesticQueryVariables>(ContractChangeOrderDomesticDocument, options);
        }
export type ContractChangeOrderDomesticQueryHookResult = ReturnType<typeof useContractChangeOrderDomesticQuery>;
export type ContractChangeOrderDomesticLazyQueryHookResult = ReturnType<typeof useContractChangeOrderDomesticLazyQuery>;
export type ContractChangeOrderDomesticQueryResult = Apollo.QueryResult<Types.ContractChangeOrderDomesticQuery, Types.ContractChangeOrderDomesticQueryVariables>;
export const GetCustomerGroupMasterDocument = gql`
    query getCustomerGroupMaster {
  customerGroup1 {
    id
    code
    name
  }
  customerGroup2 {
    id
    code
    name
  }
  customerGroup3 {
    id
    code
    name
  }
  customerGroup4 {
    id
    code
    name
  }
}
    `;

/**
 * __useGetCustomerGroupMasterQuery__
 *
 * To run a query within a React component, call `useGetCustomerGroupMasterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerGroupMasterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerGroupMasterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerGroupMasterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetCustomerGroupMasterQuery, Types.GetCustomerGroupMasterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCustomerGroupMasterQuery, Types.GetCustomerGroupMasterQueryVariables>(GetCustomerGroupMasterDocument, options);
      }
export function useGetCustomerGroupMasterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCustomerGroupMasterQuery, Types.GetCustomerGroupMasterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCustomerGroupMasterQuery, Types.GetCustomerGroupMasterQueryVariables>(GetCustomerGroupMasterDocument, options);
        }
export type GetCustomerGroupMasterQueryHookResult = ReturnType<typeof useGetCustomerGroupMasterQuery>;
export type GetCustomerGroupMasterLazyQueryHookResult = ReturnType<typeof useGetCustomerGroupMasterLazyQuery>;
export type GetCustomerGroupMasterQueryResult = Apollo.QueryResult<Types.GetCustomerGroupMasterQuery, Types.GetCustomerGroupMasterQueryVariables>;
export const GetCreditLimitDocument = gql`
    query getCreditLimit($input: CreditLimitInput) {
  getCreditLimit(input: $input) {
    creditControlArea
    creditLimit
    creditAccount
    creditLimitUsed
    receivables
    specialLiabil
    saleValue
    creditExposure
    secondReceivables
    creditAvaiable
    currency
    creditBlockStatus
  }
}
    `;

/**
 * __useGetCreditLimitQuery__
 *
 * To run a query within a React component, call `useGetCreditLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditLimitQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCreditLimitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetCreditLimitQuery, Types.GetCreditLimitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCreditLimitQuery, Types.GetCreditLimitQueryVariables>(GetCreditLimitDocument, options);
      }
export function useGetCreditLimitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCreditLimitQuery, Types.GetCreditLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCreditLimitQuery, Types.GetCreditLimitQueryVariables>(GetCreditLimitDocument, options);
        }
export type GetCreditLimitQueryHookResult = ReturnType<typeof useGetCreditLimitQuery>;
export type GetCreditLimitLazyQueryHookResult = ReturnType<typeof useGetCreditLimitLazyQuery>;
export type GetCreditLimitQueryResult = Apollo.QueryResult<Types.GetCreditLimitQuery, Types.GetCreditLimitQueryVariables>;
export const GetIncotermDocument = gql`
    query getIncoterm {
  incoterms1 {
    id
    code
    description
  }
}
    `;

/**
 * __useGetIncotermQuery__
 *
 * To run a query within a React component, call `useGetIncotermQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncotermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncotermQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIncotermQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetIncotermQuery, Types.GetIncotermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetIncotermQuery, Types.GetIncotermQueryVariables>(GetIncotermDocument, options);
      }
export function useGetIncotermLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetIncotermQuery, Types.GetIncotermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetIncotermQuery, Types.GetIncotermQueryVariables>(GetIncotermDocument, options);
        }
export type GetIncotermQueryHookResult = ReturnType<typeof useGetIncotermQuery>;
export type GetIncotermLazyQueryHookResult = ReturnType<typeof useGetIncotermLazyQuery>;
export type GetIncotermQueryResult = Apollo.QueryResult<Types.GetIncotermQuery, Types.GetIncotermQueryVariables>;
export const GetOrderEmailToAndCcDocument = gql`
    query getOrderEmailToAndCc($bu: String, $soldToCode: [String], $saleOrg: [String], $soNo: [String]) {
  getOrderEmailToAndCc(
    bu: $bu
    soldToCode: $soldToCode
    saleOrg: $saleOrg
    soNo: $soNo
  ) {
    to
    cc
  }
}
    `;

/**
 * __useGetOrderEmailToAndCcQuery__
 *
 * To run a query within a React component, call `useGetOrderEmailToAndCcQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderEmailToAndCcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderEmailToAndCcQuery({
 *   variables: {
 *      bu: // value for 'bu'
 *      soldToCode: // value for 'soldToCode'
 *      saleOrg: // value for 'saleOrg'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useGetOrderEmailToAndCcQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetOrderEmailToAndCcQuery, Types.GetOrderEmailToAndCcQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetOrderEmailToAndCcQuery, Types.GetOrderEmailToAndCcQueryVariables>(GetOrderEmailToAndCcDocument, options);
      }
export function useGetOrderEmailToAndCcLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetOrderEmailToAndCcQuery, Types.GetOrderEmailToAndCcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetOrderEmailToAndCcQuery, Types.GetOrderEmailToAndCcQueryVariables>(GetOrderEmailToAndCcDocument, options);
        }
export type GetOrderEmailToAndCcQueryHookResult = ReturnType<typeof useGetOrderEmailToAndCcQuery>;
export type GetOrderEmailToAndCcLazyQueryHookResult = ReturnType<typeof useGetOrderEmailToAndCcLazyQuery>;
export type GetOrderEmailToAndCcQueryResult = Apollo.QueryResult<Types.GetOrderEmailToAndCcQuery, Types.GetOrderEmailToAndCcQueryVariables>;
export const SapChangeOrderDocument = gql`
    query sapChangeOrder($filter: SAPChangeOrderInput) {
  sapChangeOrder(filter: $filter) {
    soNo
    contractNo
    poNo
    soldToParty
    shipTo
    country
    incoterm
    payment
    bu
    projectName
    company
    paymentTerms
    creditStatusOfDocument
    orderDate
    orderStatusSap
    orderStatusEOrdering
    soldToCode
    salesOrgCode
    isNotRef
    cashSale {
      status
      message
      cashSaleStatus
      statusName
      __typename
    }
  }
}
    `;

/**
 * __useSapChangeOrderQuery__
 *
 * To run a query within a React component, call `useSapChangeOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSapChangeOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSapChangeOrderQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSapChangeOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SapChangeOrderQuery, Types.SapChangeOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SapChangeOrderQuery, Types.SapChangeOrderQueryVariables>(SapChangeOrderDocument, options);
      }
export function useSapChangeOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SapChangeOrderQuery, Types.SapChangeOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SapChangeOrderQuery, Types.SapChangeOrderQueryVariables>(SapChangeOrderDocument, options);
        }
export type SapChangeOrderQueryHookResult = ReturnType<typeof useSapChangeOrderQuery>;
export type SapChangeOrderLazyQueryHookResult = ReturnType<typeof useSapChangeOrderLazyQuery>;
export type SapChangeOrderQueryResult = Apollo.QueryResult<Types.SapChangeOrderQuery, Types.SapChangeOrderQueryVariables>;
export const UpdateInquiryMethodExportDocument = gql`
    mutation updateInquiryMethodExport($orderLineId: ID!, $input: UpdateInquiryMethodExportInput!) {
  updateInquiryMethodExport(orderLineId: $orderLineId, input: $input) {
    orderLine {
      id
      inquiryMethod
    }
  }
}
    `;
export type UpdateInquiryMethodExportMutationFn = Apollo.MutationFunction<Types.UpdateInquiryMethodExportMutation, Types.UpdateInquiryMethodExportMutationVariables>;

/**
 * __useUpdateInquiryMethodExportMutation__
 *
 * To run a mutation, you first call `useUpdateInquiryMethodExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInquiryMethodExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInquiryMethodExportMutation, { data, loading, error }] = useUpdateInquiryMethodExportMutation({
 *   variables: {
 *      orderLineId: // value for 'orderLineId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInquiryMethodExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateInquiryMethodExportMutation, Types.UpdateInquiryMethodExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateInquiryMethodExportMutation, Types.UpdateInquiryMethodExportMutationVariables>(UpdateInquiryMethodExportDocument, options);
      }
export type UpdateInquiryMethodExportMutationHookResult = ReturnType<typeof useUpdateInquiryMethodExportMutation>;
export type UpdateInquiryMethodExportMutationResult = Apollo.MutationResult<Types.UpdateInquiryMethodExportMutation>;
export type UpdateInquiryMethodExportMutationOptions = Apollo.BaseMutationOptions<Types.UpdateInquiryMethodExportMutation, Types.UpdateInquiryMethodExportMutationVariables>;
export const AtpctpConfirmMutationDocument = gql`
    mutation ATPCTPConfirmMutation($input: ATPCTPConfirmInputType!) {
  atpCtpConfirm(input: $input) {
    errors {
      field
      message
      code
    }
  }
}
    `;
export type AtpctpConfirmMutationMutationFn = Apollo.MutationFunction<Types.AtpctpConfirmMutationMutation, Types.AtpctpConfirmMutationMutationVariables>;

/**
 * __useAtpctpConfirmMutationMutation__
 *
 * To run a mutation, you first call `useAtpctpConfirmMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtpctpConfirmMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atpctpConfirmMutationMutation, { data, loading, error }] = useAtpctpConfirmMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtpctpConfirmMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtpctpConfirmMutationMutation, Types.AtpctpConfirmMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtpctpConfirmMutationMutation, Types.AtpctpConfirmMutationMutationVariables>(AtpctpConfirmMutationDocument, options);
      }
export type AtpctpConfirmMutationMutationHookResult = ReturnType<typeof useAtpctpConfirmMutationMutation>;
export type AtpctpConfirmMutationMutationResult = Apollo.MutationResult<Types.AtpctpConfirmMutationMutation>;
export type AtpctpConfirmMutationMutationOptions = Apollo.BaseMutationOptions<Types.AtpctpConfirmMutationMutation, Types.AtpctpConfirmMutationMutationVariables>;
export const CheckoutAtpctpConfirmMutationDocument = gql`
    mutation CheckoutATPCTPConfirmMutation($input: CheckoutATPCTPConfirmInputType!) {
  checkoutAtpCtpConfirm(input: $input) {
    items {
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      orderNo
      action
      calculatedItemNo
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type CheckoutAtpctpConfirmMutationMutationFn = Apollo.MutationFunction<Types.CheckoutAtpctpConfirmMutationMutation, Types.CheckoutAtpctpConfirmMutationMutationVariables>;

/**
 * __useCheckoutAtpctpConfirmMutationMutation__
 *
 * To run a mutation, you first call `useCheckoutAtpctpConfirmMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutAtpctpConfirmMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutAtpctpConfirmMutationMutation, { data, loading, error }] = useCheckoutAtpctpConfirmMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutAtpctpConfirmMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CheckoutAtpctpConfirmMutationMutation, Types.CheckoutAtpctpConfirmMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CheckoutAtpctpConfirmMutationMutation, Types.CheckoutAtpctpConfirmMutationMutationVariables>(CheckoutAtpctpConfirmMutationDocument, options);
      }
export type CheckoutAtpctpConfirmMutationMutationHookResult = ReturnType<typeof useCheckoutAtpctpConfirmMutationMutation>;
export type CheckoutAtpctpConfirmMutationMutationResult = Apollo.MutationResult<Types.CheckoutAtpctpConfirmMutationMutation>;
export type CheckoutAtpctpConfirmMutationMutationOptions = Apollo.BaseMutationOptions<Types.CheckoutAtpctpConfirmMutationMutation, Types.CheckoutAtpctpConfirmMutationMutationVariables>;
export const CheckoutAtpctpRequestMutationDocument = gql`
    mutation CheckoutATPCTPRequestMutation($input: [CheckoutATPCTPRequestOrderLineInput!]!) {
  checkoutAtpCtpRequest(orderLines: $input) {
    items {
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      orderNo
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    itemsFailed {
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      orderNo
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
    }
  }
}
    `;
export type CheckoutAtpctpRequestMutationMutationFn = Apollo.MutationFunction<Types.CheckoutAtpctpRequestMutationMutation, Types.CheckoutAtpctpRequestMutationMutationVariables>;

/**
 * __useCheckoutAtpctpRequestMutationMutation__
 *
 * To run a mutation, you first call `useCheckoutAtpctpRequestMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutAtpctpRequestMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutAtpctpRequestMutationMutation, { data, loading, error }] = useCheckoutAtpctpRequestMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutAtpctpRequestMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CheckoutAtpctpRequestMutationMutation, Types.CheckoutAtpctpRequestMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CheckoutAtpctpRequestMutationMutation, Types.CheckoutAtpctpRequestMutationMutationVariables>(CheckoutAtpctpRequestMutationDocument, options);
      }
export type CheckoutAtpctpRequestMutationMutationHookResult = ReturnType<typeof useCheckoutAtpctpRequestMutationMutation>;
export type CheckoutAtpctpRequestMutationMutationResult = Apollo.MutationResult<Types.CheckoutAtpctpRequestMutationMutation>;
export type CheckoutAtpctpRequestMutationMutationOptions = Apollo.BaseMutationOptions<Types.CheckoutAtpctpRequestMutationMutation, Types.CheckoutAtpctpRequestMutationMutationVariables>;
export const AddProductsToChangeExportOrderDocument = gql`
    mutation addProductsToChangeExportOrder($id: ID!, $input: [ChangeExportOrderLineAddProductInput!]!) {
  addProductsToChangeExportOrder(id: $id, input: $input) {
    errors {
      field
      message
      code
      __typename
    }
    result {
      id
      materialCode
      materialDescription
      quantity
      quantityUnit
      weight
      weightUnit
      itemCatEo
      piProduct {
        id
        contract {
          currency
        }
        pricePerUnit
        remainingQuantity
      }
      netPrice
      plant
      refPiNo
      route
      conditionGroup1
      materialGroup2
      commissionPercent
      commissionAmount
      commissionUnit
      rollDiameter
      rollCoreDiameter
      noOfRolls
      rollPerPallet
      palletSize
      palletNo
      noOfPackage
      packingList
      shippingPoint
      remark
      rejectReason
      inquiryMethod
    }
  }
}
    `;
export type AddProductsToChangeExportOrderMutationFn = Apollo.MutationFunction<Types.AddProductsToChangeExportOrderMutation, Types.AddProductsToChangeExportOrderMutationVariables>;

/**
 * __useAddProductsToChangeExportOrderMutation__
 *
 * To run a mutation, you first call `useAddProductsToChangeExportOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToChangeExportOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToChangeExportOrderMutation, { data, loading, error }] = useAddProductsToChangeExportOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductsToChangeExportOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddProductsToChangeExportOrderMutation, Types.AddProductsToChangeExportOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddProductsToChangeExportOrderMutation, Types.AddProductsToChangeExportOrderMutationVariables>(AddProductsToChangeExportOrderDocument, options);
      }
export type AddProductsToChangeExportOrderMutationHookResult = ReturnType<typeof useAddProductsToChangeExportOrderMutation>;
export type AddProductsToChangeExportOrderMutationResult = Apollo.MutationResult<Types.AddProductsToChangeExportOrderMutation>;
export type AddProductsToChangeExportOrderMutationOptions = Apollo.BaseMutationOptions<Types.AddProductsToChangeExportOrderMutation, Types.AddProductsToChangeExportOrderMutationVariables>;
export const UpdateExportOrderLinesDraftDocument = gql`
    mutation updateExportOrderLinesDraft($input: ExportOrderUpdateDraftInput!) {
  updateExportOrderLinesDraft(input: $input) {
    status
    orderLines {
      id
      quantity
    }
  }
}
    `;
export type UpdateExportOrderLinesDraftMutationFn = Apollo.MutationFunction<Types.UpdateExportOrderLinesDraftMutation, Types.UpdateExportOrderLinesDraftMutationVariables>;

/**
 * __useUpdateExportOrderLinesDraftMutation__
 *
 * To run a mutation, you first call `useUpdateExportOrderLinesDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExportOrderLinesDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExportOrderLinesDraftMutation, { data, loading, error }] = useUpdateExportOrderLinesDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExportOrderLinesDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateExportOrderLinesDraftMutation, Types.UpdateExportOrderLinesDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateExportOrderLinesDraftMutation, Types.UpdateExportOrderLinesDraftMutationVariables>(UpdateExportOrderLinesDraftDocument, options);
      }
export type UpdateExportOrderLinesDraftMutationHookResult = ReturnType<typeof useUpdateExportOrderLinesDraftMutation>;
export type UpdateExportOrderLinesDraftMutationResult = Apollo.MutationResult<Types.UpdateExportOrderLinesDraftMutation>;
export type UpdateExportOrderLinesDraftMutationOptions = Apollo.BaseMutationOptions<Types.UpdateExportOrderLinesDraftMutation, Types.UpdateExportOrderLinesDraftMutationVariables>;
export const ExportOrderAtpCtpRequestDocument = gql`
    mutation exportOrderAtpCtpRequest($input: [ExportATPCTPRequestOrderLineInput!]!) {
  exportOrderAtpCtpRequest(orderLines: $input) {
    items {
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      orderNo
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    itemsFailed {
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      orderNo
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
    }
  }
}
    `;
export type ExportOrderAtpCtpRequestMutationFn = Apollo.MutationFunction<Types.ExportOrderAtpCtpRequestMutation, Types.ExportOrderAtpCtpRequestMutationVariables>;

/**
 * __useExportOrderAtpCtpRequestMutation__
 *
 * To run a mutation, you first call `useExportOrderAtpCtpRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOrderAtpCtpRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOrderAtpCtpRequestMutation, { data, loading, error }] = useExportOrderAtpCtpRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportOrderAtpCtpRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExportOrderAtpCtpRequestMutation, Types.ExportOrderAtpCtpRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExportOrderAtpCtpRequestMutation, Types.ExportOrderAtpCtpRequestMutationVariables>(ExportOrderAtpCtpRequestDocument, options);
      }
export type ExportOrderAtpCtpRequestMutationHookResult = ReturnType<typeof useExportOrderAtpCtpRequestMutation>;
export type ExportOrderAtpCtpRequestMutationResult = Apollo.MutationResult<Types.ExportOrderAtpCtpRequestMutation>;
export type ExportOrderAtpCtpRequestMutationOptions = Apollo.BaseMutationOptions<Types.ExportOrderAtpCtpRequestMutation, Types.ExportOrderAtpCtpRequestMutationVariables>;
export const ExportOrderAtpCtpConfirmDocument = gql`
    mutation exportOrderAtpCtpConfirm($input: ExportATPCTPConfirmInputType!) {
  exportOrderAtpCtpConfirm(input: $input) {
    items {
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      orderNo
      action
      calculatedItemNo
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
    }
    iPlanErrorMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    sapOrderErrorMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type ExportOrderAtpCtpConfirmMutationFn = Apollo.MutationFunction<Types.ExportOrderAtpCtpConfirmMutation, Types.ExportOrderAtpCtpConfirmMutationVariables>;

/**
 * __useExportOrderAtpCtpConfirmMutation__
 *
 * To run a mutation, you first call `useExportOrderAtpCtpConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOrderAtpCtpConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOrderAtpCtpConfirmMutation, { data, loading, error }] = useExportOrderAtpCtpConfirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportOrderAtpCtpConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExportOrderAtpCtpConfirmMutation, Types.ExportOrderAtpCtpConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExportOrderAtpCtpConfirmMutation, Types.ExportOrderAtpCtpConfirmMutationVariables>(ExportOrderAtpCtpConfirmDocument, options);
      }
export type ExportOrderAtpCtpConfirmMutationHookResult = ReturnType<typeof useExportOrderAtpCtpConfirmMutation>;
export type ExportOrderAtpCtpConfirmMutationResult = Apollo.MutationResult<Types.ExportOrderAtpCtpConfirmMutation>;
export type ExportOrderAtpCtpConfirmMutationOptions = Apollo.BaseMutationOptions<Types.ExportOrderAtpCtpConfirmMutation, Types.ExportOrderAtpCtpConfirmMutationVariables>;
export const ExportChangeOrderAddNewOrderLineDocument = gql`
    mutation ExportChangeOrderAddNewOrderLine($id: ID!, $input: ExportAddNewOrderLineInput!) {
  exportChangeOrderAddNewOrderLines(id: $id, input: $input) {
    success
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
      soNo
    }
  }
}
    `;
export type ExportChangeOrderAddNewOrderLineMutationFn = Apollo.MutationFunction<Types.ExportChangeOrderAddNewOrderLineMutation, Types.ExportChangeOrderAddNewOrderLineMutationVariables>;

/**
 * __useExportChangeOrderAddNewOrderLineMutation__
 *
 * To run a mutation, you first call `useExportChangeOrderAddNewOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportChangeOrderAddNewOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportChangeOrderAddNewOrderLineMutation, { data, loading, error }] = useExportChangeOrderAddNewOrderLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportChangeOrderAddNewOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExportChangeOrderAddNewOrderLineMutation, Types.ExportChangeOrderAddNewOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExportChangeOrderAddNewOrderLineMutation, Types.ExportChangeOrderAddNewOrderLineMutationVariables>(ExportChangeOrderAddNewOrderLineDocument, options);
      }
export type ExportChangeOrderAddNewOrderLineMutationHookResult = ReturnType<typeof useExportChangeOrderAddNewOrderLineMutation>;
export type ExportChangeOrderAddNewOrderLineMutationResult = Apollo.MutationResult<Types.ExportChangeOrderAddNewOrderLineMutation>;
export type ExportChangeOrderAddNewOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.ExportChangeOrderAddNewOrderLineMutation, Types.ExportChangeOrderAddNewOrderLineMutationVariables>;
export const CancelDeleteExportOrderDocument = gql`
    mutation cancelDeleteExportOrder($itemNos: [String], $reason: ExportOrderReasonForRejectInput!, $soNo: String) {
  cancelDeleteExportOrder(soNo: $soNo, itemNos: $itemNos, reason: $reason) {
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
      soNo
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type CancelDeleteExportOrderMutationFn = Apollo.MutationFunction<Types.CancelDeleteExportOrderMutation, Types.CancelDeleteExportOrderMutationVariables>;

/**
 * __useCancelDeleteExportOrderMutation__
 *
 * To run a mutation, you first call `useCancelDeleteExportOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeleteExportOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeleteExportOrderMutation, { data, loading, error }] = useCancelDeleteExportOrderMutation({
 *   variables: {
 *      itemNos: // value for 'itemNos'
 *      reason: // value for 'reason'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useCancelDeleteExportOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelDeleteExportOrderMutation, Types.CancelDeleteExportOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelDeleteExportOrderMutation, Types.CancelDeleteExportOrderMutationVariables>(CancelDeleteExportOrderDocument, options);
      }
export type CancelDeleteExportOrderMutationHookResult = ReturnType<typeof useCancelDeleteExportOrderMutation>;
export type CancelDeleteExportOrderMutationResult = Apollo.MutationResult<Types.CancelDeleteExportOrderMutation>;
export type CancelDeleteExportOrderMutationOptions = Apollo.BaseMutationOptions<Types.CancelDeleteExportOrderMutation, Types.CancelDeleteExportOrderMutationVariables>;
export const UndoOrderLinesExportDocument = gql`
    mutation undoOrderLinesExport($itemNo: [String]!, $soNo: String!) {
  undoOrderLinesExport(itemNo: $itemNo, soNo: $soNo) {
    success
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    errors {
      message
      code
    }
  }
}
    `;
export type UndoOrderLinesExportMutationFn = Apollo.MutationFunction<Types.UndoOrderLinesExportMutation, Types.UndoOrderLinesExportMutationVariables>;

/**
 * __useUndoOrderLinesExportMutation__
 *
 * To run a mutation, you first call `useUndoOrderLinesExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoOrderLinesExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoOrderLinesExportMutation, { data, loading, error }] = useUndoOrderLinesExportMutation({
 *   variables: {
 *      itemNo: // value for 'itemNo'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useUndoOrderLinesExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UndoOrderLinesExportMutation, Types.UndoOrderLinesExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UndoOrderLinesExportMutation, Types.UndoOrderLinesExportMutationVariables>(UndoOrderLinesExportDocument, options);
      }
export type UndoOrderLinesExportMutationHookResult = ReturnType<typeof useUndoOrderLinesExportMutation>;
export type UndoOrderLinesExportMutationResult = Apollo.MutationResult<Types.UndoOrderLinesExportMutation>;
export type UndoOrderLinesExportMutationOptions = Apollo.BaseMutationOptions<Types.UndoOrderLinesExportMutation, Types.UndoOrderLinesExportMutationVariables>;
export const EditOrderExportDocument = gql`
    mutation editOrderExport($input: EditExportOrderInput!) {
  editOrderExport(input: $input) {
    success
    iplanMessages {
      itemNo
      firstCode
      secondCode
      message
      __typename
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    errors {
      field
      message
      code
    }
    sapWarningMessages {
      message
      order
      source
    }
  }
}
    `;
export type EditOrderExportMutationFn = Apollo.MutationFunction<Types.EditOrderExportMutation, Types.EditOrderExportMutationVariables>;

/**
 * __useEditOrderExportMutation__
 *
 * To run a mutation, you first call `useEditOrderExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrderExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrderExportMutation, { data, loading, error }] = useEditOrderExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditOrderExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditOrderExportMutation, Types.EditOrderExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditOrderExportMutation, Types.EditOrderExportMutationVariables>(EditOrderExportDocument, options);
      }
export type EditOrderExportMutationHookResult = ReturnType<typeof useEditOrderExportMutation>;
export type EditOrderExportMutationResult = Apollo.MutationResult<Types.EditOrderExportMutation>;
export type EditOrderExportMutationOptions = Apollo.BaseMutationOptions<Types.EditOrderExportMutation, Types.EditOrderExportMutationVariables>;
export const DeleteExportOrderLineDraftDocument = gql`
    mutation deleteExportOrderLineDraft($id: ID!) {
  deleteExportOrderLineDraft(id: $id) {
    success
    errors {
      message
      field
      code
    }
  }
}
    `;
export type DeleteExportOrderLineDraftMutationFn = Apollo.MutationFunction<Types.DeleteExportOrderLineDraftMutation, Types.DeleteExportOrderLineDraftMutationVariables>;

/**
 * __useDeleteExportOrderLineDraftMutation__
 *
 * To run a mutation, you first call `useDeleteExportOrderLineDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExportOrderLineDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExportOrderLineDraftMutation, { data, loading, error }] = useDeleteExportOrderLineDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExportOrderLineDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteExportOrderLineDraftMutation, Types.DeleteExportOrderLineDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteExportOrderLineDraftMutation, Types.DeleteExportOrderLineDraftMutationVariables>(DeleteExportOrderLineDraftDocument, options);
      }
export type DeleteExportOrderLineDraftMutationHookResult = ReturnType<typeof useDeleteExportOrderLineDraftMutation>;
export type DeleteExportOrderLineDraftMutationResult = Apollo.MutationResult<Types.DeleteExportOrderLineDraftMutation>;
export type DeleteExportOrderLineDraftMutationOptions = Apollo.BaseMutationOptions<Types.DeleteExportOrderLineDraftMutation, Types.DeleteExportOrderLineDraftMutationVariables>;
export const SuggestionShipToChangeOrderSearchDocument = gql`
    query suggestionShipToChangeOrderSearch($filter: ChangeOrderShipToFilterInput, $first: Int) {
  suggestionShipToChangeOrderSearch(filter: $filter, first: $first) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        displayCodeName
        partnerCode
      }
    }
  }
}
    `;

/**
 * __useSuggestionShipToChangeOrderSearchQuery__
 *
 * To run a query within a React component, call `useSuggestionShipToChangeOrderSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionShipToChangeOrderSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionShipToChangeOrderSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSuggestionShipToChangeOrderSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionShipToChangeOrderSearchQuery, Types.SuggestionShipToChangeOrderSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionShipToChangeOrderSearchQuery, Types.SuggestionShipToChangeOrderSearchQueryVariables>(SuggestionShipToChangeOrderSearchDocument, options);
      }
export function useSuggestionShipToChangeOrderSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionShipToChangeOrderSearchQuery, Types.SuggestionShipToChangeOrderSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionShipToChangeOrderSearchQuery, Types.SuggestionShipToChangeOrderSearchQueryVariables>(SuggestionShipToChangeOrderSearchDocument, options);
        }
export type SuggestionShipToChangeOrderSearchQueryHookResult = ReturnType<typeof useSuggestionShipToChangeOrderSearchQuery>;
export type SuggestionShipToChangeOrderSearchLazyQueryHookResult = ReturnType<typeof useSuggestionShipToChangeOrderSearchLazyQuery>;
export type SuggestionShipToChangeOrderSearchQueryResult = Apollo.QueryResult<Types.SuggestionShipToChangeOrderSearchQuery, Types.SuggestionShipToChangeOrderSearchQueryVariables>;
export const SuggestionSoldToChangeOrderSearchDocument = gql`
    query suggestionSoldToChangeOrderSearch($filter: ChangeOrderSoldToFilterInput, $first: Int, $before: String, $after: String) {
  suggestionSoldToChangeOrderSearch(
    filter: $filter
    first: $first
    before: $before
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        partnerCode
        displayCodeName
      }
    }
  }
}
    `;

/**
 * __useSuggestionSoldToChangeOrderSearchQuery__
 *
 * To run a query within a React component, call `useSuggestionSoldToChangeOrderSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSoldToChangeOrderSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSoldToChangeOrderSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSuggestionSoldToChangeOrderSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSoldToChangeOrderSearchQuery, Types.SuggestionSoldToChangeOrderSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSoldToChangeOrderSearchQuery, Types.SuggestionSoldToChangeOrderSearchQueryVariables>(SuggestionSoldToChangeOrderSearchDocument, options);
      }
export function useSuggestionSoldToChangeOrderSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSoldToChangeOrderSearchQuery, Types.SuggestionSoldToChangeOrderSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSoldToChangeOrderSearchQuery, Types.SuggestionSoldToChangeOrderSearchQueryVariables>(SuggestionSoldToChangeOrderSearchDocument, options);
        }
export type SuggestionSoldToChangeOrderSearchQueryHookResult = ReturnType<typeof useSuggestionSoldToChangeOrderSearchQuery>;
export type SuggestionSoldToChangeOrderSearchLazyQueryHookResult = ReturnType<typeof useSuggestionSoldToChangeOrderSearchLazyQuery>;
export type SuggestionSoldToChangeOrderSearchQueryResult = Apollo.QueryResult<Types.SuggestionSoldToChangeOrderSearchQuery, Types.SuggestionSoldToChangeOrderSearchQueryVariables>;
export const FilterCompaniesExportOrderByBusinessUnitDocument = gql`
    query filterCompaniesExportOrderByBusinessUnit($first: Int, $filter: ExportCompaniesFilterInput) {
  filterCompaniesExportOrderByBusinessUnit(first: $first, filter: $filter) {
    edges {
      node {
        label: name
        value: code
      }
    }
  }
}
    `;

/**
 * __useFilterCompaniesExportOrderByBusinessUnitQuery__
 *
 * To run a query within a React component, call `useFilterCompaniesExportOrderByBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCompaniesExportOrderByBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCompaniesExportOrderByBusinessUnitQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFilterCompaniesExportOrderByBusinessUnitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterCompaniesExportOrderByBusinessUnitQuery, Types.FilterCompaniesExportOrderByBusinessUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterCompaniesExportOrderByBusinessUnitQuery, Types.FilterCompaniesExportOrderByBusinessUnitQueryVariables>(FilterCompaniesExportOrderByBusinessUnitDocument, options);
      }
export function useFilterCompaniesExportOrderByBusinessUnitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterCompaniesExportOrderByBusinessUnitQuery, Types.FilterCompaniesExportOrderByBusinessUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterCompaniesExportOrderByBusinessUnitQuery, Types.FilterCompaniesExportOrderByBusinessUnitQueryVariables>(FilterCompaniesExportOrderByBusinessUnitDocument, options);
        }
export type FilterCompaniesExportOrderByBusinessUnitQueryHookResult = ReturnType<typeof useFilterCompaniesExportOrderByBusinessUnitQuery>;
export type FilterCompaniesExportOrderByBusinessUnitLazyQueryHookResult = ReturnType<typeof useFilterCompaniesExportOrderByBusinessUnitLazyQuery>;
export type FilterCompaniesExportOrderByBusinessUnitQueryResult = Apollo.QueryResult<Types.FilterCompaniesExportOrderByBusinessUnitQuery, Types.FilterCompaniesExportOrderByBusinessUnitQueryVariables>;
export const FilterCompaniesExportOrderByUserLoginDocument = gql`
    query filterCompaniesExportOrderByUserLogin {
  filterCompaniesExportOrderByUserLogin {
    label: name
    value: code
  }
}
    `;

/**
 * __useFilterCompaniesExportOrderByUserLoginQuery__
 *
 * To run a query within a React component, call `useFilterCompaniesExportOrderByUserLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCompaniesExportOrderByUserLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCompaniesExportOrderByUserLoginQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterCompaniesExportOrderByUserLoginQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterCompaniesExportOrderByUserLoginQuery, Types.FilterCompaniesExportOrderByUserLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterCompaniesExportOrderByUserLoginQuery, Types.FilterCompaniesExportOrderByUserLoginQueryVariables>(FilterCompaniesExportOrderByUserLoginDocument, options);
      }
export function useFilterCompaniesExportOrderByUserLoginLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterCompaniesExportOrderByUserLoginQuery, Types.FilterCompaniesExportOrderByUserLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterCompaniesExportOrderByUserLoginQuery, Types.FilterCompaniesExportOrderByUserLoginQueryVariables>(FilterCompaniesExportOrderByUserLoginDocument, options);
        }
export type FilterCompaniesExportOrderByUserLoginQueryHookResult = ReturnType<typeof useFilterCompaniesExportOrderByUserLoginQuery>;
export type FilterCompaniesExportOrderByUserLoginLazyQueryHookResult = ReturnType<typeof useFilterCompaniesExportOrderByUserLoginLazyQuery>;
export type FilterCompaniesExportOrderByUserLoginQueryResult = Apollo.QueryResult<Types.FilterCompaniesExportOrderByUserLoginQuery, Types.FilterCompaniesExportOrderByUserLoginQueryVariables>;
export const FilterBusinessExportOrderDocument = gql`
    query filterBusinessExportOrder {
  filterBusinessExportOrder {
    label: name
    value: name
  }
}
    `;

/**
 * __useFilterBusinessExportOrderQuery__
 *
 * To run a query within a React component, call `useFilterBusinessExportOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterBusinessExportOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterBusinessExportOrderQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterBusinessExportOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterBusinessExportOrderQuery, Types.FilterBusinessExportOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterBusinessExportOrderQuery, Types.FilterBusinessExportOrderQueryVariables>(FilterBusinessExportOrderDocument, options);
      }
export function useFilterBusinessExportOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterBusinessExportOrderQuery, Types.FilterBusinessExportOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterBusinessExportOrderQuery, Types.FilterBusinessExportOrderQueryVariables>(FilterBusinessExportOrderDocument, options);
        }
export type FilterBusinessExportOrderQueryHookResult = ReturnType<typeof useFilterBusinessExportOrderQuery>;
export type FilterBusinessExportOrderLazyQueryHookResult = ReturnType<typeof useFilterBusinessExportOrderLazyQuery>;
export type FilterBusinessExportOrderQueryResult = Apollo.QueryResult<Types.FilterBusinessExportOrderQuery, Types.FilterBusinessExportOrderQueryVariables>;
export const ExportOrdersDocument = gql`
    query ExportOrders($sortBy: ExportOrderSortingInput, $filter: ExportOrderFilterInput, $before: String, $after: String, $first: Int, $last: Int) {
  exportOrders(
    sortBy: $sortBy
    filter: $filter
    first: $first
    before: $before
    after: $after
    last: $last
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
    edges {
      node {
        id
        pi {
          code
          paymentTerm
          soldTo {
            name
            code
          }
          shipToCountry
        }
        eoNo
        poNo
        shipTo
        incoterm
        statusSap
        status
        salesOrganization {
          name
          code
          businessUnit {
            name
          }
        }
        createdAt
      }
    }
    totalCount
    latestPageItemNumber
  }
}
    `;

/**
 * __useExportOrdersQuery__
 *
 * To run a query within a React component, call `useExportOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportOrdersQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useExportOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ExportOrdersQuery, Types.ExportOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportOrdersQuery, Types.ExportOrdersQueryVariables>(ExportOrdersDocument, options);
      }
export function useExportOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportOrdersQuery, Types.ExportOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportOrdersQuery, Types.ExportOrdersQueryVariables>(ExportOrdersDocument, options);
        }
export type ExportOrdersQueryHookResult = ReturnType<typeof useExportOrdersQuery>;
export type ExportOrdersLazyQueryHookResult = ReturnType<typeof useExportOrdersLazyQuery>;
export type ExportOrdersQueryResult = Apollo.QueryResult<Types.ExportOrdersQuery, Types.ExportOrdersQueryVariables>;
export const ExportOrderWithAllItemsDocument = gql`
    query ExportOrderWithAllItems($orderId: ID!) {
  exportOrderWithAllItems(orderId: $orderId) {
    id
    paymentTerm
    eoNo
    soNo
    contractType
    soldToAddress
    taxPercent
    pi {
      id
      placeOfDelivery
      currency
      shipTo
      billTo
      paymentTerm
      etd
      eta
      soldTo {
        id
        displayText
        addressText
        code
        __typename
      }
      code
      poNo
      incoterm
      salesOrganization {
        id
        code
        name
        __typename
      }
      distributionChannel {
        id
        code
        name
        __typename
      }
      division {
        id
        code
        name
        __typename
      }
      salesOffice {
        id
        code
        name
        __typename
      }
      salesGroup {
        id
        code
        name
        __typename
      }
      __typename
    }
    orderType
    salesOrganization {
      code
      name
      id
      __typename
    }
    distributionChannel {
      code
      name
      id
      __typename
    }
    division {
      code
      name
      id
      __typename
    }
    salesOffice {
      code
      name
      id
      __typename
    }
    salesGroup {
      code
      name
      id
      __typename
    }
    poDate
    poNo
    requestDate
    refPiNo
    netPrice
    docCurrency
    usage
    unloadingPoint
    placeOfDelivery
    portOfDischarge
    portOfLoading
    noOfContainers
    shippingMark
    uom
    gwUom
    etd
    eta
    dlcNo
    dlcExpiryDate
    dlcLatestDeliveryDate
    description
    payer
    endCustomer
    contactPerson
    salesEmployee
    author
    taxAmount
    netPrice
    totalPrice
    shipTo
    billTo
    paymentInstruction
    remark
    productionInformation
    internalCommentToWarehouse
    lines {
      id
      itemNo
      materialCode
      materialDescription
      isMaterialOutsource
      piProduct {
        id
        materialCode
        pricePerUnit
        matGroup1
        product {
          materialGroup
          widthOfRoll
          lengthOfRoll
          id
          name
          slug: materialCode
          salesUnit
          __typename
        }
        currency
        remainingQuantity
        remainingQuantityEx
        limitQuantity
        weight
        weightUnit
        calculation
        __typename
      }
      quantity
      quantityUnit
      weight
      weightUnit
      salesUnit
      itemCatEo
      plant
      refPiNo
      requestDate
      confirmedDate
      rejectReason
      conditionGroup1
      route
      rollQuantity
      rollDiameter
      rollCoreDiameter
      remark
      palletSize
      palletNo
      rollPerPallet
      packageQuantity
      packingList
      commissionPercent
      commissionAmount
      commissionUnit
      shippingPoint
      deliveryTolOver
      deliveryTolUnder
      deliveryTolUnlimited
      materialGroup2
      inquiryMethod
      __typename
    }
    status
    __typename
  }
}
    `;

/**
 * __useExportOrderWithAllItemsQuery__
 *
 * To run a query within a React component, call `useExportOrderWithAllItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportOrderWithAllItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportOrderWithAllItemsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useExportOrderWithAllItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ExportOrderWithAllItemsQuery, Types.ExportOrderWithAllItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportOrderWithAllItemsQuery, Types.ExportOrderWithAllItemsQueryVariables>(ExportOrderWithAllItemsDocument, options);
      }
export function useExportOrderWithAllItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportOrderWithAllItemsQuery, Types.ExportOrderWithAllItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportOrderWithAllItemsQuery, Types.ExportOrderWithAllItemsQueryVariables>(ExportOrderWithAllItemsDocument, options);
        }
export type ExportOrderWithAllItemsQueryHookResult = ReturnType<typeof useExportOrderWithAllItemsQuery>;
export type ExportOrderWithAllItemsLazyQueryHookResult = ReturnType<typeof useExportOrderWithAllItemsLazyQuery>;
export type ExportOrderWithAllItemsQueryResult = Apollo.QueryResult<Types.ExportOrderWithAllItemsQuery, Types.ExportOrderWithAllItemsQueryVariables>;
export const ContractExportOrderAllItemBySoNoDocument = gql`
    query contractExportOrderAllItemBySoNo($soNo: String!) {
  exportOrderWithAllItemsBySoNo(soNo: $soNo) {
    orderStatus
    poDate
    eoNo
    contractNo
    taxPercent
    orderType
    salesOrg
    distributionChannel
    division
    salesOff
    salesGroup
    poNo
    requestDate
    docCurrency
    paymentTerms
    incoterms1
    incoterms2
    refPiNo
    orderAmtBeforeVat
    orderAmtVat
    orderAmtAfterVat
    originalRequestDate
    description
    usage
    unloadingPoint
    orderPartners {
      payerName
      partnerRole
      partnerNo
      addrLink
      address {
        name
        addrNo
        city
        postCode
        district
        street
        transpzone
        country
        nameForPartners
        strSuppl1
        strSuppl2
        strSuppl3
        location
      }
      itemNo
    }
    orderItems {
      allowChangeInquiryMethod
      id
      itemNo
      itemRemain
      remainingQuantity
      remainingQuantityEx
      poDate
      reasonReject
      confirmedDate
      material
      materialDesc
      itemQty
      salesUnit
      plant
      paymentTerm
      poNumber
      itemCategory
      materialGroup1
      saleText1Th
      routeId
      routeName
      requestedDate
      untimatedTol
      weightPerUnit
      orderQty
      comfirmQty
      deliveryQty
      deliveryStatus
      saleQtyDivision
      saleQtyFactor
      prdHierachy
      shippingPoint
      contractNo
      contractItemNo
      atp
      atpDetails
      block
      run
      paperMachine
      refPiStock
      conditionGroup1
      inquiryMethod
      overDeliveryTol
      underDeliveryTol
      deliveryTolOver
      deliveryTolUnder
      deliveryTolUnlimited
      flagR5
      isMaterialOutsource
      itemProductionState
      assignQuantity
      itemStatusEn
      orderType
      originalRequestDate
      poSubcontract
      poStatus
    }
    orderCondition {
      itemNo
      conditionType
      conditionRate
      currency
      conditionUnit
      conditionPriceUnit
      conditionPriceOrder
      conditionBaseValue
    }
    orderText {
      itemNo
      textId
      language
      textLine {
        text
      }
    }
    fixedItemNo
  }
}
    `;

/**
 * __useContractExportOrderAllItemBySoNoQuery__
 *
 * To run a query within a React component, call `useContractExportOrderAllItemBySoNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractExportOrderAllItemBySoNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractExportOrderAllItemBySoNoQuery({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useContractExportOrderAllItemBySoNoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractExportOrderAllItemBySoNoQuery, Types.ContractExportOrderAllItemBySoNoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractExportOrderAllItemBySoNoQuery, Types.ContractExportOrderAllItemBySoNoQueryVariables>(ContractExportOrderAllItemBySoNoDocument, options);
      }
export function useContractExportOrderAllItemBySoNoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractExportOrderAllItemBySoNoQuery, Types.ContractExportOrderAllItemBySoNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractExportOrderAllItemBySoNoQuery, Types.ContractExportOrderAllItemBySoNoQueryVariables>(ContractExportOrderAllItemBySoNoDocument, options);
        }
export type ContractExportOrderAllItemBySoNoQueryHookResult = ReturnType<typeof useContractExportOrderAllItemBySoNoQuery>;
export type ContractExportOrderAllItemBySoNoLazyQueryHookResult = ReturnType<typeof useContractExportOrderAllItemBySoNoLazyQuery>;
export type ContractExportOrderAllItemBySoNoQueryResult = Apollo.QueryResult<Types.ContractExportOrderAllItemBySoNoQuery, Types.ContractExportOrderAllItemBySoNoQueryVariables>;
export const ExportPiGetAllProductsDocument = gql`
    query exportPiGetAllProducts($id: ID!) {
  exportPi(id: $id) {
    id
    code
    soldTo {
      id
      code
      name
    }
    soldToName
    poNo
    incoterm
    paymentTerm
    shipToCountry
    shipToName
    allPiProducts {
      id
      itemNo
      product {
        id
        name
        slug
      }
      weight
      quantityUnit
      totalQuantity
      remainingQuantity
      weightUnit
      salesUnit
      pricePerUnit
      currency
      calculation
      limitQuantity
      limitQuantityOrderLine
      cartQuantity
      remainingQuantityEx
    }
  }
}
    `;

/**
 * __useExportPiGetAllProductsQuery__
 *
 * To run a query within a React component, call `useExportPiGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPiGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPiGetAllProductsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportPiGetAllProductsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ExportPiGetAllProductsQuery, Types.ExportPiGetAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportPiGetAllProductsQuery, Types.ExportPiGetAllProductsQueryVariables>(ExportPiGetAllProductsDocument, options);
      }
export function useExportPiGetAllProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportPiGetAllProductsQuery, Types.ExportPiGetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportPiGetAllProductsQuery, Types.ExportPiGetAllProductsQueryVariables>(ExportPiGetAllProductsDocument, options);
        }
export type ExportPiGetAllProductsQueryHookResult = ReturnType<typeof useExportPiGetAllProductsQuery>;
export type ExportPiGetAllProductsLazyQueryHookResult = ReturnType<typeof useExportPiGetAllProductsLazyQuery>;
export type ExportPiGetAllProductsQueryResult = Apollo.QueryResult<Types.ExportPiGetAllProductsQuery, Types.ExportPiGetAllProductsQueryVariables>;
export const ScgpMeDocument = gql`
    query scgpMe {
  scgpMe {
    id
    extendData {
      defaultBusinessUnit {
        id
        name
        __typename
      }
      defaultSalesOrganizations {
        name
        code
        __typename
      }
      scgpBus {
        code
        name
        __typename
      }
      scgpSalesOrganizations {
        code
        name
        __typename
      }
      scgpSalesOrganizationsAll {
        code
        name
        __typename
      }
      scgpSalesGroups {
        code
        name
        __typename
      }
      salesOrgByBuAndUser {
        businessUnit
        salesOrganizations {
          code
          name
          shortName
        }
      }
      salesOrgByBu {
        businessUnit
        salesOrganizations {
          code
          name
          shortName
        }
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useScgpMeQuery__
 *
 * To run a query within a React component, call `useScgpMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useScgpMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScgpMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useScgpMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ScgpMeQuery, Types.ScgpMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ScgpMeQuery, Types.ScgpMeQueryVariables>(ScgpMeDocument, options);
      }
export function useScgpMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ScgpMeQuery, Types.ScgpMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ScgpMeQuery, Types.ScgpMeQueryVariables>(ScgpMeDocument, options);
        }
export type ScgpMeQueryHookResult = ReturnType<typeof useScgpMeQuery>;
export type ScgpMeLazyQueryHookResult = ReturnType<typeof useScgpMeLazyQuery>;
export type ScgpMeQueryResult = Apollo.QueryResult<Types.ScgpMeQuery, Types.ScgpMeQueryVariables>;
export const ShopInfoDocument = gql`
    query ShopInfo {
  shop {
    countries {
      ...CountryWithCode
    }
    defaultCountry {
      ...CountryWithCode
    }
    defaultWeightUnit
    displayGrossPrices
    domain {
      host
      url
    }
    languages {
      ...Language
    }
    includeTaxesInPrices
    name
    trackInventoryByDefault
    permissions {
      code
      name
    }
    version
  }
}
    ${CountryWithCodeFragmentDoc}
${LanguageFragmentDoc}`;

/**
 * __useShopInfoQuery__
 *
 * To run a query within a React component, call `useShopInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ShopInfoQuery, Types.ShopInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ShopInfoQuery, Types.ShopInfoQueryVariables>(ShopInfoDocument, options);
      }
export function useShopInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ShopInfoQuery, Types.ShopInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ShopInfoQuery, Types.ShopInfoQueryVariables>(ShopInfoDocument, options);
        }
export type ShopInfoQueryHookResult = ReturnType<typeof useShopInfoQuery>;
export type ShopInfoLazyQueryHookResult = ReturnType<typeof useShopInfoLazyQuery>;
export type ShopInfoQueryResult = Apollo.QueryResult<Types.ShopInfoQuery, Types.ShopInfoQueryVariables>;
export const ShopCountriesDocument = gql`
    query ShopCountries($filter: CountryFilterInput) {
  shop {
    countries(filter: $filter) {
      code
      country
    }
  }
}
    `;

/**
 * __useShopCountriesQuery__
 *
 * To run a query within a React component, call `useShopCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopCountriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useShopCountriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ShopCountriesQuery, Types.ShopCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ShopCountriesQuery, Types.ShopCountriesQueryVariables>(ShopCountriesDocument, options);
      }
export function useShopCountriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ShopCountriesQuery, Types.ShopCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ShopCountriesQuery, Types.ShopCountriesQueryVariables>(ShopCountriesDocument, options);
        }
export type ShopCountriesQueryHookResult = ReturnType<typeof useShopCountriesQuery>;
export type ShopCountriesLazyQueryHookResult = ReturnType<typeof useShopCountriesLazyQuery>;
export type ShopCountriesQueryResult = Apollo.QueryResult<Types.ShopCountriesQuery, Types.ShopCountriesQueryVariables>;
export const RefreshLimitsDocument = gql`
    query RefreshLimits($channels: Boolean!, $orders: Boolean!, $productVariants: Boolean!, $staffUsers: Boolean!, $warehouses: Boolean!) {
  shop {
    ...ShopLimit
  }
}
    ${ShopLimitFragmentDoc}`;

/**
 * __useRefreshLimitsQuery__
 *
 * To run a query within a React component, call `useRefreshLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefreshLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefreshLimitsQuery({
 *   variables: {
 *      channels: // value for 'channels'
 *      orders: // value for 'orders'
 *      productVariants: // value for 'productVariants'
 *      staffUsers: // value for 'staffUsers'
 *      warehouses: // value for 'warehouses'
 *   },
 * });
 */
export function useRefreshLimitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RefreshLimitsQuery, Types.RefreshLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RefreshLimitsQuery, Types.RefreshLimitsQueryVariables>(RefreshLimitsDocument, options);
      }
export function useRefreshLimitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RefreshLimitsQuery, Types.RefreshLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RefreshLimitsQuery, Types.RefreshLimitsQueryVariables>(RefreshLimitsDocument, options);
        }
export type RefreshLimitsQueryHookResult = ReturnType<typeof useRefreshLimitsQuery>;
export type RefreshLimitsLazyQueryHookResult = ReturnType<typeof useRefreshLimitsLazyQuery>;
export type RefreshLimitsQueryResult = Apollo.QueryResult<Types.RefreshLimitsQuery, Types.RefreshLimitsQueryVariables>;
export const AddOrderLineDocument = gql`
    mutation addOrderLine($id: ID, $orderId: String!, $materialCode: String!, $totalItems: Int) {
  addOrderLine(
    id: $id
    orderId: $orderId
    materialCode: $materialCode
    totalItems: $totalItems
  ) {
    errors {
      message
      code
    }
    itemNoUpdated
    orderLines {
      id
      materialCode
      materialDescription
      materialType
      quantity
      bomUnitQuantity
      customerMatCode
      plant
      requestDate
      paymentTermItem
      productionFlag
      itemNo
      priceCurrency
      weight
      salesUnit
      weightUnit
      overDeliveryTol
      underDeliveryTol
      prcGroup1
      bomFlag
      parentId
      parentItemNo
      salesUnitList {
        toUnit
        fromUnit
        calculation
        __typename
      }
      batchFlag
      shipTo
      internalCommentsToWarehouse
      externalCommentsToCustomer
      saleText1
      saleText2
      saleText3
      saleText4
      remark
      itemNote
      prItemText
      lotNo
      productionMemo
    }
  }
}
    `;
export type AddOrderLineMutationFn = Apollo.MutationFunction<Types.AddOrderLineMutation, Types.AddOrderLineMutationVariables>;

/**
 * __useAddOrderLineMutation__
 *
 * To run a mutation, you first call `useAddOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrderLineMutation, { data, loading, error }] = useAddOrderLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orderId: // value for 'orderId'
 *      materialCode: // value for 'materialCode'
 *      totalItems: // value for 'totalItems'
 *   },
 * });
 */
export function useAddOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddOrderLineMutation, Types.AddOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddOrderLineMutation, Types.AddOrderLineMutationVariables>(AddOrderLineDocument, options);
      }
export type AddOrderLineMutationHookResult = ReturnType<typeof useAddOrderLineMutation>;
export type AddOrderLineMutationResult = Apollo.MutationResult<Types.AddOrderLineMutation>;
export type AddOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.AddOrderLineMutation, Types.AddOrderLineMutationVariables>;
export const DeleteOrderLinesDocument = gql`
    mutation deleteOrderLines($ids: [ID]!, $totalItems: Int) {
  deleteOrderLines(ids: $ids, totalItems: $totalItems) {
    errors {
      code
      field
      message
    }
  }
}
    `;
export type DeleteOrderLinesMutationFn = Apollo.MutationFunction<Types.DeleteOrderLinesMutation, Types.DeleteOrderLinesMutationVariables>;

/**
 * __useDeleteOrderLinesMutation__
 *
 * To run a mutation, you first call `useDeleteOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderLinesMutation, { data, loading, error }] = useDeleteOrderLinesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      totalItems: // value for 'totalItems'
 *   },
 * });
 */
export function useDeleteOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteOrderLinesMutation, Types.DeleteOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteOrderLinesMutation, Types.DeleteOrderLinesMutationVariables>(DeleteOrderLinesDocument, options);
      }
export type DeleteOrderLinesMutationHookResult = ReturnType<typeof useDeleteOrderLinesMutation>;
export type DeleteOrderLinesMutationResult = Apollo.MutationResult<Types.DeleteOrderLinesMutation>;
export type DeleteOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderLinesMutation, Types.DeleteOrderLinesMutationVariables>;
export const UpdateCipOrderDocument = gql`
    mutation updateCipOrder($id: ID!, $input: CipOrderUpdateInput!) {
  updateCipOrder(id: $id, input: $input) {
    order {
      id
    }
    success
    cpItemMessages {
      itemNo
      materialCode
      materialDescription
      quantity
      requestDate
      confirmDate
      originalDate
      bomFlag
      plant
      parentItemNo
      parentBom
      showInPopup
    }
    cpErrorMessages {
      id
      itemNo
      errorMessage
      errorCode
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      field
      message
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
    eorWarnings {
      message
      order
      source
    }
  }
}
    `;
export type UpdateCipOrderMutationFn = Apollo.MutationFunction<Types.UpdateCipOrderMutation, Types.UpdateCipOrderMutationVariables>;

/**
 * __useUpdateCipOrderMutation__
 *
 * To run a mutation, you first call `useUpdateCipOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCipOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCipOrderMutation, { data, loading, error }] = useUpdateCipOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCipOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateCipOrderMutation, Types.UpdateCipOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateCipOrderMutation, Types.UpdateCipOrderMutationVariables>(UpdateCipOrderDocument, options);
      }
export type UpdateCipOrderMutationHookResult = ReturnType<typeof useUpdateCipOrderMutation>;
export type UpdateCipOrderMutationResult = Apollo.MutationResult<Types.UpdateCipOrderMutation>;
export type UpdateCipOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCipOrderMutation, Types.UpdateCipOrderMutationVariables>;
export const CancelCipOrderDocument = gql`
    mutation cancelCipOrder($orderLines: [CancelDeleteCipOrderLinesInput], $soNo: String!) {
  cancelCipOrder(soNo: $soNo, orderLines: $orderLines) {
    status
    errors {
      message
      code
      field
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      errorCode
      itemNo
      errorMessage
    }
  }
}
    `;
export type CancelCipOrderMutationFn = Apollo.MutationFunction<Types.CancelCipOrderMutation, Types.CancelCipOrderMutationVariables>;

/**
 * __useCancelCipOrderMutation__
 *
 * To run a mutation, you first call `useCancelCipOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCipOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCipOrderMutation, { data, loading, error }] = useCancelCipOrderMutation({
 *   variables: {
 *      orderLines: // value for 'orderLines'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useCancelCipOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelCipOrderMutation, Types.CancelCipOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelCipOrderMutation, Types.CancelCipOrderMutationVariables>(CancelCipOrderDocument, options);
      }
export type CancelCipOrderMutationHookResult = ReturnType<typeof useCancelCipOrderMutation>;
export type CancelCipOrderMutationResult = Apollo.MutationResult<Types.CancelCipOrderMutation>;
export type CancelCipOrderMutationOptions = Apollo.BaseMutationOptions<Types.CancelCipOrderMutation, Types.CancelCipOrderMutationVariables>;
export const CipChangeOrderUpdateDocument = gql`
    mutation cipChangeOrderUpdate($input: CipChangeOrderEditInput!) {
  cipChangeOrderUpdate(input: $input) {
    order {
      id
    }
    success
    cpItemMessages {
      itemNo
      materialCode
      materialDescription
      quantity
      requestDate
      confirmDate
      originalDate
      bomFlag
      plant
      parentItemNo
      parentBom
      showInPopup
    }
    cpErrorMessages {
      id
      itemNo
      errorMessage
      errorCode
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      field
      message
      code
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
  }
}
    `;
export type CipChangeOrderUpdateMutationFn = Apollo.MutationFunction<Types.CipChangeOrderUpdateMutation, Types.CipChangeOrderUpdateMutationVariables>;

/**
 * __useCipChangeOrderUpdateMutation__
 *
 * To run a mutation, you first call `useCipChangeOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCipChangeOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cipChangeOrderUpdateMutation, { data, loading, error }] = useCipChangeOrderUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCipChangeOrderUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CipChangeOrderUpdateMutation, Types.CipChangeOrderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CipChangeOrderUpdateMutation, Types.CipChangeOrderUpdateMutationVariables>(CipChangeOrderUpdateDocument, options);
      }
export type CipChangeOrderUpdateMutationHookResult = ReturnType<typeof useCipChangeOrderUpdateMutation>;
export type CipChangeOrderUpdateMutationResult = Apollo.MutationResult<Types.CipChangeOrderUpdateMutation>;
export type CipChangeOrderUpdateMutationOptions = Apollo.BaseMutationOptions<Types.CipChangeOrderUpdateMutation, Types.CipChangeOrderUpdateMutationVariables>;
export const UndoCancelCipOrderLinesDocument = gql`
    mutation undoCancelCipOrderLines($itemNo: [String]!, $soNo: String!, $totalItems: Int) {
  undoCancelCipOrderLines(itemNo: $itemNo, soNo: $soNo, totalItems: $totalItems) {
    success
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
    errors {
      code
      message
    }
  }
}
    `;
export type UndoCancelCipOrderLinesMutationFn = Apollo.MutationFunction<Types.UndoCancelCipOrderLinesMutation, Types.UndoCancelCipOrderLinesMutationVariables>;

/**
 * __useUndoCancelCipOrderLinesMutation__
 *
 * To run a mutation, you first call `useUndoCancelCipOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoCancelCipOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoCancelCipOrderLinesMutation, { data, loading, error }] = useUndoCancelCipOrderLinesMutation({
 *   variables: {
 *      itemNo: // value for 'itemNo'
 *      soNo: // value for 'soNo'
 *      totalItems: // value for 'totalItems'
 *   },
 * });
 */
export function useUndoCancelCipOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UndoCancelCipOrderLinesMutation, Types.UndoCancelCipOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UndoCancelCipOrderLinesMutation, Types.UndoCancelCipOrderLinesMutationVariables>(UndoCancelCipOrderLinesDocument, options);
      }
export type UndoCancelCipOrderLinesMutationHookResult = ReturnType<typeof useUndoCancelCipOrderLinesMutation>;
export type UndoCancelCipOrderLinesMutationResult = Apollo.MutationResult<Types.UndoCancelCipOrderLinesMutation>;
export type UndoCancelCipOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.UndoCancelCipOrderLinesMutation, Types.UndoCancelCipOrderLinesMutationVariables>;
export const CipChangeOrderAddNewOrderLineDocument = gql`
    mutation cipChangeOrderAddNewOrderLine($input: CipChangeOrderEditInput!) {
  cipChangeOrderAddNewOrderLine(input: $input) {
    order {
      id
    }
    success
    cpItemMessages {
      itemNo
      materialCode
      materialDescription
      quantity
      requestDate
      confirmDate
      originalDate
      bomFlag
      plant
      parentItemNo
      parentBom
      showInPopup
    }
    cpErrorMessages {
      id
      itemNo
      errorMessage
      errorCode
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      field
      message
      code
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
  }
}
    `;
export type CipChangeOrderAddNewOrderLineMutationFn = Apollo.MutationFunction<Types.CipChangeOrderAddNewOrderLineMutation, Types.CipChangeOrderAddNewOrderLineMutationVariables>;

/**
 * __useCipChangeOrderAddNewOrderLineMutation__
 *
 * To run a mutation, you first call `useCipChangeOrderAddNewOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCipChangeOrderAddNewOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cipChangeOrderAddNewOrderLineMutation, { data, loading, error }] = useCipChangeOrderAddNewOrderLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCipChangeOrderAddNewOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CipChangeOrderAddNewOrderLineMutation, Types.CipChangeOrderAddNewOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CipChangeOrderAddNewOrderLineMutation, Types.CipChangeOrderAddNewOrderLineMutationVariables>(CipChangeOrderAddNewOrderLineDocument, options);
      }
export type CipChangeOrderAddNewOrderLineMutationHookResult = ReturnType<typeof useCipChangeOrderAddNewOrderLineMutation>;
export type CipChangeOrderAddNewOrderLineMutationResult = Apollo.MutationResult<Types.CipChangeOrderAddNewOrderLineMutation>;
export type CipChangeOrderAddNewOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.CipChangeOrderAddNewOrderLineMutation, Types.CipChangeOrderAddNewOrderLineMutationVariables>;
export const GetSapPriceCalcDocument = gql`
    mutation GetSapPriceCalc($id: ID!, $input: PriceCalculationInput!) {
  getPriceCalculation(id: $id, input: $input) {
    response {
      orderItemsOut {
        itemNo
        materialCode
        materialDescription
        materialType
        manualPriceFlag
        pricePerUnit
        netValue
        currency
        priceStatus
        priceStatusDesc
      }
      orderHeaderOut {
        orderAmountBeforeVat
        orderAmountVat
        orderAmountAfterVat
        currency
      }
    }
    success
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      errorCode
      itemNo
      errorMessage
    }
    errors {
      field
      message
    }
  }
}
    `;
export type GetSapPriceCalcMutationFn = Apollo.MutationFunction<Types.GetSapPriceCalcMutation, Types.GetSapPriceCalcMutationVariables>;

/**
 * __useGetSapPriceCalcMutation__
 *
 * To run a mutation, you first call `useGetSapPriceCalcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetSapPriceCalcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getSapPriceCalcMutation, { data, loading, error }] = useGetSapPriceCalcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSapPriceCalcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.GetSapPriceCalcMutation, Types.GetSapPriceCalcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.GetSapPriceCalcMutation, Types.GetSapPriceCalcMutationVariables>(GetSapPriceCalcDocument, options);
      }
export type GetSapPriceCalcMutationHookResult = ReturnType<typeof useGetSapPriceCalcMutation>;
export type GetSapPriceCalcMutationResult = Apollo.MutationResult<Types.GetSapPriceCalcMutation>;
export type GetSapPriceCalcMutationOptions = Apollo.BaseMutationOptions<Types.GetSapPriceCalcMutation, Types.GetSapPriceCalcMutationVariables>;
export const DownloadOrdersPdfDocument = gql`
    mutation downloadOrdersPdf($soNo: ID!) {
  downloadOrdersPdf(soNo: $soNo) {
    exportedFileBase64
    fileName
    errors {
      field
      message
      code
    }
  }
}
    `;
export type DownloadOrdersPdfMutationFn = Apollo.MutationFunction<Types.DownloadOrdersPdfMutation, Types.DownloadOrdersPdfMutationVariables>;

/**
 * __useDownloadOrdersPdfMutation__
 *
 * To run a mutation, you first call `useDownloadOrdersPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadOrdersPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadOrdersPdfMutation, { data, loading, error }] = useDownloadOrdersPdfMutation({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useDownloadOrdersPdfMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DownloadOrdersPdfMutation, Types.DownloadOrdersPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DownloadOrdersPdfMutation, Types.DownloadOrdersPdfMutationVariables>(DownloadOrdersPdfDocument, options);
      }
export type DownloadOrdersPdfMutationHookResult = ReturnType<typeof useDownloadOrdersPdfMutation>;
export type DownloadOrdersPdfMutationResult = Apollo.MutationResult<Types.DownloadOrdersPdfMutation>;
export type DownloadOrdersPdfMutationOptions = Apollo.BaseMutationOptions<Types.DownloadOrdersPdfMutation, Types.DownloadOrdersPdfMutationVariables>;
export const CpUpdateCreateOrderDocument = gql`
    mutation cpUpdateCreateOrder($input: CpOrderUpdateInput!) {
  cpUpdateCreateOrder(input: $input) {
    order {
      id
    }
    success
    cpItemMessages {
      itemNo
      materialCode
      materialDescription
      quantity
      requestDate
      confirmDate
      originalDate
      bomFlag
      plant
      parentItemNo
      parentBom
      showInPopup
    }
    cpErrorMessages {
      id
      itemNo
      errorMessage
      errorCode
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    errors {
      field
      message
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
  }
}
    `;
export type CpUpdateCreateOrderMutationFn = Apollo.MutationFunction<Types.CpUpdateCreateOrderMutation, Types.CpUpdateCreateOrderMutationVariables>;

/**
 * __useCpUpdateCreateOrderMutation__
 *
 * To run a mutation, you first call `useCpUpdateCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCpUpdateCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cpUpdateCreateOrderMutation, { data, loading, error }] = useCpUpdateCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCpUpdateCreateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CpUpdateCreateOrderMutation, Types.CpUpdateCreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CpUpdateCreateOrderMutation, Types.CpUpdateCreateOrderMutationVariables>(CpUpdateCreateOrderDocument, options);
      }
export type CpUpdateCreateOrderMutationHookResult = ReturnType<typeof useCpUpdateCreateOrderMutation>;
export type CpUpdateCreateOrderMutationResult = Apollo.MutationResult<Types.CpUpdateCreateOrderMutation>;
export type CpUpdateCreateOrderMutationOptions = Apollo.BaseMutationOptions<Types.CpUpdateCreateOrderMutation, Types.CpUpdateCreateOrderMutationVariables>;
export const UpdateOrderLineOtcShipToDocument = gql`
    mutation updateOrderLineOtcShipTo($lineId: ID!, $otcShipTo: CipOrderOtcPartnerInput!) {
  updateOrderLineOtcShipTo(lineId: $lineId, otcShipTo: $otcShipTo) {
    id
  }
}
    `;
export type UpdateOrderLineOtcShipToMutationFn = Apollo.MutationFunction<Types.UpdateOrderLineOtcShipToMutation, Types.UpdateOrderLineOtcShipToMutationVariables>;

/**
 * __useUpdateOrderLineOtcShipToMutation__
 *
 * To run a mutation, you first call `useUpdateOrderLineOtcShipToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderLineOtcShipToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderLineOtcShipToMutation, { data, loading, error }] = useUpdateOrderLineOtcShipToMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *      otcShipTo: // value for 'otcShipTo'
 *   },
 * });
 */
export function useUpdateOrderLineOtcShipToMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateOrderLineOtcShipToMutation, Types.UpdateOrderLineOtcShipToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateOrderLineOtcShipToMutation, Types.UpdateOrderLineOtcShipToMutationVariables>(UpdateOrderLineOtcShipToDocument, options);
      }
export type UpdateOrderLineOtcShipToMutationHookResult = ReturnType<typeof useUpdateOrderLineOtcShipToMutation>;
export type UpdateOrderLineOtcShipToMutationResult = Apollo.MutationResult<Types.UpdateOrderLineOtcShipToMutation>;
export type UpdateOrderLineOtcShipToMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderLineOtcShipToMutation, Types.UpdateOrderLineOtcShipToMutationVariables>;
export const DeleteOrderLineOtcShipToDocument = gql`
    mutation deleteOrderLineOtcShipTo($lineId: ID!) {
  deleteOrderLineOtcShipTo(lineId: $lineId) {
    __typename
  }
}
    `;
export type DeleteOrderLineOtcShipToMutationFn = Apollo.MutationFunction<Types.DeleteOrderLineOtcShipToMutation, Types.DeleteOrderLineOtcShipToMutationVariables>;

/**
 * __useDeleteOrderLineOtcShipToMutation__
 *
 * To run a mutation, you first call `useDeleteOrderLineOtcShipToMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderLineOtcShipToMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderLineOtcShipToMutation, { data, loading, error }] = useDeleteOrderLineOtcShipToMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useDeleteOrderLineOtcShipToMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteOrderLineOtcShipToMutation, Types.DeleteOrderLineOtcShipToMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteOrderLineOtcShipToMutation, Types.DeleteOrderLineOtcShipToMutationVariables>(DeleteOrderLineOtcShipToDocument, options);
      }
export type DeleteOrderLineOtcShipToMutationHookResult = ReturnType<typeof useDeleteOrderLineOtcShipToMutation>;
export type DeleteOrderLineOtcShipToMutationResult = Apollo.MutationResult<Types.DeleteOrderLineOtcShipToMutation>;
export type DeleteOrderLineOtcShipToMutationOptions = Apollo.BaseMutationOptions<Types.DeleteOrderLineOtcShipToMutation, Types.DeleteOrderLineOtcShipToMutationVariables>;
export const AddCipSplitOrderDocument = gql`
    mutation addCipSplitOrder($soNo: String!, $isBom: Boolean!, $originLineItems: [SplitCipOrderLineInput!], $splitLineItems: [SplitCipOrderLineInput!], $totalItems: Int) {
  addCipSplitOrderLine(
    isBom: $isBom
    soNo: $soNo
    originLineItems: $originLineItems
    splitLineItems: $splitLineItems
    totalItems: $totalItems
  ) {
    success
    cpItemMessages {
      itemNo
      materialCode
      materialDescription
      quantity
      requestDate
      confirmDate
      originalDate
      bomFlag
      plant
      parentItemNo
      parentBom
      showInPopup
    }
    cpErrorMessages {
      id
      itemNo
      errorMessage
      errorCode
    }
    errors {
      field
      message
      code
    }
    sapOrderMessages {
      soNo
      errorCode
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorMessage
      errorCode
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
  }
}
    `;
export type AddCipSplitOrderMutationFn = Apollo.MutationFunction<Types.AddCipSplitOrderMutation, Types.AddCipSplitOrderMutationVariables>;

/**
 * __useAddCipSplitOrderMutation__
 *
 * To run a mutation, you first call `useAddCipSplitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCipSplitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCipSplitOrderMutation, { data, loading, error }] = useAddCipSplitOrderMutation({
 *   variables: {
 *      soNo: // value for 'soNo'
 *      isBom: // value for 'isBom'
 *      originLineItems: // value for 'originLineItems'
 *      splitLineItems: // value for 'splitLineItems'
 *      totalItems: // value for 'totalItems'
 *   },
 * });
 */
export function useAddCipSplitOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddCipSplitOrderMutation, Types.AddCipSplitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddCipSplitOrderMutation, Types.AddCipSplitOrderMutationVariables>(AddCipSplitOrderDocument, options);
      }
export type AddCipSplitOrderMutationHookResult = ReturnType<typeof useAddCipSplitOrderMutation>;
export type AddCipSplitOrderMutationResult = Apollo.MutationResult<Types.AddCipSplitOrderMutation>;
export type AddCipSplitOrderMutationOptions = Apollo.BaseMutationOptions<Types.AddCipSplitOrderMutation, Types.AddCipSplitOrderMutationVariables>;
export const SendEmailFromChangeOrderDocument = gql`
    mutation sendEmailFromChangeOrder($cc: String!, $content: String!, $subject: String!, $to: String!, $soNo: String!) {
  sendEmailFromChangeOrder(
    to: $to
    cc: $cc
    subject: $subject
    content: $content
    soNo: $soNo
  ) {
    status
    errors {
      message
      code
      field
    }
  }
}
    `;
export type SendEmailFromChangeOrderMutationFn = Apollo.MutationFunction<Types.SendEmailFromChangeOrderMutation, Types.SendEmailFromChangeOrderMutationVariables>;

/**
 * __useSendEmailFromChangeOrderMutation__
 *
 * To run a mutation, you first call `useSendEmailFromChangeOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailFromChangeOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailFromChangeOrderMutation, { data, loading, error }] = useSendEmailFromChangeOrderMutation({
 *   variables: {
 *      cc: // value for 'cc'
 *      content: // value for 'content'
 *      subject: // value for 'subject'
 *      to: // value for 'to'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useSendEmailFromChangeOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SendEmailFromChangeOrderMutation, Types.SendEmailFromChangeOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SendEmailFromChangeOrderMutation, Types.SendEmailFromChangeOrderMutationVariables>(SendEmailFromChangeOrderDocument, options);
      }
export type SendEmailFromChangeOrderMutationHookResult = ReturnType<typeof useSendEmailFromChangeOrderMutation>;
export type SendEmailFromChangeOrderMutationResult = Apollo.MutationResult<Types.SendEmailFromChangeOrderMutation>;
export type SendEmailFromChangeOrderMutationOptions = Apollo.BaseMutationOptions<Types.SendEmailFromChangeOrderMutation, Types.SendEmailFromChangeOrderMutationVariables>;
export const DuplicateOrderCipDocument = gql`
    mutation DuplicateOrderCip($soNo: ID!) {
  duplicateOrderCip(soNo: $soNo) {
    errors {
      field
      message
      code
    }
    order {
      id
    }
  }
}
    `;
export type DuplicateOrderCipMutationFn = Apollo.MutationFunction<Types.DuplicateOrderCipMutation, Types.DuplicateOrderCipMutationVariables>;

/**
 * __useDuplicateOrderCipMutation__
 *
 * To run a mutation, you first call `useDuplicateOrderCipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateOrderCipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateOrderCipMutation, { data, loading, error }] = useDuplicateOrderCipMutation({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useDuplicateOrderCipMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DuplicateOrderCipMutation, Types.DuplicateOrderCipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DuplicateOrderCipMutation, Types.DuplicateOrderCipMutationVariables>(DuplicateOrderCipDocument, options);
      }
export type DuplicateOrderCipMutationHookResult = ReturnType<typeof useDuplicateOrderCipMutation>;
export type DuplicateOrderCipMutationResult = Apollo.MutationResult<Types.DuplicateOrderCipMutation>;
export type DuplicateOrderCipMutationOptions = Apollo.BaseMutationOptions<Types.DuplicateOrderCipMutation, Types.DuplicateOrderCipMutationVariables>;
export const AddCipSplitOrderAfterCpDocument = gql`
    mutation addCipSplitOrderAfterCp($soNo: String!, $isBom: Boolean!, $originLineItems: [SplitCipOrderLineInputAfterCp!], $splitLineItems: [SplitCipOrderLineInputAfterCp!]) {
  addCipSplitOrderLineAfterCp(
    isBom: $isBom
    soNo: $soNo
    originLineItems: $originLineItems
    splitLineItems: $splitLineItems
  ) {
    success
    cpItemMessages {
      itemNo
      materialCode
      materialDescription
      quantity
      requestDate
      confirmDate
      originalDate
      bomFlag
      plant
      parentItemNo
      parentBom
      showInPopup
    }
    cpErrorMessages {
      id
      itemNo
      errorMessage
      errorCode
    }
    errors {
      field
      message
      code
    }
    sapOrderMessages {
      soNo
      errorCode
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorMessage
      errorCode
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
  }
}
    `;
export type AddCipSplitOrderAfterCpMutationFn = Apollo.MutationFunction<Types.AddCipSplitOrderAfterCpMutation, Types.AddCipSplitOrderAfterCpMutationVariables>;

/**
 * __useAddCipSplitOrderAfterCpMutation__
 *
 * To run a mutation, you first call `useAddCipSplitOrderAfterCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCipSplitOrderAfterCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCipSplitOrderAfterCpMutation, { data, loading, error }] = useAddCipSplitOrderAfterCpMutation({
 *   variables: {
 *      soNo: // value for 'soNo'
 *      isBom: // value for 'isBom'
 *      originLineItems: // value for 'originLineItems'
 *      splitLineItems: // value for 'splitLineItems'
 *   },
 * });
 */
export function useAddCipSplitOrderAfterCpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddCipSplitOrderAfterCpMutation, Types.AddCipSplitOrderAfterCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddCipSplitOrderAfterCpMutation, Types.AddCipSplitOrderAfterCpMutationVariables>(AddCipSplitOrderAfterCpDocument, options);
      }
export type AddCipSplitOrderAfterCpMutationHookResult = ReturnType<typeof useAddCipSplitOrderAfterCpMutation>;
export type AddCipSplitOrderAfterCpMutationResult = Apollo.MutationResult<Types.AddCipSplitOrderAfterCpMutation>;
export type AddCipSplitOrderAfterCpMutationOptions = Apollo.BaseMutationOptions<Types.AddCipSplitOrderAfterCpMutation, Types.AddCipSplitOrderAfterCpMutationVariables>;
export const CancelDeleteCipOrderLinesDocument = gql`
    mutation cancelDeleteCipOrderLines($orderLines: [CancelDeleteCipOrderLinesInput], $soNo: String!, $totalItems: Int) {
  cancelDeleteCipOrderLines(
    soNo: $soNo
    orderLines: $orderLines
    totalItems: $totalItems
  ) {
    status
    errors {
      message
      code
      field
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      itemNo
      errorCode
      errorMessage
    }
    warningMessages {
      message
      order
      source
      itemNo
    }
  }
}
    `;
export type CancelDeleteCipOrderLinesMutationFn = Apollo.MutationFunction<Types.CancelDeleteCipOrderLinesMutation, Types.CancelDeleteCipOrderLinesMutationVariables>;

/**
 * __useCancelDeleteCipOrderLinesMutation__
 *
 * To run a mutation, you first call `useCancelDeleteCipOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeleteCipOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeleteCipOrderLinesMutation, { data, loading, error }] = useCancelDeleteCipOrderLinesMutation({
 *   variables: {
 *      orderLines: // value for 'orderLines'
 *      soNo: // value for 'soNo'
 *      totalItems: // value for 'totalItems'
 *   },
 * });
 */
export function useCancelDeleteCipOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CancelDeleteCipOrderLinesMutation, Types.CancelDeleteCipOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CancelDeleteCipOrderLinesMutation, Types.CancelDeleteCipOrderLinesMutationVariables>(CancelDeleteCipOrderLinesDocument, options);
      }
export type CancelDeleteCipOrderLinesMutationHookResult = ReturnType<typeof useCancelDeleteCipOrderLinesMutation>;
export type CancelDeleteCipOrderLinesMutationResult = Apollo.MutationResult<Types.CancelDeleteCipOrderLinesMutation>;
export type CancelDeleteCipOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.CancelDeleteCipOrderLinesMutation, Types.CancelDeleteCipOrderLinesMutationVariables>;
export const SyncCipOrderDocument = gql`
    mutation syncCipOrder($soNo: String!) {
  syncCipOrder(soNo: $soNo) {
    order {
      id
      soNo
      __typename
      orderLines {
        ...syncFieldOrderLines
        __typename
      }
    }
    errors {
      message
      code
      field
      __typename
    }
    sapOrderMessages {
      id
      soNo
      errorMessage
      __typename
    }
    __typename
  }
}
    ${SyncFieldOrderLinesFragmentDoc}`;
export type SyncCipOrderMutationFn = Apollo.MutationFunction<Types.SyncCipOrderMutation, Types.SyncCipOrderMutationVariables>;

/**
 * __useSyncCipOrderMutation__
 *
 * To run a mutation, you first call `useSyncCipOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCipOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCipOrderMutation, { data, loading, error }] = useSyncCipOrderMutation({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useSyncCipOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SyncCipOrderMutation, Types.SyncCipOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SyncCipOrderMutation, Types.SyncCipOrderMutationVariables>(SyncCipOrderDocument, options);
      }
export type SyncCipOrderMutationHookResult = ReturnType<typeof useSyncCipOrderMutation>;
export type SyncCipOrderMutationResult = Apollo.MutationResult<Types.SyncCipOrderMutation>;
export type SyncCipOrderMutationOptions = Apollo.BaseMutationOptions<Types.SyncCipOrderMutation, Types.SyncCipOrderMutationVariables>;
export const SubmitCashSaleDocument = gql`
    mutation SubmitCashSale($input: CashSaleInput!, $files: [CashSaleFileInput]) {
  submitCashSale(input: $input, files: $files) {
    status
    message
    cashSaleStatus
    errors {
      field
      message
      code
      __typename
    }
    __typename
  }
}
    `;
export type SubmitCashSaleMutationFn = Apollo.MutationFunction<Types.SubmitCashSaleMutation, Types.SubmitCashSaleMutationVariables>;

/**
 * __useSubmitCashSaleMutation__
 *
 * To run a mutation, you first call `useSubmitCashSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCashSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCashSaleMutation, { data, loading, error }] = useSubmitCashSaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSubmitCashSaleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SubmitCashSaleMutation, Types.SubmitCashSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SubmitCashSaleMutation, Types.SubmitCashSaleMutationVariables>(SubmitCashSaleDocument, options);
      }
export type SubmitCashSaleMutationHookResult = ReturnType<typeof useSubmitCashSaleMutation>;
export type SubmitCashSaleMutationResult = Apollo.MutationResult<Types.SubmitCashSaleMutation>;
export type SubmitCashSaleMutationOptions = Apollo.BaseMutationOptions<Types.SubmitCashSaleMutation, Types.SubmitCashSaleMutationVariables>;
export const SubmitCashSaleUpdateDocument = gql`
    mutation submitCashSaleUpdate($input: CashSaleInput!, $files: [CashSaleFileInput]) {
  submitCashSaleUpdate(input: $input, files: $files) {
    status
    message
    cashSaleStatus
    errors {
      field
      message
      code
      __typename
    }
    __typename
  }
}
    `;
export type SubmitCashSaleUpdateMutationFn = Apollo.MutationFunction<Types.SubmitCashSaleUpdateMutation, Types.SubmitCashSaleUpdateMutationVariables>;

/**
 * __useSubmitCashSaleUpdateMutation__
 *
 * To run a mutation, you first call `useSubmitCashSaleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCashSaleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCashSaleUpdateMutation, { data, loading, error }] = useSubmitCashSaleUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSubmitCashSaleUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.SubmitCashSaleUpdateMutation, Types.SubmitCashSaleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.SubmitCashSaleUpdateMutation, Types.SubmitCashSaleUpdateMutationVariables>(SubmitCashSaleUpdateDocument, options);
      }
export type SubmitCashSaleUpdateMutationHookResult = ReturnType<typeof useSubmitCashSaleUpdateMutation>;
export type SubmitCashSaleUpdateMutationResult = Apollo.MutationResult<Types.SubmitCashSaleUpdateMutation>;
export type SubmitCashSaleUpdateMutationOptions = Apollo.BaseMutationOptions<Types.SubmitCashSaleUpdateMutation, Types.SubmitCashSaleUpdateMutationVariables>;
export const GetDataSelectSalesTabDocument = gql`
    query getDataSelectSalesTab($saleOrg: String) {
  salesOrganizations {
    id
    name
    shortName
    code
  }
  distributionChannelsDomestic {
    id
    name
    code
  }
  scgDivisions {
    id
    name
    code
  }
  salesOffices(saleOrg: $saleOrg) {
    id
    name
    code
  }
  salesGroups(saleOrg: $saleOrg) {
    id
    name
    code
  }
}
    `;

/**
 * __useGetDataSelectSalesTabQuery__
 *
 * To run a query within a React component, call `useGetDataSelectSalesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSelectSalesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSelectSalesTabQuery({
 *   variables: {
 *      saleOrg: // value for 'saleOrg'
 *   },
 * });
 */
export function useGetDataSelectSalesTabQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetDataSelectSalesTabQuery, Types.GetDataSelectSalesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetDataSelectSalesTabQuery, Types.GetDataSelectSalesTabQueryVariables>(GetDataSelectSalesTabDocument, options);
      }
export function useGetDataSelectSalesTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetDataSelectSalesTabQuery, Types.GetDataSelectSalesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetDataSelectSalesTabQuery, Types.GetDataSelectSalesTabQueryVariables>(GetDataSelectSalesTabDocument, options);
        }
export type GetDataSelectSalesTabQueryHookResult = ReturnType<typeof useGetDataSelectSalesTabQuery>;
export type GetDataSelectSalesTabLazyQueryHookResult = ReturnType<typeof useGetDataSelectSalesTabLazyQuery>;
export type GetDataSelectSalesTabQueryResult = Apollo.QueryResult<Types.GetDataSelectSalesTabQuery, Types.GetDataSelectSalesTabQueryVariables>;
export const GetSalesDataDocument = gql`
    query getSalesData($saleOrg: String, $distributionChannelType: DistributionChannelType!) {
  getSalesData(
    saleOrg: $saleOrg
    distributionChannelType: $distributionChannelType
  ) {
    salesOrganization {
      id
      code
      name
      displayText
    }
    defaultSalesOrganization {
      id
      code
      name
    }
    distributionChannel {
      id
      code
      name
      displayText
    }
    division {
      id
      name
      code
    }
    defaultOtcSoldTo {
      id
      name
      code
      displayText
    }
  }
}
    `;

/**
 * __useGetSalesDataQuery__
 *
 * To run a query within a React component, call `useGetSalesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesDataQuery({
 *   variables: {
 *      saleOrg: // value for 'saleOrg'
 *      distributionChannelType: // value for 'distributionChannelType'
 *   },
 * });
 */
export function useGetSalesDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetSalesDataQuery, Types.GetSalesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetSalesDataQuery, Types.GetSalesDataQueryVariables>(GetSalesDataDocument, options);
      }
export function useGetSalesDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetSalesDataQuery, Types.GetSalesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetSalesDataQuery, Types.GetSalesDataQueryVariables>(GetSalesDataDocument, options);
        }
export type GetSalesDataQueryHookResult = ReturnType<typeof useGetSalesDataQuery>;
export type GetSalesDataLazyQueryHookResult = ReturnType<typeof useGetSalesDataLazyQuery>;
export type GetSalesDataQueryResult = Apollo.QueryResult<Types.GetSalesDataQuery, Types.GetSalesDataQueryVariables>;
export const GetCustomerBlockDocument = gql`
    query getCustomerBlock($input: CustomerBlockInput) {
  getCustomerBlock(input: $input) {
    customerBlock
  }
}
    `;

/**
 * __useGetCustomerBlockQuery__
 *
 * To run a query within a React component, call `useGetCustomerBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBlockQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCustomerBlockQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetCustomerBlockQuery, Types.GetCustomerBlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCustomerBlockQuery, Types.GetCustomerBlockQueryVariables>(GetCustomerBlockDocument, options);
      }
export function useGetCustomerBlockLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCustomerBlockQuery, Types.GetCustomerBlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCustomerBlockQuery, Types.GetCustomerBlockQueryVariables>(GetCustomerBlockDocument, options);
        }
export type GetCustomerBlockQueryHookResult = ReturnType<typeof useGetCustomerBlockQuery>;
export type GetCustomerBlockLazyQueryHookResult = ReturnType<typeof useGetCustomerBlockLazyQuery>;
export type GetCustomerBlockQueryResult = Apollo.QueryResult<Types.GetCustomerBlockQuery, Types.GetCustomerBlockQueryVariables>;
export const SearchSuggestionSoldTosCipDocument = gql`
    query searchSuggestionSoldTosCip($first: Int, $filter: DomesticSoldToFilterInput, $saleOrg: String, $distributionChannel: String, $division: String, $oneTimeCustomer: Boolean) {
  searchSuggestionSoldTosCip(
    first: $first
    filter: $filter
    saleOrg: $saleOrg
    distributionChannel: $distributionChannel
    division: $division
    oneTimeCustomer: $oneTimeCustomer
  ) {
    totalCount
    edges {
      node {
        id
        name
        code
        displayText
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSearchSuggestionSoldTosCipQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionSoldTosCipQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionSoldTosCipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionSoldTosCipQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      saleOrg: // value for 'saleOrg'
 *      distributionChannel: // value for 'distributionChannel'
 *      division: // value for 'division'
 *      oneTimeCustomer: // value for 'oneTimeCustomer'
 *   },
 * });
 */
export function useSearchSuggestionSoldTosCipQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SearchSuggestionSoldTosCipQuery, Types.SearchSuggestionSoldTosCipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchSuggestionSoldTosCipQuery, Types.SearchSuggestionSoldTosCipQueryVariables>(SearchSuggestionSoldTosCipDocument, options);
      }
export function useSearchSuggestionSoldTosCipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchSuggestionSoldTosCipQuery, Types.SearchSuggestionSoldTosCipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchSuggestionSoldTosCipQuery, Types.SearchSuggestionSoldTosCipQueryVariables>(SearchSuggestionSoldTosCipDocument, options);
        }
export type SearchSuggestionSoldTosCipQueryHookResult = ReturnType<typeof useSearchSuggestionSoldTosCipQuery>;
export type SearchSuggestionSoldTosCipLazyQueryHookResult = ReturnType<typeof useSearchSuggestionSoldTosCipLazyQuery>;
export type SearchSuggestionSoldTosCipQueryResult = Apollo.QueryResult<Types.SearchSuggestionSoldTosCipQuery, Types.SearchSuggestionSoldTosCipQueryVariables>;
export const PmtMatSearchDocument = gql`
    query pmtMatSearch($filter: PmtMatSearchInput, $saleOrg: String!) {
  pmtMatSearch(filter: $filter, saleOrg: $saleOrg) {
    stockFg
    stockQa
    stockWip
    hold
    custName
    custId
    custCode
    pc
    materialNo
    partNo
    description
    saleText
    rate
    flute
    board
    width
    length
    height
    vendorName
    netPrice
    purTxt
    remark
    weightBox
    plant
    saleOrg
    lastUpdate
  }
}
    `;

/**
 * __usePmtMatSearchQuery__
 *
 * To run a query within a React component, call `usePmtMatSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePmtMatSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePmtMatSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      saleOrg: // value for 'saleOrg'
 *   },
 * });
 */
export function usePmtMatSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PmtMatSearchQuery, Types.PmtMatSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PmtMatSearchQuery, Types.PmtMatSearchQueryVariables>(PmtMatSearchDocument, options);
      }
export function usePmtMatSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PmtMatSearchQuery, Types.PmtMatSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PmtMatSearchQuery, Types.PmtMatSearchQueryVariables>(PmtMatSearchDocument, options);
        }
export type PmtMatSearchQueryHookResult = ReturnType<typeof usePmtMatSearchQuery>;
export type PmtMatSearchLazyQueryHookResult = ReturnType<typeof usePmtMatSearchLazyQuery>;
export type PmtMatSearchQueryResult = Apollo.QueryResult<Types.PmtMatSearchQuery, Types.PmtMatSearchQueryVariables>;
export const SearchSuggestionShipTosforCipDocument = gql`
    query searchSuggestionShipTosforCip($first: Int, $filter: CipHeaderShipTosFilterInput, $soldTo: String!, $saleOrg: String!, $distributionChannel: String!, $division: String!) {
  searchSuggestionShipTo(
    first: $first
    filter: $filter
    soldTo: $soldTo
    saleOrg: $saleOrg
    distributionChannel: $distributionChannel
    division: $division
  ) {
    edges {
      node {
        partnerCode
        displayCodeName
        addressText
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useSearchSuggestionShipTosforCipQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionShipTosforCipQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionShipTosforCipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionShipTosforCipQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      soldTo: // value for 'soldTo'
 *      saleOrg: // value for 'saleOrg'
 *      distributionChannel: // value for 'distributionChannel'
 *      division: // value for 'division'
 *   },
 * });
 */
export function useSearchSuggestionShipTosforCipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SearchSuggestionShipTosforCipQuery, Types.SearchSuggestionShipTosforCipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchSuggestionShipTosforCipQuery, Types.SearchSuggestionShipTosforCipQueryVariables>(SearchSuggestionShipTosforCipDocument, options);
      }
export function useSearchSuggestionShipTosforCipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchSuggestionShipTosforCipQuery, Types.SearchSuggestionShipTosforCipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchSuggestionShipTosforCipQuery, Types.SearchSuggestionShipTosforCipQueryVariables>(SearchSuggestionShipTosforCipDocument, options);
        }
export type SearchSuggestionShipTosforCipQueryHookResult = ReturnType<typeof useSearchSuggestionShipTosforCipQuery>;
export type SearchSuggestionShipTosforCipLazyQueryHookResult = ReturnType<typeof useSearchSuggestionShipTosforCipLazyQuery>;
export type SearchSuggestionShipTosforCipQueryResult = Apollo.QueryResult<Types.SearchSuggestionShipTosforCipQuery, Types.SearchSuggestionShipTosforCipQueryVariables>;
export const ShipToUnloadingPointDocument = gql`
    query shipToUnloadingPoint($shipTo: String!) {
  shipToUnloadingPoint(shipTo: $shipTo) {
    shipTo
    unloadingPoints {
      id
      unloadingPoint
    }
    defaultUnloadingPoint {
      id
      unloadingPoint
    }
  }
}
    `;

/**
 * __useShipToUnloadingPointQuery__
 *
 * To run a query within a React component, call `useShipToUnloadingPointQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipToUnloadingPointQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipToUnloadingPointQuery({
 *   variables: {
 *      shipTo: // value for 'shipTo'
 *   },
 * });
 */
export function useShipToUnloadingPointQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ShipToUnloadingPointQuery, Types.ShipToUnloadingPointQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ShipToUnloadingPointQuery, Types.ShipToUnloadingPointQueryVariables>(ShipToUnloadingPointDocument, options);
      }
export function useShipToUnloadingPointLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ShipToUnloadingPointQuery, Types.ShipToUnloadingPointQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ShipToUnloadingPointQuery, Types.ShipToUnloadingPointQueryVariables>(ShipToUnloadingPointDocument, options);
        }
export type ShipToUnloadingPointQueryHookResult = ReturnType<typeof useShipToUnloadingPointQuery>;
export type ShipToUnloadingPointLazyQueryHookResult = ReturnType<typeof useShipToUnloadingPointLazyQuery>;
export type ShipToUnloadingPointQueryResult = Apollo.QueryResult<Types.ShipToUnloadingPointQuery, Types.ShipToUnloadingPointQueryVariables>;
export const SoldToHeaderInfoCipDocument = gql`
    query soldToHeaderInfoCip($soldTo: String!, $saleOrg: String!, $distributionChannel: String!, $division: String!) {
  soldToHeaderInfoCip(
    soldTo: $soldTo
    saleOrg: $saleOrg
    distributionChannel: $distributionChannel
    division: $division
  ) {
    orderType
    taxClassification
    paymentTerm {
      code
      name
    }
    defaultPaymentTerm {
      code
      name
    }
    soldTo {
      id
      code
      name
      displayText
    }
    shipTo {
      code
      name
      addressText
    }
    billTo {
      code
      name
      addressText
    }
    unloadingPoints {
      id
      unloadingPoint
    }
    saleEmployee
    saleGroup {
      id
      name
      code
    }
    saleOffice {
      id
      code
    }
    defaultSaleGroup {
      id
      name
      code
    }
    defaultShipTo {
      code
      name
      addressText
      displayText
    }
    defaultBillTo {
      code
      name
      addressText
      displayText
    }
    defaultUnloadingPoint {
      id
      unloadingPoint
    }
    headerNote1En {
      textId
      textLine
    }
    commentsToWarehouseEn {
      textId
      textLine
    }
    headerNote1Th {
      textId
      textLine
    }
    commentsToWarehouseTh {
      textId
      textLine
    }
  }
}
    `;

/**
 * __useSoldToHeaderInfoCipQuery__
 *
 * To run a query within a React component, call `useSoldToHeaderInfoCipQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoldToHeaderInfoCipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoldToHeaderInfoCipQuery({
 *   variables: {
 *      soldTo: // value for 'soldTo'
 *      saleOrg: // value for 'saleOrg'
 *      distributionChannel: // value for 'distributionChannel'
 *      division: // value for 'division'
 *   },
 * });
 */
export function useSoldToHeaderInfoCipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SoldToHeaderInfoCipQuery, Types.SoldToHeaderInfoCipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SoldToHeaderInfoCipQuery, Types.SoldToHeaderInfoCipQueryVariables>(SoldToHeaderInfoCipDocument, options);
      }
export function useSoldToHeaderInfoCipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SoldToHeaderInfoCipQuery, Types.SoldToHeaderInfoCipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SoldToHeaderInfoCipQuery, Types.SoldToHeaderInfoCipQueryVariables>(SoldToHeaderInfoCipDocument, options);
        }
export type SoldToHeaderInfoCipQueryHookResult = ReturnType<typeof useSoldToHeaderInfoCipQuery>;
export type SoldToHeaderInfoCipLazyQueryHookResult = ReturnType<typeof useSoldToHeaderInfoCipLazyQuery>;
export type SoldToHeaderInfoCipQueryResult = Apollo.QueryResult<Types.SoldToHeaderInfoCipQuery, Types.SoldToHeaderInfoCipQueryVariables>;
export const GetPlantsByMatCodeDocument = gql`
    query getPlantsByMatCode($materialCode: String!) {
  getPlantsByMatCode(materialCode: $materialCode) {
    plantCode
    plantName
  }
}
    `;

/**
 * __useGetPlantsByMatCodeQuery__
 *
 * To run a query within a React component, call `useGetPlantsByMatCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantsByMatCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantsByMatCodeQuery({
 *   variables: {
 *      materialCode: // value for 'materialCode'
 *   },
 * });
 */
export function useGetPlantsByMatCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetPlantsByMatCodeQuery, Types.GetPlantsByMatCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetPlantsByMatCodeQuery, Types.GetPlantsByMatCodeQueryVariables>(GetPlantsByMatCodeDocument, options);
      }
export function useGetPlantsByMatCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetPlantsByMatCodeQuery, Types.GetPlantsByMatCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetPlantsByMatCodeQuery, Types.GetPlantsByMatCodeQueryVariables>(GetPlantsByMatCodeDocument, options);
        }
export type GetPlantsByMatCodeQueryHookResult = ReturnType<typeof useGetPlantsByMatCodeQuery>;
export type GetPlantsByMatCodeLazyQueryHookResult = ReturnType<typeof useGetPlantsByMatCodeLazyQuery>;
export type GetPlantsByMatCodeQueryResult = Apollo.QueryResult<Types.GetPlantsByMatCodeQuery, Types.GetPlantsByMatCodeQueryVariables>;
export const GetTransportationDocument = gql`
    query GetTransportation($countryCode: String!) {
  transportation(countryCode: $countryCode) {
    countryCode
    id
    transportZoneCode
    transportZoneName
  }
}
    `;

/**
 * __useGetTransportationQuery__
 *
 * To run a query within a React component, call `useGetTransportationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransportationQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetTransportationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetTransportationQuery, Types.GetTransportationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetTransportationQuery, Types.GetTransportationQueryVariables>(GetTransportationDocument, options);
      }
export function useGetTransportationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetTransportationQuery, Types.GetTransportationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetTransportationQuery, Types.GetTransportationQueryVariables>(GetTransportationDocument, options);
        }
export type GetTransportationQueryHookResult = ReturnType<typeof useGetTransportationQuery>;
export type GetTransportationLazyQueryHookResult = ReturnType<typeof useGetTransportationLazyQuery>;
export type GetTransportationQueryResult = Apollo.QueryResult<Types.GetTransportationQuery, Types.GetTransportationQueryVariables>;
export const GetCountryMasterDataDocument = gql`
    query getCountryMasterData {
  getCountryMasterData {
    countryCode
    countryName
  }
}
    `;

/**
 * __useGetCountryMasterDataQuery__
 *
 * To run a query within a React component, call `useGetCountryMasterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryMasterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryMasterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryMasterDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetCountryMasterDataQuery, Types.GetCountryMasterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCountryMasterDataQuery, Types.GetCountryMasterDataQueryVariables>(GetCountryMasterDataDocument, options);
      }
export function useGetCountryMasterDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCountryMasterDataQuery, Types.GetCountryMasterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCountryMasterDataQuery, Types.GetCountryMasterDataQueryVariables>(GetCountryMasterDataDocument, options);
        }
export type GetCountryMasterDataQueryHookResult = ReturnType<typeof useGetCountryMasterDataQuery>;
export type GetCountryMasterDataLazyQueryHookResult = ReturnType<typeof useGetCountryMasterDataLazyQuery>;
export type GetCountryMasterDataQueryResult = Apollo.QueryResult<Types.GetCountryMasterDataQuery, Types.GetCountryMasterDataQueryVariables>;
export const SearchSuggestionMaterialDocument = gql`
    query searchSuggestionMaterial($first: Int, $filter: MaterialSearchFilterInput, $saleOrg: String!, $distributionChannel: String!, $searchBy: SearchMaterialBy!, $soldTo: String, $status: String) {
  searchSuggestionMaterial(
    first: $first
    filter: $filter
    saleOrg: $saleOrg
    distributionChannel: $distributionChannel
    searchBy: $searchBy
    soldTo: $soldTo
    status: $status
  ) {
    totalCount
    edges {
      node {
        id
        materialCode
        descriptionEn
        soldToMaterialCode
        displayText
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSearchSuggestionMaterialQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionMaterialQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      saleOrg: // value for 'saleOrg'
 *      distributionChannel: // value for 'distributionChannel'
 *      searchBy: // value for 'searchBy'
 *      soldTo: // value for 'soldTo'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSearchSuggestionMaterialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SearchSuggestionMaterialQuery, Types.SearchSuggestionMaterialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchSuggestionMaterialQuery, Types.SearchSuggestionMaterialQueryVariables>(SearchSuggestionMaterialDocument, options);
      }
export function useSearchSuggestionMaterialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchSuggestionMaterialQuery, Types.SearchSuggestionMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchSuggestionMaterialQuery, Types.SearchSuggestionMaterialQueryVariables>(SearchSuggestionMaterialDocument, options);
        }
export type SearchSuggestionMaterialQueryHookResult = ReturnType<typeof useSearchSuggestionMaterialQuery>;
export type SearchSuggestionMaterialLazyQueryHookResult = ReturnType<typeof useSearchSuggestionMaterialLazyQuery>;
export type SearchSuggestionMaterialQueryResult = Apollo.QueryResult<Types.SearchSuggestionMaterialQuery, Types.SearchSuggestionMaterialQueryVariables>;
export const GetOrderDataDocument = gql`
    query getOrderData($orderId: String!) {
  getOrderData(orderId: $orderId) {
    id
    soNo
    orderType
    orderTypeDesc
    poNumber
    status
    soldToAddress
    orderAmtBeforeVat
    orderAmtVat
    orderAmtAfterVat
    itemCategory
    routeId
    routeName
    info
    itemCategory
    billTo
    routeId
    routeName
    unloadingPoint
    salesEmployee
    orderExtension {
      taxClass
      additionalTxtFromHeader
      additionalTxtHeaderNote1
      additionalTxtCash
      otcSoldTo {
        soldToCode
        address {
          addressCode
          name1
          name2
          name3
          name4
          city
          postalCode
          district
          street1
          street2
          street3
          street4
          location
          transportZoneCode
          transportZoneName
          countryCode
          countryName
          telephoneNo
          telephoneExtension
          mobileNo
          faxNo
          faxNoExt
          email
          language
          taxNumber1
          taxNumber2
          taxId
          branchId
        }
      }
      otcBillTo {
        soldToCode
        address {
          addressCode
          name1
          name2
          name3
          name4
          city
          postalCode
          district
          street1
          street2
          street3
          street4
          location
          transportZoneCode
          transportZoneName
          countryCode
          countryName
          telephoneNo
          telephoneExtension
          mobileNo
          faxNo
          faxNoExt
          email
          language
          taxNumber1
          taxNumber2
          taxId
          branchId
        }
      }
      otcShipTo {
        soldToCode
        address {
          addressCode
          name1
          name2
          name3
          name4
          city
          postalCode
          district
          street1
          street2
          street3
          street4
          location
          transportZoneCode
          transportZoneName
          countryCode
          countryName
          telephoneNo
          telephoneExtension
          mobileNo
          faxNo
          faxNoExt
          email
          language
          taxNumber1
          taxNumber2
          taxId
          branchId
        }
      }
    }
    customer {
      id
      name
      code
      soldToCode
      soldToName
      representatives {
        addresses {
          streetAddress1
          streetAddress2
          __typename
        }
        firstName
        lastName
        __typename
      }
      displayText
      addressText
      __typename
    }
    taxPercent
    soldTo {
      displayText
      addressText
      __typename
    }
    shipTo
    billTo
    scgpSalesEmployee {
      id
      code
      name
      __typename
    }
    customerGroup {
      id
      code
      name
      __typename
    }
    customerGroup1 {
      id
      code
      name
      __typename
    }
    customerGroup2 {
      id
      code
      name
      __typename
    }
    customerGroup3 {
      id
      code
      name
      __typename
    }
    customerGroup4 {
      id
      code
      name
      __typename
    }
    poDate
    requestDate
    paymentTerm
    dpNo
    invoiceNo
    deliveryBlock
    incoterm
    incoterms1 {
      id
      code
      description
      __typename
    }
    route
    shippingPoint
    internalCommentsToLogistic
    internalCommentsToWarehouse
    externalCommentsToCustomer
    productInformation
    saleOrganization {
      id
      code
      name
      __typename
    }
    salesGroup {
      id
      name
      code
      __typename
    }
    saleOffice {
      id
      name
      code
      __typename
    }
    division {
      id
      name
      code
      __typename
    }
    distributionChannel {
      id
      name
      code
      __typename
    }
    orderLines {
      ...fieldOrderLinesCip
      __typename
    }
    __typename
  }
}
    ${FieldOrderLinesCipFragmentDoc}`;

/**
 * __useGetOrderDataQuery__
 *
 * To run a query within a React component, call `useGetOrderDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderDataQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetOrderDataQuery, Types.GetOrderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetOrderDataQuery, Types.GetOrderDataQueryVariables>(GetOrderDataDocument, options);
      }
export function useGetOrderDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetOrderDataQuery, Types.GetOrderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetOrderDataQuery, Types.GetOrderDataQueryVariables>(GetOrderDataDocument, options);
        }
export type GetOrderDataQueryHookResult = ReturnType<typeof useGetOrderDataQuery>;
export type GetOrderDataLazyQueryHookResult = ReturnType<typeof useGetOrderDataLazyQuery>;
export type GetOrderDataQueryResult = Apollo.QueryResult<Types.GetOrderDataQuery, Types.GetOrderDataQueryVariables>;
export const PreviewDomesticOrderDocument = gql`
    query previewDomesticOrder($id: ID!) {
  previewDomesticOrder(id: $id) {
    previewHeaderData {
      soNo
      poNumber
      orderDate
      paymentTerm
      saleOrganization
      saleEmployee
      customerName
      shipTo
      billTo
    }
    previewItemData {
      itemNo
      materialCode
      materialDescription
      quantity
      salesUnit
      weight
      weightUnit
      pricePerUnit
      netPrice
      requestDate
      confirmedDate
      plant
      confirmedPlant
      bomFlag
      parentItemNo
      itemStatusEn
      itemStatusTh
    }
    previewFooterData {
      netTotalPrice
      totalVat
      orderAmountAfterVat
      currency
    }
  }
}
    `;

/**
 * __usePreviewDomesticOrderQuery__
 *
 * To run a query within a React component, call `usePreviewDomesticOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDomesticOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDomesticOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewDomesticOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PreviewDomesticOrderQuery, Types.PreviewDomesticOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PreviewDomesticOrderQuery, Types.PreviewDomesticOrderQueryVariables>(PreviewDomesticOrderDocument, options);
      }
export function usePreviewDomesticOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PreviewDomesticOrderQuery, Types.PreviewDomesticOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PreviewDomesticOrderQuery, Types.PreviewDomesticOrderQueryVariables>(PreviewDomesticOrderDocument, options);
        }
export type PreviewDomesticOrderQueryHookResult = ReturnType<typeof usePreviewDomesticOrderQuery>;
export type PreviewDomesticOrderLazyQueryHookResult = ReturnType<typeof usePreviewDomesticOrderLazyQuery>;
export type PreviewDomesticOrderQueryResult = Apollo.QueryResult<Types.PreviewDomesticOrderQuery, Types.PreviewDomesticOrderQueryVariables>;
export const GetOrderEmailToAndCcForNotRefDocument = gql`
    query getOrderEmailToAndCcForNotRef($soldToCode: [String], $saleOrg: [String], $soNo: [String]) {
  getOrderEmailToAndCcForNotRef(
    soldToCode: $soldToCode
    saleOrg: $saleOrg
    soNo: $soNo
  ) {
    to
    cc
  }
}
    `;

/**
 * __useGetOrderEmailToAndCcForNotRefQuery__
 *
 * To run a query within a React component, call `useGetOrderEmailToAndCcForNotRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderEmailToAndCcForNotRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderEmailToAndCcForNotRefQuery({
 *   variables: {
 *      soldToCode: // value for 'soldToCode'
 *      saleOrg: // value for 'saleOrg'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useGetOrderEmailToAndCcForNotRefQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetOrderEmailToAndCcForNotRefQuery, Types.GetOrderEmailToAndCcForNotRefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetOrderEmailToAndCcForNotRefQuery, Types.GetOrderEmailToAndCcForNotRefQueryVariables>(GetOrderEmailToAndCcForNotRefDocument, options);
      }
export function useGetOrderEmailToAndCcForNotRefLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetOrderEmailToAndCcForNotRefQuery, Types.GetOrderEmailToAndCcForNotRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetOrderEmailToAndCcForNotRefQuery, Types.GetOrderEmailToAndCcForNotRefQueryVariables>(GetOrderEmailToAndCcForNotRefDocument, options);
        }
export type GetOrderEmailToAndCcForNotRefQueryHookResult = ReturnType<typeof useGetOrderEmailToAndCcForNotRefQuery>;
export type GetOrderEmailToAndCcForNotRefLazyQueryHookResult = ReturnType<typeof useGetOrderEmailToAndCcForNotRefLazyQuery>;
export type GetOrderEmailToAndCcForNotRefQueryResult = Apollo.QueryResult<Types.GetOrderEmailToAndCcForNotRefQuery, Types.GetOrderEmailToAndCcForNotRefQueryVariables>;
export const OrderViewDataDocument = gql`
    query orderViewData($soNo: String!) {
  orderViewData(soNo: $soNo) {
    id
    soNo
    poNo
    oneTimeFlag
    distributionChannelCode
    distributionChannelName
    salesOrgCode
    salesOrgName
    salesOrgShortName
    salesOff
    salesOffName
    divisionCode
    divisionName
    priceDate
    status
    orderAmtBeforeVat
    orderAmtVat
    orderAmtAfterVat
    currency
    requestDate
    paymentTerms
    salesOrgDisplayText
    divisionCode
    salesGroupCode
    salesEmployee
    soldToCode
    soldToDisplayText
    billToDisplayText
    shipToDisplayText
    internalCommentsToLogistic
    internalCommentsToWarehouse
    externalCommentsToCustomer
    productionInformation
    formHeader
    headerNote1
    cash
    unloadingPoint
    orderDate
    salesGroupCode
    salesGroupName
    otcOrderPartners {
      partnerRole
      partnerNo
      addrLink
      payerName
      address {
        addrNo
        name
        city
        postCode
        district
        street
        transpzone
        country
        countryName
        nameForPartners
        location
        strSuppl1
        strSuppl2
        strSuppl3
        telNoList {
          telNo
          telNoExt
        }
        mobileNo
        faxNo
        faxNoExt
        language
        orderTaxNumber {
          taxNumber1
          taxNumber2
          taxId
          branchId
        }
      }
      itemNo
      oneTimeFlag
    }
    orderItems {
      ...changeFieldOrderLines
      __typename
    }
    orderCondition {
      itemNo
      conditionType
      conditionRate
      currency
      conditionUnit
      conditionPriceUnit
      conditionPriceOrder
      conditionBaseValue
    }
    orderText {
      itemNo
      textId
      language
      textLine {
        text
      }
    }
    cashSale {
      ...cashSaleResponse
      __typename
    }
    itemNoLatest
    poDate
    orderType
    orderTypeDesc
    taxClass
    paymentTermsDisplayText
    salesEmployeeDisplayText
    __typename
  }
}
    ${ChangeFieldOrderLinesFragmentDoc}
${CashSaleResponseFragmentDoc}`;

/**
 * __useOrderViewDataQuery__
 *
 * To run a query within a React component, call `useOrderViewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderViewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderViewDataQuery({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useOrderViewDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.OrderViewDataQuery, Types.OrderViewDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrderViewDataQuery, Types.OrderViewDataQueryVariables>(OrderViewDataDocument, options);
      }
export function useOrderViewDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrderViewDataQuery, Types.OrderViewDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrderViewDataQuery, Types.OrderViewDataQueryVariables>(OrderViewDataDocument, options);
        }
export type OrderViewDataQueryHookResult = ReturnType<typeof useOrderViewDataQuery>;
export type OrderViewDataLazyQueryHookResult = ReturnType<typeof useOrderViewDataLazyQuery>;
export type OrderViewDataQueryResult = Apollo.QueryResult<Types.OrderViewDataQuery, Types.OrderViewDataQueryVariables>;
export const ShipToUnloadingAndTaxDocument = gql`
    query shipToUnloadingAndTax($shipTo: String!, $saleOrg: String!, $distributionChannel: String!, $division: String!) {
  shipToUnloadingAndTax(
    shipTo: $shipTo
    saleOrg: $saleOrg
    distributionChannel: $distributionChannel
    division: $division
  ) {
    shipTo
    unloadingPoints {
      id
      soldToCode
      unloadingPoint
      factoryCalendar
      factoryCalendarDesc
    }
    defaultUnloadingPoint {
      id
      soldToCode
      unloadingPoint
      factoryCalendar
      factoryCalendarDesc
    }
    taxClassification
    __typename
  }
}
    `;

/**
 * __useShipToUnloadingAndTaxQuery__
 *
 * To run a query within a React component, call `useShipToUnloadingAndTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipToUnloadingAndTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipToUnloadingAndTaxQuery({
 *   variables: {
 *      shipTo: // value for 'shipTo'
 *      saleOrg: // value for 'saleOrg'
 *      distributionChannel: // value for 'distributionChannel'
 *      division: // value for 'division'
 *   },
 * });
 */
export function useShipToUnloadingAndTaxQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ShipToUnloadingAndTaxQuery, Types.ShipToUnloadingAndTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ShipToUnloadingAndTaxQuery, Types.ShipToUnloadingAndTaxQueryVariables>(ShipToUnloadingAndTaxDocument, options);
      }
export function useShipToUnloadingAndTaxLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ShipToUnloadingAndTaxQuery, Types.ShipToUnloadingAndTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ShipToUnloadingAndTaxQuery, Types.ShipToUnloadingAndTaxQueryVariables>(ShipToUnloadingAndTaxDocument, options);
        }
export type ShipToUnloadingAndTaxQueryHookResult = ReturnType<typeof useShipToUnloadingAndTaxQuery>;
export type ShipToUnloadingAndTaxLazyQueryHookResult = ReturnType<typeof useShipToUnloadingAndTaxLazyQuery>;
export type ShipToUnloadingAndTaxQueryResult = Apollo.QueryResult<Types.ShipToUnloadingAndTaxQuery, Types.ShipToUnloadingAndTaxQueryVariables>;
export const GetArOutstandingDocument = gql`
    query getArOutstanding($input: ArOutstandingInput!) {
  getArOutstanding(input: $input) {
    currentAmount
    status
    message
    __typename
  }
}
    `;

/**
 * __useGetArOutstandingQuery__
 *
 * To run a query within a React component, call `useGetArOutstandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArOutstandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArOutstandingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetArOutstandingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetArOutstandingQuery, Types.GetArOutstandingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetArOutstandingQuery, Types.GetArOutstandingQueryVariables>(GetArOutstandingDocument, options);
      }
export function useGetArOutstandingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetArOutstandingQuery, Types.GetArOutstandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetArOutstandingQuery, Types.GetArOutstandingQueryVariables>(GetArOutstandingDocument, options);
        }
export type GetArOutstandingQueryHookResult = ReturnType<typeof useGetArOutstandingQuery>;
export type GetArOutstandingLazyQueryHookResult = ReturnType<typeof useGetArOutstandingLazyQuery>;
export type GetArOutstandingQueryResult = Apollo.QueryResult<Types.GetArOutstandingQuery, Types.GetArOutstandingQueryVariables>;
export const GetCashSaleStatusDocument = gql`
    query getCashSaleStatus($soNo: String!) {
  getCashSaleStatus(soNo: $soNo) {
    status
    message
    cashSaleStatus
    statusName
    updateFlag
    __typename
  }
}
    `;

/**
 * __useGetCashSaleStatusQuery__
 *
 * To run a query within a React component, call `useGetCashSaleStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashSaleStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashSaleStatusQuery({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useGetCashSaleStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetCashSaleStatusQuery, Types.GetCashSaleStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCashSaleStatusQuery, Types.GetCashSaleStatusQueryVariables>(GetCashSaleStatusDocument, options);
      }
export function useGetCashSaleStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCashSaleStatusQuery, Types.GetCashSaleStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCashSaleStatusQuery, Types.GetCashSaleStatusQueryVariables>(GetCashSaleStatusDocument, options);
        }
export type GetCashSaleStatusQueryHookResult = ReturnType<typeof useGetCashSaleStatusQuery>;
export type GetCashSaleStatusLazyQueryHookResult = ReturnType<typeof useGetCashSaleStatusLazyQuery>;
export type GetCashSaleStatusQueryResult = Apollo.QueryResult<Types.GetCashSaleStatusQuery, Types.GetCashSaleStatusQueryVariables>;
export const CreateContractCheckoutDocument = gql`
    mutation createContractCheckout($input: ContractCheckoutCreateInput!) {
  createContractCheckout(input: $input) {
    checkout {
      id
    }
  }
}
    `;
export type CreateContractCheckoutMutationFn = Apollo.MutationFunction<Types.CreateContractCheckoutMutation, Types.CreateContractCheckoutMutationVariables>;

/**
 * __useCreateContractCheckoutMutation__
 *
 * To run a mutation, you first call `useCreateContractCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractCheckoutMutation, { data, loading, error }] = useCreateContractCheckoutMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CreateContractCheckoutMutation, Types.CreateContractCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CreateContractCheckoutMutation, Types.CreateContractCheckoutMutationVariables>(CreateContractCheckoutDocument, options);
      }
export type CreateContractCheckoutMutationHookResult = ReturnType<typeof useCreateContractCheckoutMutation>;
export type CreateContractCheckoutMutationResult = Apollo.MutationResult<Types.CreateContractCheckoutMutation>;
export type CreateContractCheckoutMutationOptions = Apollo.BaseMutationOptions<Types.CreateContractCheckoutMutation, Types.CreateContractCheckoutMutationVariables>;
export const DeleteContractCheckoutLinesDocument = gql`
    mutation deleteContractCheckoutLines($checkoutLineIds: [ID]!) {
  deleteContractCheckoutLines(checkoutLineIds: $checkoutLineIds) {
    status
    errors {
      code
      field
      message
    }
  }
}
    `;
export type DeleteContractCheckoutLinesMutationFn = Apollo.MutationFunction<Types.DeleteContractCheckoutLinesMutation, Types.DeleteContractCheckoutLinesMutationVariables>;

/**
 * __useDeleteContractCheckoutLinesMutation__
 *
 * To run a mutation, you first call `useDeleteContractCheckoutLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractCheckoutLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractCheckoutLinesMutation, { data, loading, error }] = useDeleteContractCheckoutLinesMutation({
 *   variables: {
 *      checkoutLineIds: // value for 'checkoutLineIds'
 *   },
 * });
 */
export function useDeleteContractCheckoutLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteContractCheckoutLinesMutation, Types.DeleteContractCheckoutLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteContractCheckoutLinesMutation, Types.DeleteContractCheckoutLinesMutationVariables>(DeleteContractCheckoutLinesDocument, options);
      }
export type DeleteContractCheckoutLinesMutationHookResult = ReturnType<typeof useDeleteContractCheckoutLinesMutation>;
export type DeleteContractCheckoutLinesMutationResult = Apollo.MutationResult<Types.DeleteContractCheckoutLinesMutation>;
export type DeleteContractCheckoutLinesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteContractCheckoutLinesMutation, Types.DeleteContractCheckoutLinesMutationVariables>;
export const UpdateContractCheckoutDocument = gql`
    mutation updateContractCheckout($detailId: ID!, $input: ContractCheckoutUpdateInput!) {
  updateContractCheckout(id: $detailId, input: $input) {
    errors {
      field
      message
      code
    }
    checkout {
      id
    }
  }
}
    `;
export type UpdateContractCheckoutMutationFn = Apollo.MutationFunction<Types.UpdateContractCheckoutMutation, Types.UpdateContractCheckoutMutationVariables>;

/**
 * __useUpdateContractCheckoutMutation__
 *
 * To run a mutation, you first call `useUpdateContractCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractCheckoutMutation, { data, loading, error }] = useUpdateContractCheckoutMutation({
 *   variables: {
 *      detailId: // value for 'detailId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractCheckoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateContractCheckoutMutation, Types.UpdateContractCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateContractCheckoutMutation, Types.UpdateContractCheckoutMutationVariables>(UpdateContractCheckoutDocument, options);
      }
export type UpdateContractCheckoutMutationHookResult = ReturnType<typeof useUpdateContractCheckoutMutation>;
export type UpdateContractCheckoutMutationResult = Apollo.MutationResult<Types.UpdateContractCheckoutMutation>;
export type UpdateContractCheckoutMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContractCheckoutMutation, Types.UpdateContractCheckoutMutationVariables>;
export const CreateOrderDocument = gql`
    mutation CreateOrder($input: ContractOrderCreateInput!) {
  createContractOrder(input: $input) {
    order {
      id
      customer {
        id
      }
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type CreateOrderMutationFn = Apollo.MutationFunction<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>(CreateOrderDocument, options);
      }
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<Types.CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrderMutation, Types.CreateOrderMutationVariables>;
export const UpdateContractOrderDocument = gql`
    mutation updateContractOrder($id: ID!, $input: ContractOrderUpdateInput!) {
  updateContractOrder(id: $id, input: $input) {
    order {
      id
    }
    success
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      errorCode
      errorMessage
      itemNo
    }
    errors {
      field
      message
      code
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    warningMessages {
      message
      order
      source
    }
  }
}
    `;
export type UpdateContractOrderMutationFn = Apollo.MutationFunction<Types.UpdateContractOrderMutation, Types.UpdateContractOrderMutationVariables>;

/**
 * __useUpdateContractOrderMutation__
 *
 * To run a mutation, you first call `useUpdateContractOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractOrderMutation, { data, loading, error }] = useUpdateContractOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateContractOrderMutation, Types.UpdateContractOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateContractOrderMutation, Types.UpdateContractOrderMutationVariables>(UpdateContractOrderDocument, options);
      }
export type UpdateContractOrderMutationHookResult = ReturnType<typeof useUpdateContractOrderMutation>;
export type UpdateContractOrderMutationResult = Apollo.MutationResult<Types.UpdateContractOrderMutation>;
export type UpdateContractOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContractOrderMutation, Types.UpdateContractOrderMutationVariables>;
export const DeleteCustomerCartItemsDocument = gql`
    mutation deleteCustomerCartItems($cartItemIds: [ID]!) {
  deleteCustomerCartItems(cartItemIds: $cartItemIds) {
    status
    errors {
      message
    }
  }
}
    `;
export type DeleteCustomerCartItemsMutationFn = Apollo.MutationFunction<Types.DeleteCustomerCartItemsMutation, Types.DeleteCustomerCartItemsMutationVariables>;

/**
 * __useDeleteCustomerCartItemsMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerCartItemsMutation, { data, loading, error }] = useDeleteCustomerCartItemsMutation({
 *   variables: {
 *      cartItemIds: // value for 'cartItemIds'
 *   },
 * });
 */
export function useDeleteCustomerCartItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteCustomerCartItemsMutation, Types.DeleteCustomerCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteCustomerCartItemsMutation, Types.DeleteCustomerCartItemsMutationVariables>(DeleteCustomerCartItemsDocument, options);
      }
export type DeleteCustomerCartItemsMutationHookResult = ReturnType<typeof useDeleteCustomerCartItemsMutation>;
export type DeleteCustomerCartItemsMutationResult = Apollo.MutationResult<Types.DeleteCustomerCartItemsMutation>;
export type DeleteCustomerCartItemsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCustomerCartItemsMutation, Types.DeleteCustomerCartItemsMutationVariables>;
export const CreateCustomerCartDocument = gql`
    mutation createCustomerCart($input: CustomerCartCreateInput!) {
  createCustomerCart(input: $input) {
    errors {
      message
    }
    cart {
      id
      cartItems {
        id
      }
    }
  }
}
    `;
export type CreateCustomerCartMutationFn = Apollo.MutationFunction<Types.CreateCustomerCartMutation, Types.CreateCustomerCartMutationVariables>;

/**
 * __useCreateCustomerCartMutation__
 *
 * To run a mutation, you first call `useCreateCustomerCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerCartMutation, { data, loading, error }] = useCreateCustomerCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CreateCustomerCartMutation, Types.CreateCustomerCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CreateCustomerCartMutation, Types.CreateCustomerCartMutationVariables>(CreateCustomerCartDocument, options);
      }
export type CreateCustomerCartMutationHookResult = ReturnType<typeof useCreateCustomerCartMutation>;
export type CreateCustomerCartMutationResult = Apollo.MutationResult<Types.CreateCustomerCartMutation>;
export type CreateCustomerCartMutationOptions = Apollo.BaseMutationOptions<Types.CreateCustomerCartMutation, Types.CreateCustomerCartMutationVariables>;
export const UpdateCustomerCartDocument = gql`
    mutation UpdateCustomerCart($id: ID!, $input: CustomerCartUpdateInput!) {
  updateCustomerCart(id: $id, input: $input) {
    errors {
      message
    }
    cart {
      id
      contract {
        code
      }
      createdBy {
        id
      }
      quantity
      cartItems {
        id
        variant {
          name
        }
        quantity
        customerProduct {
          name
          slug
        }
        customerProductVariant {
          name
          slug
        }
      }
    }
  }
}
    `;
export type UpdateCustomerCartMutationFn = Apollo.MutationFunction<Types.UpdateCustomerCartMutation, Types.UpdateCustomerCartMutationVariables>;

/**
 * __useUpdateCustomerCartMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerCartMutation, { data, loading, error }] = useUpdateCustomerCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateCustomerCartMutation, Types.UpdateCustomerCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateCustomerCartMutation, Types.UpdateCustomerCartMutationVariables>(UpdateCustomerCartDocument, options);
      }
export type UpdateCustomerCartMutationHookResult = ReturnType<typeof useUpdateCustomerCartMutation>;
export type UpdateCustomerCartMutationResult = Apollo.MutationResult<Types.UpdateCustomerCartMutation>;
export type UpdateCustomerCartMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomerCartMutation, Types.UpdateCustomerCartMutationVariables>;
export const UpdateCustomerCartLinesDocument = gql`
    mutation updateCustomerCartLines($id: ID!, $input: CustomerCartLinesUpdateQuantityInput!) {
  updateCustomerCartLines(id: $id, input: $input) {
    cart {
      cartItems {
        cart {
          id
        }
      }
    }
  }
}
    `;
export type UpdateCustomerCartLinesMutationFn = Apollo.MutationFunction<Types.UpdateCustomerCartLinesMutation, Types.UpdateCustomerCartLinesMutationVariables>;

/**
 * __useUpdateCustomerCartLinesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerCartLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerCartLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerCartLinesMutation, { data, loading, error }] = useUpdateCustomerCartLinesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerCartLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateCustomerCartLinesMutation, Types.UpdateCustomerCartLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateCustomerCartLinesMutation, Types.UpdateCustomerCartLinesMutationVariables>(UpdateCustomerCartLinesDocument, options);
      }
export type UpdateCustomerCartLinesMutationHookResult = ReturnType<typeof useUpdateCustomerCartLinesMutation>;
export type UpdateCustomerCartLinesMutationResult = Apollo.MutationResult<Types.UpdateCustomerCartLinesMutation>;
export type UpdateCustomerCartLinesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomerCartLinesMutation, Types.UpdateCustomerCartLinesMutationVariables>;
export const ContractsDocument = gql`
    query Contracts($soldToCode: String!, $contractNo: String, $filter: TempContractFilterInput, $sortBy: ContractsSortingInput, $before: String, $after: String, $first: Int, $last: Int) {
  contracts(
    soldToCode: $soldToCode
    contractNo: $contractNo
    filter: $filter
    sortBy: $sortBy
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        contractNo
        company {
          id
          name
          businessUnit {
            name
          }
        }
        salesOrganization {
          code
        }
        customer {
          soldToCode
        }
        prcGroup1
        projectName
        startDate
        endDate
        paymentTerm
        paymentTermKey
        paymentTermDescTh
        products {
          id
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    latestPageItemNumber
    totalCount
  }
}
    `;

/**
 * __useContractsQuery__
 *
 * To run a query within a React component, call `useContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractsQuery({
 *   variables: {
 *      soldToCode: // value for 'soldToCode'
 *      contractNo: // value for 'contractNo'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useContractsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractsQuery, Types.ContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractsQuery, Types.ContractsQueryVariables>(ContractsDocument, options);
      }
export function useContractsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractsQuery, Types.ContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractsQuery, Types.ContractsQueryVariables>(ContractsDocument, options);
        }
export type ContractsQueryHookResult = ReturnType<typeof useContractsQuery>;
export type ContractsLazyQueryHookResult = ReturnType<typeof useContractsLazyQuery>;
export type ContractsQueryResult = Apollo.QueryResult<Types.ContractsQuery, Types.ContractsQueryVariables>;
export const ContractDocument = gql`
    query Contract($id: ID!, $soNo: String) {
  contract(contractId: $id, soNo: $soNo) {
    id
    contractNo
    currency
    prcGroup1
    salesOrganization {
      code
    }
    customer {
      name
      id
      code
      soldToCode
      soldToName
      representatives {
        firstName
        lastName
      }
      displayText
      addressText
    }
    company {
      id
      name
      shortName
      fullName
      businessUnit {
        name
      }
    }
    projectName
    startDate
    endDate
    paymentTerm
    prcGroup1
    paymentTermKey
    paymentTermDescTh
    products {
      id
      price
      name
      materialDescription
      total
      remain
      salesUnit
      weightUnit
      productId
      itemNo
      matGroup1
      materialCode
      product {
        id
        name
        code
        description
        materialType
        weight
      }
    }
  }
}
    `;

/**
 * __useContractQuery__
 *
 * To run a query within a React component, call `useContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractQuery, Types.ContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractQuery, Types.ContractQueryVariables>(ContractDocument, options);
      }
export function useContractLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractQuery, Types.ContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractQuery, Types.ContractQueryVariables>(ContractDocument, options);
        }
export type ContractQueryHookResult = ReturnType<typeof useContractQuery>;
export type ContractLazyQueryHookResult = ReturnType<typeof useContractLazyQuery>;
export type ContractQueryResult = Apollo.QueryResult<Types.ContractQuery, Types.ContractQueryVariables>;
export const GetBusinessUnitDocument = gql`
    query getBusinessUnit {
  businessUnits(first: 10) {
    edges {
      node {
        id
        name
        companies {
          id
          name
          shortName
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetBusinessUnitQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessUnitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetBusinessUnitQuery, Types.GetBusinessUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetBusinessUnitQuery, Types.GetBusinessUnitQueryVariables>(GetBusinessUnitDocument, options);
      }
export function useGetBusinessUnitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetBusinessUnitQuery, Types.GetBusinessUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetBusinessUnitQuery, Types.GetBusinessUnitQueryVariables>(GetBusinessUnitDocument, options);
        }
export type GetBusinessUnitQueryHookResult = ReturnType<typeof useGetBusinessUnitQuery>;
export type GetBusinessUnitLazyQueryHookResult = ReturnType<typeof useGetBusinessUnitLazyQuery>;
export type GetBusinessUnitQueryResult = Apollo.QueryResult<Types.GetBusinessUnitQuery, Types.GetBusinessUnitQueryVariables>;
export const ContractProductDocument = gql`
    query contractProduct($productId: ID!, $contractId: ID!, $contractMaterialId: ID!, $soNo: ID) {
  contractProduct(
    productId: $productId
    contractId: $contractId
    contractMaterialId: $contractMaterialId
    soNo: $soNo
  ) {
    id
    total
    remain
    price
    salesUnit
    contract {
      id
      projectName
      currency
      startDate
      endDate
      paymentTerm
      prcGroup1
    }
    product {
      id
      name
      salesUnit
      code
      description
      variants {
        id
        name
        code
        descriptionTh
        descriptionEn
        variantType
        weight
      }
    }
  }
}
    `;

/**
 * __useContractProductQuery__
 *
 * To run a query within a React component, call `useContractProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      contractId: // value for 'contractId'
 *      contractMaterialId: // value for 'contractMaterialId'
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useContractProductQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractProductQuery, Types.ContractProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractProductQuery, Types.ContractProductQueryVariables>(ContractProductDocument, options);
      }
export function useContractProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractProductQuery, Types.ContractProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractProductQuery, Types.ContractProductQueryVariables>(ContractProductDocument, options);
        }
export type ContractProductQueryHookResult = ReturnType<typeof useContractProductQuery>;
export type ContractProductLazyQueryHookResult = ReturnType<typeof useContractProductLazyQuery>;
export type ContractProductQueryResult = Apollo.QueryResult<Types.ContractProductQuery, Types.ContractProductQueryVariables>;
export const CartTotalCheckoutDocument = gql`
    query CartTotalCheckout {
  totalContractCheckouts {
    totalProducts
    totalCustomers
  }
}
    `;

/**
 * __useCartTotalCheckoutQuery__
 *
 * To run a query within a React component, call `useCartTotalCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartTotalCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartTotalCheckoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useCartTotalCheckoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CartTotalCheckoutQuery, Types.CartTotalCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CartTotalCheckoutQuery, Types.CartTotalCheckoutQueryVariables>(CartTotalCheckoutDocument, options);
      }
export function useCartTotalCheckoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CartTotalCheckoutQuery, Types.CartTotalCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CartTotalCheckoutQuery, Types.CartTotalCheckoutQueryVariables>(CartTotalCheckoutDocument, options);
        }
export type CartTotalCheckoutQueryHookResult = ReturnType<typeof useCartTotalCheckoutQuery>;
export type CartTotalCheckoutLazyQueryHookResult = ReturnType<typeof useCartTotalCheckoutLazyQuery>;
export type CartTotalCheckoutQueryResult = Apollo.QueryResult<Types.CartTotalCheckoutQuery, Types.CartTotalCheckoutQueryVariables>;
export const CartCheckoutDocument = gql`
    query CartCheckout($first: Int, $sortBy: ContractCheckoutsSortingInput) {
  contractCheckouts(first: $first, sortBy: $sortBy) {
    edges {
      node {
        id
        customer {
          id
          name
          code
          soldToCode
          representatives {
            firstName
            lastName
          }
        }
        contract {
          id
          paymentTerm
        }
        quantity
      }
    }
  }
}
    `;

/**
 * __useCartCheckoutQuery__
 *
 * To run a query within a React component, call `useCartCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartCheckoutQuery({
 *   variables: {
 *      first: // value for 'first'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCartCheckoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CartCheckoutQuery, Types.CartCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CartCheckoutQuery, Types.CartCheckoutQueryVariables>(CartCheckoutDocument, options);
      }
export function useCartCheckoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CartCheckoutQuery, Types.CartCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CartCheckoutQuery, Types.CartCheckoutQueryVariables>(CartCheckoutDocument, options);
        }
export type CartCheckoutQueryHookResult = ReturnType<typeof useCartCheckoutQuery>;
export type CartCheckoutLazyQueryHookResult = ReturnType<typeof useCartCheckoutLazyQuery>;
export type CartCheckoutQueryResult = Apollo.QueryResult<Types.CartCheckoutQuery, Types.CartCheckoutQueryVariables>;
export const GetListSaleOrganizationsDocument = gql`
    query GetListSaleOrganizations {
  salesOrganizations {
    id
    name
    code
  }
}
    `;

/**
 * __useGetListSaleOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetListSaleOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListSaleOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListSaleOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListSaleOrganizationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListSaleOrganizationsQuery, Types.GetListSaleOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListSaleOrganizationsQuery, Types.GetListSaleOrganizationsQueryVariables>(GetListSaleOrganizationsDocument, options);
      }
export function useGetListSaleOrganizationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListSaleOrganizationsQuery, Types.GetListSaleOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListSaleOrganizationsQuery, Types.GetListSaleOrganizationsQueryVariables>(GetListSaleOrganizationsDocument, options);
        }
export type GetListSaleOrganizationsQueryHookResult = ReturnType<typeof useGetListSaleOrganizationsQuery>;
export type GetListSaleOrganizationsLazyQueryHookResult = ReturnType<typeof useGetListSaleOrganizationsLazyQuery>;
export type GetListSaleOrganizationsQueryResult = Apollo.QueryResult<Types.GetListSaleOrganizationsQuery, Types.GetListSaleOrganizationsQueryVariables>;
export const GetDistributionChannelDocument = gql`
    query GetDistributionChannel {
  distributionChannels {
    id
    name
    code
  }
}
    `;

/**
 * __useGetDistributionChannelQuery__
 *
 * To run a query within a React component, call `useGetDistributionChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionChannelQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDistributionChannelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetDistributionChannelQuery, Types.GetDistributionChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetDistributionChannelQuery, Types.GetDistributionChannelQueryVariables>(GetDistributionChannelDocument, options);
      }
export function useGetDistributionChannelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetDistributionChannelQuery, Types.GetDistributionChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetDistributionChannelQuery, Types.GetDistributionChannelQueryVariables>(GetDistributionChannelDocument, options);
        }
export type GetDistributionChannelQueryHookResult = ReturnType<typeof useGetDistributionChannelQuery>;
export type GetDistributionChannelLazyQueryHookResult = ReturnType<typeof useGetDistributionChannelLazyQuery>;
export type GetDistributionChannelQueryResult = Apollo.QueryResult<Types.GetDistributionChannelQuery, Types.GetDistributionChannelQueryVariables>;
export const GetListScgDivisionDocument = gql`
    query GetListScgDivision {
  scgDivisions {
    id
    name
    code
  }
}
    `;

/**
 * __useGetListScgDivisionQuery__
 *
 * To run a query within a React component, call `useGetListScgDivisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListScgDivisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListScgDivisionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListScgDivisionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListScgDivisionQuery, Types.GetListScgDivisionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListScgDivisionQuery, Types.GetListScgDivisionQueryVariables>(GetListScgDivisionDocument, options);
      }
export function useGetListScgDivisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListScgDivisionQuery, Types.GetListScgDivisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListScgDivisionQuery, Types.GetListScgDivisionQueryVariables>(GetListScgDivisionDocument, options);
        }
export type GetListScgDivisionQueryHookResult = ReturnType<typeof useGetListScgDivisionQuery>;
export type GetListScgDivisionLazyQueryHookResult = ReturnType<typeof useGetListScgDivisionLazyQuery>;
export type GetListScgDivisionQueryResult = Apollo.QueryResult<Types.GetListScgDivisionQuery, Types.GetListScgDivisionQueryVariables>;
export const GetListSalesOfficesDocument = gql`
    query GetListSalesOffices {
  salesOffices {
    id
    name
    code
  }
}
    `;

/**
 * __useGetListSalesOfficesQuery__
 *
 * To run a query within a React component, call `useGetListSalesOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListSalesOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListSalesOfficesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListSalesOfficesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListSalesOfficesQuery, Types.GetListSalesOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListSalesOfficesQuery, Types.GetListSalesOfficesQueryVariables>(GetListSalesOfficesDocument, options);
      }
export function useGetListSalesOfficesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListSalesOfficesQuery, Types.GetListSalesOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListSalesOfficesQuery, Types.GetListSalesOfficesQueryVariables>(GetListSalesOfficesDocument, options);
        }
export type GetListSalesOfficesQueryHookResult = ReturnType<typeof useGetListSalesOfficesQuery>;
export type GetListSalesOfficesLazyQueryHookResult = ReturnType<typeof useGetListSalesOfficesLazyQuery>;
export type GetListSalesOfficesQueryResult = Apollo.QueryResult<Types.GetListSalesOfficesQuery, Types.GetListSalesOfficesQueryVariables>;
export const GetListSaleGroupsDocument = gql`
    query GetListSaleGroups {
  salesGroups {
    id
    name
    code
  }
}
    `;

/**
 * __useGetListSaleGroupsQuery__
 *
 * To run a query within a React component, call `useGetListSaleGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListSaleGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListSaleGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListSaleGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListSaleGroupsQuery, Types.GetListSaleGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListSaleGroupsQuery, Types.GetListSaleGroupsQueryVariables>(GetListSaleGroupsDocument, options);
      }
export function useGetListSaleGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListSaleGroupsQuery, Types.GetListSaleGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListSaleGroupsQuery, Types.GetListSaleGroupsQueryVariables>(GetListSaleGroupsDocument, options);
        }
export type GetListSaleGroupsQueryHookResult = ReturnType<typeof useGetListSaleGroupsQuery>;
export type GetListSaleGroupsLazyQueryHookResult = ReturnType<typeof useGetListSaleGroupsLazyQuery>;
export type GetListSaleGroupsQueryResult = Apollo.QueryResult<Types.GetListSaleGroupsQuery, Types.GetListSaleGroupsQueryVariables>;
export const ContractCheckoutDocument = gql`
    query contractCheckout($id: ID!, $sortBy: CheckoutLineSortingInput) {
  contractCheckout(id: $id) {
    id
    customer {
      id
      name
      code
      soldToCode
      representatives {
        firstName
        lastName
      }
    }
    contract {
      id
      paymentTerm
      contractNo
      currency
      startDate
      endDate
      projectName
    }
    lines(sortBy: $sortBy) {
      id
      quantity
      price
      product {
        id
        name
        salesUnit
        baseUnit
        purchaseUnit
        materialType
        materialCode
      }
      variant {
        id
        name
        weight
        salesUnit
        limitQuantity
      }
      contractProduct {
        id
      }
      selected
    }
  }
}
    `;

/**
 * __useContractCheckoutQuery__
 *
 * To run a query within a React component, call `useContractCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useContractCheckoutQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractCheckoutQuery, Types.ContractCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractCheckoutQuery, Types.ContractCheckoutQueryVariables>(ContractCheckoutDocument, options);
      }
export function useContractCheckoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractCheckoutQuery, Types.ContractCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractCheckoutQuery, Types.ContractCheckoutQueryVariables>(ContractCheckoutDocument, options);
        }
export type ContractCheckoutQueryHookResult = ReturnType<typeof useContractCheckoutQuery>;
export type ContractCheckoutLazyQueryHookResult = ReturnType<typeof useContractCheckoutLazyQuery>;
export type ContractCheckoutQueryResult = Apollo.QueryResult<Types.ContractCheckoutQuery, Types.ContractCheckoutQueryVariables>;
export const ContractCheckoutProductVariantDocument = gql`
    query contractCheckoutProductVariant($id: ID!) {
  contractCheckoutProductVariant(id: $id) {
    contractProduct {
      id
      name
      total
      remain
      salesUnit
      price
      deliveryOver
      deliveryUnder
      materialDescription
      productId
      contract {
        id
        contractNo
        prcGroup1
      }
    }
    productVariant {
      id
      name
      salesUnit
      baseUnit
      purchaseUnit
      materialType
      variants {
        id
        name: descriptionEn
        salesUnit
        descriptionEn
        limitQuantity
        variantType
        code
      }
    }
  }
}
    `;

/**
 * __useContractCheckoutProductVariantQuery__
 *
 * To run a query within a React component, call `useContractCheckoutProductVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractCheckoutProductVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractCheckoutProductVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractCheckoutProductVariantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractCheckoutProductVariantQuery, Types.ContractCheckoutProductVariantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractCheckoutProductVariantQuery, Types.ContractCheckoutProductVariantQueryVariables>(ContractCheckoutProductVariantDocument, options);
      }
export function useContractCheckoutProductVariantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractCheckoutProductVariantQuery, Types.ContractCheckoutProductVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractCheckoutProductVariantQuery, Types.ContractCheckoutProductVariantQueryVariables>(ContractCheckoutProductVariantDocument, options);
        }
export type ContractCheckoutProductVariantQueryHookResult = ReturnType<typeof useContractCheckoutProductVariantQuery>;
export type ContractCheckoutProductVariantLazyQueryHookResult = ReturnType<typeof useContractCheckoutProductVariantLazyQuery>;
export type ContractCheckoutProductVariantQueryResult = Apollo.QueryResult<Types.ContractCheckoutProductVariantQuery, Types.ContractCheckoutProductVariantQueryVariables>;
export const CustomerCheckoutContractDocument = gql`
    query CustomerCheckoutContract($id: ID!, $sortBy: CustomerProductSortingInput) {
  customerCheckoutContract(id: $id) {
    id
    code
    customer {
      id
      lastName
      firstName
      customerNo
    }
    company {
      id
      name
      businessUnit {
        name
      }
    }
    soldTo {
      code
      name
    }
    projectName
    startDate
    endDate
    paymentTerm
    products(sortBy: $sortBy) {
      id
      weight
      weightUnit
      remainingQuantity
      totalQuantity
      pricePerUnit
      product {
        id
        name: slug
        slug
        materialType
      }
    }
  }
}
    `;

/**
 * __useCustomerCheckoutContractQuery__
 *
 * To run a query within a React component, call `useCustomerCheckoutContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCheckoutContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCheckoutContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCustomerCheckoutContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerCheckoutContractQuery, Types.CustomerCheckoutContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerCheckoutContractQuery, Types.CustomerCheckoutContractQueryVariables>(CustomerCheckoutContractDocument, options);
      }
export function useCustomerCheckoutContractLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerCheckoutContractQuery, Types.CustomerCheckoutContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerCheckoutContractQuery, Types.CustomerCheckoutContractQueryVariables>(CustomerCheckoutContractDocument, options);
        }
export type CustomerCheckoutContractQueryHookResult = ReturnType<typeof useCustomerCheckoutContractQuery>;
export type CustomerCheckoutContractLazyQueryHookResult = ReturnType<typeof useCustomerCheckoutContractLazyQuery>;
export type CustomerCheckoutContractQueryResult = Apollo.QueryResult<Types.CustomerCheckoutContractQuery, Types.CustomerCheckoutContractQueryVariables>;
export const ContractOrderDocument = gql`
    query ContractOrder($soNo: String!) {
  contractOrder(soNo: $soNo) {
    id
    contract {
      currency
    }
    customer {
      id
      name
      code
      soldToCode
      representatives {
        addresses {
          streetAddress1
          streetAddress2
        }
        firstName
        lastName
      }
    }
    status
    poDate
    poNumber
    shipTo
    billTo
    requestDate
    internalCommentsToWarehouse
    internalCommentsToLogistic
    externalCommentsToCustomer
    productInformation
    orderType
    saleOrganization {
      id
      name
      code
    }
    distributionChannel {
      id
      name
      code
    }
    division {
      id
      name
      code
    }
    saleOffice {
      id
      name
      code
    }
    saleGroup {
      id
      name
      code
    }
    totalPrice
    orderLines {
      id
      order {
        id
      }
      product {
        id
        name
        salesUnit
      }
      variant {
        id
        name
        weight
      }
      quantity
      plant
      price
      netPrice
      requestDate
      internalCommentsToWarehouse
      shipTo
      paymentTerm
      productInformation
      checkoutLine {
        id
      }
      contractProduct {
        total
        remain
        price
        plant
        deliveryOver
        deliveryUnder
      }
    }
  }
}
    `;

/**
 * __useContractOrderQuery__
 *
 * To run a query within a React component, call `useContractOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractOrderQuery({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useContractOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ContractOrderQuery, Types.ContractOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ContractOrderQuery, Types.ContractOrderQueryVariables>(ContractOrderDocument, options);
      }
export function useContractOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ContractOrderQuery, Types.ContractOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ContractOrderQuery, Types.ContractOrderQueryVariables>(ContractOrderDocument, options);
        }
export type ContractOrderQueryHookResult = ReturnType<typeof useContractOrderQuery>;
export type ContractOrderLazyQueryHookResult = ReturnType<typeof useContractOrderLazyQuery>;
export type ContractOrderQueryResult = Apollo.QueryResult<Types.ContractOrderQuery, Types.ContractOrderQueryVariables>;
export const CustomerCartsDocument = gql`
    query customerCarts($first: Int, $sortBy: CustomerCartsSortingInput, $soldToId: ID!) {
  customerCarts(first: $first, sortBy: $sortBy, soldToId: $soldToId) {
    edges {
      node {
        id
        contract {
          code
          projectName
        }
        quantity
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useCustomerCartsQuery__
 *
 * To run a query within a React component, call `useCustomerCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCartsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      sortBy: // value for 'sortBy'
 *      soldToId: // value for 'soldToId'
 *   },
 * });
 */
export function useCustomerCartsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerCartsQuery, Types.CustomerCartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerCartsQuery, Types.CustomerCartsQueryVariables>(CustomerCartsDocument, options);
      }
export function useCustomerCartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerCartsQuery, Types.CustomerCartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerCartsQuery, Types.CustomerCartsQueryVariables>(CustomerCartsDocument, options);
        }
export type CustomerCartsQueryHookResult = ReturnType<typeof useCustomerCartsQuery>;
export type CustomerCartsLazyQueryHookResult = ReturnType<typeof useCustomerCartsLazyQuery>;
export type CustomerCartsQueryResult = Apollo.QueryResult<Types.CustomerCartsQuery, Types.CustomerCartsQueryVariables>;
export const CustomerCartTotalsDocument = gql`
    query customerCartTotals($soldToId: ID!) {
  customerCartTotals(soldToId: $soldToId) {
    totalContracts
    totalProducts
  }
}
    `;

/**
 * __useCustomerCartTotalsQuery__
 *
 * To run a query within a React component, call `useCustomerCartTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCartTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCartTotalsQuery({
 *   variables: {
 *      soldToId: // value for 'soldToId'
 *   },
 * });
 */
export function useCustomerCartTotalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerCartTotalsQuery, Types.CustomerCartTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerCartTotalsQuery, Types.CustomerCartTotalsQueryVariables>(CustomerCartTotalsDocument, options);
      }
export function useCustomerCartTotalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerCartTotalsQuery, Types.CustomerCartTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerCartTotalsQuery, Types.CustomerCartTotalsQueryVariables>(CustomerCartTotalsDocument, options);
        }
export type CustomerCartTotalsQueryHookResult = ReturnType<typeof useCustomerCartTotalsQuery>;
export type CustomerCartTotalsLazyQueryHookResult = ReturnType<typeof useCustomerCartTotalsLazyQuery>;
export type CustomerCartTotalsQueryResult = Apollo.QueryResult<Types.CustomerCartTotalsQuery, Types.CustomerCartTotalsQueryVariables>;
export const CustomerCartDocument = gql`
    query customerCart($cartId: ID!) {
  customerCart(id: $cartId) {
    id
    contract {
      id
      code
      projectName
    }
    quantity
    cartItems {
      id
      quantity
      contractProductId
      variant {
        id
        limitQuantity
        name
        salesUnit
      }
    }
  }
}
    `;

/**
 * __useCustomerCartQuery__
 *
 * To run a query within a React component, call `useCustomerCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCartQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useCustomerCartQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerCartQuery, Types.CustomerCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerCartQuery, Types.CustomerCartQueryVariables>(CustomerCartDocument, options);
      }
export function useCustomerCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerCartQuery, Types.CustomerCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerCartQuery, Types.CustomerCartQueryVariables>(CustomerCartDocument, options);
        }
export type CustomerCartQueryHookResult = ReturnType<typeof useCustomerCartQuery>;
export type CustomerCartLazyQueryHookResult = ReturnType<typeof useCustomerCartLazyQuery>;
export type CustomerCartQueryResult = Apollo.QueryResult<Types.CustomerCartQuery, Types.CustomerCartQueryVariables>;
export const CustomerCartProductVariantDocument = gql`
    query customerCartProductVariant($id: ID!) {
  customerCartProductVariant(id: $id) {
    contractProduct {
      id
      quantityUnit
      remainingQuantity
      materialDescription
      product {
        id
        name: slug
        slug
        materialType
        descriptionEn
        variants {
          id
          name: descriptionTh
          descriptionEn
          descriptionTh
          salesUnit
          weight
          limitQuantity
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerCartProductVariantQuery__
 *
 * To run a query within a React component, call `useCustomerCartProductVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCartProductVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCartProductVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerCartProductVariantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerCartProductVariantQuery, Types.CustomerCartProductVariantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerCartProductVariantQuery, Types.CustomerCartProductVariantQueryVariables>(CustomerCartProductVariantDocument, options);
      }
export function useCustomerCartProductVariantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerCartProductVariantQuery, Types.CustomerCartProductVariantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerCartProductVariantQuery, Types.CustomerCartProductVariantQueryVariables>(CustomerCartProductVariantDocument, options);
        }
export type CustomerCartProductVariantQueryHookResult = ReturnType<typeof useCustomerCartProductVariantQuery>;
export type CustomerCartProductVariantLazyQueryHookResult = ReturnType<typeof useCustomerCartProductVariantLazyQuery>;
export type CustomerCartProductVariantQueryResult = Apollo.QueryResult<Types.CustomerCartProductVariantQuery, Types.CustomerCartProductVariantQueryVariables>;
export const CustomerContractProductDocument = gql`
    query customerContractProduct($contractId: ID!, $productId: ID!, $contractMaterialId: ID!, $orderId: ID) {
  customerContractProduct(
    contractId: $contractId
    productId: $productId
    contractMaterialId: $contractMaterialId
  ) {
    id
    product {
      name: slug
      slug
      descriptionEn
      variants {
        id
        variantType
        name: descriptionTh
        descriptionTh
        descriptionEn
        weight
      }
    }
    contract {
      currency
    }
    totalQuantity
    remainingQuantity(orderId: $orderId)
    pricePerUnit
    currency
    weightUnit
  }
}
    `;

/**
 * __useCustomerContractProductQuery__
 *
 * To run a query within a React component, call `useCustomerContractProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractProductQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *      productId: // value for 'productId'
 *      contractMaterialId: // value for 'contractMaterialId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCustomerContractProductQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerContractProductQuery, Types.CustomerContractProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerContractProductQuery, Types.CustomerContractProductQueryVariables>(CustomerContractProductDocument, options);
      }
export function useCustomerContractProductLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerContractProductQuery, Types.CustomerContractProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerContractProductQuery, Types.CustomerContractProductQueryVariables>(CustomerContractProductDocument, options);
        }
export type CustomerContractProductQueryHookResult = ReturnType<typeof useCustomerContractProductQuery>;
export type CustomerContractProductLazyQueryHookResult = ReturnType<typeof useCustomerContractProductLazyQuery>;
export type CustomerContractProductQueryResult = Apollo.QueryResult<Types.CustomerContractProductQuery, Types.CustomerContractProductQueryVariables>;
export const MaterialSearchSuggestionDocument = gql`
    query materialSearchSuggestion($first: Int, $filter: MaterialMasterFilterInput, $distributionChannelType: DistributionChannelType!) {
  materialSearchSuggestion(
    first: $first
    filter: $filter
    distributionChannelType: $distributionChannelType
  ) {
    edges {
      node {
        id
        code
      }
    }
  }
}
    `;

/**
 * __useMaterialSearchSuggestionQuery__
 *
 * To run a query within a React component, call `useMaterialSearchSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialSearchSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialSearchSuggestionQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      distributionChannelType: // value for 'distributionChannelType'
 *   },
 * });
 */
export function useMaterialSearchSuggestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.MaterialSearchSuggestionQuery, Types.MaterialSearchSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.MaterialSearchSuggestionQuery, Types.MaterialSearchSuggestionQueryVariables>(MaterialSearchSuggestionDocument, options);
      }
export function useMaterialSearchSuggestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.MaterialSearchSuggestionQuery, Types.MaterialSearchSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.MaterialSearchSuggestionQuery, Types.MaterialSearchSuggestionQueryVariables>(MaterialSearchSuggestionDocument, options);
        }
export type MaterialSearchSuggestionQueryHookResult = ReturnType<typeof useMaterialSearchSuggestionQuery>;
export type MaterialSearchSuggestionLazyQueryHookResult = ReturnType<typeof useMaterialSearchSuggestionLazyQuery>;
export type MaterialSearchSuggestionQueryResult = Apollo.QueryResult<Types.MaterialSearchSuggestionQuery, Types.MaterialSearchSuggestionQueryVariables>;
export const GradeGramSearchSuggestionDocument = gql`
    query gradeGramSearchSuggestion($first: Int, $filter: MaterialMasterFilterInput, $distributionChannelType: DistributionChannelType!) {
  materialSearchSuggestion(
    first: $first
    filter: $filter
    distributionChannelType: $distributionChannelType
  ) {
    edges {
      node {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGradeGramSearchSuggestionQuery__
 *
 * To run a query within a React component, call `useGradeGramSearchSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradeGramSearchSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradeGramSearchSuggestionQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      distributionChannelType: // value for 'distributionChannelType'
 *   },
 * });
 */
export function useGradeGramSearchSuggestionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GradeGramSearchSuggestionQuery, Types.GradeGramSearchSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GradeGramSearchSuggestionQuery, Types.GradeGramSearchSuggestionQueryVariables>(GradeGramSearchSuggestionDocument, options);
      }
export function useGradeGramSearchSuggestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GradeGramSearchSuggestionQuery, Types.GradeGramSearchSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GradeGramSearchSuggestionQuery, Types.GradeGramSearchSuggestionQueryVariables>(GradeGramSearchSuggestionDocument, options);
        }
export type GradeGramSearchSuggestionQueryHookResult = ReturnType<typeof useGradeGramSearchSuggestionQuery>;
export type GradeGramSearchSuggestionLazyQueryHookResult = ReturnType<typeof useGradeGramSearchSuggestionLazyQuery>;
export type GradeGramSearchSuggestionQueryResult = Apollo.QueryResult<Types.GradeGramSearchSuggestionQuery, Types.GradeGramSearchSuggestionQueryVariables>;
export const GetCartProductItemsDocument = gql`
    query getCartProductItems($soldToCode: String!, $contractCode: String!) {
  cartProductItems(soldToCode: $soldToCode, contractCode: $contractCode) {
    id
    quantity
    product {
      id
      name
    }
    contractProduct {
      id
    }
    variant {
      id
      name
      weight
      salesUnit
    }
    selected
  }
}
    `;

/**
 * __useGetCartProductItemsQuery__
 *
 * To run a query within a React component, call `useGetCartProductItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartProductItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartProductItemsQuery({
 *   variables: {
 *      soldToCode: // value for 'soldToCode'
 *      contractCode: // value for 'contractCode'
 *   },
 * });
 */
export function useGetCartProductItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetCartProductItemsQuery, Types.GetCartProductItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCartProductItemsQuery, Types.GetCartProductItemsQueryVariables>(GetCartProductItemsDocument, options);
      }
export function useGetCartProductItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCartProductItemsQuery, Types.GetCartProductItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCartProductItemsQuery, Types.GetCartProductItemsQueryVariables>(GetCartProductItemsDocument, options);
        }
export type GetCartProductItemsQueryHookResult = ReturnType<typeof useGetCartProductItemsQuery>;
export type GetCartProductItemsLazyQueryHookResult = ReturnType<typeof useGetCartProductItemsLazyQuery>;
export type GetCartProductItemsQueryResult = Apollo.QueryResult<Types.GetCartProductItemsQuery, Types.GetCartProductItemsQueryVariables>;
export const CreateCustomerOrderDocument = gql`
    mutation CreateCustomerOrder($input: CreateCustomerOrderInput!) {
  createCustomerOrder(input: $input) {
    order {
      id
      contract {
        soldTo {
          id
          code
          name
          representatives {
            id
            email
          }
        }
        company {
          id
          name
        }
        code
        projectName
        startDate
        endDate
        paymentTerm
      }
      totalPrice
      totalPriceIncTax
      taxAmount
      status
      orderDate
      orderNo
      requestDeliveryDate
      shipTo
      billTo
      unloadingPoint
      remarkForInvoice
      remarkForLogistic
      createdAt
      updatedAt
      lines {
        order {
          orderNo
        }
        contractProduct {
          contract {
            projectName
          }
          product {
            name
            slug
          }
          pricePerUnit
          quantityUnit
          currency
          weight
          weightUnit
        }
        variant {
          name
          slug
        }
        quantity
        quantityUnit
        weightPerUnit
        totalWeight
        pricePerUnit
        totalPrice
        requestDeliveryDate
      }
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type CreateCustomerOrderMutationFn = Apollo.MutationFunction<Types.CreateCustomerOrderMutation, Types.CreateCustomerOrderMutationVariables>;

/**
 * __useCreateCustomerOrderMutation__
 *
 * To run a mutation, you first call `useCreateCustomerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerOrderMutation, { data, loading, error }] = useCreateCustomerOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CreateCustomerOrderMutation, Types.CreateCustomerOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CreateCustomerOrderMutation, Types.CreateCustomerOrderMutationVariables>(CreateCustomerOrderDocument, options);
      }
export type CreateCustomerOrderMutationHookResult = ReturnType<typeof useCreateCustomerOrderMutation>;
export type CreateCustomerOrderMutationResult = Apollo.MutationResult<Types.CreateCustomerOrderMutation>;
export type CreateCustomerOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateCustomerOrderMutation, Types.CreateCustomerOrderMutationVariables>;
export const AddProductToCustomerOrderDocument = gql`
    mutation AddProductToCustomerOrder($id: ID!, $input: [CustomerOrderLineInput!]!) {
  addProductToCustomerOrder(id: $id, input: $input) {
    order {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type AddProductToCustomerOrderMutationFn = Apollo.MutationFunction<Types.AddProductToCustomerOrderMutation, Types.AddProductToCustomerOrderMutationVariables>;

/**
 * __useAddProductToCustomerOrderMutation__
 *
 * To run a mutation, you first call `useAddProductToCustomerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToCustomerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToCustomerOrderMutation, { data, loading, error }] = useAddProductToCustomerOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductToCustomerOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddProductToCustomerOrderMutation, Types.AddProductToCustomerOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddProductToCustomerOrderMutation, Types.AddProductToCustomerOrderMutationVariables>(AddProductToCustomerOrderDocument, options);
      }
export type AddProductToCustomerOrderMutationHookResult = ReturnType<typeof useAddProductToCustomerOrderMutation>;
export type AddProductToCustomerOrderMutationResult = Apollo.MutationResult<Types.AddProductToCustomerOrderMutation>;
export type AddProductToCustomerOrderMutationOptions = Apollo.BaseMutationOptions<Types.AddProductToCustomerOrderMutation, Types.AddProductToCustomerOrderMutationVariables>;
export const UpdateCustomerOrderDocument = gql`
    mutation UpdateCustomerOrder($id: ID!, $input: CustomerOrderInformationUpdateInput!) {
  updateCustomerOrder(id: $id, input: $input) {
    errors {
      field
      message
      code
    }
    order {
      id
      status
    }
    success
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      errorCode
      itemNo
      errorMessage
    }
    warningMessages {
      message
      order
      source
    }
  }
}
    `;
export type UpdateCustomerOrderMutationFn = Apollo.MutationFunction<Types.UpdateCustomerOrderMutation, Types.UpdateCustomerOrderMutationVariables>;

/**
 * __useUpdateCustomerOrderMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerOrderMutation, { data, loading, error }] = useUpdateCustomerOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateCustomerOrderMutation, Types.UpdateCustomerOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateCustomerOrderMutation, Types.UpdateCustomerOrderMutationVariables>(UpdateCustomerOrderDocument, options);
      }
export type UpdateCustomerOrderMutationHookResult = ReturnType<typeof useUpdateCustomerOrderMutation>;
export type UpdateCustomerOrderMutationResult = Apollo.MutationResult<Types.UpdateCustomerOrderMutation>;
export type UpdateCustomerOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomerOrderMutation, Types.UpdateCustomerOrderMutationVariables>;
export const DeleteCustomerOrderLinesDocument = gql`
    mutation DeleteCustomerOrderLines($ids: [ID], $deleteAll: Boolean, $orderId: ID) {
  deleteCustomerOrderLines(ids: $ids, deleteAll: $deleteAll, orderId: $orderId) {
    errors {
      field
      message
    }
    status
  }
}
    `;
export type DeleteCustomerOrderLinesMutationFn = Apollo.MutationFunction<Types.DeleteCustomerOrderLinesMutation, Types.DeleteCustomerOrderLinesMutationVariables>;

/**
 * __useDeleteCustomerOrderLinesMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerOrderLinesMutation, { data, loading, error }] = useDeleteCustomerOrderLinesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      deleteAll: // value for 'deleteAll'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useDeleteCustomerOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteCustomerOrderLinesMutation, Types.DeleteCustomerOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteCustomerOrderLinesMutation, Types.DeleteCustomerOrderLinesMutationVariables>(DeleteCustomerOrderLinesDocument, options);
      }
export type DeleteCustomerOrderLinesMutationHookResult = ReturnType<typeof useDeleteCustomerOrderLinesMutation>;
export type DeleteCustomerOrderLinesMutationResult = Apollo.MutationResult<Types.DeleteCustomerOrderLinesMutation>;
export type DeleteCustomerOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteCustomerOrderLinesMutation, Types.DeleteCustomerOrderLinesMutationVariables>;
export const UpdateCustomerOrderLinesDocument = gql`
    mutation UpdateCustomerOrderLines($orderId: ID!, $input: CustomerOrderLinesUpdateInput!) {
  updateCustomerOrderLines(orderId: $orderId, input: $input) {
    errors {
      field
      message
      code
    }
    order {
      id
    }
  }
}
    `;
export type UpdateCustomerOrderLinesMutationFn = Apollo.MutationFunction<Types.UpdateCustomerOrderLinesMutation, Types.UpdateCustomerOrderLinesMutationVariables>;

/**
 * __useUpdateCustomerOrderLinesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerOrderLinesMutation, { data, loading, error }] = useUpdateCustomerOrderLinesMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateCustomerOrderLinesMutation, Types.UpdateCustomerOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateCustomerOrderLinesMutation, Types.UpdateCustomerOrderLinesMutationVariables>(UpdateCustomerOrderLinesDocument, options);
      }
export type UpdateCustomerOrderLinesMutationHookResult = ReturnType<typeof useUpdateCustomerOrderLinesMutation>;
export type UpdateCustomerOrderLinesMutationResult = Apollo.MutationResult<Types.UpdateCustomerOrderLinesMutation>;
export type UpdateCustomerOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomerOrderLinesMutation, Types.UpdateCustomerOrderLinesMutationVariables>;
export const UpdateRequestDateOnIplanDocument = gql`
    mutation updateRequestDateOnIplan($orderLinesId: [ID]!, $confirm: Boolean) {
  updateRequestDateOnIplan(orderLinesId: $orderLinesId, confirm: $confirm) {
    status
    errors {
      field
      message
      code
    }
  }
}
    `;
export type UpdateRequestDateOnIplanMutationFn = Apollo.MutationFunction<Types.UpdateRequestDateOnIplanMutation, Types.UpdateRequestDateOnIplanMutationVariables>;

/**
 * __useUpdateRequestDateOnIplanMutation__
 *
 * To run a mutation, you first call `useUpdateRequestDateOnIplanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestDateOnIplanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestDateOnIplanMutation, { data, loading, error }] = useUpdateRequestDateOnIplanMutation({
 *   variables: {
 *      orderLinesId: // value for 'orderLinesId'
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useUpdateRequestDateOnIplanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateRequestDateOnIplanMutation, Types.UpdateRequestDateOnIplanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateRequestDateOnIplanMutation, Types.UpdateRequestDateOnIplanMutationVariables>(UpdateRequestDateOnIplanDocument, options);
      }
export type UpdateRequestDateOnIplanMutationHookResult = ReturnType<typeof useUpdateRequestDateOnIplanMutation>;
export type UpdateRequestDateOnIplanMutationResult = Apollo.MutationResult<Types.UpdateRequestDateOnIplanMutation>;
export type UpdateRequestDateOnIplanMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRequestDateOnIplanMutation, Types.UpdateRequestDateOnIplanMutationVariables>;
export const CustomerUnloadingPointsDocument = gql`
    query customerUnloadingPoints($soldTo: String!) {
  contractUnloadingPoint(soldToCode: $soldTo) {
    unloadingPoint
  }
}
    `;

/**
 * __useCustomerUnloadingPointsQuery__
 *
 * To run a query within a React component, call `useCustomerUnloadingPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerUnloadingPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerUnloadingPointsQuery({
 *   variables: {
 *      soldTo: // value for 'soldTo'
 *   },
 * });
 */
export function useCustomerUnloadingPointsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerUnloadingPointsQuery, Types.CustomerUnloadingPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerUnloadingPointsQuery, Types.CustomerUnloadingPointsQueryVariables>(CustomerUnloadingPointsDocument, options);
      }
export function useCustomerUnloadingPointsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerUnloadingPointsQuery, Types.CustomerUnloadingPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerUnloadingPointsQuery, Types.CustomerUnloadingPointsQueryVariables>(CustomerUnloadingPointsDocument, options);
        }
export type CustomerUnloadingPointsQueryHookResult = ReturnType<typeof useCustomerUnloadingPointsQuery>;
export type CustomerUnloadingPointsLazyQueryHookResult = ReturnType<typeof useCustomerUnloadingPointsLazyQuery>;
export type CustomerUnloadingPointsQueryResult = Apollo.QueryResult<Types.CustomerUnloadingPointsQuery, Types.CustomerUnloadingPointsQueryVariables>;
export const CustomerContractsDocument = gql`
    query CustomerContracts($contractNo: [String], $soldToId: ID!, $before: String, $after: String, $first: Int, $last: Int, $filter: CustomerContractFilterInput, $sortBy: CustomerContractsSortingInput) {
  scgpCustomerContracts(
    contractNo: $contractNo
    soldToId: $soldToId
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
    sortBy: $sortBy
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      node {
        id
        soldTo {
          representatives {
            id
          }
        }
        company {
          name
          shortName
          fullName
        }
        customer {
          id
        }
        code
        projectName
        startDate
        endDate
        paymentTerm
        paymentTermKey
        paymentTermDescriptionTh
        products {
          totalQuantity
          remainingQuantity
          pricePerUnit
          quantityUnit
          currency
          weight
          weightUnit
          limitQuantity
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerContractsQuery__
 *
 * To run a query within a React component, call `useCustomerContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerContractsQuery({
 *   variables: {
 *      contractNo: // value for 'contractNo'
 *      soldToId: // value for 'soldToId'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useCustomerContractsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerContractsQuery, Types.CustomerContractsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerContractsQuery, Types.CustomerContractsQueryVariables>(CustomerContractsDocument, options);
      }
export function useCustomerContractsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerContractsQuery, Types.CustomerContractsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerContractsQuery, Types.CustomerContractsQueryVariables>(CustomerContractsDocument, options);
        }
export type CustomerContractsQueryHookResult = ReturnType<typeof useCustomerContractsQuery>;
export type CustomerContractsLazyQueryHookResult = ReturnType<typeof useCustomerContractsLazyQuery>;
export type CustomerContractsQueryResult = Apollo.QueryResult<Types.CustomerContractsQuery, Types.CustomerContractsQueryVariables>;
export const CustomerOrderDocument = gql`
    query CustomerOrder($orderId: ID!, $before: String, $after: String, $first: Int, $last: Int) {
  customerOrder(orderId: $orderId) {
    id
    contract {
      id
      code
      projectName
      paymentTerm
      paymentTermDescriptionTh
      currency
      company {
        id
        name
        businessUnit {
          id
          name
        }
      }
      soldTo {
        id
        code
        name
      }
      startDate
      endDate
    }
    totalPrice
    totalPriceIncTax
    taxAmount
    taxPercent
    orderDate
    orderNo
    requestDeliveryDate
    shipTo
    billTo
    unloadingPoint
    remarkForInvoice
    remarkForLogistic
    status
    lines(before: $before, after: $after, first: $first, last: $last) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          availableQuantity
          id
          quantity
          quantityUnit
          weightPerUnit
          totalWeight
          pricePerUnit
          totalPrice
          contractProduct {
            id
            pricePerUnit
            remainingQuantity
            totalQuantity
            contract {
              id
              paymentTerm
              paymentTermDescriptionTh
            }
            product {
              id
              name
            }
          }
          variant {
            id
            name
            descriptionEn
            limitQuantity
          }
          requestDeliveryDate
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerOrderQuery__
 *
 * To run a query within a React component, call `useCustomerOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useCustomerOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerOrderQuery, Types.CustomerOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerOrderQuery, Types.CustomerOrderQueryVariables>(CustomerOrderDocument, options);
      }
export function useCustomerOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerOrderQuery, Types.CustomerOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerOrderQuery, Types.CustomerOrderQueryVariables>(CustomerOrderDocument, options);
        }
export type CustomerOrderQueryHookResult = ReturnType<typeof useCustomerOrderQuery>;
export type CustomerOrderLazyQueryHookResult = ReturnType<typeof useCustomerOrderLazyQuery>;
export type CustomerOrderQueryResult = Apollo.QueryResult<Types.CustomerOrderQuery, Types.CustomerOrderQueryVariables>;
export const CustomerOrderHeaderDocument = gql`
    query CustomerOrderHeader($orderId: ID!) {
  customerOrder(orderId: $orderId) {
    id
    soldToAddress
    contract {
      id
      currency
      code
      projectName
      paymentTerm
      paymentTermDescriptionTh
      company {
        id
        name
        businessUnit {
          id
          name
        }
      }
      soldTo {
        id
        code
        name
      }
      startDate
      endDate
    }
    totalPrice
    totalPriceIncTax
    taxPercent
    taxAmount
    orderDate
    orderNo
    requestDeliveryDate
    shipTo
    billTo
    unloadingPoint
    internalCommentsToWarehouse
    internalCommentsToLogistic
    remarkForInvoice
    remarkForLogistic
    status
    createdBy {
      id
      addresses {
        streetAddress1
        streetAddress2
      }
      firstName
      lastName
      company {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCustomerOrderHeaderQuery__
 *
 * To run a query within a React component, call `useCustomerOrderHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrderHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrderHeaderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCustomerOrderHeaderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerOrderHeaderQuery, Types.CustomerOrderHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerOrderHeaderQuery, Types.CustomerOrderHeaderQueryVariables>(CustomerOrderHeaderDocument, options);
      }
export function useCustomerOrderHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerOrderHeaderQuery, Types.CustomerOrderHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerOrderHeaderQuery, Types.CustomerOrderHeaderQueryVariables>(CustomerOrderHeaderDocument, options);
        }
export type CustomerOrderHeaderQueryHookResult = ReturnType<typeof useCustomerOrderHeaderQuery>;
export type CustomerOrderHeaderLazyQueryHookResult = ReturnType<typeof useCustomerOrderHeaderLazyQuery>;
export type CustomerOrderHeaderQueryResult = Apollo.QueryResult<Types.CustomerOrderHeaderQuery, Types.CustomerOrderHeaderQueryVariables>;
export const ScgpCustomerContractDocument = gql`
    query scgpCustomerContract($id: ID!) {
  scgpCustomerContract(id: $id) {
    id
    code
    currency
    soldTo {
      id
      code
      name
    }
    customer {
      id
      firstName
      lastName
      customerNo
    }
    projectName
    startDate
    endDate
    paymentTerm
    paymentTermKey
    paymentTermDescriptionTh
    company {
      businessUnit {
        name
      }
      name
      shortName
      fullName
    }
    products {
      id
      weightUnit
      remainingQuantity
      totalQuantity
      pricePerUnit
      limitQuantity
      materialDescription
      product {
        name
        id
        materialType
        descriptionEn
      }
    }
  }
}
    `;

/**
 * __useScgpCustomerContractQuery__
 *
 * To run a query within a React component, call `useScgpCustomerContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useScgpCustomerContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScgpCustomerContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScgpCustomerContractQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ScgpCustomerContractQuery, Types.ScgpCustomerContractQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ScgpCustomerContractQuery, Types.ScgpCustomerContractQueryVariables>(ScgpCustomerContractDocument, options);
      }
export function useScgpCustomerContractLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ScgpCustomerContractQuery, Types.ScgpCustomerContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ScgpCustomerContractQuery, Types.ScgpCustomerContractQueryVariables>(ScgpCustomerContractDocument, options);
        }
export type ScgpCustomerContractQueryHookResult = ReturnType<typeof useScgpCustomerContractQuery>;
export type ScgpCustomerContractLazyQueryHookResult = ReturnType<typeof useScgpCustomerContractLazyQuery>;
export type ScgpCustomerContractQueryResult = Apollo.QueryResult<Types.ScgpCustomerContractQuery, Types.ScgpCustomerContractQueryVariables>;
export const PreviewCustomerOrderDocument = gql`
    query previewCustomerOrder($id: ID!, $sortBy: OrderLinesSortingInput, $before: String, $after: String, $first: Int, $last: Int) {
  previewCustomerOrder(id: $id) {
    id
    totalPrice
    taxAmount
    totalPriceIncTax
    currency {
      code
    }
    contract {
      code
      projectName
    }
    soNo
    poNo
    orderNo
    createdAt
    paymentTerm
    paymentTermDescriptionTh
    shipTo
    customerSoldToOrder
    soldToAddress
    previewOrderLines(
      sortBy: $sortBy
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      latestPageItemNumber
      totalCount
      edges {
        node {
          id
          itemNo
          materialVariantCode
          materialDescription
          quantity
          contractProduct {
            product {
              descriptionEn
              salesUnit
            }
          }
          logErrors
          logOldProduct
          descriptionEn
          salesUnit
          orderQuantityTon
          requestDeliveryDate
          confirmedDate
          originalRequestDate
        }
      }
    }
    failOrderLines {
      id
      itemNo
      materialVariantCode
      materialDescription
      contractProduct {
        product {
          descriptionEn
          salesUnit
        }
      }
      descriptionEn
      quantity
      salesUnit
      orderQuantityTon
      requestDeliveryDate
      confirmedDate
    }
  }
}
    `;

/**
 * __usePreviewCustomerOrderQuery__
 *
 * To run a query within a React component, call `usePreviewCustomerOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCustomerOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCustomerOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePreviewCustomerOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PreviewCustomerOrderQuery, Types.PreviewCustomerOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PreviewCustomerOrderQuery, Types.PreviewCustomerOrderQueryVariables>(PreviewCustomerOrderDocument, options);
      }
export function usePreviewCustomerOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PreviewCustomerOrderQuery, Types.PreviewCustomerOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PreviewCustomerOrderQuery, Types.PreviewCustomerOrderQueryVariables>(PreviewCustomerOrderDocument, options);
        }
export type PreviewCustomerOrderQueryHookResult = ReturnType<typeof usePreviewCustomerOrderQuery>;
export type PreviewCustomerOrderLazyQueryHookResult = ReturnType<typeof usePreviewCustomerOrderLazyQuery>;
export type PreviewCustomerOrderQueryResult = Apollo.QueryResult<Types.PreviewCustomerOrderQuery, Types.PreviewCustomerOrderQueryVariables>;
export const UpdateOrderLinesDomesticDocument = gql`
    mutation updateOrderLinesDomestic($id: ID!, $input: ContractOrderLinesUpdateInput!) {
  updateOrderLines(id: $id, input: $input) {
    errors {
      message
      code
    }
    order {
      id
      orderLines {
        id
        requestDate
        productInformation
        unit
        externalCommentsToCustomer
        internalCommentsToLogistic
        internalCommentsToWarehouse
        shipTo
        billTo
        shippingPoint
        route
      }
    }
  }
}
    `;
export type UpdateOrderLinesDomesticMutationFn = Apollo.MutationFunction<Types.UpdateOrderLinesDomesticMutation, Types.UpdateOrderLinesDomesticMutationVariables>;

/**
 * __useUpdateOrderLinesDomesticMutation__
 *
 * To run a mutation, you first call `useUpdateOrderLinesDomesticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderLinesDomesticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderLinesDomesticMutation, { data, loading, error }] = useUpdateOrderLinesDomesticMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderLinesDomesticMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateOrderLinesDomesticMutation, Types.UpdateOrderLinesDomesticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateOrderLinesDomesticMutation, Types.UpdateOrderLinesDomesticMutationVariables>(UpdateOrderLinesDomesticDocument, options);
      }
export type UpdateOrderLinesDomesticMutationHookResult = ReturnType<typeof useUpdateOrderLinesDomesticMutation>;
export type UpdateOrderLinesDomesticMutationResult = Apollo.MutationResult<Types.UpdateOrderLinesDomesticMutation>;
export type UpdateOrderLinesDomesticMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrderLinesDomesticMutation, Types.UpdateOrderLinesDomesticMutationVariables>;
export const DeleteContractOrderLinesDomesticDocument = gql`
    mutation deleteContractOrderLinesDomestic($ids: [ID]!) {
  deleteContractOrderLines(ids: $ids) {
    errors {
      code
      field
      message
      __typename
    }
    __typename
  }
}
    `;
export type DeleteContractOrderLinesDomesticMutationFn = Apollo.MutationFunction<Types.DeleteContractOrderLinesDomesticMutation, Types.DeleteContractOrderLinesDomesticMutationVariables>;

/**
 * __useDeleteContractOrderLinesDomesticMutation__
 *
 * To run a mutation, you first call `useDeleteContractOrderLinesDomesticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractOrderLinesDomesticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractOrderLinesDomesticMutation, { data, loading, error }] = useDeleteContractOrderLinesDomesticMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteContractOrderLinesDomesticMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteContractOrderLinesDomesticMutation, Types.DeleteContractOrderLinesDomesticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteContractOrderLinesDomesticMutation, Types.DeleteContractOrderLinesDomesticMutationVariables>(DeleteContractOrderLinesDomesticDocument, options);
      }
export type DeleteContractOrderLinesDomesticMutationHookResult = ReturnType<typeof useDeleteContractOrderLinesDomesticMutation>;
export type DeleteContractOrderLinesDomesticMutationResult = Apollo.MutationResult<Types.DeleteContractOrderLinesDomesticMutation>;
export type DeleteContractOrderLinesDomesticMutationOptions = Apollo.BaseMutationOptions<Types.DeleteContractOrderLinesDomesticMutation, Types.DeleteContractOrderLinesDomesticMutationVariables>;
export const DeleteAndSyncOrderLineDocument = gql`
    mutation deleteAndSyncOrderLine($soNo: String) {
  deleteAndSyncOrderLine(soNo: $soNo) {
    status
  }
}
    `;
export type DeleteAndSyncOrderLineMutationFn = Apollo.MutationFunction<Types.DeleteAndSyncOrderLineMutation, Types.DeleteAndSyncOrderLineMutationVariables>;

/**
 * __useDeleteAndSyncOrderLineMutation__
 *
 * To run a mutation, you first call `useDeleteAndSyncOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAndSyncOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAndSyncOrderLineMutation, { data, loading, error }] = useDeleteAndSyncOrderLineMutation({
 *   variables: {
 *      soNo: // value for 'soNo'
 *   },
 * });
 */
export function useDeleteAndSyncOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteAndSyncOrderLineMutation, Types.DeleteAndSyncOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteAndSyncOrderLineMutation, Types.DeleteAndSyncOrderLineMutationVariables>(DeleteAndSyncOrderLineDocument, options);
      }
export type DeleteAndSyncOrderLineMutationHookResult = ReturnType<typeof useDeleteAndSyncOrderLineMutation>;
export type DeleteAndSyncOrderLineMutationResult = Apollo.MutationResult<Types.DeleteAndSyncOrderLineMutation>;
export type DeleteAndSyncOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.DeleteAndSyncOrderLineMutation, Types.DeleteAndSyncOrderLineMutationVariables>;
export const UpdateAllContractOrderLineDomesticDocument = gql`
    mutation updateAllContractOrderLineDomestic($id: ID!, $plant: String, $requestDate: Date) {
  updateAllContractOrderLine(id: $id, plant: $plant, requestDate: $requestDate) {
    orderline {
      id
    }
  }
}
    `;
export type UpdateAllContractOrderLineDomesticMutationFn = Apollo.MutationFunction<Types.UpdateAllContractOrderLineDomesticMutation, Types.UpdateAllContractOrderLineDomesticMutationVariables>;

/**
 * __useUpdateAllContractOrderLineDomesticMutation__
 *
 * To run a mutation, you first call `useUpdateAllContractOrderLineDomesticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllContractOrderLineDomesticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllContractOrderLineDomesticMutation, { data, loading, error }] = useUpdateAllContractOrderLineDomesticMutation({
 *   variables: {
 *      id: // value for 'id'
 *      plant: // value for 'plant'
 *      requestDate: // value for 'requestDate'
 *   },
 * });
 */
export function useUpdateAllContractOrderLineDomesticMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateAllContractOrderLineDomesticMutation, Types.UpdateAllContractOrderLineDomesticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateAllContractOrderLineDomesticMutation, Types.UpdateAllContractOrderLineDomesticMutationVariables>(UpdateAllContractOrderLineDomesticDocument, options);
      }
export type UpdateAllContractOrderLineDomesticMutationHookResult = ReturnType<typeof useUpdateAllContractOrderLineDomesticMutation>;
export type UpdateAllContractOrderLineDomesticMutationResult = Apollo.MutationResult<Types.UpdateAllContractOrderLineDomesticMutation>;
export type UpdateAllContractOrderLineDomesticMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAllContractOrderLineDomesticMutation, Types.UpdateAllContractOrderLineDomesticMutationVariables>;
export const UpdateRequireAttentionItemsParameterDomesticDocument = gql`
    mutation updateRequireAttentionItemsParameterDomestic($input: RequireAttentionItemParameterUpdateInput, $itemsId: String!) {
  updateRequireAttentionItemsParameter(input: $input, itemsId: $itemsId) {
    errors {
      field
      message
      code
    }
    requireAttentionItems {
      inquiryMethodCode
      transportationMethod
      typeOfDeliveryValue
      fixSourceAssignment
      splitOrderItemValue
      partialDeliveryValue
      consignmentValue
    }
  }
}
    `;
export type UpdateRequireAttentionItemsParameterDomesticMutationFn = Apollo.MutationFunction<Types.UpdateRequireAttentionItemsParameterDomesticMutation, Types.UpdateRequireAttentionItemsParameterDomesticMutationVariables>;

/**
 * __useUpdateRequireAttentionItemsParameterDomesticMutation__
 *
 * To run a mutation, you first call `useUpdateRequireAttentionItemsParameterDomesticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequireAttentionItemsParameterDomesticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequireAttentionItemsParameterDomesticMutation, { data, loading, error }] = useUpdateRequireAttentionItemsParameterDomesticMutation({
 *   variables: {
 *      input: // value for 'input'
 *      itemsId: // value for 'itemsId'
 *   },
 * });
 */
export function useUpdateRequireAttentionItemsParameterDomesticMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateRequireAttentionItemsParameterDomesticMutation, Types.UpdateRequireAttentionItemsParameterDomesticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateRequireAttentionItemsParameterDomesticMutation, Types.UpdateRequireAttentionItemsParameterDomesticMutationVariables>(UpdateRequireAttentionItemsParameterDomesticDocument, options);
      }
export type UpdateRequireAttentionItemsParameterDomesticMutationHookResult = ReturnType<typeof useUpdateRequireAttentionItemsParameterDomesticMutation>;
export type UpdateRequireAttentionItemsParameterDomesticMutationResult = Apollo.MutationResult<Types.UpdateRequireAttentionItemsParameterDomesticMutation>;
export type UpdateRequireAttentionItemsParameterDomesticMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRequireAttentionItemsParameterDomesticMutation, Types.UpdateRequireAttentionItemsParameterDomesticMutationVariables>;
export const UpdateContractOrderDomesticDocument = gql`
    mutation updateContractOrderDomestic($id: ID!, $input: ContractOrderUpdateInput!) {
  updateContractOrder(id: $id, input: $input) {
    order {
      id
    }
    success
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      errorCode
      errorMessage
      itemNo
    }
    errors {
      field
      message
      code
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    warningMessages {
      message
      order
      source
    }
    eorWarnings {
      message
      order
      source
    }
  }
}
    `;
export type UpdateContractOrderDomesticMutationFn = Apollo.MutationFunction<Types.UpdateContractOrderDomesticMutation, Types.UpdateContractOrderDomesticMutationVariables>;

/**
 * __useUpdateContractOrderDomesticMutation__
 *
 * To run a mutation, you first call `useUpdateContractOrderDomesticMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractOrderDomesticMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractOrderDomesticMutation, { data, loading, error }] = useUpdateContractOrderDomesticMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractOrderDomesticMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateContractOrderDomesticMutation, Types.UpdateContractOrderDomesticMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateContractOrderDomesticMutation, Types.UpdateContractOrderDomesticMutationVariables>(UpdateContractOrderDomesticDocument, options);
      }
export type UpdateContractOrderDomesticMutationHookResult = ReturnType<typeof useUpdateContractOrderDomesticMutation>;
export type UpdateContractOrderDomesticMutationResult = Apollo.MutationResult<Types.UpdateContractOrderDomesticMutation>;
export type UpdateContractOrderDomesticMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContractOrderDomesticMutation, Types.UpdateContractOrderDomesticMutationVariables>;
export const ChangeParameterIPlanDocument = gql`
    mutation changeParameterIPlan($orderLineId: ID!) {
  changeParameterIPlan(orderLineId: $orderLineId) {
    errors {
      field
      message
      code
    }
    dropdown {
      dropdownDomesticOrExport
      dropdownAsapClearStock
    }
  }
}
    `;
export type ChangeParameterIPlanMutationFn = Apollo.MutationFunction<Types.ChangeParameterIPlanMutation, Types.ChangeParameterIPlanMutationVariables>;

/**
 * __useChangeParameterIPlanMutation__
 *
 * To run a mutation, you first call `useChangeParameterIPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeParameterIPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeParameterIPlanMutation, { data, loading, error }] = useChangeParameterIPlanMutation({
 *   variables: {
 *      orderLineId: // value for 'orderLineId'
 *   },
 * });
 */
export function useChangeParameterIPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ChangeParameterIPlanMutation, Types.ChangeParameterIPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ChangeParameterIPlanMutation, Types.ChangeParameterIPlanMutationVariables>(ChangeParameterIPlanDocument, options);
      }
export type ChangeParameterIPlanMutationHookResult = ReturnType<typeof useChangeParameterIPlanMutation>;
export type ChangeParameterIPlanMutationResult = Apollo.MutationResult<Types.ChangeParameterIPlanMutation>;
export type ChangeParameterIPlanMutationOptions = Apollo.BaseMutationOptions<Types.ChangeParameterIPlanMutation, Types.ChangeParameterIPlanMutationVariables>;
export const PassParameterToIPlanDocument = gql`
    mutation passParameterToIPlan($inquiryMethodCode: String!, $orderLineId: ID!) {
  passParameterToIPlan(
    inquiryMethodCode: $inquiryMethodCode
    orderLineId: $orderLineId
  ) {
    status
  }
}
    `;
export type PassParameterToIPlanMutationFn = Apollo.MutationFunction<Types.PassParameterToIPlanMutation, Types.PassParameterToIPlanMutationVariables>;

/**
 * __usePassParameterToIPlanMutation__
 *
 * To run a mutation, you first call `usePassParameterToIPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePassParameterToIPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passParameterToIPlanMutation, { data, loading, error }] = usePassParameterToIPlanMutation({
 *   variables: {
 *      inquiryMethodCode: // value for 'inquiryMethodCode'
 *      orderLineId: // value for 'orderLineId'
 *   },
 * });
 */
export function usePassParameterToIPlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PassParameterToIPlanMutation, Types.PassParameterToIPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PassParameterToIPlanMutation, Types.PassParameterToIPlanMutationVariables>(PassParameterToIPlanDocument, options);
      }
export type PassParameterToIPlanMutationHookResult = ReturnType<typeof usePassParameterToIPlanMutation>;
export type PassParameterToIPlanMutationResult = Apollo.MutationResult<Types.PassParameterToIPlanMutation>;
export type PassParameterToIPlanMutationOptions = Apollo.BaseMutationOptions<Types.PassParameterToIPlanMutation, Types.PassParameterToIPlanMutationVariables>;
export const Get_Realtime_PartnerDocument = gql`
    mutation GET_REALTIME_PARTNER($distributionChannel: String!, $division: String!, $saleOrgCode: String!, $soldToCode: String!, $piMessageId: String!, $orderType: OrderType, $type: [RealtimePartnerType]!) {
  getSapRealtimePartner(
    distributionChannel: $distributionChannel
    division: $division
    saleOrgCode: $saleOrgCode
    soldToCode: $soldToCode
    piMessageId: $piMessageId
    type: $type
    orderType: $orderType
  ) {
    response {
      partnerFunction
      partnerFunctionDesc
      partnerNo
      partnerName
      displayText
      addressText
    }
    rawResponse
  }
}
    `;
export type Get_Realtime_PartnerMutationFn = Apollo.MutationFunction<Types.Get_Realtime_PartnerMutation, Types.Get_Realtime_PartnerMutationVariables>;

/**
 * __useGet_Realtime_PartnerMutation__
 *
 * To run a mutation, you first call `useGet_Realtime_PartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGet_Realtime_PartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRealtimePartnerMutation, { data, loading, error }] = useGet_Realtime_PartnerMutation({
 *   variables: {
 *      distributionChannel: // value for 'distributionChannel'
 *      division: // value for 'division'
 *      saleOrgCode: // value for 'saleOrgCode'
 *      soldToCode: // value for 'soldToCode'
 *      piMessageId: // value for 'piMessageId'
 *      orderType: // value for 'orderType'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGet_Realtime_PartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.Get_Realtime_PartnerMutation, Types.Get_Realtime_PartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.Get_Realtime_PartnerMutation, Types.Get_Realtime_PartnerMutationVariables>(Get_Realtime_PartnerDocument, options);
      }
export type Get_Realtime_PartnerMutationHookResult = ReturnType<typeof useGet_Realtime_PartnerMutation>;
export type Get_Realtime_PartnerMutationResult = Apollo.MutationResult<Types.Get_Realtime_PartnerMutation>;
export type Get_Realtime_PartnerMutationOptions = Apollo.BaseMutationOptions<Types.Get_Realtime_PartnerMutation, Types.Get_Realtime_PartnerMutationVariables>;
export const AddProductsToDomesticOrderDocument = gql`
    mutation addProductsToDomesticOrder($id: ID!, $input: [DomesticOrderLineAddProductInput!]!) {
  addProductsToDomesticOrder(id: $id, input: $input) {
    errors {
      field
      message
      code
      __typename
    }
    order {
      id
      __typename
    }
    orderLines {
      id
      paymentTerm
      itemNo
      product {
        id
        code
        description
        salesUnit
        __typename
      }
      inquiryMethod
      requestDate
      requestDateChangeReason
      confirmedDate
      shippingMark
      quantity
      unit
      weight
      weightUnit
      plant
      price
      netPrice
      priceCurrency
      paymentCondition
      itemCategory
      shippingPoint
      route
      poNo
      poNoExternal
      poDate
      overDeliveryTol
      underDeliveryTol
      deliveryTolUnlimited
      prcGroup1
      iplan {
        atpCtp
        atpCtpDetail
        block
        run
        paperMachine
        iplantConfirmQuantity
        salesUnit
        __typename
      }
      shipTo
      internalCommentsToWarehouse
      externalCommentsToCustomer
      internalCommentsToLogistic
      productInformation
      status
      variant {
        id
        weight
        code
        descriptionTh
        descriptionEn
        __typename
      }
      contractProduct {
        id
        remain
        price
        currency
        matGroup1
        matGroup1Desc
        __typename
      }
      __typename
      __typename
    }
    __typename
  }
}
    `;
export type AddProductsToDomesticOrderMutationFn = Apollo.MutationFunction<Types.AddProductsToDomesticOrderMutation, Types.AddProductsToDomesticOrderMutationVariables>;

/**
 * __useAddProductsToDomesticOrderMutation__
 *
 * To run a mutation, you first call `useAddProductsToDomesticOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToDomesticOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToDomesticOrderMutation, { data, loading, error }] = useAddProductsToDomesticOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductsToDomesticOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddProductsToDomesticOrderMutation, Types.AddProductsToDomesticOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddProductsToDomesticOrderMutation, Types.AddProductsToDomesticOrderMutationVariables>(AddProductsToDomesticOrderDocument, options);
      }
export type AddProductsToDomesticOrderMutationHookResult = ReturnType<typeof useAddProductsToDomesticOrderMutation>;
export type AddProductsToDomesticOrderMutationResult = Apollo.MutationResult<Types.AddProductsToDomesticOrderMutation>;
export type AddProductsToDomesticOrderMutationOptions = Apollo.BaseMutationOptions<Types.AddProductsToDomesticOrderMutation, Types.AddProductsToDomesticOrderMutationVariables>;
export const PreviewDomesticPageOrderDocument = gql`
    query previewDomesticPageOrder($id: ID!, $sortBy: DomesticOrderLinesSortingInput, $before: String, $after: String, $first: Int, $last: Int) {
  previewDomesticPageOrder(id: $id) {
    id
    soNo
    poNumber
    createdAt
    paymentTerm
    paymentTermKey
    paymentTermDescTh
    poDate
    poNo
    contract {
      code: contractNo
      projectName
    }
    soldTo {
      soldToCode
      soldToName
      addressText
    }
    shipTo
    billTo
    totalPrice
    taxAmount
    totalPriceIncTax
    currency
    previewOrderLines(
      sortBy: $sortBy
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      latestPageItemNumber
      edges {
        node {
          id
          itemNo
          variant {
            code
            salesUnit
          }
          prcGroup1
          unit
          salesUnit
          weightUnit
          weightUnitTon
          netWeightTon
          logErrors
          logOldProduct
          descriptionEn
          quantity
          orderQuantityTon
          requestDate
          originalRequestDate
          confirmedDate
          plant
        }
      }
    }
  }
}
    `;

/**
 * __usePreviewDomesticPageOrderQuery__
 *
 * To run a query within a React component, call `usePreviewDomesticPageOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewDomesticPageOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewDomesticPageOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function usePreviewDomesticPageOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PreviewDomesticPageOrderQuery, Types.PreviewDomesticPageOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PreviewDomesticPageOrderQuery, Types.PreviewDomesticPageOrderQueryVariables>(PreviewDomesticPageOrderDocument, options);
      }
export function usePreviewDomesticPageOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PreviewDomesticPageOrderQuery, Types.PreviewDomesticPageOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PreviewDomesticPageOrderQuery, Types.PreviewDomesticPageOrderQueryVariables>(PreviewDomesticPageOrderDocument, options);
        }
export type PreviewDomesticPageOrderQueryHookResult = ReturnType<typeof usePreviewDomesticPageOrderQuery>;
export type PreviewDomesticPageOrderLazyQueryHookResult = ReturnType<typeof usePreviewDomesticPageOrderLazyQuery>;
export type PreviewDomesticPageOrderQueryResult = Apollo.QueryResult<Types.PreviewDomesticPageOrderQuery, Types.PreviewDomesticPageOrderQueryVariables>;
export const SearchSuggestionDomesticSoldTosDocument = gql`
    query searchSuggestionDomesticSoldTos($bu: String, $first: Int, $filter: DomesticSoldToFilterInput) {
  searchSuggestionDomesticSoldTos(first: $first, filter: $filter, bu: $bu) {
    totalCount
    edges {
      node {
        id
        name
        code
        displayText
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSearchSuggestionDomesticSoldTosQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionDomesticSoldTosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionDomesticSoldTosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionDomesticSoldTosQuery({
 *   variables: {
 *      bu: // value for 'bu'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSuggestionDomesticSoldTosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SearchSuggestionDomesticSoldTosQuery, Types.SearchSuggestionDomesticSoldTosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchSuggestionDomesticSoldTosQuery, Types.SearchSuggestionDomesticSoldTosQueryVariables>(SearchSuggestionDomesticSoldTosDocument, options);
      }
export function useSearchSuggestionDomesticSoldTosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchSuggestionDomesticSoldTosQuery, Types.SearchSuggestionDomesticSoldTosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchSuggestionDomesticSoldTosQuery, Types.SearchSuggestionDomesticSoldTosQueryVariables>(SearchSuggestionDomesticSoldTosDocument, options);
        }
export type SearchSuggestionDomesticSoldTosQueryHookResult = ReturnType<typeof useSearchSuggestionDomesticSoldTosQuery>;
export type SearchSuggestionDomesticSoldTosLazyQueryHookResult = ReturnType<typeof useSearchSuggestionDomesticSoldTosLazyQuery>;
export type SearchSuggestionDomesticSoldTosQueryResult = Apollo.QueryResult<Types.SearchSuggestionDomesticSoldTosQuery, Types.SearchSuggestionDomesticSoldTosQueryVariables>;
export const CreateExportCartDocument = gql`
    mutation createExportCart($input: ExportCartCreateInput!) {
  createExportCart(input: $input) {
    cart {
      id
      items {
        id
      }
    }
    errors {
      message
    }
  }
}
    `;
export type CreateExportCartMutationFn = Apollo.MutationFunction<Types.CreateExportCartMutation, Types.CreateExportCartMutationVariables>;

/**
 * __useCreateExportCartMutation__
 *
 * To run a mutation, you first call `useCreateExportCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportCartMutation, { data, loading, error }] = useCreateExportCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExportCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CreateExportCartMutation, Types.CreateExportCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CreateExportCartMutation, Types.CreateExportCartMutationVariables>(CreateExportCartDocument, options);
      }
export type CreateExportCartMutationHookResult = ReturnType<typeof useCreateExportCartMutation>;
export type CreateExportCartMutationResult = Apollo.MutationResult<Types.CreateExportCartMutation>;
export type CreateExportCartMutationOptions = Apollo.BaseMutationOptions<Types.CreateExportCartMutation, Types.CreateExportCartMutationVariables>;
export const CreateExportOrderDocument = gql`
    mutation CreateExportOrder($input: ExportOrderCreateInput!) {
  createExportOrder(input: $input) {
    order {
      id
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type CreateExportOrderMutationFn = Apollo.MutationFunction<Types.CreateExportOrderMutation, Types.CreateExportOrderMutationVariables>;

/**
 * __useCreateExportOrderMutation__
 *
 * To run a mutation, you first call `useCreateExportOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportOrderMutation, { data, loading, error }] = useCreateExportOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExportOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.CreateExportOrderMutation, Types.CreateExportOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.CreateExportOrderMutation, Types.CreateExportOrderMutationVariables>(CreateExportOrderDocument, options);
      }
export type CreateExportOrderMutationHookResult = ReturnType<typeof useCreateExportOrderMutation>;
export type CreateExportOrderMutationResult = Apollo.MutationResult<Types.CreateExportOrderMutation>;
export type CreateExportOrderMutationOptions = Apollo.BaseMutationOptions<Types.CreateExportOrderMutation, Types.CreateExportOrderMutationVariables>;
export const DeleteExportCartItemsDocument = gql`
    mutation deleteExportCartItems($cartItemIds: [ID]!) {
  deleteExportCartItems(cartItemIds: $cartItemIds) {
    status
    errors {
      code
      message
      field
    }
  }
}
    `;
export type DeleteExportCartItemsMutationFn = Apollo.MutationFunction<Types.DeleteExportCartItemsMutation, Types.DeleteExportCartItemsMutationVariables>;

/**
 * __useDeleteExportCartItemsMutation__
 *
 * To run a mutation, you first call `useDeleteExportCartItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExportCartItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExportCartItemsMutation, { data, loading, error }] = useDeleteExportCartItemsMutation({
 *   variables: {
 *      cartItemIds: // value for 'cartItemIds'
 *   },
 * });
 */
export function useDeleteExportCartItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteExportCartItemsMutation, Types.DeleteExportCartItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteExportCartItemsMutation, Types.DeleteExportCartItemsMutationVariables>(DeleteExportCartItemsDocument, options);
      }
export type DeleteExportCartItemsMutationHookResult = ReturnType<typeof useDeleteExportCartItemsMutation>;
export type DeleteExportCartItemsMutationResult = Apollo.MutationResult<Types.DeleteExportCartItemsMutation>;
export type DeleteExportCartItemsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteExportCartItemsMutation, Types.DeleteExportCartItemsMutationVariables>;
export const AddProductsToExportOrderDocument = gql`
    mutation AddProductsToExportOrder($id: ID!, $input: [ExportOrderLineAddProductInput!]!) {
  addProductsToExportOrder(id: $id, input: $input) {
    errors {
      field
      message
      code
    }
    order {
      id
      lines(last: 100) {
        edges {
          node {
            id
            itemNo
            materialCode
            materialDescription
            piProduct {
              id
              materialCode
              pricePerUnit
              matGroup1
              product {
                materialGroup
                widthOfRoll
                lengthOfRoll
                id
                name
                slug: materialCode
                salesUnit
                __typename
              }
              currency
              remainingQuantity
              remainingQuantityEx
              limitQuantity
              weight
              weightUnit
              calculation
              __typename
            }
            quantity
            quantityUnit
            weight
            weightUnit
            salesUnit
            itemCatEo
            plant
            refPiNo
            requestDate
            confirmedDate
            rejectReason
            conditionGroup1
            route
            rollQuantity
            rollDiameter
            rollCoreDiameter
            remark
            palletSize
            palletNo
            rollPerPallet
            packageQuantity
            packingList
            commissionPercent
            commissionAmount
            commissionUnit
            shippingPoint
            deliveryTolOver
            deliveryTolUnder
            deliveryTolUnlimited
            materialGroup2
            inquiryMethod
            __typename
          }
        }
      }
    }
  }
}
    `;
export type AddProductsToExportOrderMutationFn = Apollo.MutationFunction<Types.AddProductsToExportOrderMutation, Types.AddProductsToExportOrderMutationVariables>;

/**
 * __useAddProductsToExportOrderMutation__
 *
 * To run a mutation, you first call `useAddProductsToExportOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductsToExportOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductsToExportOrderMutation, { data, loading, error }] = useAddProductsToExportOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProductsToExportOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddProductsToExportOrderMutation, Types.AddProductsToExportOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddProductsToExportOrderMutation, Types.AddProductsToExportOrderMutationVariables>(AddProductsToExportOrderDocument, options);
      }
export type AddProductsToExportOrderMutationHookResult = ReturnType<typeof useAddProductsToExportOrderMutation>;
export type AddProductsToExportOrderMutationResult = Apollo.MutationResult<Types.AddProductsToExportOrderMutation>;
export type AddProductsToExportOrderMutationOptions = Apollo.BaseMutationOptions<Types.AddProductsToExportOrderMutation, Types.AddProductsToExportOrderMutationVariables>;
export const UpdateAllExportOrderLineDocument = gql`
    mutation UpdateAllExportOrderLine($id: ID!, $input: ExportOrderLineUpdateAllInput!) {
  updateAllExportOrderLine(id: $id, input: $input) {
    errors {
      field
      message
      code
    }
    order {
      id
    }
  }
}
    `;
export type UpdateAllExportOrderLineMutationFn = Apollo.MutationFunction<Types.UpdateAllExportOrderLineMutation, Types.UpdateAllExportOrderLineMutationVariables>;

/**
 * __useUpdateAllExportOrderLineMutation__
 *
 * To run a mutation, you first call `useUpdateAllExportOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllExportOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllExportOrderLineMutation, { data, loading, error }] = useUpdateAllExportOrderLineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllExportOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateAllExportOrderLineMutation, Types.UpdateAllExportOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateAllExportOrderLineMutation, Types.UpdateAllExportOrderLineMutationVariables>(UpdateAllExportOrderLineDocument, options);
      }
export type UpdateAllExportOrderLineMutationHookResult = ReturnType<typeof useUpdateAllExportOrderLineMutation>;
export type UpdateAllExportOrderLineMutationResult = Apollo.MutationResult<Types.UpdateAllExportOrderLineMutation>;
export type UpdateAllExportOrderLineMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAllExportOrderLineMutation, Types.UpdateAllExportOrderLineMutationVariables>;
export const UpdateExportCartDocument = gql`
    mutation UpdateExportCart($id: ID!, $input: ExportCartUpdateInput!) {
  updateExportCart(id: $id, input: $input) {
    cart {
      id
      pi {
        id
        code
        poNo
      }
      soldTo {
        id
      }
      createdBy {
        id
      }
      items {
        id
        quantity
        piProduct {
          id
        }
      }
    }
  }
}
    `;
export type UpdateExportCartMutationFn = Apollo.MutationFunction<Types.UpdateExportCartMutation, Types.UpdateExportCartMutationVariables>;

/**
 * __useUpdateExportCartMutation__
 *
 * To run a mutation, you first call `useUpdateExportCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExportCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExportCartMutation, { data, loading, error }] = useUpdateExportCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExportCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateExportCartMutation, Types.UpdateExportCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateExportCartMutation, Types.UpdateExportCartMutationVariables>(UpdateExportCartDocument, options);
      }
export type UpdateExportCartMutationHookResult = ReturnType<typeof useUpdateExportCartMutation>;
export type UpdateExportCartMutationResult = Apollo.MutationResult<Types.UpdateExportCartMutation>;
export type UpdateExportCartMutationOptions = Apollo.BaseMutationOptions<Types.UpdateExportCartMutation, Types.UpdateExportCartMutationVariables>;
export const UpdateExportOrderDocument = gql`
    mutation UpdateExportOrder($id: ID!, $input: ExportOrderUpdateInput!) {
  updateExportOrder(id: $id, input: $input) {
    errors {
      field
      message
      code
    }
    success
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      errorCode
      errorMessage
      itemNo
    }
    order {
      id
      soNo
    }
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
    }
    warningMessages {
      message
      order
      source
    }
  }
}
    `;
export type UpdateExportOrderMutationFn = Apollo.MutationFunction<Types.UpdateExportOrderMutation, Types.UpdateExportOrderMutationVariables>;

/**
 * __useUpdateExportOrderMutation__
 *
 * To run a mutation, you first call `useUpdateExportOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExportOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExportOrderMutation, { data, loading, error }] = useUpdateExportOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExportOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateExportOrderMutation, Types.UpdateExportOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateExportOrderMutation, Types.UpdateExportOrderMutationVariables>(UpdateExportOrderDocument, options);
      }
export type UpdateExportOrderMutationHookResult = ReturnType<typeof useUpdateExportOrderMutation>;
export type UpdateExportOrderMutationResult = Apollo.MutationResult<Types.UpdateExportOrderMutation>;
export type UpdateExportOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateExportOrderMutation, Types.UpdateExportOrderMutationVariables>;
export const DeleteExportOrderLinesDocument = gql`
    mutation DeleteExportOrderLines($deleteAll: Boolean, $ids: [ID], $orderId: ID) {
  deleteExportOrderLines(deleteAll: $deleteAll, ids: $ids, orderId: $orderId) {
    errors {
      field
      message
      code
    }
    status
  }
}
    `;
export type DeleteExportOrderLinesMutationFn = Apollo.MutationFunction<Types.DeleteExportOrderLinesMutation, Types.DeleteExportOrderLinesMutationVariables>;

/**
 * __useDeleteExportOrderLinesMutation__
 *
 * To run a mutation, you first call `useDeleteExportOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExportOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExportOrderLinesMutation, { data, loading, error }] = useDeleteExportOrderLinesMutation({
 *   variables: {
 *      deleteAll: // value for 'deleteAll'
 *      ids: // value for 'ids'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useDeleteExportOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteExportOrderLinesMutation, Types.DeleteExportOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteExportOrderLinesMutation, Types.DeleteExportOrderLinesMutationVariables>(DeleteExportOrderLinesDocument, options);
      }
export type DeleteExportOrderLinesMutationHookResult = ReturnType<typeof useDeleteExportOrderLinesMutation>;
export type DeleteExportOrderLinesMutationResult = Apollo.MutationResult<Types.DeleteExportOrderLinesMutation>;
export type DeleteExportOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.DeleteExportOrderLinesMutation, Types.DeleteExportOrderLinesMutationVariables>;
export const UpdateExportOrderLinesDocument = gql`
    mutation UpdateExportOrderLines($id: ID!, $input: [ExportOrderLineUpdateInput!]!) {
  updateExportOrderLines(input: $input, orderId: $id) {
    order {
      id
      pi {
        id
        soldTo {
          id
          code
          addressText
        }
        code
        poNo
        soldToName
        shipToName
        shipToCountry
        incoterm
        paymentTerm
      }
      totalPrice
      taxAmount
      currency
      status
      requestDeliveryDate
      orderType
      shippingMark
      contactPerson
      lines(first: 10, sortBy: {field: MATERIAL_CODE, direction: DESC}) {
        edges {
          node {
            id
            piProduct {
              id
              pi: contract {
                id
                code
                poNo
                soldToName
                shipToName
                shipToCountry
                incoterm
                paymentTerm
              }
              product {
                id
                name
                description
              }
              totalQuantity
              remainingQuantity
              pricePerUnit
              quantityUnit
              currency
              weight
              weightUnit
            }
            quantity
            quantityUnit
            weight
            weightUnit
            vatPercent
            itemCatEo
            plant
            refPiNo
            requestDate
            route
            deliveryTolOver
            deliveryTolUnder
            deliveryTolUnlimited
            rollDiameter
            rollCoreDiameter
            rollQuantity
            rollPerPallet
            palletSize
            palletNo
            packageQuantity
            packingList
            shippingPoint
            remark
            rejectReason
            rejectReason
            conditionGroup1
            materialGroup2
            commissionPercent
            commissionAmount
            commissionUnit
          }
        }
      }
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type UpdateExportOrderLinesMutationFn = Apollo.MutationFunction<Types.UpdateExportOrderLinesMutation, Types.UpdateExportOrderLinesMutationVariables>;

/**
 * __useUpdateExportOrderLinesMutation__
 *
 * To run a mutation, you first call `useUpdateExportOrderLinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExportOrderLinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExportOrderLinesMutation, { data, loading, error }] = useUpdateExportOrderLinesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExportOrderLinesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateExportOrderLinesMutation, Types.UpdateExportOrderLinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateExportOrderLinesMutation, Types.UpdateExportOrderLinesMutationVariables>(UpdateExportOrderLinesDocument, options);
      }
export type UpdateExportOrderLinesMutationHookResult = ReturnType<typeof useUpdateExportOrderLinesMutation>;
export type UpdateExportOrderLinesMutationResult = Apollo.MutationResult<Types.UpdateExportOrderLinesMutation>;
export type UpdateExportOrderLinesMutationOptions = Apollo.BaseMutationOptions<Types.UpdateExportOrderLinesMutation, Types.UpdateExportOrderLinesMutationVariables>;
export const UpdateDraftExportCartDocument = gql`
    mutation updateDraftExportCart($cartId: ID!, $input: ExportCartDraftUpdateInput!) {
  updateDraftExportCart(cartId: $cartId, input: $input) {
    cart {
      id
    }
    errors {
      message
    }
  }
}
    `;
export type UpdateDraftExportCartMutationFn = Apollo.MutationFunction<Types.UpdateDraftExportCartMutation, Types.UpdateDraftExportCartMutationVariables>;

/**
 * __useUpdateDraftExportCartMutation__
 *
 * To run a mutation, you first call `useUpdateDraftExportCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDraftExportCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDraftExportCartMutation, { data, loading, error }] = useUpdateDraftExportCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDraftExportCartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateDraftExportCartMutation, Types.UpdateDraftExportCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateDraftExportCartMutation, Types.UpdateDraftExportCartMutationVariables>(UpdateDraftExportCartDocument, options);
      }
export type UpdateDraftExportCartMutationHookResult = ReturnType<typeof useUpdateDraftExportCartMutation>;
export type UpdateDraftExportCartMutationResult = Apollo.MutationResult<Types.UpdateDraftExportCartMutation>;
export type UpdateDraftExportCartMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDraftExportCartMutation, Types.UpdateDraftExportCartMutationVariables>;
export const ExportSoldTosDocument = gql`
    query exportSoldTos($first: Int, $filter: ExportSoldToFilterInput) {
  exportSoldTos(first: $first, filter: $filter) {
    totalCount
    edges {
      node {
        id
        name
        code
        displayText
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useExportSoldTosQuery__
 *
 * To run a query within a React component, call `useExportSoldTosQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportSoldTosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportSoldTosQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useExportSoldTosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ExportSoldTosQuery, Types.ExportSoldTosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportSoldTosQuery, Types.ExportSoldTosQueryVariables>(ExportSoldTosDocument, options);
      }
export function useExportSoldTosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportSoldTosQuery, Types.ExportSoldTosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportSoldTosQuery, Types.ExportSoldTosQueryVariables>(ExportSoldTosDocument, options);
        }
export type ExportSoldTosQueryHookResult = ReturnType<typeof useExportSoldTosQuery>;
export type ExportSoldTosLazyQueryHookResult = ReturnType<typeof useExportSoldTosLazyQuery>;
export type ExportSoldTosQueryResult = Apollo.QueryResult<Types.ExportSoldTosQuery, Types.ExportSoldTosQueryVariables>;
export const ExportPisDocument = gql`
    query exportPis($filter: ExportPIFilterInput, $sortBy: ExportPIsSortingInput, $before: String, $after: String, $first: Int, $last: Int) {
  exportPis(
    filter: $filter
    sortBy: $sortBy
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    edges {
      node {
        id
        code
        poNo
        soldTo {
          id
          displayText
        }
        shipToName
        shipToCountry
        incoterm
        paymentTerm
        paymentTermKey
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    latestPageItemNumber
  }
}
    `;

/**
 * __useExportPisQuery__
 *
 * To run a query within a React component, call `useExportPisQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPisQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useExportPisQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ExportPisQuery, Types.ExportPisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportPisQuery, Types.ExportPisQueryVariables>(ExportPisDocument, options);
      }
export function useExportPisLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportPisQuery, Types.ExportPisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportPisQuery, Types.ExportPisQueryVariables>(ExportPisDocument, options);
        }
export type ExportPisQueryHookResult = ReturnType<typeof useExportPisQuery>;
export type ExportPisLazyQueryHookResult = ReturnType<typeof useExportPisLazyQuery>;
export type ExportPisQueryResult = Apollo.QueryResult<Types.ExportPisQuery, Types.ExportPisQueryVariables>;
export const ExportPiDocument = gql`
    query exportPi($id: ID!, $sortBy: ExportPIProductsSortingInput, $before: String, $after: String, $first: Int, $last: Int) {
  exportPi(id: $id) {
    id
    code
    soldTo {
      id
      code
      name
    }
    salesOrganizationCode
    soldToName
    poNo
    incoterm
    paymentTerm
    shipToCountry
    shipToName
    currency
    piProducts(
      sortBy: $sortBy
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      latestPageItemNumber
      edges {
        node {
          id
          salesUnit
          product {
            id
            name
            description
          }
          weight
          quantityUnit
          totalQuantity
          remainingQuantity
          weightUnit
          pricePerUnit
          currency
          calculation
          limitQuantity
          limitQuantityOrderLine
          cartQuantity
          remainingQuantityEx
        }
      }
    }
  }
}
    `;

/**
 * __useExportPiQuery__
 *
 * To run a query within a React component, call `useExportPiQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPiQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useExportPiQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ExportPiQuery, Types.ExportPiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportPiQuery, Types.ExportPiQueryVariables>(ExportPiDocument, options);
      }
export function useExportPiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportPiQuery, Types.ExportPiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportPiQuery, Types.ExportPiQueryVariables>(ExportPiDocument, options);
        }
export type ExportPiQueryHookResult = ReturnType<typeof useExportPiQuery>;
export type ExportPiLazyQueryHookResult = ReturnType<typeof useExportPiLazyQuery>;
export type ExportPiQueryResult = Apollo.QueryResult<Types.ExportPiQuery, Types.ExportPiQueryVariables>;
export const ExportCartsDocument = gql`
    query exportCarts($before: String, $after: String, $first: Int, $last: Int, $filter: CartPiFilterInput, $sortBy: ExportCartSortingInput) {
  exportCarts {
    totalPi
    totalSoldTo
    totalCartItem
    carts(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      latestPageItemNumber
      edges {
        node {
          id
          pi {
            code
          }
          soldTo {
            code
            name
          }
          totalItems
        }
      }
    }
  }
}
    `;

/**
 * __useExportCartsQuery__
 *
 * To run a query within a React component, call `useExportCartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCartsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useExportCartsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ExportCartsQuery, Types.ExportCartsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportCartsQuery, Types.ExportCartsQueryVariables>(ExportCartsDocument, options);
      }
export function useExportCartsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportCartsQuery, Types.ExportCartsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportCartsQuery, Types.ExportCartsQueryVariables>(ExportCartsDocument, options);
        }
export type ExportCartsQueryHookResult = ReturnType<typeof useExportCartsQuery>;
export type ExportCartsLazyQueryHookResult = ReturnType<typeof useExportCartsLazyQuery>;
export type ExportCartsQueryResult = Apollo.QueryResult<Types.ExportCartsQuery, Types.ExportCartsQueryVariables>;
export const ExportCartsSearchDocument = gql`
    query exportCartsSearch($before: String, $after: String, $first: Int, $last: Int, $filter: CartFilterInput, $sortBy: ExportCartSortingInput) {
  exportCartsSearch {
    totalPi
    totalSoldTo
    totalCartItem
    exportCarts(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        __typename
      }
      totalCount
      latestPageItemNumber
      edges {
        node {
          id
          pi {
            code
          }
          soldTo {
            code
            name
          }
          totalItems
        }
      }
    }
  }
}
    `;

/**
 * __useExportCartsSearchQuery__
 *
 * To run a query within a React component, call `useExportCartsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCartsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCartsSearchQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useExportCartsSearchQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ExportCartsSearchQuery, Types.ExportCartsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ExportCartsSearchQuery, Types.ExportCartsSearchQueryVariables>(ExportCartsSearchDocument, options);
      }
export function useExportCartsSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ExportCartsSearchQuery, Types.ExportCartsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ExportCartsSearchQuery, Types.ExportCartsSearchQueryVariables>(ExportCartsSearchDocument, options);
        }
export type ExportCartsSearchQueryHookResult = ReturnType<typeof useExportCartsSearchQuery>;
export type ExportCartsSearchLazyQueryHookResult = ReturnType<typeof useExportCartsSearchLazyQuery>;
export type ExportCartsSearchQueryResult = Apollo.QueryResult<Types.ExportCartsSearchQuery, Types.ExportCartsSearchQueryVariables>;
export const TotalCountExportCartDocument = gql`
    query TotalCountExportCart {
  exportCarts {
    totalPi
    totalSoldTo
    totalCartItem
  }
}
    `;

/**
 * __useTotalCountExportCartQuery__
 *
 * To run a query within a React component, call `useTotalCountExportCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalCountExportCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalCountExportCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalCountExportCartQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.TotalCountExportCartQuery, Types.TotalCountExportCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.TotalCountExportCartQuery, Types.TotalCountExportCartQueryVariables>(TotalCountExportCartDocument, options);
      }
export function useTotalCountExportCartLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.TotalCountExportCartQuery, Types.TotalCountExportCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.TotalCountExportCartQuery, Types.TotalCountExportCartQueryVariables>(TotalCountExportCartDocument, options);
        }
export type TotalCountExportCartQueryHookResult = ReturnType<typeof useTotalCountExportCartQuery>;
export type TotalCountExportCartLazyQueryHookResult = ReturnType<typeof useTotalCountExportCartLazyQuery>;
export type TotalCountExportCartQueryResult = Apollo.QueryResult<Types.TotalCountExportCartQuery, Types.TotalCountExportCartQueryVariables>;
export const GetCartDetailDataDocument = gql`
    query GetCartDetailData($id: ID, $sortBy: ExportCartItemSortingInput, $before: String, $after: String, $first: Int, $last: Int) {
  exportCart(id: $id) {
    id
    pi {
      id
      code
      currency
    }
    soldTo {
      name
      code
    }
    items(
      first: $first
      before: $before
      last: $last
      after: $after
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      latestPageItemNumber
      edges {
        node {
          id
          quantity
          piProduct {
            id
            product {
              name
              slug
            }
            totalQuantity
            remainingQuantity
            remainingQuantityEx
            weight
            pricePerUnit
            quantityUnit
            currency
            weightUnit
            salesUnit
            calculation
            limitQuantity
            limitQuantityOrderLine
          }
        }
      }
    }
    totalItems
  }
}
    `;

/**
 * __useGetCartDetailDataQuery__
 *
 * To run a query within a React component, call `useGetCartDetailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCartDetailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCartDetailDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      sortBy: // value for 'sortBy'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetCartDetailDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetCartDetailDataQuery, Types.GetCartDetailDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCartDetailDataQuery, Types.GetCartDetailDataQueryVariables>(GetCartDetailDataDocument, options);
      }
export function useGetCartDetailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCartDetailDataQuery, Types.GetCartDetailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCartDetailDataQuery, Types.GetCartDetailDataQueryVariables>(GetCartDetailDataDocument, options);
        }
export type GetCartDetailDataQueryHookResult = ReturnType<typeof useGetCartDetailDataQuery>;
export type GetCartDetailDataLazyQueryHookResult = ReturnType<typeof useGetCartDetailDataLazyQuery>;
export type GetCartDetailDataQueryResult = Apollo.QueryResult<Types.GetCartDetailDataQuery, Types.GetCartDetailDataQueryVariables>;
export const GetDataSelectAgencyTabDocument = gql`
    query getDataSelectAgencyTab($saleOrg: String) {
  salesOrganizations {
    id
    name: shortName
    code
  }
  distributionChannelsExport {
    id
    name
    code
  }
  scgDivisions {
    id
    name
    code
  }
  salesOffices(saleOrg: $saleOrg) {
    id
    name
    code
  }
  salesGroups(saleOrg: $saleOrg) {
    id
    name
    code
  }
}
    `;

/**
 * __useGetDataSelectAgencyTabQuery__
 *
 * To run a query within a React component, call `useGetDataSelectAgencyTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataSelectAgencyTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataSelectAgencyTabQuery({
 *   variables: {
 *      saleOrg: // value for 'saleOrg'
 *   },
 * });
 */
export function useGetDataSelectAgencyTabQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetDataSelectAgencyTabQuery, Types.GetDataSelectAgencyTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetDataSelectAgencyTabQuery, Types.GetDataSelectAgencyTabQueryVariables>(GetDataSelectAgencyTabDocument, options);
      }
export function useGetDataSelectAgencyTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetDataSelectAgencyTabQuery, Types.GetDataSelectAgencyTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetDataSelectAgencyTabQuery, Types.GetDataSelectAgencyTabQueryVariables>(GetDataSelectAgencyTabDocument, options);
        }
export type GetDataSelectAgencyTabQueryHookResult = ReturnType<typeof useGetDataSelectAgencyTabQuery>;
export type GetDataSelectAgencyTabLazyQueryHookResult = ReturnType<typeof useGetDataSelectAgencyTabLazyQuery>;
export type GetDataSelectAgencyTabQueryResult = Apollo.QueryResult<Types.GetDataSelectAgencyTabQuery, Types.GetDataSelectAgencyTabQueryVariables>;
export const ExportCustomerMaterialTemplateDocument = gql`
    mutation exportCustomerMaterialTemplate {
  exportCustomerMaterialTemplate {
    fileName
    contentType
    exportedFileBase64
    errors {
      field
      message
      code
    }
  }
}
    `;
export type ExportCustomerMaterialTemplateMutationFn = Apollo.MutationFunction<Types.ExportCustomerMaterialTemplateMutation, Types.ExportCustomerMaterialTemplateMutationVariables>;

/**
 * __useExportCustomerMaterialTemplateMutation__
 *
 * To run a mutation, you first call `useExportCustomerMaterialTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCustomerMaterialTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCustomerMaterialTemplateMutation, { data, loading, error }] = useExportCustomerMaterialTemplateMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportCustomerMaterialTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExportCustomerMaterialTemplateMutation, Types.ExportCustomerMaterialTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExportCustomerMaterialTemplateMutation, Types.ExportCustomerMaterialTemplateMutationVariables>(ExportCustomerMaterialTemplateDocument, options);
      }
export type ExportCustomerMaterialTemplateMutationHookResult = ReturnType<typeof useExportCustomerMaterialTemplateMutation>;
export type ExportCustomerMaterialTemplateMutationResult = Apollo.MutationResult<Types.ExportCustomerMaterialTemplateMutation>;
export type ExportCustomerMaterialTemplateMutationOptions = Apollo.BaseMutationOptions<Types.ExportCustomerMaterialTemplateMutation, Types.ExportCustomerMaterialTemplateMutationVariables>;
export const UploadCustomerMaterialsDocument = gql`
    mutation uploadCustomerMaterials($file: Upload!, $input: CustomerMaterialUploadInput!) {
  uploadCustomerMaterials(file: $file, input: $input) {
    status
    rows
    errors {
      field
      message
      data {
        soldToCode
        salesOrganizationCode
        distributionChannelCode
        soldToMaterialCode
        materialCode
      }
    }
  }
}
    `;
export type UploadCustomerMaterialsMutationFn = Apollo.MutationFunction<Types.UploadCustomerMaterialsMutation, Types.UploadCustomerMaterialsMutationVariables>;

/**
 * __useUploadCustomerMaterialsMutation__
 *
 * To run a mutation, you first call `useUploadCustomerMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomerMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomerMaterialsMutation, { data, loading, error }] = useUploadCustomerMaterialsMutation({
 *   variables: {
 *      file: // value for 'file'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCustomerMaterialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UploadCustomerMaterialsMutation, Types.UploadCustomerMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UploadCustomerMaterialsMutation, Types.UploadCustomerMaterialsMutationVariables>(UploadCustomerMaterialsDocument, options);
      }
export type UploadCustomerMaterialsMutationHookResult = ReturnType<typeof useUploadCustomerMaterialsMutation>;
export type UploadCustomerMaterialsMutationResult = Apollo.MutationResult<Types.UploadCustomerMaterialsMutation>;
export type UploadCustomerMaterialsMutationOptions = Apollo.BaseMutationOptions<Types.UploadCustomerMaterialsMutation, Types.UploadCustomerMaterialsMutationVariables>;
export const DownloadCustomerMaterialExcelDocument = gql`
    mutation downloadCustomerMaterialExcel($distributionChannelId: ID, $saleOrganizationId: String, $soldToCode: String) {
  downloadCustomerMaterialExcel(
    distributionChannelId: $distributionChannelId
    saleOrganizationId: $saleOrganizationId
    soldToCode: $soldToCode
  ) {
    success
    fileName
    exportedFileBase64
    errorMessage
  }
}
    `;
export type DownloadCustomerMaterialExcelMutationFn = Apollo.MutationFunction<Types.DownloadCustomerMaterialExcelMutation, Types.DownloadCustomerMaterialExcelMutationVariables>;

/**
 * __useDownloadCustomerMaterialExcelMutation__
 *
 * To run a mutation, you first call `useDownloadCustomerMaterialExcelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadCustomerMaterialExcelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadCustomerMaterialExcelMutation, { data, loading, error }] = useDownloadCustomerMaterialExcelMutation({
 *   variables: {
 *      distributionChannelId: // value for 'distributionChannelId'
 *      saleOrganizationId: // value for 'saleOrganizationId'
 *      soldToCode: // value for 'soldToCode'
 *   },
 * });
 */
export function useDownloadCustomerMaterialExcelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DownloadCustomerMaterialExcelMutation, Types.DownloadCustomerMaterialExcelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DownloadCustomerMaterialExcelMutation, Types.DownloadCustomerMaterialExcelMutationVariables>(DownloadCustomerMaterialExcelDocument, options);
      }
export type DownloadCustomerMaterialExcelMutationHookResult = ReturnType<typeof useDownloadCustomerMaterialExcelMutation>;
export type DownloadCustomerMaterialExcelMutationResult = Apollo.MutationResult<Types.DownloadCustomerMaterialExcelMutation>;
export type DownloadCustomerMaterialExcelMutationOptions = Apollo.BaseMutationOptions<Types.DownloadCustomerMaterialExcelMutation, Types.DownloadCustomerMaterialExcelMutationVariables>;
export const UpdateCustomerMaterialsDocument = gql`
    mutation UpdateCustomerMaterials($id: ID!, $soldToMaterialCode: String!, $materialCode: String!) {
  updateCustomerMaterials(
    id: $id
    soldToMaterialCode: $soldToMaterialCode
    materialCode: $materialCode
  ) {
    status
    items {
      soldToMaterialCode
      materialCode
      __typename
    }
    itemErrors {
      soldToMaterialCode
      materialCode
      __typename
    }
    __typename
  }
}
    `;
export type UpdateCustomerMaterialsMutationFn = Apollo.MutationFunction<Types.UpdateCustomerMaterialsMutation, Types.UpdateCustomerMaterialsMutationVariables>;

/**
 * __useUpdateCustomerMaterialsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMaterialsMutation, { data, loading, error }] = useUpdateCustomerMaterialsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      soldToMaterialCode: // value for 'soldToMaterialCode'
 *      materialCode: // value for 'materialCode'
 *   },
 * });
 */
export function useUpdateCustomerMaterialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateCustomerMaterialsMutation, Types.UpdateCustomerMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateCustomerMaterialsMutation, Types.UpdateCustomerMaterialsMutationVariables>(UpdateCustomerMaterialsDocument, options);
      }
export type UpdateCustomerMaterialsMutationHookResult = ReturnType<typeof useUpdateCustomerMaterialsMutation>;
export type UpdateCustomerMaterialsMutationResult = Apollo.MutationResult<Types.UpdateCustomerMaterialsMutation>;
export type UpdateCustomerMaterialsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateCustomerMaterialsMutation, Types.UpdateCustomerMaterialsMutationVariables>;
export const AddCustomerMaterialsDocument = gql`
    mutation AddCustomerMaterials($soldTo: String!, $saleOrg: String!, $distribution: String!, $items: [CustomerMaterialItemInput!]!) {
  addCustomerMaterials(
    soldTo: $soldTo
    saleOrg: $saleOrg
    distribution: $distribution
    items: $items
  ) {
    status
    items {
      distributionChannelCode
      id
      materialCode
      salesOrganization {
        code
        displayText
      }
      soldTo {
        code
        displayText
      }
      soldToMaterialCode
      __typename
    }
    itemErrors {
      soldToMaterialCode
      materialCode
      __typename
    }
    __typename
  }
}
    `;
export type AddCustomerMaterialsMutationFn = Apollo.MutationFunction<Types.AddCustomerMaterialsMutation, Types.AddCustomerMaterialsMutationVariables>;

/**
 * __useAddCustomerMaterialsMutation__
 *
 * To run a mutation, you first call `useAddCustomerMaterialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomerMaterialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomerMaterialsMutation, { data, loading, error }] = useAddCustomerMaterialsMutation({
 *   variables: {
 *      soldTo: // value for 'soldTo'
 *      saleOrg: // value for 'saleOrg'
 *      distribution: // value for 'distribution'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useAddCustomerMaterialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AddCustomerMaterialsMutation, Types.AddCustomerMaterialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AddCustomerMaterialsMutation, Types.AddCustomerMaterialsMutationVariables>(AddCustomerMaterialsDocument, options);
      }
export type AddCustomerMaterialsMutationHookResult = ReturnType<typeof useAddCustomerMaterialsMutation>;
export type AddCustomerMaterialsMutationResult = Apollo.MutationResult<Types.AddCustomerMaterialsMutation>;
export type AddCustomerMaterialsMutationOptions = Apollo.BaseMutationOptions<Types.AddCustomerMaterialsMutation, Types.AddCustomerMaterialsMutationVariables>;
export const SearchSuggestionSoldTosCustMatDocument = gql`
    query searchSuggestionSoldTosCustMat($first: Int, $filter: DomesticSoldToFilterInput) {
  searchSuggestionSoldTosCustMat(first: $first, filter: $filter) {
    totalCount
    edges {
      node {
        id
        name
        code
        domesticSoldToSearchFilterDisplayText
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useSearchSuggestionSoldTosCustMatQuery__
 *
 * To run a query within a React component, call `useSearchSuggestionSoldTosCustMatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestionSoldTosCustMatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestionSoldTosCustMatQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSuggestionSoldTosCustMatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SearchSuggestionSoldTosCustMatQuery, Types.SearchSuggestionSoldTosCustMatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchSuggestionSoldTosCustMatQuery, Types.SearchSuggestionSoldTosCustMatQueryVariables>(SearchSuggestionSoldTosCustMatDocument, options);
      }
export function useSearchSuggestionSoldTosCustMatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchSuggestionSoldTosCustMatQuery, Types.SearchSuggestionSoldTosCustMatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchSuggestionSoldTosCustMatQuery, Types.SearchSuggestionSoldTosCustMatQueryVariables>(SearchSuggestionSoldTosCustMatDocument, options);
        }
export type SearchSuggestionSoldTosCustMatQueryHookResult = ReturnType<typeof useSearchSuggestionSoldTosCustMatQuery>;
export type SearchSuggestionSoldTosCustMatLazyQueryHookResult = ReturnType<typeof useSearchSuggestionSoldTosCustMatLazyQuery>;
export type SearchSuggestionSoldTosCustMatQueryResult = Apollo.QueryResult<Types.SearchSuggestionSoldTosCustMatQuery, Types.SearchSuggestionSoldTosCustMatQueryVariables>;
export const GetSaleOrgAndDistChannelBySoldToDocument = gql`
    query getSaleOrgAndDistChannelBySoldTo($soldTo: String!) {
  getSaleOrgAndDistChannelBySoldTo(soldTo: $soldTo) {
    salesOrganization {
      id
      code
      shortName
      displayText
    }
    distributionChannel {
      id
      code
      name
      displayText
    }
    salesOrgByDistChannel {
      salesOrg
      distributionChannel {
        id
        code
        name
        displayText
      }
    }
    distChannelBySalesOrg {
      distributionChannel
      salesOrg {
        id
        code
        shortName
        displayText
      }
    }
  }
}
    `;

/**
 * __useGetSaleOrgAndDistChannelBySoldToQuery__
 *
 * To run a query within a React component, call `useGetSaleOrgAndDistChannelBySoldToQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleOrgAndDistChannelBySoldToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleOrgAndDistChannelBySoldToQuery({
 *   variables: {
 *      soldTo: // value for 'soldTo'
 *   },
 * });
 */
export function useGetSaleOrgAndDistChannelBySoldToQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetSaleOrgAndDistChannelBySoldToQuery, Types.GetSaleOrgAndDistChannelBySoldToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetSaleOrgAndDistChannelBySoldToQuery, Types.GetSaleOrgAndDistChannelBySoldToQueryVariables>(GetSaleOrgAndDistChannelBySoldToDocument, options);
      }
export function useGetSaleOrgAndDistChannelBySoldToLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetSaleOrgAndDistChannelBySoldToQuery, Types.GetSaleOrgAndDistChannelBySoldToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetSaleOrgAndDistChannelBySoldToQuery, Types.GetSaleOrgAndDistChannelBySoldToQueryVariables>(GetSaleOrgAndDistChannelBySoldToDocument, options);
        }
export type GetSaleOrgAndDistChannelBySoldToQueryHookResult = ReturnType<typeof useGetSaleOrgAndDistChannelBySoldToQuery>;
export type GetSaleOrgAndDistChannelBySoldToLazyQueryHookResult = ReturnType<typeof useGetSaleOrgAndDistChannelBySoldToLazyQuery>;
export type GetSaleOrgAndDistChannelBySoldToQueryResult = Apollo.QueryResult<Types.GetSaleOrgAndDistChannelBySoldToQuery, Types.GetSaleOrgAndDistChannelBySoldToQueryVariables>;
export const CustomerMaterialsDocument = gql`
    query customerMaterials($filter: CustomerMaterialInput) {
  customerMaterials(filter: $filter) {
    id
    soldTo {
      code
      name
      displayText
      __typename
    }
    salesOrganization {
      code
      name
      displayText
      __typename
    }
    distributionChannelCode
    soldToMaterialCode
    materialCode
    sapMaterial {
      materialCode
      materialDescription
      displayText
    }
    __typename
  }
}
    `;

/**
 * __useCustomerMaterialsQuery__
 *
 * To run a query within a React component, call `useCustomerMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerMaterialsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerMaterialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CustomerMaterialsQuery, Types.CustomerMaterialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerMaterialsQuery, Types.CustomerMaterialsQueryVariables>(CustomerMaterialsDocument, options);
      }
export function useCustomerMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerMaterialsQuery, Types.CustomerMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerMaterialsQuery, Types.CustomerMaterialsQueryVariables>(CustomerMaterialsDocument, options);
        }
export type CustomerMaterialsQueryHookResult = ReturnType<typeof useCustomerMaterialsQuery>;
export type CustomerMaterialsLazyQueryHookResult = ReturnType<typeof useCustomerMaterialsLazyQuery>;
export type CustomerMaterialsQueryResult = Apollo.QueryResult<Types.CustomerMaterialsQuery, Types.CustomerMaterialsQueryVariables>;
export const ListCustomersDocument = gql`
    query ListCustomers($after: String, $before: String, $first: Int, $last: Int, $filter: CustomerFilterInput, $sort: UserSortingInput, $PERMISSION_MANAGE_ORDERS: Boolean!) {
  customers(
    after: $after
    before: $before
    first: $first
    last: $last
    filter: $filter
    sortBy: $sort
  ) {
    edges {
      node {
        ...Customer
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${CustomerFragmentDoc}`;

/**
 * __useListCustomersQuery__
 *
 * To run a query within a React component, call `useListCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      PERMISSION_MANAGE_ORDERS: // value for 'PERMISSION_MANAGE_ORDERS'
 *   },
 * });
 */
export function useListCustomersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ListCustomersQuery, Types.ListCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListCustomersQuery, Types.ListCustomersQueryVariables>(ListCustomersDocument, options);
      }
export function useListCustomersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListCustomersQuery, Types.ListCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListCustomersQuery, Types.ListCustomersQueryVariables>(ListCustomersDocument, options);
        }
export type ListCustomersQueryHookResult = ReturnType<typeof useListCustomersQuery>;
export type ListCustomersLazyQueryHookResult = ReturnType<typeof useListCustomersLazyQuery>;
export type ListCustomersQueryResult = Apollo.QueryResult<Types.ListCustomersQuery, Types.ListCustomersQueryVariables>;
export const CustomerDetailsDocument = gql`
    query CustomerDetails($id: ID!, $PERMISSION_MANAGE_ORDERS: Boolean!) {
  user(id: $id) {
    ...CustomerDetails
  }
}
    ${CustomerDetailsFragmentDoc}`;

/**
 * __useCustomerDetailsQuery__
 *
 * To run a query within a React component, call `useCustomerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      PERMISSION_MANAGE_ORDERS: // value for 'PERMISSION_MANAGE_ORDERS'
 *   },
 * });
 */
export function useCustomerDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerDetailsQuery, Types.CustomerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerDetailsQuery, Types.CustomerDetailsQueryVariables>(CustomerDetailsDocument, options);
      }
export function useCustomerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerDetailsQuery, Types.CustomerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerDetailsQuery, Types.CustomerDetailsQueryVariables>(CustomerDetailsDocument, options);
        }
export type CustomerDetailsQueryHookResult = ReturnType<typeof useCustomerDetailsQuery>;
export type CustomerDetailsLazyQueryHookResult = ReturnType<typeof useCustomerDetailsLazyQuery>;
export type CustomerDetailsQueryResult = Apollo.QueryResult<Types.CustomerDetailsQuery, Types.CustomerDetailsQueryVariables>;
export const CustomerAddressesDocument = gql`
    query CustomerAddresses($id: ID!) {
  user(id: $id) {
    ...CustomerAddresses
  }
}
    ${CustomerAddressesFragmentDoc}`;

/**
 * __useCustomerAddressesQuery__
 *
 * To run a query within a React component, call `useCustomerAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAddressesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerAddressesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.CustomerAddressesQuery, Types.CustomerAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerAddressesQuery, Types.CustomerAddressesQueryVariables>(CustomerAddressesDocument, options);
      }
export function useCustomerAddressesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerAddressesQuery, Types.CustomerAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerAddressesQuery, Types.CustomerAddressesQueryVariables>(CustomerAddressesDocument, options);
        }
export type CustomerAddressesQueryHookResult = ReturnType<typeof useCustomerAddressesQuery>;
export type CustomerAddressesLazyQueryHookResult = ReturnType<typeof useCustomerAddressesLazyQuery>;
export type CustomerAddressesQueryResult = Apollo.QueryResult<Types.CustomerAddressesQuery, Types.CustomerAddressesQueryVariables>;
export const CustomerCreateDataDocument = gql`
    query CustomerCreateData {
  shop {
    countries {
      code
      country
    }
  }
}
    `;

/**
 * __useCustomerCreateDataQuery__
 *
 * To run a query within a React component, call `useCustomerCreateDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerCreateDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerCreateDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CustomerCreateDataQuery, Types.CustomerCreateDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerCreateDataQuery, Types.CustomerCreateDataQueryVariables>(CustomerCreateDataDocument, options);
      }
export function useCustomerCreateDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerCreateDataQuery, Types.CustomerCreateDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerCreateDataQuery, Types.CustomerCreateDataQueryVariables>(CustomerCreateDataDocument, options);
        }
export type CustomerCreateDataQueryHookResult = ReturnType<typeof useCustomerCreateDataQuery>;
export type CustomerCreateDataLazyQueryHookResult = ReturnType<typeof useCustomerCreateDataLazyQuery>;
export type CustomerCreateDataQueryResult = Apollo.QueryResult<Types.CustomerCreateDataQuery, Types.CustomerCreateDataQueryVariables>;
export const DeliverySoldToDocument = gql`
    query deliverySoldTo($filter: DomesticSoldToFilterInput, $before: String, $after: String, $first: Int) {
  deliverySoldTo(filter: $filter, before: $before, after: $after, first: $first) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        soldToCode
        soldToName
      }
    }
  }
}
    `;

/**
 * __useDeliverySoldToQuery__
 *
 * To run a query within a React component, call `useDeliverySoldToQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliverySoldToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliverySoldToQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDeliverySoldToQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DeliverySoldToQuery, Types.DeliverySoldToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DeliverySoldToQuery, Types.DeliverySoldToQueryVariables>(DeliverySoldToDocument, options);
      }
export function useDeliverySoldToLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DeliverySoldToQuery, Types.DeliverySoldToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DeliverySoldToQuery, Types.DeliverySoldToQueryVariables>(DeliverySoldToDocument, options);
        }
export type DeliverySoldToQueryHookResult = ReturnType<typeof useDeliverySoldToQuery>;
export type DeliverySoldToLazyQueryHookResult = ReturnType<typeof useDeliverySoldToLazyQuery>;
export type DeliverySoldToQueryResult = Apollo.QueryResult<Types.DeliverySoldToQuery, Types.DeliverySoldToQueryVariables>;
export const DeliveryMaterialCodeDescriptionDocument = gql`
    query deliveryMaterialCodeDescription($filter: MaterialCodeDescriptionFilterInput, $before: String, $after: String, $first: Int) {
  deliveryMaterialCodeDescription(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        code
        descriptionEn
      }
    }
  }
}
    `;

/**
 * __useDeliveryMaterialCodeDescriptionQuery__
 *
 * To run a query within a React component, call `useDeliveryMaterialCodeDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryMaterialCodeDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryMaterialCodeDescriptionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDeliveryMaterialCodeDescriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DeliveryMaterialCodeDescriptionQuery, Types.DeliveryMaterialCodeDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DeliveryMaterialCodeDescriptionQuery, Types.DeliveryMaterialCodeDescriptionQueryVariables>(DeliveryMaterialCodeDescriptionDocument, options);
      }
export function useDeliveryMaterialCodeDescriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DeliveryMaterialCodeDescriptionQuery, Types.DeliveryMaterialCodeDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DeliveryMaterialCodeDescriptionQuery, Types.DeliveryMaterialCodeDescriptionQueryVariables>(DeliveryMaterialCodeDescriptionDocument, options);
        }
export type DeliveryMaterialCodeDescriptionQueryHookResult = ReturnType<typeof useDeliveryMaterialCodeDescriptionQuery>;
export type DeliveryMaterialCodeDescriptionLazyQueryHookResult = ReturnType<typeof useDeliveryMaterialCodeDescriptionLazyQuery>;
export type DeliveryMaterialCodeDescriptionQueryResult = Apollo.QueryResult<Types.DeliveryMaterialCodeDescriptionQuery, Types.DeliveryMaterialCodeDescriptionQueryVariables>;
export const DeliverySalesOrganizationDocument = gql`
    query deliverySalesOrganization {
  deliverySalesOrganization {
    code
    name
  }
}
    `;

/**
 * __useDeliverySalesOrganizationQuery__
 *
 * To run a query within a React component, call `useDeliverySalesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliverySalesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliverySalesOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliverySalesOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DeliverySalesOrganizationQuery, Types.DeliverySalesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DeliverySalesOrganizationQuery, Types.DeliverySalesOrganizationQueryVariables>(DeliverySalesOrganizationDocument, options);
      }
export function useDeliverySalesOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DeliverySalesOrganizationQuery, Types.DeliverySalesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DeliverySalesOrganizationQuery, Types.DeliverySalesOrganizationQueryVariables>(DeliverySalesOrganizationDocument, options);
        }
export type DeliverySalesOrganizationQueryHookResult = ReturnType<typeof useDeliverySalesOrganizationQuery>;
export type DeliverySalesOrganizationLazyQueryHookResult = ReturnType<typeof useDeliverySalesOrganizationLazyQuery>;
export type DeliverySalesOrganizationQueryResult = Apollo.QueryResult<Types.DeliverySalesOrganizationQuery, Types.DeliverySalesOrganizationQueryVariables>;
export const GetSalesOrgBySoldToDocument = gql`
    query getSalesOrgBySoldTo($soldToCode: String!) {
  getSalesOrgBySoldTo(soldToCode: $soldToCode) {
    name
    code
    shortName
    fullName
    businessUnit {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useGetSalesOrgBySoldToQuery__
 *
 * To run a query within a React component, call `useGetSalesOrgBySoldToQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesOrgBySoldToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesOrgBySoldToQuery({
 *   variables: {
 *      soldToCode: // value for 'soldToCode'
 *   },
 * });
 */
export function useGetSalesOrgBySoldToQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetSalesOrgBySoldToQuery, Types.GetSalesOrgBySoldToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetSalesOrgBySoldToQuery, Types.GetSalesOrgBySoldToQueryVariables>(GetSalesOrgBySoldToDocument, options);
      }
export function useGetSalesOrgBySoldToLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetSalesOrgBySoldToQuery, Types.GetSalesOrgBySoldToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetSalesOrgBySoldToQuery, Types.GetSalesOrgBySoldToQueryVariables>(GetSalesOrgBySoldToDocument, options);
        }
export type GetSalesOrgBySoldToQueryHookResult = ReturnType<typeof useGetSalesOrgBySoldToQuery>;
export type GetSalesOrgBySoldToLazyQueryHookResult = ReturnType<typeof useGetSalesOrgBySoldToLazyQuery>;
export type GetSalesOrgBySoldToQueryResult = Apollo.QueryResult<Types.GetSalesOrgBySoldToQuery, Types.GetSalesOrgBySoldToQueryVariables>;
export const GetLmsReportCsCustomerDocument = gql`
    query getLmsReportCsCustomer($filter: LMSReportCSCustomerInput) {
  getLmsReportCsCustomer(filter: $filter) {
    dnNo
    dataItem {
      poNo
      soNo
      itemNo
      materialDescription
      deliveryQty
      saleUnit
      lmsStatus
      matNumber
      deliveryWeight
      weightUnitTon
      parentItemNo
      delivery
      deliveryGrp
      deliveryItem
      billNo
    }
    soldToCode
    soldToName
    destinationName
    cutOffDate
    cutOffTime
    truckNo
    originName
    planDelivery
    statusId
    statusText
    boxPosition
    etaDistance
    estimatedTime
    carrierName
    boxSpeed
    boxGpsTime
    shipment
    accDistance
    goodIssueTime
    destinationInbound
    eta
    etaDuration
    status
    message
    shippingPoint
    returnFlag
    phoneNo
    contractId
    contractAbbr
    giTime
    summaryGrandTotal
  }
}
    `;

/**
 * __useGetLmsReportCsCustomerQuery__
 *
 * To run a query within a React component, call `useGetLmsReportCsCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLmsReportCsCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLmsReportCsCustomerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLmsReportCsCustomerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetLmsReportCsCustomerQuery, Types.GetLmsReportCsCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetLmsReportCsCustomerQuery, Types.GetLmsReportCsCustomerQueryVariables>(GetLmsReportCsCustomerDocument, options);
      }
export function useGetLmsReportCsCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetLmsReportCsCustomerQuery, Types.GetLmsReportCsCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetLmsReportCsCustomerQuery, Types.GetLmsReportCsCustomerQueryVariables>(GetLmsReportCsCustomerDocument, options);
        }
export type GetLmsReportCsCustomerQueryHookResult = ReturnType<typeof useGetLmsReportCsCustomerQuery>;
export type GetLmsReportCsCustomerLazyQueryHookResult = ReturnType<typeof useGetLmsReportCsCustomerLazyQuery>;
export type GetLmsReportCsCustomerQueryResult = Apollo.QueryResult<Types.GetLmsReportCsCustomerQuery, Types.GetLmsReportCsCustomerQueryVariables>;
export const GetListLmsReportCsAdminDocument = gql`
    query getListLmsReportCsAdmin {
  listLmsReportCsAdmin {
    dpNo
    poNo
    soNo
    itemNo
    materialDescription
    quantity
    saleUnit
    soldToCodeName
    shipToName
    giDateTime
    carRegistrationNo
    departurePlacePosition
    estimateDateTime
    transportationStatus
    currentPosition
    remainingDistanceAsKilometers
    estimatedArrivalDateAndTime
  }
}
    `;

/**
 * __useGetListLmsReportCsAdminQuery__
 *
 * To run a query within a React component, call `useGetListLmsReportCsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListLmsReportCsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListLmsReportCsAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListLmsReportCsAdminQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListLmsReportCsAdminQuery, Types.GetListLmsReportCsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListLmsReportCsAdminQuery, Types.GetListLmsReportCsAdminQueryVariables>(GetListLmsReportCsAdminDocument, options);
      }
export function useGetListLmsReportCsAdminLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListLmsReportCsAdminQuery, Types.GetListLmsReportCsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListLmsReportCsAdminQuery, Types.GetListLmsReportCsAdminQueryVariables>(GetListLmsReportCsAdminDocument, options);
        }
export type GetListLmsReportCsAdminQueryHookResult = ReturnType<typeof useGetListLmsReportCsAdminQuery>;
export type GetListLmsReportCsAdminLazyQueryHookResult = ReturnType<typeof useGetListLmsReportCsAdminLazyQuery>;
export type GetListLmsReportCsAdminQueryResult = Apollo.QueryResult<Types.GetListLmsReportCsAdminQuery, Types.GetListLmsReportCsAdminQueryVariables>;
export const GetGpsTrackingDocument = gql`
    query getGpsTracking($gpsTracking: String!) {
  getGpsTracking(gpsTracking: $gpsTracking) {
    shipmentNo
    carRegistrationNo
    currentPosition
    carrier
    speed
    dateAndTimeOfTheLastSignalReceived
    paymentNo
    placeOfDelivery
    carStatus
    destinationReachTime
    estimateToCustomersFromTheirCurrentLocation
    approximateRemainingDistance
    estimatedTime
    estimatedArrivalTime
    distanceFromFactoryToCustomer
    dateOfIssuanceOfInvoice
    deliveryDeadline
  }
}
    `;

/**
 * __useGetGpsTrackingQuery__
 *
 * To run a query within a React component, call `useGetGpsTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpsTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpsTrackingQuery({
 *   variables: {
 *      gpsTracking: // value for 'gpsTracking'
 *   },
 * });
 */
export function useGetGpsTrackingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetGpsTrackingQuery, Types.GetGpsTrackingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetGpsTrackingQuery, Types.GetGpsTrackingQueryVariables>(GetGpsTrackingDocument, options);
      }
export function useGetGpsTrackingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetGpsTrackingQuery, Types.GetGpsTrackingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetGpsTrackingQuery, Types.GetGpsTrackingQueryVariables>(GetGpsTrackingDocument, options);
        }
export type GetGpsTrackingQueryHookResult = ReturnType<typeof useGetGpsTrackingQuery>;
export type GetGpsTrackingLazyQueryHookResult = ReturnType<typeof useGetGpsTrackingLazyQuery>;
export type GetGpsTrackingQueryResult = Apollo.QueryResult<Types.GetGpsTrackingQuery, Types.GetGpsTrackingQueryVariables>;
export const GetDpHyperlinkDocument = gql`
    query getDpHyperlink($dpNo: String!) {
  getDpHyperlink(dpNo: $dpNo) {
    totalQuantity
    dpNoLines {
      dpNo
      poNo
      soNo
      materialDescription
      quantity
      saleUnit
    }
  }
}
    `;

/**
 * __useGetDpHyperlinkQuery__
 *
 * To run a query within a React component, call `useGetDpHyperlinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDpHyperlinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDpHyperlinkQuery({
 *   variables: {
 *      dpNo: // value for 'dpNo'
 *   },
 * });
 */
export function useGetDpHyperlinkQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetDpHyperlinkQuery, Types.GetDpHyperlinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetDpHyperlinkQuery, Types.GetDpHyperlinkQueryVariables>(GetDpHyperlinkDocument, options);
      }
export function useGetDpHyperlinkLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetDpHyperlinkQuery, Types.GetDpHyperlinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetDpHyperlinkQuery, Types.GetDpHyperlinkQueryVariables>(GetDpHyperlinkDocument, options);
        }
export type GetDpHyperlinkQueryHookResult = ReturnType<typeof useGetDpHyperlinkQuery>;
export type GetDpHyperlinkLazyQueryHookResult = ReturnType<typeof useGetDpHyperlinkLazyQuery>;
export type GetDpHyperlinkQueryResult = Apollo.QueryResult<Types.GetDpHyperlinkQuery, Types.GetDpHyperlinkQueryVariables>;
export const GetgpsReportCsCustomerDocument = gql`
    query getgpsReportCsCustomer($filter: GPSReportCSCustomerInput) {
  getGpsReportCsCustomer(filter: $filter) {
    truckNo
    boxPosition
    carrierName
    boxSpeed
    boxGpsTime
    shipment
    dnNo
    destinationName
    statusId
    destinationInbound
    eta
    etaDistance
    etaDuration
    estimatedTime
    accDistance
    goodIssueTime
    planDelivery
    statusText
    __typename
  }
}
    `;

/**
 * __useGetgpsReportCsCustomerQuery__
 *
 * To run a query within a React component, call `useGetgpsReportCsCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetgpsReportCsCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetgpsReportCsCustomerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetgpsReportCsCustomerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetgpsReportCsCustomerQuery, Types.GetgpsReportCsCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetgpsReportCsCustomerQuery, Types.GetgpsReportCsCustomerQueryVariables>(GetgpsReportCsCustomerDocument, options);
      }
export function useGetgpsReportCsCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetgpsReportCsCustomerQuery, Types.GetgpsReportCsCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetgpsReportCsCustomerQuery, Types.GetgpsReportCsCustomerQueryVariables>(GetgpsReportCsCustomerDocument, options);
        }
export type GetgpsReportCsCustomerQueryHookResult = ReturnType<typeof useGetgpsReportCsCustomerQuery>;
export type GetgpsReportCsCustomerLazyQueryHookResult = ReturnType<typeof useGetgpsReportCsCustomerLazyQuery>;
export type GetgpsReportCsCustomerQueryResult = Apollo.QueryResult<Types.GetgpsReportCsCustomerQuery, Types.GetgpsReportCsCustomerQueryVariables>;
export const GetCustomerLmsReportDocument = gql`
    query getCustomerLmsReport {
  customerLmsReport {
    dpNo
    poNo
    soNo
    itemNo
    departurePlacePositions
    materialDescription
    quantity
    shipTo
    giDate
    carRegistrationNo
    estimateDateTime
    transportStatus
    currentPosition
    remainingDistanceAsKilometer
    estimatedArrivalDatetime
    saleUnit
    gpsTracking {
      shipmentNo
      estimatedTime
      carRegistrationNo
      currentPosition
      carrier
      velocity
      lastSignalReceivedDatetime
      paymentNumber
      deliveryPlace
      carStatus
      destinationReachTime
      estimatedToCustomerFromCurrentLocation
      remainingDistanceAsKilometer
      estimateArrivalTime
      distanceFromFactoryToCustomer
      isssuanceOfInvoiceDate
      deliveryDeadline
    }
  }
}
    `;

/**
 * __useGetCustomerLmsReportQuery__
 *
 * To run a query within a React component, call `useGetCustomerLmsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerLmsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerLmsReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerLmsReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetCustomerLmsReportQuery, Types.GetCustomerLmsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetCustomerLmsReportQuery, Types.GetCustomerLmsReportQueryVariables>(GetCustomerLmsReportDocument, options);
      }
export function useGetCustomerLmsReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetCustomerLmsReportQuery, Types.GetCustomerLmsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetCustomerLmsReportQuery, Types.GetCustomerLmsReportQueryVariables>(GetCustomerLmsReportDocument, options);
        }
export type GetCustomerLmsReportQueryHookResult = ReturnType<typeof useGetCustomerLmsReportQuery>;
export type GetCustomerLmsReportLazyQueryHookResult = ReturnType<typeof useGetCustomerLmsReportLazyQuery>;
export type GetCustomerLmsReportQueryResult = Apollo.QueryResult<Types.GetCustomerLmsReportQuery, Types.GetCustomerLmsReportQueryVariables>;
export const ExportExcelUploadTemplateDocument = gql`
    mutation exportExcelUploadTemplate {
  exportExcelUploadTemplate {
    exportedFileBase64
    fileName
    __typename
  }
}
    `;
export type ExportExcelUploadTemplateMutationFn = Apollo.MutationFunction<Types.ExportExcelUploadTemplateMutation, Types.ExportExcelUploadTemplateMutationVariables>;

/**
 * __useExportExcelUploadTemplateMutation__
 *
 * To run a mutation, you first call `useExportExcelUploadTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportExcelUploadTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportExcelUploadTemplateMutation, { data, loading, error }] = useExportExcelUploadTemplateMutation({
 *   variables: {
 *   },
 * });
 */
export function useExportExcelUploadTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExportExcelUploadTemplateMutation, Types.ExportExcelUploadTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExportExcelUploadTemplateMutation, Types.ExportExcelUploadTemplateMutationVariables>(ExportExcelUploadTemplateDocument, options);
      }
export type ExportExcelUploadTemplateMutationHookResult = ReturnType<typeof useExportExcelUploadTemplateMutation>;
export type ExportExcelUploadTemplateMutationResult = Apollo.MutationResult<Types.ExportExcelUploadTemplateMutation>;
export type ExportExcelUploadTemplateMutationOptions = Apollo.BaseMutationOptions<Types.ExportExcelUploadTemplateMutation, Types.ExportExcelUploadTemplateMutationVariables>;
export const ExcelUploadFileDocument = gql`
    mutation ExcelUploadFile($file: Upload!, $orderType: String!, $saleOrg: String!, $uploadType: UploadType!, $distributionChannel: String!, $division: String!) {
  uploadExcel(
    file: $file
    orderType: $orderType
    saleOrg: $saleOrg
    uploadType: $uploadType
    distributionChannel: $distributionChannel
    division: $division
  ) {
    status
    rows
    errors {
      field
      code
      message
    }
  }
}
    `;
export type ExcelUploadFileMutationFn = Apollo.MutationFunction<Types.ExcelUploadFileMutation, Types.ExcelUploadFileMutationVariables>;

/**
 * __useExcelUploadFileMutation__
 *
 * To run a mutation, you first call `useExcelUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcelUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excelUploadFileMutation, { data, loading, error }] = useExcelUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      orderType: // value for 'orderType'
 *      saleOrg: // value for 'saleOrg'
 *      uploadType: // value for 'uploadType'
 *      distributionChannel: // value for 'distributionChannel'
 *      division: // value for 'division'
 *   },
 * });
 */
export function useExcelUploadFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ExcelUploadFileMutation, Types.ExcelUploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ExcelUploadFileMutation, Types.ExcelUploadFileMutationVariables>(ExcelUploadFileDocument, options);
      }
export type ExcelUploadFileMutationHookResult = ReturnType<typeof useExcelUploadFileMutation>;
export type ExcelUploadFileMutationResult = Apollo.MutationResult<Types.ExcelUploadFileMutation>;
export type ExcelUploadFileMutationOptions = Apollo.BaseMutationOptions<Types.ExcelUploadFileMutation, Types.ExcelUploadFileMutationVariables>;
export const ValidExcelFileDocument = gql`
    mutation validExcelFile($fileName: String!) {
  validExcelFile(fileName: $fileName) {
    valid
    errors {
      field
      code
      message
    }
  }
}
    `;
export type ValidExcelFileMutationFn = Apollo.MutationFunction<Types.ValidExcelFileMutation, Types.ValidExcelFileMutationVariables>;

/**
 * __useValidExcelFileMutation__
 *
 * To run a mutation, you first call `useValidExcelFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidExcelFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validExcelFileMutation, { data, loading, error }] = useValidExcelFileMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useValidExcelFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ValidExcelFileMutation, Types.ValidExcelFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ValidExcelFileMutation, Types.ValidExcelFileMutationVariables>(ValidExcelFileDocument, options);
      }
export type ValidExcelFileMutationHookResult = ReturnType<typeof useValidExcelFileMutation>;
export type ValidExcelFileMutationResult = Apollo.MutationResult<Types.ValidExcelFileMutation>;
export type ValidExcelFileMutationOptions = Apollo.BaseMutationOptions<Types.ValidExcelFileMutation, Types.ValidExcelFileMutationVariables>;
export const FilterMaterialCodeNameCustomerOrderDocument = gql`
    query filterMaterialCodeNameCustomerOrder($distributionChannelType: DistributionChannelType!, $filter: CustomerMaterialCodeNameFilterInput, $before: String, $after: String, $first: Int) {
  filterMaterialCodeNameCustomerOrder(
    distributionChannelType: $distributionChannelType
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        name
        slug
        code
        descriptionEn
      }
    }
  }
}
    `;

/**
 * __useFilterMaterialCodeNameCustomerOrderQuery__
 *
 * To run a query within a React component, call `useFilterMaterialCodeNameCustomerOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterMaterialCodeNameCustomerOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterMaterialCodeNameCustomerOrderQuery({
 *   variables: {
 *      distributionChannelType: // value for 'distributionChannelType'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterMaterialCodeNameCustomerOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FilterMaterialCodeNameCustomerOrderQuery, Types.FilterMaterialCodeNameCustomerOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterMaterialCodeNameCustomerOrderQuery, Types.FilterMaterialCodeNameCustomerOrderQueryVariables>(FilterMaterialCodeNameCustomerOrderDocument, options);
      }
export function useFilterMaterialCodeNameCustomerOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterMaterialCodeNameCustomerOrderQuery, Types.FilterMaterialCodeNameCustomerOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterMaterialCodeNameCustomerOrderQuery, Types.FilterMaterialCodeNameCustomerOrderQueryVariables>(FilterMaterialCodeNameCustomerOrderDocument, options);
        }
export type FilterMaterialCodeNameCustomerOrderQueryHookResult = ReturnType<typeof useFilterMaterialCodeNameCustomerOrderQuery>;
export type FilterMaterialCodeNameCustomerOrderLazyQueryHookResult = ReturnType<typeof useFilterMaterialCodeNameCustomerOrderLazyQuery>;
export type FilterMaterialCodeNameCustomerOrderQueryResult = Apollo.QueryResult<Types.FilterMaterialCodeNameCustomerOrderQuery, Types.FilterMaterialCodeNameCustomerOrderQueryVariables>;
export const FilterCustomerBusinessUnitDocument = gql`
    query filterCustomerBusinessUnit {
  filterCustomerBusinessUnit {
    label: name
    value: code
    isDefaultForInquirySearch
  }
}
    `;

/**
 * __useFilterCustomerBusinessUnitQuery__
 *
 * To run a query within a React component, call `useFilterCustomerBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCustomerBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCustomerBusinessUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterCustomerBusinessUnitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterCustomerBusinessUnitQuery, Types.FilterCustomerBusinessUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterCustomerBusinessUnitQuery, Types.FilterCustomerBusinessUnitQueryVariables>(FilterCustomerBusinessUnitDocument, options);
      }
export function useFilterCustomerBusinessUnitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterCustomerBusinessUnitQuery, Types.FilterCustomerBusinessUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterCustomerBusinessUnitQuery, Types.FilterCustomerBusinessUnitQueryVariables>(FilterCustomerBusinessUnitDocument, options);
        }
export type FilterCustomerBusinessUnitQueryHookResult = ReturnType<typeof useFilterCustomerBusinessUnitQuery>;
export type FilterCustomerBusinessUnitLazyQueryHookResult = ReturnType<typeof useFilterCustomerBusinessUnitLazyQuery>;
export type FilterCustomerBusinessUnitQueryResult = Apollo.QueryResult<Types.FilterCustomerBusinessUnitQuery, Types.FilterCustomerBusinessUnitQueryVariables>;
export const FilterCustomerCompanyByBuDocument = gql`
    query filterCustomerCompanyByBu($filter: CustomerCompanyFilterInput, $before: String, $after: String, $first: Int) {
  filterCustomerCompanyByBu(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        name
        shortName
        code
      }
    }
  }
}
    `;

/**
 * __useFilterCustomerCompanyByBuQuery__
 *
 * To run a query within a React component, call `useFilterCustomerCompanyByBuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCustomerCompanyByBuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCustomerCompanyByBuQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterCustomerCompanyByBuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterCustomerCompanyByBuQuery, Types.FilterCustomerCompanyByBuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterCustomerCompanyByBuQuery, Types.FilterCustomerCompanyByBuQueryVariables>(FilterCustomerCompanyByBuDocument, options);
      }
export function useFilterCustomerCompanyByBuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterCustomerCompanyByBuQuery, Types.FilterCustomerCompanyByBuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterCustomerCompanyByBuQuery, Types.FilterCustomerCompanyByBuQueryVariables>(FilterCustomerCompanyByBuDocument, options);
        }
export type FilterCustomerCompanyByBuQueryHookResult = ReturnType<typeof useFilterCustomerCompanyByBuQuery>;
export type FilterCustomerCompanyByBuLazyQueryHookResult = ReturnType<typeof useFilterCustomerCompanyByBuLazyQuery>;
export type FilterCustomerCompanyByBuQueryResult = Apollo.QueryResult<Types.FilterCustomerCompanyByBuQuery, Types.FilterCustomerCompanyByBuQueryVariables>;
export const FilterCustomerSalesGroupByCompanyDocument = gql`
    query filterCustomerSalesGroupByCompany($filter: CustomerSalesGroupFilterInput, $before: String, $after: String, $first: Int) {
  filterCustomerSalesGroupByCompany(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useFilterCustomerSalesGroupByCompanyQuery__
 *
 * To run a query within a React component, call `useFilterCustomerSalesGroupByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCustomerSalesGroupByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCustomerSalesGroupByCompanyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterCustomerSalesGroupByCompanyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterCustomerSalesGroupByCompanyQuery, Types.FilterCustomerSalesGroupByCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterCustomerSalesGroupByCompanyQuery, Types.FilterCustomerSalesGroupByCompanyQueryVariables>(FilterCustomerSalesGroupByCompanyDocument, options);
      }
export function useFilterCustomerSalesGroupByCompanyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterCustomerSalesGroupByCompanyQuery, Types.FilterCustomerSalesGroupByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterCustomerSalesGroupByCompanyQuery, Types.FilterCustomerSalesGroupByCompanyQueryVariables>(FilterCustomerSalesGroupByCompanyDocument, options);
        }
export type FilterCustomerSalesGroupByCompanyQueryHookResult = ReturnType<typeof useFilterCustomerSalesGroupByCompanyQuery>;
export type FilterCustomerSalesGroupByCompanyLazyQueryHookResult = ReturnType<typeof useFilterCustomerSalesGroupByCompanyLazyQuery>;
export type FilterCustomerSalesGroupByCompanyQueryResult = Apollo.QueryResult<Types.FilterCustomerSalesGroupByCompanyQuery, Types.FilterCustomerSalesGroupByCompanyQueryVariables>;
export const CustomerOrdersDocument = gql`
    query customerOrders($sortBy: CustomerOrderSortingInput, $filter: CustomerOrderFilterInput, $before: String, $after: String, $first: Int) {
  customerOrders(
    sortBy: $sortBy
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    totalCount
    latestPageItemNumber
    edges {
      node {
        id
        soNo
        poNo
        contract {
          code
        }
        customerSoldToOrder
        soldTo {
          displayText
        }
        contract {
          projectName
          soldTo {
            displayText
          }
        }
        company {
          name
          code
        }
        paymentTerm
        orderDate
        status
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useCustomerOrdersQuery__
 *
 * To run a query within a React component, call `useCustomerOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrdersQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCustomerOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CustomerOrdersQuery, Types.CustomerOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerOrdersQuery, Types.CustomerOrdersQueryVariables>(CustomerOrdersDocument, options);
      }
export function useCustomerOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerOrdersQuery, Types.CustomerOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerOrdersQuery, Types.CustomerOrdersQueryVariables>(CustomerOrdersDocument, options);
        }
export type CustomerOrdersQueryHookResult = ReturnType<typeof useCustomerOrdersQuery>;
export type CustomerOrdersLazyQueryHookResult = ReturnType<typeof useCustomerOrdersLazyQuery>;
export type CustomerOrdersQueryResult = Apollo.QueryResult<Types.CustomerOrdersQuery, Types.CustomerOrdersQueryVariables>;
export const CustomerOrdersFromSapDocument = gql`
    query customerOrdersFromSap($input: SAPOrderRequest) {
  customerOrdersFromSap(input: $input) {
    id: sdDoc
    sdDoc
    status
    createDate
    createTime
    poNo
    salesOrg
    descriptionInContract
    creditStatus
    deliverStatus
    soldTo
    soldToName1
    shipTo
    shipToName1
    countrySh
    countryName
    incotermS1
    incotermS2
    paymentTerm
    paymentTermDesc
    eOrderingStatus
    contractPi
  }
}
    `;

/**
 * __useCustomerOrdersFromSapQuery__
 *
 * To run a query within a React component, call `useCustomerOrdersFromSapQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerOrdersFromSapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerOrdersFromSapQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerOrdersFromSapQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.CustomerOrdersFromSapQuery, Types.CustomerOrdersFromSapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.CustomerOrdersFromSapQuery, Types.CustomerOrdersFromSapQueryVariables>(CustomerOrdersFromSapDocument, options);
      }
export function useCustomerOrdersFromSapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.CustomerOrdersFromSapQuery, Types.CustomerOrdersFromSapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.CustomerOrdersFromSapQuery, Types.CustomerOrdersFromSapQueryVariables>(CustomerOrdersFromSapDocument, options);
        }
export type CustomerOrdersFromSapQueryHookResult = ReturnType<typeof useCustomerOrdersFromSapQuery>;
export type CustomerOrdersFromSapLazyQueryHookResult = ReturnType<typeof useCustomerOrdersFromSapLazyQuery>;
export type CustomerOrdersFromSapQueryResult = Apollo.QueryResult<Types.CustomerOrdersFromSapQuery, Types.CustomerOrdersFromSapQueryVariables>;
export const FilterRequireAttentionSalesOrganizationDocument = gql`
    query filterRequireAttentionSalesOrganization {
  filterRequireAttentionSalesOrganization {
    name
    code
    shortName
  }
}
    `;

/**
 * __useFilterRequireAttentionSalesOrganizationQuery__
 *
 * To run a query within a React component, call `useFilterRequireAttentionSalesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRequireAttentionSalesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRequireAttentionSalesOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterRequireAttentionSalesOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterRequireAttentionSalesOrganizationQuery, Types.FilterRequireAttentionSalesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterRequireAttentionSalesOrganizationQuery, Types.FilterRequireAttentionSalesOrganizationQueryVariables>(FilterRequireAttentionSalesOrganizationDocument, options);
      }
export function useFilterRequireAttentionSalesOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterRequireAttentionSalesOrganizationQuery, Types.FilterRequireAttentionSalesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterRequireAttentionSalesOrganizationQuery, Types.FilterRequireAttentionSalesOrganizationQueryVariables>(FilterRequireAttentionSalesOrganizationDocument, options);
        }
export type FilterRequireAttentionSalesOrganizationQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesOrganizationQuery>;
export type FilterRequireAttentionSalesOrganizationLazyQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesOrganizationLazyQuery>;
export type FilterRequireAttentionSalesOrganizationQueryResult = Apollo.QueryResult<Types.FilterRequireAttentionSalesOrganizationQuery, Types.FilterRequireAttentionSalesOrganizationQueryVariables>;
export const DropDownListOrderTypeDocument = gql`
    query dropDownListOrderType {
  dropDownListOrderType {
    orderType
  }
}
    `;

/**
 * __useDropDownListOrderTypeQuery__
 *
 * To run a query within a React component, call `useDropDownListOrderTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropDownListOrderTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropDownListOrderTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useDropDownListOrderTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DropDownListOrderTypeQuery, Types.DropDownListOrderTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DropDownListOrderTypeQuery, Types.DropDownListOrderTypeQueryVariables>(DropDownListOrderTypeDocument, options);
      }
export function useDropDownListOrderTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DropDownListOrderTypeQuery, Types.DropDownListOrderTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DropDownListOrderTypeQuery, Types.DropDownListOrderTypeQueryVariables>(DropDownListOrderTypeDocument, options);
        }
export type DropDownListOrderTypeQueryHookResult = ReturnType<typeof useDropDownListOrderTypeQuery>;
export type DropDownListOrderTypeLazyQueryHookResult = ReturnType<typeof useDropDownListOrderTypeLazyQuery>;
export type DropDownListOrderTypeQueryResult = Apollo.QueryResult<Types.DropDownListOrderTypeQuery, Types.DropDownListOrderTypeQueryVariables>;
export const FilterRequireAttentionSalesGroupDocument = gql`
    query filterRequireAttentionSalesGroup {
  filterRequireAttentionSalesGroup {
    name
    code
  }
}
    `;

/**
 * __useFilterRequireAttentionSalesGroupQuery__
 *
 * To run a query within a React component, call `useFilterRequireAttentionSalesGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRequireAttentionSalesGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRequireAttentionSalesGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilterRequireAttentionSalesGroupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterRequireAttentionSalesGroupQuery, Types.FilterRequireAttentionSalesGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterRequireAttentionSalesGroupQuery, Types.FilterRequireAttentionSalesGroupQueryVariables>(FilterRequireAttentionSalesGroupDocument, options);
      }
export function useFilterRequireAttentionSalesGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterRequireAttentionSalesGroupQuery, Types.FilterRequireAttentionSalesGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterRequireAttentionSalesGroupQuery, Types.FilterRequireAttentionSalesGroupQueryVariables>(FilterRequireAttentionSalesGroupDocument, options);
        }
export type FilterRequireAttentionSalesGroupQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesGroupQuery>;
export type FilterRequireAttentionSalesGroupLazyQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesGroupLazyQuery>;
export type FilterRequireAttentionSalesGroupQueryResult = Apollo.QueryResult<Types.FilterRequireAttentionSalesGroupQuery, Types.FilterRequireAttentionSalesGroupQueryVariables>;
export const FilterRequireAttentionSoldToDocument = gql`
    query filterRequireAttentionSoldTo($filter: RequireAttentionSoldToFilterInput, $first: Int) {
  filterRequireAttentionSoldTo(filter: $filter, first: $first) {
    totalCount
    edges {
      node {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useFilterRequireAttentionSoldToQuery__
 *
 * To run a query within a React component, call `useFilterRequireAttentionSoldToQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRequireAttentionSoldToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRequireAttentionSoldToQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterRequireAttentionSoldToQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterRequireAttentionSoldToQuery, Types.FilterRequireAttentionSoldToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterRequireAttentionSoldToQuery, Types.FilterRequireAttentionSoldToQueryVariables>(FilterRequireAttentionSoldToDocument, options);
      }
export function useFilterRequireAttentionSoldToLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterRequireAttentionSoldToQuery, Types.FilterRequireAttentionSoldToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterRequireAttentionSoldToQuery, Types.FilterRequireAttentionSoldToQueryVariables>(FilterRequireAttentionSoldToDocument, options);
        }
export type FilterRequireAttentionSoldToQueryHookResult = ReturnType<typeof useFilterRequireAttentionSoldToQuery>;
export type FilterRequireAttentionSoldToLazyQueryHookResult = ReturnType<typeof useFilterRequireAttentionSoldToLazyQuery>;
export type FilterRequireAttentionSoldToQueryResult = Apollo.QueryResult<Types.FilterRequireAttentionSoldToQuery, Types.FilterRequireAttentionSoldToQueryVariables>;
export const FilterRequireAttentionSaleEmployeeDocument = gql`
    query filterRequireAttentionSaleEmployee($filter: RequireAttentionSaleEmployeeFilterInput, $first: Int) {
  filterRequireAttentionSaleEmployee(filter: $filter, first: $first) {
    edges {
      node {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useFilterRequireAttentionSaleEmployeeQuery__
 *
 * To run a query within a React component, call `useFilterRequireAttentionSaleEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRequireAttentionSaleEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRequireAttentionSaleEmployeeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterRequireAttentionSaleEmployeeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterRequireAttentionSaleEmployeeQuery, Types.FilterRequireAttentionSaleEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterRequireAttentionSaleEmployeeQuery, Types.FilterRequireAttentionSaleEmployeeQueryVariables>(FilterRequireAttentionSaleEmployeeDocument, options);
      }
export function useFilterRequireAttentionSaleEmployeeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterRequireAttentionSaleEmployeeQuery, Types.FilterRequireAttentionSaleEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterRequireAttentionSaleEmployeeQuery, Types.FilterRequireAttentionSaleEmployeeQueryVariables>(FilterRequireAttentionSaleEmployeeDocument, options);
        }
export type FilterRequireAttentionSaleEmployeeQueryHookResult = ReturnType<typeof useFilterRequireAttentionSaleEmployeeQuery>;
export type FilterRequireAttentionSaleEmployeeLazyQueryHookResult = ReturnType<typeof useFilterRequireAttentionSaleEmployeeLazyQuery>;
export type FilterRequireAttentionSaleEmployeeQueryResult = Apollo.QueryResult<Types.FilterRequireAttentionSaleEmployeeQuery, Types.FilterRequireAttentionSaleEmployeeQueryVariables>;
export const DropdownListMaterialGroup1Document = gql`
    query dropdownListMaterialGroup1($bu: String) {
  dropdownListMaterialGroup1(bu: $bu) {
    materialGroup1
    materialGroup1Desc
    salesOrganizationCode
  }
}
    `;

/**
 * __useDropdownListMaterialGroup1Query__
 *
 * To run a query within a React component, call `useDropdownListMaterialGroup1Query` and pass it any options that fit your needs.
 * When your component renders, `useDropdownListMaterialGroup1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropdownListMaterialGroup1Query({
 *   variables: {
 *      bu: // value for 'bu'
 *   },
 * });
 */
export function useDropdownListMaterialGroup1Query(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DropdownListMaterialGroup1Query, Types.DropdownListMaterialGroup1QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DropdownListMaterialGroup1Query, Types.DropdownListMaterialGroup1QueryVariables>(DropdownListMaterialGroup1Document, options);
      }
export function useDropdownListMaterialGroup1LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DropdownListMaterialGroup1Query, Types.DropdownListMaterialGroup1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DropdownListMaterialGroup1Query, Types.DropdownListMaterialGroup1QueryVariables>(DropdownListMaterialGroup1Document, options);
        }
export type DropdownListMaterialGroup1QueryHookResult = ReturnType<typeof useDropdownListMaterialGroup1Query>;
export type DropdownListMaterialGroup1LazyQueryHookResult = ReturnType<typeof useDropdownListMaterialGroup1LazyQuery>;
export type DropdownListMaterialGroup1QueryResult = Apollo.QueryResult<Types.DropdownListMaterialGroup1Query, Types.DropdownListMaterialGroup1QueryVariables>;
export const DropDownMaterialPricingGroupDocument = gql`
    query dropDownMaterialPricingGroup {
  dropDownMaterialPricingGroup {
    materialPricingGroup
  }
}
    `;

/**
 * __useDropDownMaterialPricingGroupQuery__
 *
 * To run a query within a React component, call `useDropDownMaterialPricingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useDropDownMaterialPricingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDropDownMaterialPricingGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useDropDownMaterialPricingGroupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DropDownMaterialPricingGroupQuery, Types.DropDownMaterialPricingGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DropDownMaterialPricingGroupQuery, Types.DropDownMaterialPricingGroupQueryVariables>(DropDownMaterialPricingGroupDocument, options);
      }
export function useDropDownMaterialPricingGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DropDownMaterialPricingGroupQuery, Types.DropDownMaterialPricingGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DropDownMaterialPricingGroupQuery, Types.DropDownMaterialPricingGroupQueryVariables>(DropDownMaterialPricingGroupDocument, options);
        }
export type DropDownMaterialPricingGroupQueryHookResult = ReturnType<typeof useDropDownMaterialPricingGroupQuery>;
export type DropDownMaterialPricingGroupLazyQueryHookResult = ReturnType<typeof useDropDownMaterialPricingGroupLazyQuery>;
export type DropDownMaterialPricingGroupQueryResult = Apollo.QueryResult<Types.DropDownMaterialPricingGroupQuery, Types.DropDownMaterialPricingGroupQueryVariables>;
export const SuggestionSearchCreateBySaleOrderDocument = gql`
    query suggestionSearchCreateBySaleOrder($filter: SuggestionSearchUserByNameFilterInput, $first: Int) {
  suggestionSearchCreateBySaleOrder(filter: $filter, first: $first) {
    edges {
      node {
        userId
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useSuggestionSearchCreateBySaleOrderQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchCreateBySaleOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchCreateBySaleOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchCreateBySaleOrderQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSuggestionSearchCreateBySaleOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchCreateBySaleOrderQuery, Types.SuggestionSearchCreateBySaleOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchCreateBySaleOrderQuery, Types.SuggestionSearchCreateBySaleOrderQueryVariables>(SuggestionSearchCreateBySaleOrderDocument, options);
      }
export function useSuggestionSearchCreateBySaleOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchCreateBySaleOrderQuery, Types.SuggestionSearchCreateBySaleOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchCreateBySaleOrderQuery, Types.SuggestionSearchCreateBySaleOrderQueryVariables>(SuggestionSearchCreateBySaleOrderDocument, options);
        }
export type SuggestionSearchCreateBySaleOrderQueryHookResult = ReturnType<typeof useSuggestionSearchCreateBySaleOrderQuery>;
export type SuggestionSearchCreateBySaleOrderLazyQueryHookResult = ReturnType<typeof useSuggestionSearchCreateBySaleOrderLazyQuery>;
export type SuggestionSearchCreateBySaleOrderQueryResult = Apollo.QueryResult<Types.SuggestionSearchCreateBySaleOrderQuery, Types.SuggestionSearchCreateBySaleOrderQueryVariables>;
export const ListRequireAttentionFlagDocument = gql`
    query listRequireAttentionFlag {
  listRequireAttentionFlag {
    key
    value
  }
}
    `;

/**
 * __useListRequireAttentionFlagQuery__
 *
 * To run a query within a React component, call `useListRequireAttentionFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRequireAttentionFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRequireAttentionFlagQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRequireAttentionFlagQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListRequireAttentionFlagQuery, Types.ListRequireAttentionFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListRequireAttentionFlagQuery, Types.ListRequireAttentionFlagQueryVariables>(ListRequireAttentionFlagDocument, options);
      }
export function useListRequireAttentionFlagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListRequireAttentionFlagQuery, Types.ListRequireAttentionFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListRequireAttentionFlagQuery, Types.ListRequireAttentionFlagQueryVariables>(ListRequireAttentionFlagDocument, options);
        }
export type ListRequireAttentionFlagQueryHookResult = ReturnType<typeof useListRequireAttentionFlagQuery>;
export type ListRequireAttentionFlagLazyQueryHookResult = ReturnType<typeof useListRequireAttentionFlagLazyQuery>;
export type ListRequireAttentionFlagQueryResult = Apollo.QueryResult<Types.ListRequireAttentionFlagQuery, Types.ListRequireAttentionFlagQueryVariables>;
export const ListOfSaleOrderAndExcelDocument = gql`
    query listOfSaleOrderAndExcel($filter: SAPListOfSaleOrderInput) {
  listOfSaleOrderAndExcel(filter: $filter) {
    listOfSaleOrderSap {
      totalSoldTo
      soldTo
      soldToName1
      orderLines {
        createDateTime
        salesOrg
        salesGroup
        poNo
        originalRequestDate
        createDate
        reqDeliveryDate
        orderNo
        itemNo
        matNo
        matDesc
        materialPricingGroup
        orderQty
        confirmOrderQty
        deliveryQty
        pendingQty
        unit
        plant
        shippingPoint
        orderWeight
        deliveryWeight
        pendingWeight
        weightUnit
        netPrice
        netValue
        currency
        rejection
        deliveryBlock
        eOrderingOverdue1
        eOrderingOverdue2
        eOrderingRequiredAttentionFlag
        eOrderingCreateBy
        eOrderingConfirmDate
        eOrderingItemStatus
        sapStatus
        orderTrackingStatus
        priceDate
        trackingUrl
        bomFlag
        parentItemNo
        isNotRef
        orderType
        billTo
        shipTo
        unloadingPoint
        paymentTerm
        headerNote
        itemNote
        oldMaterialNo
        descriptionSaleText
        batchNo
        productionFlag
        deliveryToleranceUnder
        deliveryToleranceOver
        prNumberOs
        prItemOs
        salesEmployeeName
      }
      summary {
        orderQty
        confirmOrderQty
        deliveryQty
        pendingQty
        unit
        orderWeight
        deliveryWeight
        pendingWeight
        weightUnit
        netPrice
        netValue
        currency
        quantityData {
          orderQty
          confirmOrderQty
          deliveryQty
          pendingQty
          quantityUnit
        }
      }
    }
  }
}
    `;

/**
 * __useListOfSaleOrderAndExcelQuery__
 *
 * To run a query within a React component, call `useListOfSaleOrderAndExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfSaleOrderAndExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfSaleOrderAndExcelQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListOfSaleOrderAndExcelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListOfSaleOrderAndExcelQuery, Types.ListOfSaleOrderAndExcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListOfSaleOrderAndExcelQuery, Types.ListOfSaleOrderAndExcelQueryVariables>(ListOfSaleOrderAndExcelDocument, options);
      }
export function useListOfSaleOrderAndExcelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListOfSaleOrderAndExcelQuery, Types.ListOfSaleOrderAndExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListOfSaleOrderAndExcelQuery, Types.ListOfSaleOrderAndExcelQueryVariables>(ListOfSaleOrderAndExcelDocument, options);
        }
export type ListOfSaleOrderAndExcelQueryHookResult = ReturnType<typeof useListOfSaleOrderAndExcelQuery>;
export type ListOfSaleOrderAndExcelLazyQueryHookResult = ReturnType<typeof useListOfSaleOrderAndExcelLazyQuery>;
export type ListOfSaleOrderAndExcelQueryResult = Apollo.QueryResult<Types.ListOfSaleOrderAndExcelQuery, Types.ListOfSaleOrderAndExcelQueryVariables>;
export const DownloadListOfSaleOrderExcelDocument = gql`
    query downloadListOfSaleOrderExcel($filter: SAPListOfSaleOrderInput) {
  downloadListOfSaleOrderExcel(filter: $filter) {
    excel
  }
}
    `;

/**
 * __useDownloadListOfSaleOrderExcelQuery__
 *
 * To run a query within a React component, call `useDownloadListOfSaleOrderExcelQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadListOfSaleOrderExcelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadListOfSaleOrderExcelQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDownloadListOfSaleOrderExcelQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DownloadListOfSaleOrderExcelQuery, Types.DownloadListOfSaleOrderExcelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DownloadListOfSaleOrderExcelQuery, Types.DownloadListOfSaleOrderExcelQueryVariables>(DownloadListOfSaleOrderExcelDocument, options);
      }
export function useDownloadListOfSaleOrderExcelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DownloadListOfSaleOrderExcelQuery, Types.DownloadListOfSaleOrderExcelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DownloadListOfSaleOrderExcelQuery, Types.DownloadListOfSaleOrderExcelQueryVariables>(DownloadListOfSaleOrderExcelDocument, options);
        }
export type DownloadListOfSaleOrderExcelQueryHookResult = ReturnType<typeof useDownloadListOfSaleOrderExcelQuery>;
export type DownloadListOfSaleOrderExcelLazyQueryHookResult = ReturnType<typeof useDownloadListOfSaleOrderExcelLazyQuery>;
export type DownloadListOfSaleOrderExcelQueryResult = Apollo.QueryResult<Types.DownloadListOfSaleOrderExcelQuery, Types.DownloadListOfSaleOrderExcelQueryVariables>;
export const DownloadReportListOfSalesOrderDocument = gql`
    query DownloadReportListOfSalesOrder($first: Int, $filter: SalesOrderFilterInput, $sortBy: [InputSalesOrder]) {
  reportListOfSalesOrderDownload(first: $first, filter: $filter) {
    totalCount
    edges {
      node {
        id
        soldToCode
        soldToName
        salesOrder(sortBy: $sortBy, filter: $filter, first: $first) {
          totalCount
          edges {
            node {
              id
              requireAttentionFlag
              createBy
              createDateTime
              salesOrg
              saleGroup
              soldTo
              poNo
              originalRequestDate
              createDate
              reqDeliveryDate
              confirmDate
              orderNo
              orderItem
              materialCodeDescription
              orderQty
              confirmOrderQty
              deliveryQty
              pendingQty
              unit
              plant
              shippingPoint
              orderWeight
              pendingWeight
              deliveryWeight
              pendingQty
              weightUnit
              netPrice
              netValue
              currency
              rejection
              deliveryBlock
              overdue1
              overdue2
            }
          }
        }
      }
    }
  }
  downloadReportSaleOrder
}
    `;

/**
 * __useDownloadReportListOfSalesOrderQuery__
 *
 * To run a query within a React component, call `useDownloadReportListOfSalesOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadReportListOfSalesOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadReportListOfSalesOrderQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useDownloadReportListOfSalesOrderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.DownloadReportListOfSalesOrderQuery, Types.DownloadReportListOfSalesOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.DownloadReportListOfSalesOrderQuery, Types.DownloadReportListOfSalesOrderQueryVariables>(DownloadReportListOfSalesOrderDocument, options);
      }
export function useDownloadReportListOfSalesOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.DownloadReportListOfSalesOrderQuery, Types.DownloadReportListOfSalesOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.DownloadReportListOfSalesOrderQuery, Types.DownloadReportListOfSalesOrderQueryVariables>(DownloadReportListOfSalesOrderDocument, options);
        }
export type DownloadReportListOfSalesOrderQueryHookResult = ReturnType<typeof useDownloadReportListOfSalesOrderQuery>;
export type DownloadReportListOfSalesOrderLazyQueryHookResult = ReturnType<typeof useDownloadReportListOfSalesOrderLazyQuery>;
export type DownloadReportListOfSalesOrderQueryResult = Apollo.QueryResult<Types.DownloadReportListOfSalesOrderQuery, Types.DownloadReportListOfSalesOrderQueryVariables>;
export const ListSourceOfAppDocument = gql`
    query listSourceOfApp {
  listSourceOfApp {
    key
    value
  }
}
    `;

/**
 * __useListSourceOfAppQuery__
 *
 * To run a query within a React component, call `useListSourceOfAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSourceOfAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSourceOfAppQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSourceOfAppQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListSourceOfAppQuery, Types.ListSourceOfAppQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListSourceOfAppQuery, Types.ListSourceOfAppQueryVariables>(ListSourceOfAppDocument, options);
      }
export function useListSourceOfAppLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListSourceOfAppQuery, Types.ListSourceOfAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListSourceOfAppQuery, Types.ListSourceOfAppQueryVariables>(ListSourceOfAppDocument, options);
        }
export type ListSourceOfAppQueryHookResult = ReturnType<typeof useListSourceOfAppQuery>;
export type ListSourceOfAppLazyQueryHookResult = ReturnType<typeof useListSourceOfAppLazyQuery>;
export type ListSourceOfAppQueryResult = Apollo.QueryResult<Types.ListSourceOfAppQuery, Types.ListSourceOfAppQueryVariables>;
export const ListOrderTypesDocument = gql`
    query listOrderTypes {
  listOrderTypes {
    label
    value
    bu
    __typename
  }
}
    `;

/**
 * __useListOrderTypesQuery__
 *
 * To run a query within a React component, call `useListOrderTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrderTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrderTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListOrderTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ListOrderTypesQuery, Types.ListOrderTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListOrderTypesQuery, Types.ListOrderTypesQueryVariables>(ListOrderTypesDocument, options);
      }
export function useListOrderTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListOrderTypesQuery, Types.ListOrderTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListOrderTypesQuery, Types.ListOrderTypesQueryVariables>(ListOrderTypesDocument, options);
        }
export type ListOrderTypesQueryHookResult = ReturnType<typeof useListOrderTypesQuery>;
export type ListOrderTypesLazyQueryHookResult = ReturnType<typeof useListOrderTypesLazyQuery>;
export type ListOrderTypesQueryResult = Apollo.QueryResult<Types.ListOrderTypesQuery, Types.ListOrderTypesQueryVariables>;
export const ListPlantsByBuDocument = gql`
    query listPlantsByBu($bu: String!) {
  listPlantsByBu(bu: $bu) {
    plantCode
    plantName
    __typename
  }
}
    `;

/**
 * __useListPlantsByBuQuery__
 *
 * To run a query within a React component, call `useListPlantsByBuQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPlantsByBuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPlantsByBuQuery({
 *   variables: {
 *      bu: // value for 'bu'
 *   },
 * });
 */
export function useListPlantsByBuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ListPlantsByBuQuery, Types.ListPlantsByBuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ListPlantsByBuQuery, Types.ListPlantsByBuQueryVariables>(ListPlantsByBuDocument, options);
      }
export function useListPlantsByBuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ListPlantsByBuQuery, Types.ListPlantsByBuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ListPlantsByBuQuery, Types.ListPlantsByBuQueryVariables>(ListPlantsByBuDocument, options);
        }
export type ListPlantsByBuQueryHookResult = ReturnType<typeof useListPlantsByBuQuery>;
export type ListPlantsByBuLazyQueryHookResult = ReturnType<typeof useListPlantsByBuLazyQuery>;
export type ListPlantsByBuQueryResult = Apollo.QueryResult<Types.ListPlantsByBuQuery, Types.ListPlantsByBuQueryVariables>;
export const OrderSettingsUpdateDocument = gql`
    mutation OrderSettingsUpdate($shopSettingsInput: ShopSettingsInput!) {
  shopSettingsUpdate(input: $shopSettingsInput) {
    errors {
      ...ShopError
    }
    shop {
      ...ShopOrderSettings
    }
  }
}
    ${ShopErrorFragmentDoc}
${ShopOrderSettingsFragmentDoc}`;
export type OrderSettingsUpdateMutationFn = Apollo.MutationFunction<Types.OrderSettingsUpdateMutation, Types.OrderSettingsUpdateMutationVariables>;

/**
 * __useOrderSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useOrderSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSettingsUpdateMutation, { data, loading, error }] = useOrderSettingsUpdateMutation({
 *   variables: {
 *      shopSettingsInput: // value for 'shopSettingsInput'
 *   },
 * });
 */
export function useOrderSettingsUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.OrderSettingsUpdateMutation, Types.OrderSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.OrderSettingsUpdateMutation, Types.OrderSettingsUpdateMutationVariables>(OrderSettingsUpdateDocument, options);
      }
export type OrderSettingsUpdateMutationHookResult = ReturnType<typeof useOrderSettingsUpdateMutation>;
export type OrderSettingsUpdateMutationResult = Apollo.MutationResult<Types.OrderSettingsUpdateMutation>;
export type OrderSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<Types.OrderSettingsUpdateMutation, Types.OrderSettingsUpdateMutationVariables>;
export const OrderFulfillSettingsDocument = gql`
    query OrderFulfillSettings {
  shop {
    ...ShopOrderSettings
  }
}
    ${ShopOrderSettingsFragmentDoc}`;

/**
 * __useOrderFulfillSettingsQuery__
 *
 * To run a query within a React component, call `useOrderFulfillSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderFulfillSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderFulfillSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderFulfillSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrderFulfillSettingsQuery, Types.OrderFulfillSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrderFulfillSettingsQuery, Types.OrderFulfillSettingsQueryVariables>(OrderFulfillSettingsDocument, options);
      }
export function useOrderFulfillSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrderFulfillSettingsQuery, Types.OrderFulfillSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrderFulfillSettingsQuery, Types.OrderFulfillSettingsQueryVariables>(OrderFulfillSettingsDocument, options);
        }
export type OrderFulfillSettingsQueryHookResult = ReturnType<typeof useOrderFulfillSettingsQuery>;
export type OrderFulfillSettingsLazyQueryHookResult = ReturnType<typeof useOrderFulfillSettingsLazyQuery>;
export type OrderFulfillSettingsQueryResult = Apollo.QueryResult<Types.OrderFulfillSettingsQuery, Types.OrderFulfillSettingsQueryVariables>;
export const OrderSettingsDocument = gql`
    query OrderSettings {
  orderSettings {
    ...OrderSettings
  }
  shop {
    ...ShopOrderSettings
  }
}
    ${OrderSettingsFragmentDoc}
${ShopOrderSettingsFragmentDoc}`;

/**
 * __useOrderSettingsQuery__
 *
 * To run a query within a React component, call `useOrderSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrderSettingsQuery, Types.OrderSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrderSettingsQuery, Types.OrderSettingsQueryVariables>(OrderSettingsDocument, options);
      }
export function useOrderSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrderSettingsQuery, Types.OrderSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrderSettingsQuery, Types.OrderSettingsQueryVariables>(OrderSettingsDocument, options);
        }
export type OrderSettingsQueryHookResult = ReturnType<typeof useOrderSettingsQuery>;
export type OrderSettingsLazyQueryHookResult = ReturnType<typeof useOrderSettingsLazyQuery>;
export type OrderSettingsQueryResult = Apollo.QueryResult<Types.OrderSettingsQuery, Types.OrderSettingsQueryVariables>;
export const PermissionGroupListDocument = gql`
    query PermissionGroupList($after: String, $before: String, $first: Int, $last: Int, $filter: PermissionGroupFilterInput, $sort: PermissionGroupSortingInput) {
  permissionGroups(
    after: $after
    before: $before
    first: $first
    last: $last
    filter: $filter
    sortBy: $sort
  ) {
    edges {
      node {
        ...PermissionGroup
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PermissionGroupFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __usePermissionGroupListQuery__
 *
 * To run a query within a React component, call `usePermissionGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupListQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePermissionGroupListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PermissionGroupListQuery, Types.PermissionGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PermissionGroupListQuery, Types.PermissionGroupListQueryVariables>(PermissionGroupListDocument, options);
      }
export function usePermissionGroupListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PermissionGroupListQuery, Types.PermissionGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PermissionGroupListQuery, Types.PermissionGroupListQueryVariables>(PermissionGroupListDocument, options);
        }
export type PermissionGroupListQueryHookResult = ReturnType<typeof usePermissionGroupListQuery>;
export type PermissionGroupListLazyQueryHookResult = ReturnType<typeof usePermissionGroupListLazyQuery>;
export type PermissionGroupListQueryResult = Apollo.QueryResult<Types.PermissionGroupListQuery, Types.PermissionGroupListQueryVariables>;
export const PermissionGroupDetailsDocument = gql`
    query PermissionGroupDetails($id: ID!, $userId: ID!) {
  permissionGroup(id: $id) {
    ...PermissionGroupDetails
  }
  user(id: $userId) {
    editableGroups {
      id
    }
    userPermissions {
      code
      sourcePermissionGroups(userId: $userId) {
        id
      }
    }
  }
}
    ${PermissionGroupDetailsFragmentDoc}`;

/**
 * __usePermissionGroupDetailsQuery__
 *
 * To run a query within a React component, call `usePermissionGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePermissionGroupDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.PermissionGroupDetailsQuery, Types.PermissionGroupDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PermissionGroupDetailsQuery, Types.PermissionGroupDetailsQueryVariables>(PermissionGroupDetailsDocument, options);
      }
export function usePermissionGroupDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PermissionGroupDetailsQuery, Types.PermissionGroupDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PermissionGroupDetailsQuery, Types.PermissionGroupDetailsQueryVariables>(PermissionGroupDetailsDocument, options);
        }
export type PermissionGroupDetailsQueryHookResult = ReturnType<typeof usePermissionGroupDetailsQuery>;
export type PermissionGroupDetailsLazyQueryHookResult = ReturnType<typeof usePermissionGroupDetailsLazyQuery>;
export type PermissionGroupDetailsQueryResult = Apollo.QueryResult<Types.PermissionGroupDetailsQuery, Types.PermissionGroupDetailsQueryVariables>;
export const PoUploadFileDocument = gql`
    mutation PoUploadFile($file: Upload!, $soldToCode: String) {
  uploadPo(file: $file, soldToCode: $soldToCode) {
    status
    errors {
      field
      code
      message
    }
  }
}
    `;
export type PoUploadFileMutationFn = Apollo.MutationFunction<Types.PoUploadFileMutation, Types.PoUploadFileMutationVariables>;

/**
 * __usePoUploadFileMutation__
 *
 * To run a mutation, you first call `usePoUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePoUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [poUploadFileMutation, { data, loading, error }] = usePoUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      soldToCode: // value for 'soldToCode'
 *   },
 * });
 */
export function usePoUploadFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PoUploadFileMutation, Types.PoUploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PoUploadFileMutation, Types.PoUploadFileMutationVariables>(PoUploadFileDocument, options);
      }
export type PoUploadFileMutationHookResult = ReturnType<typeof usePoUploadFileMutation>;
export type PoUploadFileMutationResult = Apollo.MutationResult<Types.PoUploadFileMutation>;
export type PoUploadFileMutationOptions = Apollo.BaseMutationOptions<Types.PoUploadFileMutation, Types.PoUploadFileMutationVariables>;
export const RetryUploadDocument = gql`
    mutation retryUpload($id: ID!) {
  retryUpload(id: $id) {
    status
    errors {
      field
      message
      code
    }
  }
}
    `;
export type RetryUploadMutationFn = Apollo.MutationFunction<Types.RetryUploadMutation, Types.RetryUploadMutationVariables>;

/**
 * __useRetryUploadMutation__
 *
 * To run a mutation, you first call `useRetryUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryUploadMutation, { data, loading, error }] = useRetryUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.RetryUploadMutation, Types.RetryUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.RetryUploadMutation, Types.RetryUploadMutationVariables>(RetryUploadDocument, options);
      }
export type RetryUploadMutationHookResult = ReturnType<typeof useRetryUploadMutation>;
export type RetryUploadMutationResult = Apollo.MutationResult<Types.RetryUploadMutation>;
export type RetryUploadMutationOptions = Apollo.BaseMutationOptions<Types.RetryUploadMutation, Types.RetryUploadMutationVariables>;
export const PoUploadCustomerSettingsCreateDocument = gql`
    mutation PoUploadCustomerSettingsCreate($soldToId: ID) {
  poUploadCustomerSettingsCreate(soldToId: $soldToId) {
    errors {
      message
      code
    }
  }
}
    `;
export type PoUploadCustomerSettingsCreateMutationFn = Apollo.MutationFunction<Types.PoUploadCustomerSettingsCreateMutation, Types.PoUploadCustomerSettingsCreateMutationVariables>;

/**
 * __usePoUploadCustomerSettingsCreateMutation__
 *
 * To run a mutation, you first call `usePoUploadCustomerSettingsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePoUploadCustomerSettingsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [poUploadCustomerSettingsCreateMutation, { data, loading, error }] = usePoUploadCustomerSettingsCreateMutation({
 *   variables: {
 *      soldToId: // value for 'soldToId'
 *   },
 * });
 */
export function usePoUploadCustomerSettingsCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PoUploadCustomerSettingsCreateMutation, Types.PoUploadCustomerSettingsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PoUploadCustomerSettingsCreateMutation, Types.PoUploadCustomerSettingsCreateMutationVariables>(PoUploadCustomerSettingsCreateDocument, options);
      }
export type PoUploadCustomerSettingsCreateMutationHookResult = ReturnType<typeof usePoUploadCustomerSettingsCreateMutation>;
export type PoUploadCustomerSettingsCreateMutationResult = Apollo.MutationResult<Types.PoUploadCustomerSettingsCreateMutation>;
export type PoUploadCustomerSettingsCreateMutationOptions = Apollo.BaseMutationOptions<Types.PoUploadCustomerSettingsCreateMutation, Types.PoUploadCustomerSettingsCreateMutationVariables>;
export const PoUploadCustomerSettingsUpdateDocument = gql`
    mutation PoUploadCustomerSettingsUpdate($soldToId: ID, $useCustomerMaster: Boolean) {
  poUploadCustomerSettingsUpdate(
    soldToId: $soldToId
    useCustomerMaster: $useCustomerMaster
  ) {
    errors {
      message
      code
    }
  }
}
    `;
export type PoUploadCustomerSettingsUpdateMutationFn = Apollo.MutationFunction<Types.PoUploadCustomerSettingsUpdateMutation, Types.PoUploadCustomerSettingsUpdateMutationVariables>;

/**
 * __usePoUploadCustomerSettingsUpdateMutation__
 *
 * To run a mutation, you first call `usePoUploadCustomerSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePoUploadCustomerSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [poUploadCustomerSettingsUpdateMutation, { data, loading, error }] = usePoUploadCustomerSettingsUpdateMutation({
 *   variables: {
 *      soldToId: // value for 'soldToId'
 *      useCustomerMaster: // value for 'useCustomerMaster'
 *   },
 * });
 */
export function usePoUploadCustomerSettingsUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PoUploadCustomerSettingsUpdateMutation, Types.PoUploadCustomerSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PoUploadCustomerSettingsUpdateMutation, Types.PoUploadCustomerSettingsUpdateMutationVariables>(PoUploadCustomerSettingsUpdateDocument, options);
      }
export type PoUploadCustomerSettingsUpdateMutationHookResult = ReturnType<typeof usePoUploadCustomerSettingsUpdateMutation>;
export type PoUploadCustomerSettingsUpdateMutationResult = Apollo.MutationResult<Types.PoUploadCustomerSettingsUpdateMutation>;
export type PoUploadCustomerSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<Types.PoUploadCustomerSettingsUpdateMutation, Types.PoUploadCustomerSettingsUpdateMutationVariables>;
export const PoUploadCustomerSettingsDeleteDocument = gql`
    mutation PoUploadCustomerSettingsDelete($soldToId: ID) {
  poUploadCustomerSettingsDelete(soldToId: $soldToId) {
    errors {
      message
      code
    }
  }
}
    `;
export type PoUploadCustomerSettingsDeleteMutationFn = Apollo.MutationFunction<Types.PoUploadCustomerSettingsDeleteMutation, Types.PoUploadCustomerSettingsDeleteMutationVariables>;

/**
 * __usePoUploadCustomerSettingsDeleteMutation__
 *
 * To run a mutation, you first call `usePoUploadCustomerSettingsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePoUploadCustomerSettingsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [poUploadCustomerSettingsDeleteMutation, { data, loading, error }] = usePoUploadCustomerSettingsDeleteMutation({
 *   variables: {
 *      soldToId: // value for 'soldToId'
 *   },
 * });
 */
export function usePoUploadCustomerSettingsDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.PoUploadCustomerSettingsDeleteMutation, Types.PoUploadCustomerSettingsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.PoUploadCustomerSettingsDeleteMutation, Types.PoUploadCustomerSettingsDeleteMutationVariables>(PoUploadCustomerSettingsDeleteDocument, options);
      }
export type PoUploadCustomerSettingsDeleteMutationHookResult = ReturnType<typeof usePoUploadCustomerSettingsDeleteMutation>;
export type PoUploadCustomerSettingsDeleteMutationResult = Apollo.MutationResult<Types.PoUploadCustomerSettingsDeleteMutation>;
export type PoUploadCustomerSettingsDeleteMutationOptions = Apollo.BaseMutationOptions<Types.PoUploadCustomerSettingsDeleteMutation, Types.PoUploadCustomerSettingsDeleteMutationVariables>;
export const FailedFilesDocument = gql`
    query failedFiles($before: String, $after: String, $first: Int, $last: Int, $sortBy: POUploadFileLogSorterInput) {
  failedFiles(
    first: $first
    before: $before
    after: $after
    last: $last
    sortBy: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    latestPageItemNumber
    totalCount
    edges {
      node {
        id
        status
        fileName
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useFailedFilesQuery__
 *
 * To run a query within a React component, call `useFailedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFailedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFailedFilesQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useFailedFilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FailedFilesQuery, Types.FailedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FailedFilesQuery, Types.FailedFilesQueryVariables>(FailedFilesDocument, options);
      }
export function useFailedFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FailedFilesQuery, Types.FailedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FailedFilesQuery, Types.FailedFilesQueryVariables>(FailedFilesDocument, options);
        }
export type FailedFilesQueryHookResult = ReturnType<typeof useFailedFilesQuery>;
export type FailedFilesLazyQueryHookResult = ReturnType<typeof useFailedFilesLazyQuery>;
export type FailedFilesQueryResult = Apollo.QueryResult<Types.FailedFilesQuery, Types.FailedFilesQueryVariables>;
export const PoUploadCustomerSettingsDocument = gql`
    query PoUploadCustomerSettings($first: Int) {
  poUploadCustomerSettings(first: $first) {
    totalCount
    edges {
      node {
        soldTo {
          id
          soldToCode
          soldToName
        }
        useCustomerMaster
      }
    }
  }
}
    `;

/**
 * __usePoUploadCustomerSettingsQuery__
 *
 * To run a query within a React component, call `usePoUploadCustomerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoUploadCustomerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoUploadCustomerSettingsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePoUploadCustomerSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PoUploadCustomerSettingsQuery, Types.PoUploadCustomerSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PoUploadCustomerSettingsQuery, Types.PoUploadCustomerSettingsQueryVariables>(PoUploadCustomerSettingsDocument, options);
      }
export function usePoUploadCustomerSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PoUploadCustomerSettingsQuery, Types.PoUploadCustomerSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PoUploadCustomerSettingsQuery, Types.PoUploadCustomerSettingsQueryVariables>(PoUploadCustomerSettingsDocument, options);
        }
export type PoUploadCustomerSettingsQueryHookResult = ReturnType<typeof usePoUploadCustomerSettingsQuery>;
export type PoUploadCustomerSettingsLazyQueryHookResult = ReturnType<typeof usePoUploadCustomerSettingsLazyQuery>;
export type PoUploadCustomerSettingsQueryResult = Apollo.QueryResult<Types.PoUploadCustomerSettingsQuery, Types.PoUploadCustomerSettingsQueryVariables>;
export const PoUploadSuggestionSearchSoldToDocument = gql`
    query PoUploadSuggestionSearchSoldTo($filter: SoldToMasterFilterInput, $first: Int) {
  poUploadSuggestionSearchSoldTo(filter: $filter, first: $first) {
    totalCount
    edges {
      node {
        id
        soldToCode
        soldToName
      }
    }
  }
}
    `;

/**
 * __usePoUploadSuggestionSearchSoldToQuery__
 *
 * To run a query within a React component, call `usePoUploadSuggestionSearchSoldToQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoUploadSuggestionSearchSoldToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoUploadSuggestionSearchSoldToQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function usePoUploadSuggestionSearchSoldToQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.PoUploadSuggestionSearchSoldToQuery, Types.PoUploadSuggestionSearchSoldToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.PoUploadSuggestionSearchSoldToQuery, Types.PoUploadSuggestionSearchSoldToQueryVariables>(PoUploadSuggestionSearchSoldToDocument, options);
      }
export function usePoUploadSuggestionSearchSoldToLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.PoUploadSuggestionSearchSoldToQuery, Types.PoUploadSuggestionSearchSoldToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.PoUploadSuggestionSearchSoldToQuery, Types.PoUploadSuggestionSearchSoldToQueryVariables>(PoUploadSuggestionSearchSoldToDocument, options);
        }
export type PoUploadSuggestionSearchSoldToQueryHookResult = ReturnType<typeof usePoUploadSuggestionSearchSoldToQuery>;
export type PoUploadSuggestionSearchSoldToLazyQueryHookResult = ReturnType<typeof usePoUploadSuggestionSearchSoldToLazyQuery>;
export type PoUploadSuggestionSearchSoldToQueryResult = Apollo.QueryResult<Types.PoUploadSuggestionSearchSoldToQuery, Types.PoUploadSuggestionSearchSoldToQueryVariables>;
export const UpdateRequireAttentionItemsParameterDocument = gql`
    mutation updateRequireAttentionItemsParameter($input: RequireAttentionItemParameterUpdateInput!, $itemsId: String!) {
  updateRequireAttentionItemsParameter(input: $input, itemsId: $itemsId) {
    errors {
      field
      message
      code
    }
    requireAttentionItems {
      inquiryMethodCode
      transportationMethod
      typeOfDelivery
      typeOfDeliveryValue
      fixSourceAssignment
      splitOrderItem
      splitOrderItemValue
      partialDelivery
      partialDeliveryValue
      consignment
      consignmentValue
    }
  }
}
    `;
export type UpdateRequireAttentionItemsParameterMutationFn = Apollo.MutationFunction<Types.UpdateRequireAttentionItemsParameterMutation, Types.UpdateRequireAttentionItemsParameterMutationVariables>;

/**
 * __useUpdateRequireAttentionItemsParameterMutation__
 *
 * To run a mutation, you first call `useUpdateRequireAttentionItemsParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequireAttentionItemsParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequireAttentionItemsParameterMutation, { data, loading, error }] = useUpdateRequireAttentionItemsParameterMutation({
 *   variables: {
 *      input: // value for 'input'
 *      itemsId: // value for 'itemsId'
 *   },
 * });
 */
export function useUpdateRequireAttentionItemsParameterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.UpdateRequireAttentionItemsParameterMutation, Types.UpdateRequireAttentionItemsParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.UpdateRequireAttentionItemsParameterMutation, Types.UpdateRequireAttentionItemsParameterMutationVariables>(UpdateRequireAttentionItemsParameterDocument, options);
      }
export type UpdateRequireAttentionItemsParameterMutationHookResult = ReturnType<typeof useUpdateRequireAttentionItemsParameterMutation>;
export type UpdateRequireAttentionItemsParameterMutationResult = Apollo.MutationResult<Types.UpdateRequireAttentionItemsParameterMutation>;
export type UpdateRequireAttentionItemsParameterMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRequireAttentionItemsParameterMutation, Types.UpdateRequireAttentionItemsParameterMutationVariables>;
export const AcceptConfirmDateDocument = gql`
    mutation acceptConfirmDate($input: AcceptConfirmDateInput!) {
  acceptConfirmDate(input: $input) {
    errors {
      field
      message
      code
    }
    items: orderLines {
      success {
        totalCount
        edges {
          node {
            orderNo
            itemNo
          }
        }
      }
      failed {
        totalCount
        edges {
          node {
            id
            orderNo
            itemNo
          }
        }
      }
    }
  }
}
    `;
export type AcceptConfirmDateMutationFn = Apollo.MutationFunction<Types.AcceptConfirmDateMutation, Types.AcceptConfirmDateMutationVariables>;

/**
 * __useAcceptConfirmDateMutation__
 *
 * To run a mutation, you first call `useAcceptConfirmDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptConfirmDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptConfirmDateMutation, { data, loading, error }] = useAcceptConfirmDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptConfirmDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AcceptConfirmDateMutation, Types.AcceptConfirmDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AcceptConfirmDateMutation, Types.AcceptConfirmDateMutationVariables>(AcceptConfirmDateDocument, options);
      }
export type AcceptConfirmDateMutationHookResult = ReturnType<typeof useAcceptConfirmDateMutation>;
export type AcceptConfirmDateMutationResult = Apollo.MutationResult<Types.AcceptConfirmDateMutation>;
export type AcceptConfirmDateMutationOptions = Apollo.BaseMutationOptions<Types.AcceptConfirmDateMutation, Types.AcceptConfirmDateMutationVariables>;
export const DeleteRequireAttentionItemsDocument = gql`
    mutation deleteRequireAttentionItems($orderLineIds: [String], $reason: ReasonForRejectInput!) {
  deleteRequireAttentionItems(orderLineIds: $orderLineIds, reason: $reason) {
    success {
      orderNo
      itemNo
      materialCode
      materialDescription
      confirmQuantity
      confirmDate
      message
    }
    failed {
      orderNo
      itemNo
      materialCode
      materialDescription
      confirmQuantity
      confirmDate
      message
    }
    totalSuccess
    totalFailed
  }
}
    `;
export type DeleteRequireAttentionItemsMutationFn = Apollo.MutationFunction<Types.DeleteRequireAttentionItemsMutation, Types.DeleteRequireAttentionItemsMutationVariables>;

/**
 * __useDeleteRequireAttentionItemsMutation__
 *
 * To run a mutation, you first call `useDeleteRequireAttentionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRequireAttentionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRequireAttentionItemsMutation, { data, loading, error }] = useDeleteRequireAttentionItemsMutation({
 *   variables: {
 *      orderLineIds: // value for 'orderLineIds'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeleteRequireAttentionItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.DeleteRequireAttentionItemsMutation, Types.DeleteRequireAttentionItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.DeleteRequireAttentionItemsMutation, Types.DeleteRequireAttentionItemsMutationVariables>(DeleteRequireAttentionItemsDocument, options);
      }
export type DeleteRequireAttentionItemsMutationHookResult = ReturnType<typeof useDeleteRequireAttentionItemsMutation>;
export type DeleteRequireAttentionItemsMutationResult = Apollo.MutationResult<Types.DeleteRequireAttentionItemsMutation>;
export type DeleteRequireAttentionItemsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRequireAttentionItemsMutation, Types.DeleteRequireAttentionItemsMutationVariables>;
export const AcceptConfirmDateRequireAttentionItemsDocument = gql`
    mutation acceptConfirmDateRequireAttentionItems($input: AcceptConfirmDateRequireAttentionInput!) {
  acceptConfirmDateRequireAttentionItems(input: $input) {
    success {
      orderNo
      itemNo
      materialCode
      materialDescription
      confirmDate
      confirmQuantity
      sapOrderMessages {
        errorCode
        soNo
        errorMessage
      }
    }
    failed {
      orderNo
      itemNo
      materialCode
      materialDescription
      confirmDate
      confirmQuantity
      sapOrderMessages {
        errorCode
        soNo
        errorMessage
      }
    }
    totalFailed
    totalSuccess
    errors {
      code
      field
      message
    }
  }
}
    `;
export type AcceptConfirmDateRequireAttentionItemsMutationFn = Apollo.MutationFunction<Types.AcceptConfirmDateRequireAttentionItemsMutation, Types.AcceptConfirmDateRequireAttentionItemsMutationVariables>;

/**
 * __useAcceptConfirmDateRequireAttentionItemsMutation__
 *
 * To run a mutation, you first call `useAcceptConfirmDateRequireAttentionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptConfirmDateRequireAttentionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptConfirmDateRequireAttentionItemsMutation, { data, loading, error }] = useAcceptConfirmDateRequireAttentionItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptConfirmDateRequireAttentionItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AcceptConfirmDateRequireAttentionItemsMutation, Types.AcceptConfirmDateRequireAttentionItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AcceptConfirmDateRequireAttentionItemsMutation, Types.AcceptConfirmDateRequireAttentionItemsMutationVariables>(AcceptConfirmDateRequireAttentionItemsDocument, options);
      }
export type AcceptConfirmDateRequireAttentionItemsMutationHookResult = ReturnType<typeof useAcceptConfirmDateRequireAttentionItemsMutation>;
export type AcceptConfirmDateRequireAttentionItemsMutationResult = Apollo.MutationResult<Types.AcceptConfirmDateRequireAttentionItemsMutation>;
export type AcceptConfirmDateRequireAttentionItemsMutationOptions = Apollo.BaseMutationOptions<Types.AcceptConfirmDateRequireAttentionItemsMutation, Types.AcceptConfirmDateRequireAttentionItemsMutationVariables>;
export const EditRequireAttentionItemsDocument = gql`
    mutation editRequireAttentionItems($input: EditRequireAttentionInput!) {
  editRequireAttentionItems(input: $input) {
    errors {
      field
      message
    }
    success {
      orderNo
      itemNo
      materialCode
      materialDescription
      requestDate
      requestQuantity
      originalQuantity
      originalRequestDate
      sapOrderMessages {
        errorCode
        soNo
        errorMessage
      }
    }
    failed {
      orderNo
      itemNo
      materialCode
      materialDescription
      requestDate
      requestQuantity
      originalQuantity
      originalRequestDate
      sapOrderMessages {
        errorCode
        soNo
        errorMessage
      }
    }
    totalSuccess
    totalFailed
  }
}
    `;
export type EditRequireAttentionItemsMutationFn = Apollo.MutationFunction<Types.EditRequireAttentionItemsMutation, Types.EditRequireAttentionItemsMutationVariables>;

/**
 * __useEditRequireAttentionItemsMutation__
 *
 * To run a mutation, you first call `useEditRequireAttentionItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditRequireAttentionItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editRequireAttentionItemsMutation, { data, loading, error }] = useEditRequireAttentionItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditRequireAttentionItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.EditRequireAttentionItemsMutation, Types.EditRequireAttentionItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.EditRequireAttentionItemsMutation, Types.EditRequireAttentionItemsMutationVariables>(EditRequireAttentionItemsDocument, options);
      }
export type EditRequireAttentionItemsMutationHookResult = ReturnType<typeof useEditRequireAttentionItemsMutation>;
export type EditRequireAttentionItemsMutationResult = Apollo.MutationResult<Types.EditRequireAttentionItemsMutation>;
export type EditRequireAttentionItemsMutationOptions = Apollo.BaseMutationOptions<Types.EditRequireAttentionItemsMutation, Types.EditRequireAttentionItemsMutationVariables>;
export const AtpCtpRequestDocument = gql`
    mutation atpCtpRequest($orderLines: [ATPCTPRequestOrderLineInput]!) {
  atpCtpRequest(orderLines: $orderLines) {
    items {
      orderNo
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      uniqueId
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
      iplanRequestParams {
        inquiryMethodCode
        useInventory
        useConsignmentInventory
        useProjectedInventory
        useProduction
        splitOrderItem
        singleSource
        reAtpRequired
        fixSourceAssignment
        requestType
        typeOfDelivery
        transportationMethod
      }
    }
    itemsFailed {
      orderNo
      lineId
      originalItemNo
      materialVariantCode
      materialVariantDescription
      originalQuantity
      originalRequestDate
      originalPlant
      listItems {
        itemNo
        quantity
        confirmDate
        plant
        atpCtp
        atpCtpDetail
        blockCode
        runCode
        paperMachine
        unit
        onHandStock
        orderType
      }
      iplanRequestParams {
        inquiryMethodCode
        useInventory
        useConsignmentInventory
        useProjectedInventory
        useProduction
        splitOrderItem
        singleSource
        reAtpRequired
        fixSourceAssignment
        requestType
        typeOfDelivery
        transportationMethod
      }
    }
  }
}
    `;
export type AtpCtpRequestMutationFn = Apollo.MutationFunction<Types.AtpCtpRequestMutation, Types.AtpCtpRequestMutationVariables>;

/**
 * __useAtpCtpRequestMutation__
 *
 * To run a mutation, you first call `useAtpCtpRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtpCtpRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atpCtpRequestMutation, { data, loading, error }] = useAtpCtpRequestMutation({
 *   variables: {
 *      orderLines: // value for 'orderLines'
 *   },
 * });
 */
export function useAtpCtpRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtpCtpRequestMutation, Types.AtpCtpRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtpCtpRequestMutation, Types.AtpCtpRequestMutationVariables>(AtpCtpRequestDocument, options);
      }
export type AtpCtpRequestMutationHookResult = ReturnType<typeof useAtpCtpRequestMutation>;
export type AtpCtpRequestMutationResult = Apollo.MutationResult<Types.AtpCtpRequestMutation>;
export type AtpCtpRequestMutationOptions = Apollo.BaseMutationOptions<Types.AtpCtpRequestMutation, Types.AtpCtpRequestMutationVariables>;
export const AtpCtpConfirmDocument = gql`
    mutation atpCtpConfirm($input: ATPCTPConfirmInputType!) {
  atpCtpConfirm(input: $input) {
    iPlanMessages {
      itemNo
      firstCode
      secondCode
      message
      soNo
    }
    sapOrderMessages {
      errorCode
      soNo
      errorMessage
    }
    sapItemMessages {
      errorCode
      errorMessage
      itemNo
    }
    errors {
      field
      message
      code
    }
  }
}
    `;
export type AtpCtpConfirmMutationFn = Apollo.MutationFunction<Types.AtpCtpConfirmMutation, Types.AtpCtpConfirmMutationVariables>;

/**
 * __useAtpCtpConfirmMutation__
 *
 * To run a mutation, you first call `useAtpCtpConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtpCtpConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atpCtpConfirmMutation, { data, loading, error }] = useAtpCtpConfirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtpCtpConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.AtpCtpConfirmMutation, Types.AtpCtpConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.AtpCtpConfirmMutation, Types.AtpCtpConfirmMutationVariables>(AtpCtpConfirmDocument, options);
      }
export type AtpCtpConfirmMutationHookResult = ReturnType<typeof useAtpCtpConfirmMutation>;
export type AtpCtpConfirmMutationResult = Apollo.MutationResult<Types.AtpCtpConfirmMutation>;
export type AtpCtpConfirmMutationOptions = Apollo.BaseMutationOptions<Types.AtpCtpConfirmMutation, Types.AtpCtpConfirmMutationVariables>;
export const QueryDataInputParameterDocument = gql`
    query queryDataInputParameter {
  requireAttentionInquiryMethodCode {
    name
    value
  }
  requireAttentionTypeOfDelivery {
    name
    value
  }
  requireAttentionSplitOrderItemPartialDelivery {
    name
    value
  }
  requireAttentionConsignment {
    name
    value
  }
}
    `;

/**
 * __useQueryDataInputParameterQuery__
 *
 * To run a query within a React component, call `useQueryDataInputParameterQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryDataInputParameterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryDataInputParameterQuery({
 *   variables: {
 *   },
 * });
 */
export function useQueryDataInputParameterQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.QueryDataInputParameterQuery, Types.QueryDataInputParameterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.QueryDataInputParameterQuery, Types.QueryDataInputParameterQueryVariables>(QueryDataInputParameterDocument, options);
      }
export function useQueryDataInputParameterLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.QueryDataInputParameterQuery, Types.QueryDataInputParameterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.QueryDataInputParameterQuery, Types.QueryDataInputParameterQueryVariables>(QueryDataInputParameterDocument, options);
        }
export type QueryDataInputParameterQueryHookResult = ReturnType<typeof useQueryDataInputParameterQuery>;
export type QueryDataInputParameterLazyQueryHookResult = ReturnType<typeof useQueryDataInputParameterLazyQuery>;
export type QueryDataInputParameterQueryResult = Apollo.QueryResult<Types.QueryDataInputParameterQuery, Types.QueryDataInputParameterQueryVariables>;
export const RequireAttentionItemsDocument = gql`
    query requireAttentionItems($sortBy: RequireAttentionItemsSortingInput, $filter: RequireAttentionItemsFilterInput, $before: String, $after: String, $first: Int, $last: Int, $role: String!) {
  requireAttentionItems(
    sortBy: $sortBy
    filter: $filter
    before: $before
    after: $after
    first: $first
    last: $last
    role: $role
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        orderNo
        itemNo
        soldTo
        shipTo
        requestDate
        confirmedDate
        poNo
        plant
        status
        unit
        matCode
        orderId
        matDescription
        requestQuantity
        attentionType
        iplantConfirmQuantity
        assignedQuantity
        itemStatus
        originalDate
        overdue1
        overdue2
        inquiryMethodCode
        transportationMethod
        typeOfDeliveryValue
        fixSourceAssignment
        splitOrderItemValue
        partialDeliveryValue
        consignmentValue
        flagR5
      }
    }
    totalCount
    latestPageItemNumber
  }
}
    `;

/**
 * __useRequireAttentionItemsQuery__
 *
 * To run a query within a React component, call `useRequireAttentionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequireAttentionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequireAttentionItemsQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRequireAttentionItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.RequireAttentionItemsQuery, Types.RequireAttentionItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RequireAttentionItemsQuery, Types.RequireAttentionItemsQueryVariables>(RequireAttentionItemsDocument, options);
      }
export function useRequireAttentionItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RequireAttentionItemsQuery, Types.RequireAttentionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RequireAttentionItemsQuery, Types.RequireAttentionItemsQueryVariables>(RequireAttentionItemsDocument, options);
        }
export type RequireAttentionItemsQueryHookResult = ReturnType<typeof useRequireAttentionItemsQuery>;
export type RequireAttentionItemsLazyQueryHookResult = ReturnType<typeof useRequireAttentionItemsLazyQuery>;
export type RequireAttentionItemsQueryResult = Apollo.QueryResult<Types.RequireAttentionItemsQuery, Types.RequireAttentionItemsQueryVariables>;
export const FilterRequireAttentionMaterialDocument = gql`
    query filterRequireAttentionMaterial($distributionChannelType: DistributionChannelType!, $filter: RequireAttentionMaterialFilterInput, $before: String, $after: String, $first: Int) {
  filterRequireAttentionMaterial(
    distributionChannelType: $distributionChannelType
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        name
        code
        descriptionEn
      }
    }
  }
}
    `;

/**
 * __useFilterRequireAttentionMaterialQuery__
 *
 * To run a query within a React component, call `useFilterRequireAttentionMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRequireAttentionMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRequireAttentionMaterialQuery({
 *   variables: {
 *      distributionChannelType: // value for 'distributionChannelType'
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterRequireAttentionMaterialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.FilterRequireAttentionMaterialQuery, Types.FilterRequireAttentionMaterialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterRequireAttentionMaterialQuery, Types.FilterRequireAttentionMaterialQueryVariables>(FilterRequireAttentionMaterialDocument, options);
      }
export function useFilterRequireAttentionMaterialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterRequireAttentionMaterialQuery, Types.FilterRequireAttentionMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterRequireAttentionMaterialQuery, Types.FilterRequireAttentionMaterialQueryVariables>(FilterRequireAttentionMaterialDocument, options);
        }
export type FilterRequireAttentionMaterialQueryHookResult = ReturnType<typeof useFilterRequireAttentionMaterialQuery>;
export type FilterRequireAttentionMaterialLazyQueryHookResult = ReturnType<typeof useFilterRequireAttentionMaterialLazyQuery>;
export type FilterRequireAttentionMaterialQueryResult = Apollo.QueryResult<Types.FilterRequireAttentionMaterialQuery, Types.FilterRequireAttentionMaterialQueryVariables>;
export const GetFilterRequireAttentionBusinessUnitDocument = gql`
    query getFilterRequireAttentionBusinessUnit {
  filterRequireAttentionBusinessUnit {
    id
    name
    companies {
      id
      name
    }
  }
}
    `;

/**
 * __useGetFilterRequireAttentionBusinessUnitQuery__
 *
 * To run a query within a React component, call `useGetFilterRequireAttentionBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterRequireAttentionBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterRequireAttentionBusinessUnitQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterRequireAttentionBusinessUnitQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetFilterRequireAttentionBusinessUnitQuery, Types.GetFilterRequireAttentionBusinessUnitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetFilterRequireAttentionBusinessUnitQuery, Types.GetFilterRequireAttentionBusinessUnitQueryVariables>(GetFilterRequireAttentionBusinessUnitDocument, options);
      }
export function useGetFilterRequireAttentionBusinessUnitLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetFilterRequireAttentionBusinessUnitQuery, Types.GetFilterRequireAttentionBusinessUnitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetFilterRequireAttentionBusinessUnitQuery, Types.GetFilterRequireAttentionBusinessUnitQueryVariables>(GetFilterRequireAttentionBusinessUnitDocument, options);
        }
export type GetFilterRequireAttentionBusinessUnitQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionBusinessUnitQuery>;
export type GetFilterRequireAttentionBusinessUnitLazyQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionBusinessUnitLazyQuery>;
export type GetFilterRequireAttentionBusinessUnitQueryResult = Apollo.QueryResult<Types.GetFilterRequireAttentionBusinessUnitQuery, Types.GetFilterRequireAttentionBusinessUnitQueryVariables>;
export const GetFilterRequireAttentionSalesOrganizationDocument = gql`
    query getFilterRequireAttentionSalesOrganization {
  filterRequireAttentionSalesOrganization {
    name
    code
    id
    businessUnit {
      id
    }
  }
}
    `;

/**
 * __useGetFilterRequireAttentionSalesOrganizationQuery__
 *
 * To run a query within a React component, call `useGetFilterRequireAttentionSalesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterRequireAttentionSalesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterRequireAttentionSalesOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterRequireAttentionSalesOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetFilterRequireAttentionSalesOrganizationQuery, Types.GetFilterRequireAttentionSalesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetFilterRequireAttentionSalesOrganizationQuery, Types.GetFilterRequireAttentionSalesOrganizationQueryVariables>(GetFilterRequireAttentionSalesOrganizationDocument, options);
      }
export function useGetFilterRequireAttentionSalesOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetFilterRequireAttentionSalesOrganizationQuery, Types.GetFilterRequireAttentionSalesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetFilterRequireAttentionSalesOrganizationQuery, Types.GetFilterRequireAttentionSalesOrganizationQueryVariables>(GetFilterRequireAttentionSalesOrganizationDocument, options);
        }
export type GetFilterRequireAttentionSalesOrganizationQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionSalesOrganizationQuery>;
export type GetFilterRequireAttentionSalesOrganizationLazyQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionSalesOrganizationLazyQuery>;
export type GetFilterRequireAttentionSalesOrganizationQueryResult = Apollo.QueryResult<Types.GetFilterRequireAttentionSalesOrganizationQuery, Types.GetFilterRequireAttentionSalesOrganizationQueryVariables>;
export const GetFilterRequireAttentionSalesGroupDocument = gql`
    query getFilterRequireAttentionSalesGroup {
  filterRequireAttentionSalesGroup {
    name
    code
    salesOrganization {
      id
    }
  }
}
    `;

/**
 * __useGetFilterRequireAttentionSalesGroupQuery__
 *
 * To run a query within a React component, call `useGetFilterRequireAttentionSalesGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterRequireAttentionSalesGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterRequireAttentionSalesGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterRequireAttentionSalesGroupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetFilterRequireAttentionSalesGroupQuery, Types.GetFilterRequireAttentionSalesGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetFilterRequireAttentionSalesGroupQuery, Types.GetFilterRequireAttentionSalesGroupQueryVariables>(GetFilterRequireAttentionSalesGroupDocument, options);
      }
export function useGetFilterRequireAttentionSalesGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetFilterRequireAttentionSalesGroupQuery, Types.GetFilterRequireAttentionSalesGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetFilterRequireAttentionSalesGroupQuery, Types.GetFilterRequireAttentionSalesGroupQueryVariables>(GetFilterRequireAttentionSalesGroupDocument, options);
        }
export type GetFilterRequireAttentionSalesGroupQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionSalesGroupQuery>;
export type GetFilterRequireAttentionSalesGroupLazyQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionSalesGroupLazyQuery>;
export type GetFilterRequireAttentionSalesGroupQueryResult = Apollo.QueryResult<Types.GetFilterRequireAttentionSalesGroupQuery, Types.GetFilterRequireAttentionSalesGroupQueryVariables>;
export const GetRequireAttentionTypeDocument = gql`
    query getRequireAttentionType {
  requireAttentionType {
    name
    value
  }
}
    `;

/**
 * __useGetRequireAttentionTypeQuery__
 *
 * To run a query within a React component, call `useGetRequireAttentionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequireAttentionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequireAttentionTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequireAttentionTypeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetRequireAttentionTypeQuery, Types.GetRequireAttentionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetRequireAttentionTypeQuery, Types.GetRequireAttentionTypeQueryVariables>(GetRequireAttentionTypeDocument, options);
      }
export function useGetRequireAttentionTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetRequireAttentionTypeQuery, Types.GetRequireAttentionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetRequireAttentionTypeQuery, Types.GetRequireAttentionTypeQueryVariables>(GetRequireAttentionTypeDocument, options);
        }
export type GetRequireAttentionTypeQueryHookResult = ReturnType<typeof useGetRequireAttentionTypeQuery>;
export type GetRequireAttentionTypeLazyQueryHookResult = ReturnType<typeof useGetRequireAttentionTypeLazyQuery>;
export type GetRequireAttentionTypeQueryResult = Apollo.QueryResult<Types.GetRequireAttentionTypeQuery, Types.GetRequireAttentionTypeQueryVariables>;
export const GetFilterRequireAttentionMaterialGroupDocument = gql`
    query getFilterRequireAttentionMaterialGroup {
  filterRequireAttentionMaterialGroup {
    name
    code
  }
}
    `;

/**
 * __useGetFilterRequireAttentionMaterialGroupQuery__
 *
 * To run a query within a React component, call `useGetFilterRequireAttentionMaterialGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterRequireAttentionMaterialGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterRequireAttentionMaterialGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFilterRequireAttentionMaterialGroupQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetFilterRequireAttentionMaterialGroupQuery, Types.GetFilterRequireAttentionMaterialGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetFilterRequireAttentionMaterialGroupQuery, Types.GetFilterRequireAttentionMaterialGroupQueryVariables>(GetFilterRequireAttentionMaterialGroupDocument, options);
      }
export function useGetFilterRequireAttentionMaterialGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetFilterRequireAttentionMaterialGroupQuery, Types.GetFilterRequireAttentionMaterialGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetFilterRequireAttentionMaterialGroupQuery, Types.GetFilterRequireAttentionMaterialGroupQueryVariables>(GetFilterRequireAttentionMaterialGroupDocument, options);
        }
export type GetFilterRequireAttentionMaterialGroupQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionMaterialGroupQuery>;
export type GetFilterRequireAttentionMaterialGroupLazyQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionMaterialGroupLazyQuery>;
export type GetFilterRequireAttentionMaterialGroupQueryResult = Apollo.QueryResult<Types.GetFilterRequireAttentionMaterialGroupQuery, Types.GetFilterRequireAttentionMaterialGroupQueryVariables>;
export const GetRequireAttentionItemStatusDocument = gql`
    query getRequireAttentionItemStatus {
  requireAttentionItemStatus {
    name
    value
  }
}
    `;

/**
 * __useGetRequireAttentionItemStatusQuery__
 *
 * To run a query within a React component, call `useGetRequireAttentionItemStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequireAttentionItemStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequireAttentionItemStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRequireAttentionItemStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetRequireAttentionItemStatusQuery, Types.GetRequireAttentionItemStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetRequireAttentionItemStatusQuery, Types.GetRequireAttentionItemStatusQueryVariables>(GetRequireAttentionItemStatusDocument, options);
      }
export function useGetRequireAttentionItemStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetRequireAttentionItemStatusQuery, Types.GetRequireAttentionItemStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetRequireAttentionItemStatusQuery, Types.GetRequireAttentionItemStatusQueryVariables>(GetRequireAttentionItemStatusDocument, options);
        }
export type GetRequireAttentionItemStatusQueryHookResult = ReturnType<typeof useGetRequireAttentionItemStatusQuery>;
export type GetRequireAttentionItemStatusLazyQueryHookResult = ReturnType<typeof useGetRequireAttentionItemStatusLazyQuery>;
export type GetRequireAttentionItemStatusQueryResult = Apollo.QueryResult<Types.GetRequireAttentionItemStatusQuery, Types.GetRequireAttentionItemStatusQueryVariables>;
export const FilterRequireAttentionSalesOrganizationByBuDocument = gql`
    query filterRequireAttentionSalesOrganizationByBu($filter: RequireAttentionSalesOrganizationFilterInput, $before: String, $after: String, $first: Int) {
  filterRequireAttentionSalesOrganizationByBu(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useFilterRequireAttentionSalesOrganizationByBuQuery__
 *
 * To run a query within a React component, call `useFilterRequireAttentionSalesOrganizationByBuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRequireAttentionSalesOrganizationByBuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRequireAttentionSalesOrganizationByBuQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterRequireAttentionSalesOrganizationByBuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterRequireAttentionSalesOrganizationByBuQuery, Types.FilterRequireAttentionSalesOrganizationByBuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterRequireAttentionSalesOrganizationByBuQuery, Types.FilterRequireAttentionSalesOrganizationByBuQueryVariables>(FilterRequireAttentionSalesOrganizationByBuDocument, options);
      }
export function useFilterRequireAttentionSalesOrganizationByBuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterRequireAttentionSalesOrganizationByBuQuery, Types.FilterRequireAttentionSalesOrganizationByBuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterRequireAttentionSalesOrganizationByBuQuery, Types.FilterRequireAttentionSalesOrganizationByBuQueryVariables>(FilterRequireAttentionSalesOrganizationByBuDocument, options);
        }
export type FilterRequireAttentionSalesOrganizationByBuQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesOrganizationByBuQuery>;
export type FilterRequireAttentionSalesOrganizationByBuLazyQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesOrganizationByBuLazyQuery>;
export type FilterRequireAttentionSalesOrganizationByBuQueryResult = Apollo.QueryResult<Types.FilterRequireAttentionSalesOrganizationByBuQuery, Types.FilterRequireAttentionSalesOrganizationByBuQueryVariables>;
export const FilterRequireAttentionSalesGroupBySalesOrganizationDocument = gql`
    query filterRequireAttentionSalesGroupBySalesOrganization($filter: RequireAttentionSalesGroupFilterInput, $before: String, $after: String, $first: Int) {
  filterRequireAttentionSalesGroupBySalesOrganization(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        name
        code
      }
    }
  }
}
    `;

/**
 * __useFilterRequireAttentionSalesGroupBySalesOrganizationQuery__
 *
 * To run a query within a React component, call `useFilterRequireAttentionSalesGroupBySalesOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterRequireAttentionSalesGroupBySalesOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterRequireAttentionSalesGroupBySalesOrganizationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterRequireAttentionSalesGroupBySalesOrganizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterRequireAttentionSalesGroupBySalesOrganizationQuery, Types.FilterRequireAttentionSalesGroupBySalesOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterRequireAttentionSalesGroupBySalesOrganizationQuery, Types.FilterRequireAttentionSalesGroupBySalesOrganizationQueryVariables>(FilterRequireAttentionSalesGroupBySalesOrganizationDocument, options);
      }
export function useFilterRequireAttentionSalesGroupBySalesOrganizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterRequireAttentionSalesGroupBySalesOrganizationQuery, Types.FilterRequireAttentionSalesGroupBySalesOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterRequireAttentionSalesGroupBySalesOrganizationQuery, Types.FilterRequireAttentionSalesGroupBySalesOrganizationQueryVariables>(FilterRequireAttentionSalesGroupBySalesOrganizationDocument, options);
        }
export type FilterRequireAttentionSalesGroupBySalesOrganizationQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesGroupBySalesOrganizationQuery>;
export type FilterRequireAttentionSalesGroupBySalesOrganizationLazyQueryHookResult = ReturnType<typeof useFilterRequireAttentionSalesGroupBySalesOrganizationLazyQuery>;
export type FilterRequireAttentionSalesGroupBySalesOrganizationQueryResult = Apollo.QueryResult<Types.FilterRequireAttentionSalesGroupBySalesOrganizationQuery, Types.FilterRequireAttentionSalesGroupBySalesOrganizationQueryVariables>;
export const GetRequireAttentionItemsByIdsDocument = gql`
    query getRequireAttentionItemsByIds($ids: [ID], $first: Int, $after: String, $last: Int, $before: String) {
  requireAttentionItemsByIds(
    ids: $ids
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    latestPageItemNumber
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        orderNo
        matCode
        matDescription
        itemNo
        requestQuantity
        requestDate
        plant
        iplantConfirmQuantity
        assignedQuantity
        iPlan {
          atpCtp
          atpCtpDetail
          block
          run
        }
        confirmedDate
      }
    }
  }
}
    `;

/**
 * __useGetRequireAttentionItemsByIdsQuery__
 *
 * To run a query within a React component, call `useGetRequireAttentionItemsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequireAttentionItemsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequireAttentionItemsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetRequireAttentionItemsByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetRequireAttentionItemsByIdsQuery, Types.GetRequireAttentionItemsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetRequireAttentionItemsByIdsQuery, Types.GetRequireAttentionItemsByIdsQueryVariables>(GetRequireAttentionItemsByIdsDocument, options);
      }
export function useGetRequireAttentionItemsByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetRequireAttentionItemsByIdsQuery, Types.GetRequireAttentionItemsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetRequireAttentionItemsByIdsQuery, Types.GetRequireAttentionItemsByIdsQueryVariables>(GetRequireAttentionItemsByIdsDocument, options);
        }
export type GetRequireAttentionItemsByIdsQueryHookResult = ReturnType<typeof useGetRequireAttentionItemsByIdsQuery>;
export type GetRequireAttentionItemsByIdsLazyQueryHookResult = ReturnType<typeof useGetRequireAttentionItemsByIdsLazyQuery>;
export type GetRequireAttentionItemsByIdsQueryResult = Apollo.QueryResult<Types.GetRequireAttentionItemsByIdsQuery, Types.GetRequireAttentionItemsByIdsQueryVariables>;
export const GetFilterRequireAttentionShipToDocument = gql`
    query getFilterRequireAttentionShipTo($filter: RequireAttentionShipToFilterInput, $before: String, $after: String, $first: Int) {
  filterRequireAttentionShipTo(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        shipTo
      }
    }
  }
}
    `;

/**
 * __useGetFilterRequireAttentionShipToQuery__
 *
 * To run a query within a React component, call `useGetFilterRequireAttentionShipToQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilterRequireAttentionShipToQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilterRequireAttentionShipToQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetFilterRequireAttentionShipToQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetFilterRequireAttentionShipToQuery, Types.GetFilterRequireAttentionShipToQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetFilterRequireAttentionShipToQuery, Types.GetFilterRequireAttentionShipToQueryVariables>(GetFilterRequireAttentionShipToDocument, options);
      }
export function useGetFilterRequireAttentionShipToLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetFilterRequireAttentionShipToQuery, Types.GetFilterRequireAttentionShipToQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetFilterRequireAttentionShipToQuery, Types.GetFilterRequireAttentionShipToQueryVariables>(GetFilterRequireAttentionShipToDocument, options);
        }
export type GetFilterRequireAttentionShipToQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionShipToQuery>;
export type GetFilterRequireAttentionShipToLazyQueryHookResult = ReturnType<typeof useGetFilterRequireAttentionShipToLazyQuery>;
export type GetFilterRequireAttentionShipToQueryResult = Apollo.QueryResult<Types.GetFilterRequireAttentionShipToQuery, Types.GetFilterRequireAttentionShipToQueryVariables>;
export const SuggestionSearchForMaterialGradeGramDocument = gql`
    query suggestionSearchForMaterialGradeGram($filter: SuggestionSearchMaterialGradeGramFilterInput, $first: Int) {
  suggestionSearchForMaterialGradeGram(filter: $filter, first: $first) {
    totalCount
    edges {
      node {
        code
        descriptionTh
      }
    }
  }
}
    `;

/**
 * __useSuggestionSearchForMaterialGradeGramQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchForMaterialGradeGramQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchForMaterialGradeGramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchForMaterialGradeGramQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSuggestionSearchForMaterialGradeGramQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchForMaterialGradeGramQuery, Types.SuggestionSearchForMaterialGradeGramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchForMaterialGradeGramQuery, Types.SuggestionSearchForMaterialGradeGramQueryVariables>(SuggestionSearchForMaterialGradeGramDocument, options);
      }
export function useSuggestionSearchForMaterialGradeGramLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchForMaterialGradeGramQuery, Types.SuggestionSearchForMaterialGradeGramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchForMaterialGradeGramQuery, Types.SuggestionSearchForMaterialGradeGramQueryVariables>(SuggestionSearchForMaterialGradeGramDocument, options);
        }
export type SuggestionSearchForMaterialGradeGramQueryHookResult = ReturnType<typeof useSuggestionSearchForMaterialGradeGramQuery>;
export type SuggestionSearchForMaterialGradeGramLazyQueryHookResult = ReturnType<typeof useSuggestionSearchForMaterialGradeGramLazyQuery>;
export type SuggestionSearchForMaterialGradeGramQueryResult = Apollo.QueryResult<Types.SuggestionSearchForMaterialGradeGramQuery, Types.SuggestionSearchForMaterialGradeGramQueryVariables>;
export const RequireAttentionEditItemsByIdsDocument = gql`
    query requireAttentionEditItemsByIds($sortBy: RequireAttentionItemsSortingInput, $ids: [ID], $before: String, $after: String, $first: Int, $last: Int) {
  requireAttentionEditItemsByIds(
    sortBy: $sortBy
    ids: $ids
    before: $before
    after: $after
    first: $first
    last: $last
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        orderNo
        itemNo
        soldTo
        originalDate
        inquiryMethodCode
        requestDate
        confirmedDate
        requestQuantity
        iplantConfirmQuantity
        assignedQuantity
        unit
        matCode
        matDescription
        poNo
        plant
        shipTo
        itemStatus
        status
        attentionType
        overdue1
        overdue2
      }
    }
    totalCount
    latestPageItemNumber
  }
}
    `;

/**
 * __useRequireAttentionEditItemsByIdsQuery__
 *
 * To run a query within a React component, call `useRequireAttentionEditItemsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequireAttentionEditItemsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequireAttentionEditItemsByIdsQuery({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      ids: // value for 'ids'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useRequireAttentionEditItemsByIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.RequireAttentionEditItemsByIdsQuery, Types.RequireAttentionEditItemsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.RequireAttentionEditItemsByIdsQuery, Types.RequireAttentionEditItemsByIdsQueryVariables>(RequireAttentionEditItemsByIdsDocument, options);
      }
export function useRequireAttentionEditItemsByIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.RequireAttentionEditItemsByIdsQuery, Types.RequireAttentionEditItemsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.RequireAttentionEditItemsByIdsQuery, Types.RequireAttentionEditItemsByIdsQueryVariables>(RequireAttentionEditItemsByIdsDocument, options);
        }
export type RequireAttentionEditItemsByIdsQueryHookResult = ReturnType<typeof useRequireAttentionEditItemsByIdsQuery>;
export type RequireAttentionEditItemsByIdsLazyQueryHookResult = ReturnType<typeof useRequireAttentionEditItemsByIdsLazyQuery>;
export type RequireAttentionEditItemsByIdsQueryResult = Apollo.QueryResult<Types.RequireAttentionEditItemsByIdsQuery, Types.RequireAttentionEditItemsByIdsQueryVariables>;
export const OrderDraftsDocument = gql`
    query orderDrafts($before: String, $after: String, $first: Int, $last: Int, $sortBy: OrderDraftSorterInput, $filter: ScgOrderDraftFilterInput) {
  orderDrafts(
    sortBy: $sortBy
    filter: $filter
    first: $first
    before: $before
    after: $after
    last: $last
  ) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    latestPageItemNumber
    totalCount
    edges {
      node {
        id
        type
        status
        poNumber
        contractPiNo
        saleOrganization {
          code
          businessUnit {
            code
            name
          }
        }
        customer {
          code
          name
        }
        createdAt
        updatedAt
        createdBy {
          id
          email
        }
      }
    }
  }
}
    `;

/**
 * __useOrderDraftsQuery__
 *
 * To run a query within a React component, call `useOrderDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDraftsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sortBy: // value for 'sortBy'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderDraftsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.OrderDraftsQuery, Types.OrderDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.OrderDraftsQuery, Types.OrderDraftsQueryVariables>(OrderDraftsDocument, options);
      }
export function useOrderDraftsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.OrderDraftsQuery, Types.OrderDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.OrderDraftsQuery, Types.OrderDraftsQueryVariables>(OrderDraftsDocument, options);
        }
export type OrderDraftsQueryHookResult = ReturnType<typeof useOrderDraftsQuery>;
export type OrderDraftsLazyQueryHookResult = ReturnType<typeof useOrderDraftsLazyQuery>;
export type OrderDraftsQueryResult = Apollo.QueryResult<Types.OrderDraftsQuery, Types.OrderDraftsQueryVariables>;
export const SearchCustomersDocument = gql`
    query SearchCustomers($after: String, $first: Int!, $query: String!) {
  search: customers(after: $after, first: $first, filter: {search: $query}) {
    edges {
      node {
        id
        email
        firstName
        lastName
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchCustomersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SearchCustomersQuery, Types.SearchCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchCustomersQuery, Types.SearchCustomersQueryVariables>(SearchCustomersDocument, options);
      }
export function useSearchCustomersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchCustomersQuery, Types.SearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchCustomersQuery, Types.SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<typeof useSearchCustomersLazyQuery>;
export type SearchCustomersQueryResult = Apollo.QueryResult<Types.SearchCustomersQuery, Types.SearchCustomersQueryVariables>;
export const SearchPermissionGroupsDocument = gql`
    query SearchPermissionGroups($after: String, $first: Int!, $query: String!) {
  search: permissionGroups(after: $after, first: $first, filter: {search: $query}) {
    edges {
      node {
        id
        name
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useSearchPermissionGroupsQuery__
 *
 * To run a query within a React component, call `useSearchPermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPermissionGroupsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchPermissionGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SearchPermissionGroupsQuery, Types.SearchPermissionGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchPermissionGroupsQuery, Types.SearchPermissionGroupsQueryVariables>(SearchPermissionGroupsDocument, options);
      }
export function useSearchPermissionGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchPermissionGroupsQuery, Types.SearchPermissionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchPermissionGroupsQuery, Types.SearchPermissionGroupsQueryVariables>(SearchPermissionGroupsDocument, options);
        }
export type SearchPermissionGroupsQueryHookResult = ReturnType<typeof useSearchPermissionGroupsQuery>;
export type SearchPermissionGroupsLazyQueryHookResult = ReturnType<typeof useSearchPermissionGroupsLazyQuery>;
export type SearchPermissionGroupsQueryResult = Apollo.QueryResult<Types.SearchPermissionGroupsQuery, Types.SearchPermissionGroupsQueryVariables>;
export const SearchStaffMembersDocument = gql`
    query SearchStaffMembers($after: String, $first: Int!, $query: String!) {
  search: staffUsers(after: $after, first: $first, filter: {search: $query}) {
    edges {
      node {
        id
        email
        firstName
        lastName
        isActive
        avatar {
          alt
          url
        }
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useSearchStaffMembersQuery__
 *
 * To run a query within a React component, call `useSearchStaffMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStaffMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStaffMembersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchStaffMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.SearchStaffMembersQuery, Types.SearchStaffMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SearchStaffMembersQuery, Types.SearchStaffMembersQueryVariables>(SearchStaffMembersDocument, options);
      }
export function useSearchStaffMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SearchStaffMembersQuery, Types.SearchStaffMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SearchStaffMembersQuery, Types.SearchStaffMembersQueryVariables>(SearchStaffMembersDocument, options);
        }
export type SearchStaffMembersQueryHookResult = ReturnType<typeof useSearchStaffMembersQuery>;
export type SearchStaffMembersLazyQueryHookResult = ReturnType<typeof useSearchStaffMembersLazyQuery>;
export type SearchStaffMembersQueryResult = Apollo.QueryResult<Types.SearchStaffMembersQuery, Types.SearchStaffMembersQueryVariables>;
export const ShopSettingsUpdateDocument = gql`
    mutation ShopSettingsUpdate($shopSettingsInput: ShopSettingsInput!, $isCloudInstance: Boolean!) {
  shopSettingsUpdate(input: $shopSettingsInput) {
    errors {
      ...ShopError
    }
    shop {
      ...Shop
    }
  }
}
    ${ShopErrorFragmentDoc}
${ShopFragmentDoc}`;
export type ShopSettingsUpdateMutationFn = Apollo.MutationFunction<Types.ShopSettingsUpdateMutation, Types.ShopSettingsUpdateMutationVariables>;

/**
 * __useShopSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useShopSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSettingsUpdateMutation, { data, loading, error }] = useShopSettingsUpdateMutation({
 *   variables: {
 *      shopSettingsInput: // value for 'shopSettingsInput'
 *      isCloudInstance: // value for 'isCloudInstance'
 *   },
 * });
 */
export function useShopSettingsUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ShopSettingsUpdateMutation, Types.ShopSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ShopSettingsUpdateMutation, Types.ShopSettingsUpdateMutationVariables>(ShopSettingsUpdateDocument, options);
      }
export type ShopSettingsUpdateMutationHookResult = ReturnType<typeof useShopSettingsUpdateMutation>;
export type ShopSettingsUpdateMutationResult = Apollo.MutationResult<Types.ShopSettingsUpdateMutation>;
export type ShopSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ShopSettingsUpdateMutation, Types.ShopSettingsUpdateMutationVariables>;
export const SiteSettingsDocument = gql`
    query SiteSettings {
  shop {
    ...Shop
  }
}
    ${ShopFragmentDoc}`;

/**
 * __useSiteSettingsQuery__
 *
 * To run a query within a React component, call `useSiteSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>(SiteSettingsDocument, options);
      }
export function useSiteSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>(SiteSettingsDocument, options);
        }
export type SiteSettingsQueryHookResult = ReturnType<typeof useSiteSettingsQuery>;
export type SiteSettingsLazyQueryHookResult = ReturnType<typeof useSiteSettingsLazyQuery>;
export type SiteSettingsQueryResult = Apollo.QueryResult<Types.SiteSettingsQuery, Types.SiteSettingsQueryVariables>;
export const SuggestionSearchForMaterialGradeGramStockOnHandDocument = gql`
    query suggestionSearchForMaterialGradeGramStockOnHand($filter: SuggestionSearchMaterialGradeGramFilterInput, $first: Int) {
  suggestionSearchForMaterialGradeGram(first: $first, filter: $filter) {
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges {
      node {
        code
        descriptionEn
      }
    }
  }
}
    `;

/**
 * __useSuggestionSearchForMaterialGradeGramStockOnHandQuery__
 *
 * To run a query within a React component, call `useSuggestionSearchForMaterialGradeGramStockOnHandQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionSearchForMaterialGradeGramStockOnHandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionSearchForMaterialGradeGramStockOnHandQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSuggestionSearchForMaterialGradeGramStockOnHandQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.SuggestionSearchForMaterialGradeGramStockOnHandQuery, Types.SuggestionSearchForMaterialGradeGramStockOnHandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.SuggestionSearchForMaterialGradeGramStockOnHandQuery, Types.SuggestionSearchForMaterialGradeGramStockOnHandQueryVariables>(SuggestionSearchForMaterialGradeGramStockOnHandDocument, options);
      }
export function useSuggestionSearchForMaterialGradeGramStockOnHandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.SuggestionSearchForMaterialGradeGramStockOnHandQuery, Types.SuggestionSearchForMaterialGradeGramStockOnHandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.SuggestionSearchForMaterialGradeGramStockOnHandQuery, Types.SuggestionSearchForMaterialGradeGramStockOnHandQueryVariables>(SuggestionSearchForMaterialGradeGramStockOnHandDocument, options);
        }
export type SuggestionSearchForMaterialGradeGramStockOnHandQueryHookResult = ReturnType<typeof useSuggestionSearchForMaterialGradeGramStockOnHandQuery>;
export type SuggestionSearchForMaterialGradeGramStockOnHandLazyQueryHookResult = ReturnType<typeof useSuggestionSearchForMaterialGradeGramStockOnHandLazyQuery>;
export type SuggestionSearchForMaterialGradeGramStockOnHandQueryResult = Apollo.QueryResult<Types.SuggestionSearchForMaterialGradeGramStockOnHandQuery, Types.SuggestionSearchForMaterialGradeGramStockOnHandQueryVariables>;
export const GetStockOnHandReportDocument = gql`
    query getStockOnHandReport($input: GetOnHandReportInput!) {
  getStockOnHandReport(input: $input) {
    productCode
    totalUr
    customerOrderQuantity
    consignmentQuantity
    freeQuantity
    unit
    summaryAsOf
    allPlant
    customerOrderList {
      customer
      soNoSlashItem
      quantity
      pendingQuantity
      requestDate
      plant
      soNo
      createDate
      createBy {
        firstName
        lastName
      }
      saleRep
      poNo
    }
    consignmentList {
      customerSession
      quantity
      futureDummyStock
      plant
    }
    freeStockList {
      plant
      quantity
    }
  }
}
    `;

/**
 * __useGetStockOnHandReportQuery__
 *
 * To run a query within a React component, call `useGetStockOnHandReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockOnHandReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockOnHandReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetStockOnHandReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetStockOnHandReportQuery, Types.GetStockOnHandReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetStockOnHandReportQuery, Types.GetStockOnHandReportQueryVariables>(GetStockOnHandReportDocument, options);
      }
export function useGetStockOnHandReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetStockOnHandReportQuery, Types.GetStockOnHandReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetStockOnHandReportQuery, Types.GetStockOnHandReportQueryVariables>(GetStockOnHandReportDocument, options);
        }
export type GetStockOnHandReportQueryHookResult = ReturnType<typeof useGetStockOnHandReportQuery>;
export type GetStockOnHandReportLazyQueryHookResult = ReturnType<typeof useGetStockOnHandReportLazyQuery>;
export type GetStockOnHandReportQueryResult = Apollo.QueryResult<Types.GetStockOnHandReportQuery, Types.GetStockOnHandReportQueryVariables>;
export const ScgpUserRegisterDocument = gql`
    mutation ScgpUserRegister($input: ScgpUserRegisterInput!) {
  scgpUserRegister(input: $input) {
    user {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export type ScgpUserRegisterMutationFn = Apollo.MutationFunction<Types.ScgpUserRegisterMutation, Types.ScgpUserRegisterMutationVariables>;

/**
 * __useScgpUserRegisterMutation__
 *
 * To run a mutation, you first call `useScgpUserRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpUserRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpUserRegisterMutation, { data, loading, error }] = useScgpUserRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScgpUserRegisterMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpUserRegisterMutation, Types.ScgpUserRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpUserRegisterMutation, Types.ScgpUserRegisterMutationVariables>(ScgpUserRegisterDocument, options);
      }
export type ScgpUserRegisterMutationHookResult = ReturnType<typeof useScgpUserRegisterMutation>;
export type ScgpUserRegisterMutationResult = Apollo.MutationResult<Types.ScgpUserRegisterMutation>;
export type ScgpUserRegisterMutationOptions = Apollo.BaseMutationOptions<Types.ScgpUserRegisterMutation, Types.ScgpUserRegisterMutationVariables>;
export const ScgpUserUpdateDocument = gql`
    mutation ScgpUserUpdate($id: ID!, $input: ScgpUserUpdateInput!) {
  scgpUserUpdate(id: $id, input: $input) {
    user {
      id
    }
    errors {
      field
      message
    }
  }
}
    `;
export type ScgpUserUpdateMutationFn = Apollo.MutationFunction<Types.ScgpUserUpdateMutation, Types.ScgpUserUpdateMutationVariables>;

/**
 * __useScgpUserUpdateMutation__
 *
 * To run a mutation, you first call `useScgpUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpUserUpdateMutation, { data, loading, error }] = useScgpUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScgpUserUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpUserUpdateMutation, Types.ScgpUserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpUserUpdateMutation, Types.ScgpUserUpdateMutationVariables>(ScgpUserUpdateDocument, options);
      }
export type ScgpUserUpdateMutationHookResult = ReturnType<typeof useScgpUserUpdateMutation>;
export type ScgpUserUpdateMutationResult = Apollo.MutationResult<Types.ScgpUserUpdateMutation>;
export type ScgpUserUpdateMutationOptions = Apollo.BaseMutationOptions<Types.ScgpUserUpdateMutation, Types.ScgpUserUpdateMutationVariables>;
export const ChangeScgpUserStatusDocument = gql`
    mutation changeScgpUserStatus($id: ID!, $status: Boolean!) {
  changeScgpUserStatus(id: $id, status: $status) {
    user {
      id
      isActive
    }
  }
}
    `;
export type ChangeScgpUserStatusMutationFn = Apollo.MutationFunction<Types.ChangeScgpUserStatusMutation, Types.ChangeScgpUserStatusMutationVariables>;

/**
 * __useChangeScgpUserStatusMutation__
 *
 * To run a mutation, you first call `useChangeScgpUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeScgpUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeScgpUserStatusMutation, { data, loading, error }] = useChangeScgpUserStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeScgpUserStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ChangeScgpUserStatusMutation, Types.ChangeScgpUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ChangeScgpUserStatusMutation, Types.ChangeScgpUserStatusMutationVariables>(ChangeScgpUserStatusDocument, options);
      }
export type ChangeScgpUserStatusMutationHookResult = ReturnType<typeof useChangeScgpUserStatusMutation>;
export type ChangeScgpUserStatusMutationResult = Apollo.MutationResult<Types.ChangeScgpUserStatusMutation>;
export type ChangeScgpUserStatusMutationOptions = Apollo.BaseMutationOptions<Types.ChangeScgpUserStatusMutation, Types.ChangeScgpUserStatusMutationVariables>;
export const ScgpDeleteUserDocument = gql`
    mutation scgpDeleteUser($user_id: ID!) {
  scgpDeleteUser(userId: $user_id) {
    status
  }
}
    `;
export type ScgpDeleteUserMutationFn = Apollo.MutationFunction<Types.ScgpDeleteUserMutation, Types.ScgpDeleteUserMutationVariables>;

/**
 * __useScgpDeleteUserMutation__
 *
 * To run a mutation, you first call `useScgpDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScgpDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scgpDeleteUserMutation, { data, loading, error }] = useScgpDeleteUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useScgpDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<Types.ScgpDeleteUserMutation, Types.ScgpDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<Types.ScgpDeleteUserMutation, Types.ScgpDeleteUserMutationVariables>(ScgpDeleteUserDocument, options);
      }
export type ScgpDeleteUserMutationHookResult = ReturnType<typeof useScgpDeleteUserMutation>;
export type ScgpDeleteUserMutationResult = Apollo.MutationResult<Types.ScgpDeleteUserMutation>;
export type ScgpDeleteUserMutationOptions = Apollo.BaseMutationOptions<Types.ScgpDeleteUserMutation, Types.ScgpDeleteUserMutationVariables>;
export const GetParentGroupsDocument = gql`
    query getParentGroups {
  parentGroups(first: 100) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetParentGroupsQuery__
 *
 * To run a query within a React component, call `useGetParentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParentGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetParentGroupsQuery, Types.GetParentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetParentGroupsQuery, Types.GetParentGroupsQueryVariables>(GetParentGroupsDocument, options);
      }
export function useGetParentGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetParentGroupsQuery, Types.GetParentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetParentGroupsQuery, Types.GetParentGroupsQueryVariables>(GetParentGroupsDocument, options);
        }
export type GetParentGroupsQueryHookResult = ReturnType<typeof useGetParentGroupsQuery>;
export type GetParentGroupsLazyQueryHookResult = ReturnType<typeof useGetParentGroupsLazyQuery>;
export type GetParentGroupsQueryResult = Apollo.QueryResult<Types.GetParentGroupsQuery, Types.GetParentGroupsQueryVariables>;
export const GetRoleListByGroupDocument = gql`
    query getRoleListByGroup($id: ID!) {
  parentGroup(id: $id) {
    name
    id
    groups {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRoleListByGroupQuery__
 *
 * To run a query within a React component, call `useGetRoleListByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleListByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleListByGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleListByGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetRoleListByGroupQuery, Types.GetRoleListByGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetRoleListByGroupQuery, Types.GetRoleListByGroupQueryVariables>(GetRoleListByGroupDocument, options);
      }
export function useGetRoleListByGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetRoleListByGroupQuery, Types.GetRoleListByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetRoleListByGroupQuery, Types.GetRoleListByGroupQueryVariables>(GetRoleListByGroupDocument, options);
        }
export type GetRoleListByGroupQueryHookResult = ReturnType<typeof useGetRoleListByGroupQuery>;
export type GetRoleListByGroupLazyQueryHookResult = ReturnType<typeof useGetRoleListByGroupLazyQuery>;
export type GetRoleListByGroupQueryResult = Apollo.QueryResult<Types.GetRoleListByGroupQuery, Types.GetRoleListByGroupQueryVariables>;
export const GetPermissionGroupsDocument = gql`
    query getPermissionGroups {
  permissionGroups(first: 100) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetPermissionGroupsQuery__
 *
 * To run a query within a React component, call `useGetPermissionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>(GetPermissionGroupsDocument, options);
      }
export function useGetPermissionGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>(GetPermissionGroupsDocument, options);
        }
export type GetPermissionGroupsQueryHookResult = ReturnType<typeof useGetPermissionGroupsQuery>;
export type GetPermissionGroupsLazyQueryHookResult = ReturnType<typeof useGetPermissionGroupsLazyQuery>;
export type GetPermissionGroupsQueryResult = Apollo.QueryResult<Types.GetPermissionGroupsQuery, Types.GetPermissionGroupsQueryVariables>;
export const GetListUserManagementDocument = gql`
    query getListUserManagement($first: Int, $filter: ScgpUsersFilterInput, $after: String, $last: Int, $before: String, $sortBy: ScgpUserSortingInput) {
  scgpUsers(
    first: $first
    filter: $filter
    sortBy: $sortBy
    after: $after
    last: $last
    before: $before
  ) {
    edges {
      node {
        id
        extendData {
          employeeId
          customerType
          userParentGroup {
            id
            name
          }
          scgpBus {
            id
            name
          }
          scgpSalesOrganizations {
            id
            name
          }
          scgpSalesGroups {
            id
            name
          }
          updatedBy {
            firstName
            lastName
          }
        }
        firstName
        lastName
        email
        soldTos {
          code
          name
        }
        dateJoined
        permissionGroups {
          id
          name
        }
        isActive
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
    latestPageItemNumber
  }
}
    `;

/**
 * __useGetListUserManagementQuery__
 *
 * To run a query within a React component, call `useGetListUserManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListUserManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListUserManagementQuery({
 *   variables: {
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetListUserManagementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetListUserManagementQuery, Types.GetListUserManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetListUserManagementQuery, Types.GetListUserManagementQueryVariables>(GetListUserManagementDocument, options);
      }
export function useGetListUserManagementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetListUserManagementQuery, Types.GetListUserManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetListUserManagementQuery, Types.GetListUserManagementQueryVariables>(GetListUserManagementDocument, options);
        }
export type GetListUserManagementQueryHookResult = ReturnType<typeof useGetListUserManagementQuery>;
export type GetListUserManagementLazyQueryHookResult = ReturnType<typeof useGetListUserManagementLazyQuery>;
export type GetListUserManagementQueryResult = Apollo.QueryResult<Types.GetListUserManagementQuery, Types.GetListUserManagementQueryVariables>;
export const FilterSoldToScgCheckoutDocument = gql`
    query filterSoldToScgCheckout($filter: UserManagementSoldToFilterInput, $first: Int) {
  filterSoldToScgCheckout(filter: $filter, first: $first) {
    edges {
      node {
        id
        addressText
        code
        name
      }
    }
  }
}
    `;

/**
 * __useFilterSoldToScgCheckoutQuery__
 *
 * To run a query within a React component, call `useFilterSoldToScgCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterSoldToScgCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterSoldToScgCheckoutQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterSoldToScgCheckoutQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterSoldToScgCheckoutQuery, Types.FilterSoldToScgCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterSoldToScgCheckoutQuery, Types.FilterSoldToScgCheckoutQueryVariables>(FilterSoldToScgCheckoutDocument, options);
      }
export function useFilterSoldToScgCheckoutLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterSoldToScgCheckoutQuery, Types.FilterSoldToScgCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterSoldToScgCheckoutQuery, Types.FilterSoldToScgCheckoutQueryVariables>(FilterSoldToScgCheckoutDocument, options);
        }
export type FilterSoldToScgCheckoutQueryHookResult = ReturnType<typeof useFilterSoldToScgCheckoutQuery>;
export type FilterSoldToScgCheckoutLazyQueryHookResult = ReturnType<typeof useFilterSoldToScgCheckoutLazyQuery>;
export type FilterSoldToScgCheckoutQueryResult = Apollo.QueryResult<Types.FilterSoldToScgCheckoutQuery, Types.FilterSoldToScgCheckoutQueryVariables>;
export const ScgpUserDocument = gql`
    query scgpUser($id: ID!) {
  scgpUser(id: $id) {
    id
    email
    firstName
    lastName
    lastLogin
    dateJoined
    updatedAt
    isActive
    soldTos {
      id
      code
      name
    }
    permissionGroups {
      id
      name
    }
    extendData {
      displayName
      customerType
      companyEmail
      adUser
      employeeId
      saleId
      sapId
      scgpBus {
        id
        name
      }
      scgpSalesOrganizations {
        id
        code
        name
      }
      scgpSalesGroups {
        id
        code
        name
      }
      scgpDistributionChannels {
        id
        code
        name
      }
      scgpDivisions {
        id
        code
        name
      }
      scgpSalesOffices {
        id
        code
        name
      }
      createdBy {
        firstName
        lastName
      }
      updatedBy {
        firstName
        lastName
      }
      updatedAt
      userParentGroup {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useScgpUserQuery__
 *
 * To run a query within a React component, call `useScgpUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useScgpUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScgpUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScgpUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.ScgpUserQuery, Types.ScgpUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ScgpUserQuery, Types.ScgpUserQueryVariables>(ScgpUserDocument, options);
      }
export function useScgpUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ScgpUserQuery, Types.ScgpUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ScgpUserQuery, Types.ScgpUserQueryVariables>(ScgpUserDocument, options);
        }
export type ScgpUserQueryHookResult = ReturnType<typeof useScgpUserQuery>;
export type ScgpUserLazyQueryHookResult = ReturnType<typeof useScgpUserLazyQuery>;
export type ScgpUserQueryResult = Apollo.QueryResult<Types.ScgpUserQuery, Types.ScgpUserQueryVariables>;
export const ParentGroupsDocument = gql`
    query parentGroups {
  parentGroups(first: 100) {
    totalCount
    edges {
      node {
        id
        code
        name
      }
    }
  }
}
    `;

/**
 * __useParentGroupsQuery__
 *
 * To run a query within a React component, call `useParentGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParentGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParentGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useParentGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.ParentGroupsQuery, Types.ParentGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.ParentGroupsQuery, Types.ParentGroupsQueryVariables>(ParentGroupsDocument, options);
      }
export function useParentGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.ParentGroupsQuery, Types.ParentGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.ParentGroupsQuery, Types.ParentGroupsQueryVariables>(ParentGroupsDocument, options);
        }
export type ParentGroupsQueryHookResult = ReturnType<typeof useParentGroupsQuery>;
export type ParentGroupsLazyQueryHookResult = ReturnType<typeof useParentGroupsLazyQuery>;
export type ParentGroupsQueryResult = Apollo.QueryResult<Types.ParentGroupsQuery, Types.ParentGroupsQueryVariables>;
export const GetScgpGdcDataDocument = gql`
    query getScgpGdcData($adUser: String!) {
  scgpGdcData(adUser: $adUser) {
    employeeId
    email
    firstName
    lastName
    saleOrgs {
      id
      code
      name
    }
    bus {
      id
      code
      name
    }
  }
}
    `;

/**
 * __useGetScgpGdcDataQuery__
 *
 * To run a query within a React component, call `useGetScgpGdcDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScgpGdcDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScgpGdcDataQuery({
 *   variables: {
 *      adUser: // value for 'adUser'
 *   },
 * });
 */
export function useGetScgpGdcDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<Types.GetScgpGdcDataQuery, Types.GetScgpGdcDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetScgpGdcDataQuery, Types.GetScgpGdcDataQueryVariables>(GetScgpGdcDataDocument, options);
      }
export function useGetScgpGdcDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetScgpGdcDataQuery, Types.GetScgpGdcDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetScgpGdcDataQuery, Types.GetScgpGdcDataQueryVariables>(GetScgpGdcDataDocument, options);
        }
export type GetScgpGdcDataQueryHookResult = ReturnType<typeof useGetScgpGdcDataQuery>;
export type GetScgpGdcDataLazyQueryHookResult = ReturnType<typeof useGetScgpGdcDataLazyQuery>;
export type GetScgpGdcDataQueryResult = Apollo.QueryResult<Types.GetScgpGdcDataQuery, Types.GetScgpGdcDataQueryVariables>;
export const FilterUserManagementSaleOrgByBuDocument = gql`
    query filterUserManagementSaleOrgByBu($filter: UserManagementSaleOrgFilterInput, $before: String, $after: String, $first: Int) {
  filterUserManagementSaleOrgByBu(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        code
        name
        id
        shortName
      }
    }
  }
}
    `;

/**
 * __useFilterUserManagementSaleOrgByBuQuery__
 *
 * To run a query within a React component, call `useFilterUserManagementSaleOrgByBuQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterUserManagementSaleOrgByBuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterUserManagementSaleOrgByBuQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterUserManagementSaleOrgByBuQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterUserManagementSaleOrgByBuQuery, Types.FilterUserManagementSaleOrgByBuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterUserManagementSaleOrgByBuQuery, Types.FilterUserManagementSaleOrgByBuQueryVariables>(FilterUserManagementSaleOrgByBuDocument, options);
      }
export function useFilterUserManagementSaleOrgByBuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterUserManagementSaleOrgByBuQuery, Types.FilterUserManagementSaleOrgByBuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterUserManagementSaleOrgByBuQuery, Types.FilterUserManagementSaleOrgByBuQueryVariables>(FilterUserManagementSaleOrgByBuDocument, options);
        }
export type FilterUserManagementSaleOrgByBuQueryHookResult = ReturnType<typeof useFilterUserManagementSaleOrgByBuQuery>;
export type FilterUserManagementSaleOrgByBuLazyQueryHookResult = ReturnType<typeof useFilterUserManagementSaleOrgByBuLazyQuery>;
export type FilterUserManagementSaleOrgByBuQueryResult = Apollo.QueryResult<Types.FilterUserManagementSaleOrgByBuQuery, Types.FilterUserManagementSaleOrgByBuQueryVariables>;
export const FilterUserManagementSaleGroupBySaleOrgDocument = gql`
    query filterUserManagementSaleGroupBySaleOrg($filter: UserManagementSalesGroupFilterInput, $before: String, $after: String, $first: Int) {
  filterUserManagementSaleGroupBySaleOrg(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        code
        name
        id
        __typename
        displayText
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useFilterUserManagementSaleGroupBySaleOrgQuery__
 *
 * To run a query within a React component, call `useFilterUserManagementSaleGroupBySaleOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterUserManagementSaleGroupBySaleOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterUserManagementSaleGroupBySaleOrgQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterUserManagementSaleGroupBySaleOrgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterUserManagementSaleGroupBySaleOrgQuery, Types.FilterUserManagementSaleGroupBySaleOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterUserManagementSaleGroupBySaleOrgQuery, Types.FilterUserManagementSaleGroupBySaleOrgQueryVariables>(FilterUserManagementSaleGroupBySaleOrgDocument, options);
      }
export function useFilterUserManagementSaleGroupBySaleOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterUserManagementSaleGroupBySaleOrgQuery, Types.FilterUserManagementSaleGroupBySaleOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterUserManagementSaleGroupBySaleOrgQuery, Types.FilterUserManagementSaleGroupBySaleOrgQueryVariables>(FilterUserManagementSaleGroupBySaleOrgDocument, options);
        }
export type FilterUserManagementSaleGroupBySaleOrgQueryHookResult = ReturnType<typeof useFilterUserManagementSaleGroupBySaleOrgQuery>;
export type FilterUserManagementSaleGroupBySaleOrgLazyQueryHookResult = ReturnType<typeof useFilterUserManagementSaleGroupBySaleOrgLazyQuery>;
export type FilterUserManagementSaleGroupBySaleOrgQueryResult = Apollo.QueryResult<Types.FilterUserManagementSaleGroupBySaleOrgQuery, Types.FilterUserManagementSaleGroupBySaleOrgQueryVariables>;
export const FilterUserManagementSaleOfficeBySaleOrgDocument = gql`
    query filterUserManagementSaleOfficeBySaleOrg($filter: UserManagementSaleOfficeFilterInput, $before: String, $after: String, $first: Int) {
  filterUserManagementSaleOfficeBySaleOrg(
    filter: $filter
    before: $before
    after: $after
    first: $first
  ) {
    edges {
      node {
        code
        name
        id
        displayText
      }
    }
  }
}
    `;

/**
 * __useFilterUserManagementSaleOfficeBySaleOrgQuery__
 *
 * To run a query within a React component, call `useFilterUserManagementSaleOfficeBySaleOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterUserManagementSaleOfficeBySaleOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterUserManagementSaleOfficeBySaleOrgQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useFilterUserManagementSaleOfficeBySaleOrgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.FilterUserManagementSaleOfficeBySaleOrgQuery, Types.FilterUserManagementSaleOfficeBySaleOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.FilterUserManagementSaleOfficeBySaleOrgQuery, Types.FilterUserManagementSaleOfficeBySaleOrgQueryVariables>(FilterUserManagementSaleOfficeBySaleOrgDocument, options);
      }
export function useFilterUserManagementSaleOfficeBySaleOrgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.FilterUserManagementSaleOfficeBySaleOrgQuery, Types.FilterUserManagementSaleOfficeBySaleOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.FilterUserManagementSaleOfficeBySaleOrgQuery, Types.FilterUserManagementSaleOfficeBySaleOrgQueryVariables>(FilterUserManagementSaleOfficeBySaleOrgDocument, options);
        }
export type FilterUserManagementSaleOfficeBySaleOrgQueryHookResult = ReturnType<typeof useFilterUserManagementSaleOfficeBySaleOrgQuery>;
export type FilterUserManagementSaleOfficeBySaleOrgLazyQueryHookResult = ReturnType<typeof useFilterUserManagementSaleOfficeBySaleOrgLazyQuery>;
export type FilterUserManagementSaleOfficeBySaleOrgQueryResult = Apollo.QueryResult<Types.FilterUserManagementSaleOfficeBySaleOrgQuery, Types.FilterUserManagementSaleOfficeBySaleOrgQueryVariables>;
export const GetRolesAndMenuFunctionsDocument = gql`
    query getRolesAndMenuFunctions {
  getRolesAndMenuFunctions(first: 100) {
    edges {
      node {
        id
        name
        code
        groups {
          id
          name
          menuFunctions {
            code
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRolesAndMenuFunctionsQuery__
 *
 * To run a query within a React component, call `useGetRolesAndMenuFunctionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesAndMenuFunctionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesAndMenuFunctionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesAndMenuFunctionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<Types.GetRolesAndMenuFunctionsQuery, Types.GetRolesAndMenuFunctionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<Types.GetRolesAndMenuFunctionsQuery, Types.GetRolesAndMenuFunctionsQueryVariables>(GetRolesAndMenuFunctionsDocument, options);
      }
export function useGetRolesAndMenuFunctionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<Types.GetRolesAndMenuFunctionsQuery, Types.GetRolesAndMenuFunctionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<Types.GetRolesAndMenuFunctionsQuery, Types.GetRolesAndMenuFunctionsQueryVariables>(GetRolesAndMenuFunctionsDocument, options);
        }
export type GetRolesAndMenuFunctionsQueryHookResult = ReturnType<typeof useGetRolesAndMenuFunctionsQuery>;
export type GetRolesAndMenuFunctionsLazyQueryHookResult = ReturnType<typeof useGetRolesAndMenuFunctionsLazyQuery>;
export type GetRolesAndMenuFunctionsQueryResult = Apollo.QueryResult<Types.GetRolesAndMenuFunctionsQuery, Types.GetRolesAndMenuFunctionsQueryVariables>;